var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1930.13 0H-10.5601V1080H1930.13V0Z",
    fill: "#D8DAE1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1223.26 689.87C1223.81 691.4 1223.02 693.08 1221.49 693.63C1219.96 694.18 1218.28 693.39 1217.73 691.86C1217.18 690.33 1217.97 688.65 1219.5 688.1C1221.03 687.55 1222.71 688.34 1223.26 689.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M947.36 693.92C949.52 696.01 949.58 699.47 947.49 701.63C945.4 703.79 941.94 703.85 939.78 701.76C937.62 699.67 937.56 696.21 939.65 694.05C941.74 691.89 945.2 691.83 947.36 693.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M365.25 467.67C363.07 467.89 361.12 466.31 360.9 464.13C360.68 461.95 362.26 460 364.44 459.78C366.62 459.56 368.57 461.14 368.79 463.32C369.01 465.5 367.43 467.45 365.25 467.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M209.7 597.51C207.46 597.22 205.87 595.17 206.15 592.93C206.44 590.69 208.49 589.1 210.73 589.38C212.97 589.67 214.56 591.72 214.28 593.96C214 596.2 211.94 597.79 209.7 597.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M504.05 637.04C502.86 637.67 501.38 637.22 500.75 636.03C500.12 634.84 500.57 633.36 501.76 632.72C502.95 632.09 504.43 632.54 505.07 633.73C505.7 634.92 505.25 636.4 504.06 637.04H504.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1232.28 451.12C1236.24 452.99 1237.93 457.72 1236.06 461.69C1234.19 465.65 1229.46 467.34 1225.49 465.47C1221.52 463.6 1219.84 458.87 1221.71 454.9C1223.58 450.94 1228.31 449.25 1232.28 451.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M1561.79 445.84C1557.87 445.41 1555.05 441.89 1555.47 437.98C1555.9 434.06 1559.42 431.24 1563.33 431.66C1567.25 432.09 1570.07 435.61 1569.65 439.52C1569.22 443.44 1565.7 446.26 1561.79 445.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M176.45 592.33C179.26 592.17 181.68 594.31 181.84 597.13C182 599.94 179.86 602.36 177.04 602.52C174.23 602.68 171.81 600.54 171.65 597.72C171.49 594.91 173.63 592.49 176.45 592.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1387 458.95C1385.71 457.41 1385.9 455.12 1387.44 453.83C1388.98 452.54 1391.27 452.74 1392.56 454.27C1393.85 455.81 1393.65 458.1 1392.12 459.39C1390.58 460.68 1388.29 460.48 1387 458.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M103.49 497.81C106.9 495.13 111.84 495.72 114.52 499.13C117.2 502.54 116.61 507.48 113.2 510.16C109.79 512.84 104.85 512.25 102.17 508.84C99.4901 505.43 100.08 500.49 103.49 497.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M449.83 678.79C449.66 677.38 450.66 676.09 452.07 675.92C453.48 675.75 454.77 676.75 454.94 678.16C455.11 679.57 454.11 680.86 452.7 681.03C451.29 681.2 450 680.2 449.83 678.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M222.62 585.97C222.73 583.41 224.9 581.42 227.47 581.54C230.03 581.65 232.02 583.82 231.9 586.39C231.79 588.95 229.62 590.94 227.05 590.82C224.48 590.7 222.5 588.54 222.62 585.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M823.29 624.97C820.89 625.1 818.84 623.27 818.71 620.87C818.58 618.47 820.41 616.42 822.81 616.29C825.21 616.16 827.26 617.99 827.39 620.39C827.52 622.79 825.69 624.84 823.29 624.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1039.91 527.97C1040.05 529.34 1039.06 530.56 1037.7 530.7C1036.33 530.84 1035.11 529.85 1034.97 528.49C1034.83 527.12 1035.82 525.9 1037.18 525.76C1038.54 525.62 1039.77 526.61 1039.91 527.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M410.81 627.88C410.36 625.79 411.69 623.72 413.78 623.27C415.87 622.82 417.94 624.15 418.39 626.24C418.84 628.33 417.51 630.4 415.42 630.85C413.33 631.3 411.26 629.97 410.81 627.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1503.7 576.04C1502.17 576.34 1500.69 575.34 1500.39 573.81C1500.09 572.28 1501.09 570.8 1502.62 570.5C1504.15 570.2 1505.63 571.2 1505.93 572.73C1506.23 574.26 1505.23 575.74 1503.7 576.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M217.83 476.72C216.36 472.63 218.49 468.13 222.57 466.66C226.66 465.19 231.16 467.32 232.63 471.4C234.1 475.49 231.97 479.99 227.89 481.46C223.8 482.93 219.3 480.8 217.83 476.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M872.62 656.54C869.5 656.5 867 653.93 867.04 650.81C867.08 647.69 869.65 645.19 872.77 645.23C875.89 645.27 878.39 647.84 878.35 650.97C878.31 654.09 875.74 656.59 872.62 656.55V656.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M324.74 446.55C326.03 446.07 327.47 446.72 327.95 448.01C328.43 449.3 327.78 450.74 326.49 451.22C325.2 451.7 323.76 451.05 323.28 449.76C322.8 448.47 323.45 447.03 324.74 446.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M430.98 572.56C432.74 573.14 433.69 575.05 433.11 576.81C432.53 578.57 430.62 579.52 428.86 578.94C427.1 578.36 426.15 576.45 426.73 574.69C427.31 572.93 429.22 571.98 430.98 572.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M543.56 668.11C545.72 668.33 547.29 670.26 547.08 672.41C546.86 674.57 544.93 676.14 542.77 675.93C540.61 675.71 539.04 673.78 539.26 671.62C539.48 669.46 541.41 667.89 543.56 668.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M247.28 553.68C248.09 550.4 251.41 548.41 254.68 549.22C257.96 550.03 259.95 553.35 259.14 556.62C258.33 559.9 255.01 561.89 251.74 561.08C248.46 560.27 246.47 556.95 247.28 553.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1238.23 672.44C1241.42 671.31 1244.92 672.99 1246.04 676.17C1247.16 679.35 1245.49 682.86 1242.31 683.98C1239.12 685.11 1235.62 683.43 1234.5 680.25C1233.37 677.06 1235.05 673.56 1238.23 672.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M701.73 592.46C702.88 592.7 703.62 593.83 703.38 594.98C703.14 596.13 702.01 596.87 700.86 596.63C699.71 596.39 698.97 595.26 699.21 594.11C699.45 592.96 700.58 592.22 701.73 592.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M601.32 679.58C600.34 680.98 598.42 681.33 597.01 680.35C595.61 679.37 595.26 677.45 596.24 676.04C597.22 674.64 599.14 674.29 600.55 675.27C601.95 676.25 602.3 678.17 601.32 679.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M107.41 468.81C108.44 469.47 108.73 470.84 108.07 471.87C107.41 472.9 106.04 473.19 105.01 472.53C103.98 471.87 103.69 470.5 104.35 469.47C105.01 468.44 106.38 468.15 107.41 468.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M507.83 456.59C509.89 455.23 512.67 455.79 514.03 457.86C515.39 459.92 514.83 462.7 512.76 464.06C510.69 465.42 507.92 464.86 506.56 462.79C505.2 460.73 505.76 457.95 507.83 456.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M930.25 445.45C932.25 444.05 935.02 444.53 936.42 446.54C937.82 448.54 937.34 451.31 935.33 452.71C933.33 454.11 930.56 453.63 929.16 451.62C927.76 449.62 928.24 446.85 930.25 445.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M1518.98 662.31C1521.11 664.69 1520.91 668.35 1518.52 670.49C1516.14 672.62 1512.48 672.42 1510.34 670.03C1508.21 667.65 1508.41 663.99 1510.8 661.85C1513.18 659.72 1516.84 659.92 1518.98 662.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M108.35 430.67C107.32 430.25 106.83 429.09 107.24 428.06C107.66 427.03 108.82 426.54 109.85 426.95C110.88 427.37 111.37 428.53 110.96 429.56C110.54 430.59 109.38 431.08 108.35 430.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M644.27 655.32C643.08 651.72 645.03 647.84 648.63 646.65C652.23 645.46 656.11 647.41 657.3 651.01C658.49 654.61 656.54 658.49 652.94 659.68C649.34 660.87 645.46 658.92 644.27 655.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.85 449.33C272.66 449.52 271.54 448.7 271.35 447.51C271.16 446.32 271.98 445.2 273.17 445.01C274.36 444.82 275.48 445.64 275.67 446.83C275.86 448.02 275.04 449.14 273.85 449.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M78.82 511.12C74.92 509.78 72.85 505.54 74.19 501.64C75.53 497.74 79.77 495.67 83.67 497.01C87.57 498.35 89.64 502.59 88.3 506.49C86.96 510.39 82.72 512.46 78.82 511.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M89.92 576.47C89.15 575.51 89.31 574.12 90.26 573.36C91.22 572.59 92.61 572.75 93.38 573.7C94.15 574.66 93.99 576.05 93.04 576.82C92.08 577.59 90.69 577.43 89.93 576.48L89.92 576.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M925.69 406.12C926.75 406.85 927.01 408.29 926.29 409.35C925.56 410.41 924.12 410.67 923.06 409.95C922 409.22 921.74 407.78 922.46 406.72C923.19 405.66 924.63 405.4 925.69 406.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M730.7 421.75C730.28 423.84 728.25 425.2 726.16 424.78C724.07 424.36 722.71 422.33 723.13 420.24C723.55 418.15 725.58 416.79 727.67 417.21C729.76 417.63 731.12 419.66 730.7 421.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M842.82 439.22C841.79 440.41 839.99 440.55 838.8 439.52C837.61 438.49 837.47 436.69 838.5 435.5C839.53 434.31 841.33 434.17 842.52 435.2C843.71 436.23 843.85 438.03 842.82 439.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1536.75 591.56C1534.09 591.5 1531.99 589.3 1532.04 586.64C1532.1 583.98 1534.3 581.88 1536.96 581.93C1539.62 581.99 1541.72 584.19 1541.67 586.85C1541.61 589.51 1539.41 591.62 1536.75 591.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1022.16 598.91C1022.2 600.09 1021.28 601.09 1020.09 601.13C1018.91 601.17 1017.91 600.25 1017.87 599.06C1017.83 597.88 1018.75 596.88 1019.94 596.84C1021.12 596.8 1022.12 597.72 1022.16 598.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M1186.54 378.02C1188.16 378.78 1188.86 380.72 1188.09 382.34C1187.33 383.96 1185.39 384.66 1183.77 383.89C1182.15 383.13 1181.45 381.19 1182.22 379.57C1182.98 377.95 1184.92 377.25 1186.54 378.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M1088.95 414.5C1090.14 415.5 1090.29 417.27 1089.29 418.46C1088.29 419.65 1086.52 419.8 1085.33 418.8C1084.14 417.8 1083.99 416.03 1084.99 414.84C1085.99 413.65 1087.76 413.5 1088.95 414.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M240.41 587.08C239.87 586.11 240.23 584.89 241.19 584.36C242.16 583.82 243.38 584.18 243.91 585.14C244.45 586.11 244.09 587.33 243.13 587.86C242.16 588.4 240.94 588.04 240.41 587.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M619.6 506.44C622.3 507.53 623.59 510.6 622.5 513.3C621.41 516 618.34 517.29 615.64 516.2C612.94 515.11 611.65 512.04 612.74 509.34C613.83 506.64 616.9 505.35 619.6 506.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M226.38 409.37C226.97 410.31 226.69 411.55 225.75 412.14C224.81 412.73 223.57 412.45 222.98 411.51C222.39 410.57 222.67 409.33 223.61 408.74C224.55 408.15 225.79 408.43 226.38 409.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M461.21 429.39C458.78 428.8 457.3 426.35 457.89 423.92C458.48 421.49 460.93 420.01 463.36 420.6C465.79 421.19 467.27 423.64 466.68 426.07C466.09 428.5 463.64 429.98 461.21 429.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M678.27 488.04C680.56 490.54 680.4 494.43 677.9 496.72C675.4 499.01 671.51 498.85 669.22 496.34C666.93 493.84 667.09 489.95 669.59 487.66C672.09 485.37 675.98 485.53 678.27 488.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M689 657.19C685.6 656.02 683.79 652.32 684.96 648.92C686.13 645.52 689.83 643.71 693.23 644.88C696.63 646.05 698.44 649.75 697.27 653.15C696.1 656.55 692.4 658.36 689 657.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M942.32 495.48C940.6 498.11 937.08 498.86 934.45 497.14C931.82 495.42 931.07 491.9 932.79 489.27C934.51 486.64 938.03 485.89 940.66 487.61C943.29 489.33 944.04 492.85 942.32 495.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M73.31 638.89C75.17 635.98 79.05 635.13 81.96 636.99C84.87 638.85 85.72 642.73 83.86 645.64C82 648.55 78.12 649.4 75.21 647.54C72.3 645.68 71.45 641.8 73.31 638.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M862.11 525.46C860.75 525.99 859.22 525.31 858.69 523.95C858.16 522.59 858.84 521.06 860.2 520.53C861.56 520 863.09 520.68 863.62 522.04C864.15 523.4 863.47 524.93 862.11 525.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M1251.67 416.08C1249.24 416.99 1246.52 415.76 1245.61 413.33C1244.7 410.9 1245.93 408.18 1248.36 407.27C1250.79 406.36 1253.51 407.59 1254.42 410.02C1255.33 412.45 1254.1 415.17 1251.67 416.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M735.27 599.04C737.48 596.81 741.07 596.8 743.3 599.01C745.52 601.22 745.54 604.81 743.33 607.04C741.12 609.27 737.53 609.28 735.3 607.07C733.08 604.86 733.06 601.27 735.27 599.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M450.93 511.14C453.13 508.34 457.19 507.85 459.99 510.05C462.79 512.25 463.28 516.31 461.08 519.11C458.88 521.91 454.82 522.4 452.02 520.2C449.22 518 448.73 513.94 450.93 511.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M699.57 497.35C700.54 498.29 700.56 499.83 699.63 500.79C698.69 501.76 697.15 501.78 696.19 500.85C695.22 499.92 695.2 498.37 696.13 497.41C697.07 496.44 698.61 496.42 699.57 497.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M996.87 417.95C995.37 414.71 996.78 410.88 1000.02 409.38C1003.26 407.88 1007.09 409.29 1008.59 412.53C1010.09 415.77 1008.68 419.6 1005.44 421.1C1002.2 422.6 998.37 421.19 996.87 417.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M1210.1 704.55C1212.13 706.38 1212.29 709.5 1210.47 711.53C1208.64 713.56 1205.52 713.73 1203.49 711.9C1201.46 710.07 1201.3 706.95 1203.12 704.92C1204.95 702.89 1208.07 702.72 1210.1 704.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1359.19 511.86C1357.76 510.46 1357.75 508.16 1359.15 506.74C1360.55 505.31 1362.85 505.3 1364.27 506.7C1365.7 508.1 1365.71 510.4 1364.31 511.82C1362.91 513.25 1360.61 513.26 1359.19 511.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M1075.51 529.1C1075.95 526.31 1078.57 524.41 1081.35 524.85C1084.14 525.29 1086.04 527.91 1085.6 530.69C1085.16 533.48 1082.54 535.38 1079.76 534.94C1076.97 534.5 1075.07 531.88 1075.51 529.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M345.95 561.95C349.24 559.14 354.18 559.52 356.99 562.8C359.8 566.09 359.42 571.03 356.14 573.84C352.85 576.65 347.91 576.27 345.1 572.99C342.29 569.7 342.67 564.76 345.95 561.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1230.45 606.47C1231.52 602.28 1235.8 599.75 1239.99 600.82C1244.18 601.89 1246.71 606.17 1245.64 610.36C1244.57 614.55 1240.29 617.08 1236.1 616.01C1231.91 614.94 1229.38 610.66 1230.45 606.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1283.34 661.53C1281.78 657.95 1283.42 653.79 1286.99 652.24C1290.56 650.68 1294.73 652.32 1296.28 655.89C1297.84 659.46 1296.2 663.63 1292.63 665.18C1289.05 666.74 1284.89 665.1 1283.34 661.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M347.67 664.83C343.6 663.54 341.35 659.19 342.64 655.12C343.93 651.05 348.28 648.8 352.35 650.09C356.42 651.38 358.67 655.73 357.38 659.8C356.09 663.87 351.74 666.12 347.67 664.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M1358.01 561.12C1358.37 558.72 1360.6 557.07 1363 557.43C1365.4 557.79 1367.05 560.02 1366.69 562.42C1366.33 564.82 1364.1 566.47 1361.7 566.11C1359.3 565.75 1357.65 563.52 1358.01 561.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1193.91 584.63C1197.05 584.63 1199.6 582.083 1199.6 578.94C1199.6 575.798 1197.05 573.25 1193.91 573.25C1190.77 573.25 1188.22 575.798 1188.22 578.94C1188.22 582.083 1190.77 584.63 1193.91 584.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M136.07 669.97C137.42 666.74 141.13 665.21 144.37 666.56C147.61 667.91 149.13 671.62 147.78 674.86C146.43 678.09 142.72 679.62 139.48 678.27C136.24 676.92 134.72 673.21 136.07 669.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M824.16 525.41C826.36 523.01 830.08 522.85 832.48 525.05C834.88 527.25 835.04 530.97 832.84 533.37C830.64 535.77 826.92 535.93 824.52 533.73C822.12 531.53 821.96 527.81 824.16 525.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M767.51 520.54C767.67 521.97 766.65 523.26 765.22 523.42C763.79 523.58 762.5 522.56 762.34 521.13C762.18 519.7 763.2 518.41 764.63 518.25C766.06 518.09 767.35 519.11 767.51 520.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1213.38 413.99C1212.02 413.01 1211.71 411.11 1212.69 409.74C1213.67 408.38 1215.57 408.07 1216.94 409.05C1218.3 410.03 1218.61 411.93 1217.63 413.3C1216.65 414.66 1214.75 414.97 1213.38 413.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1342.22 626.69C1343.2 625.51 1344.94 625.35 1346.12 626.32C1347.3 627.3 1347.46 629.04 1346.49 630.22C1345.51 631.4 1343.77 631.56 1342.59 630.59C1341.41 629.61 1341.25 627.87 1342.22 626.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M580.41 607.57C581.04 609.21 580.22 611.05 578.58 611.68C576.94 612.31 575.1 611.49 574.47 609.85C573.84 608.21 574.66 606.37 576.3 605.74C577.94 605.11 579.78 605.93 580.41 607.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M240.37 579.25C243.58 581.85 244.08 586.57 241.48 589.78C238.88 592.99 234.16 593.49 230.95 590.89C227.74 588.29 227.24 583.57 229.84 580.36C232.44 577.15 237.16 576.65 240.37 579.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1366.25 410.61C1365.35 412.99 1362.69 414.18 1360.31 413.28C1357.93 412.38 1356.74 409.72 1357.64 407.34C1358.54 404.96 1361.2 403.77 1363.58 404.67C1365.96 405.57 1367.15 408.23 1366.25 410.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M1047.21 458.87C1050.35 461.66 1050.63 466.47 1047.83 469.61C1045.04 472.75 1040.23 473.03 1037.09 470.23C1033.95 467.44 1033.67 462.63 1036.47 459.49C1039.26 456.35 1044.07 456.07 1047.21 458.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1454.09 430.31C1455.24 429.95 1456.46 430.58 1456.82 431.73C1457.18 432.88 1456.55 434.1 1455.4 434.46C1454.25 434.82 1453.03 434.19 1452.67 433.04C1452.31 431.89 1452.94 430.67 1454.09 430.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M522.49 581.21C524.79 580.42 527.3 581.64 528.1 583.94C528.89 586.24 527.67 588.75 525.37 589.55C523.07 590.34 520.56 589.12 519.76 586.82C518.97 584.52 520.19 582.01 522.49 581.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M1258.84 491.51C1257.07 492.54 1254.8 491.94 1253.77 490.18C1252.74 488.41 1253.34 486.14 1255.1 485.11C1256.87 484.08 1259.14 484.68 1260.17 486.45C1261.2 488.22 1260.6 490.49 1258.84 491.52V491.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1386.14 676.79C1385.58 679.64 1382.8 681.5 1379.95 680.94C1377.1 680.38 1375.24 677.6 1375.8 674.75C1376.36 671.9 1379.14 670.04 1381.99 670.6C1384.84 671.16 1386.7 673.94 1386.14 676.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1029.36 504.13C1028.26 504.63 1026.95 504.15 1026.45 503.04C1025.95 501.94 1026.43 500.63 1027.54 500.13C1028.64 499.63 1029.95 500.11 1030.45 501.22C1030.95 502.32 1030.47 503.63 1029.36 504.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1303.08 426.64C1299.83 428.45 1295.73 427.27 1293.92 424.02C1292.11 420.77 1293.29 416.67 1296.54 414.86C1299.79 413.05 1303.89 414.23 1305.7 417.48C1307.51 420.73 1306.33 424.83 1303.08 426.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M521.794 425.618C522.184 424.282 521.417 422.883 520.081 422.493C518.745 422.103 517.346 422.87 516.956 424.206C516.566 425.542 517.333 426.941 518.669 427.331C520.005 427.721 521.404 426.954 521.794 425.618Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1140.37 640.03C1140.16 644.07 1136.71 647.17 1132.67 646.95C1128.63 646.73 1125.53 643.29 1125.75 639.25C1125.97 635.21 1129.41 632.11 1133.45 632.33C1137.49 632.55 1140.59 635.99 1140.37 640.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M406.33 412.32C403.96 411.37 402.8 408.68 403.76 406.3C404.71 403.93 407.4 402.77 409.78 403.72C412.15 404.67 413.31 407.36 412.36 409.74C411.41 412.12 408.72 413.27 406.34 412.31L406.33 412.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M213.27 675.13C210.27 673.82 208.91 670.33 210.22 667.33C211.53 664.33 215.02 662.97 218.02 664.28C221.02 665.59 222.38 669.08 221.07 672.08C219.76 675.08 216.27 676.44 213.27 675.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M710.17 634.85C711.49 634.76 712.63 635.76 712.72 637.08C712.81 638.4 711.81 639.54 710.49 639.63C709.17 639.72 708.03 638.72 707.94 637.4C707.85 636.08 708.85 634.94 710.17 634.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1517.39 396.38C1520.75 394.75 1524.79 396.15 1526.42 399.51C1528.05 402.87 1526.65 406.91 1523.29 408.54C1519.93 410.17 1515.89 408.77 1514.26 405.41C1512.63 402.05 1514.03 398.01 1517.39 396.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1467.89 650.032C1468.63 647.691 1467.34 645.187 1465 644.439C1462.66 643.691 1460.16 644.982 1459.41 647.323C1458.66 649.664 1459.95 652.168 1462.29 652.916C1464.63 653.664 1467.14 652.373 1467.89 650.032Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M836.05 535.7C837.01 536.37 837.24 537.69 836.58 538.64C835.91 539.6 834.59 539.83 833.64 539.17C832.68 538.5 832.45 537.18 833.11 536.23C833.78 535.27 835.1 535.04 836.05 535.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M646.18 547.04C645.77 545.76 646.47 544.39 647.75 543.98C649.03 543.57 650.4 544.27 650.81 545.55C651.22 546.83 650.52 548.2 649.24 548.61C647.96 549.02 646.59 548.32 646.18 547.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M1284.88 535.77C1282.57 538.18 1278.75 538.25 1276.34 535.95C1273.93 533.64 1273.86 529.82 1276.16 527.41C1278.47 525 1282.29 524.93 1284.7 527.23C1287.11 529.54 1287.18 533.36 1284.88 535.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1296.1 582.69C1295.15 581.91 1295.01 580.51 1295.78 579.56C1296.56 578.61 1297.96 578.47 1298.91 579.24C1299.86 580.02 1300 581.42 1299.23 582.37C1298.45 583.32 1297.05 583.46 1296.1 582.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M608.61 487.04C607.27 489.85 603.89 491.04 601.08 489.7C598.27 488.36 597.08 484.98 598.42 482.17C599.76 479.36 603.14 478.17 605.95 479.51C608.76 480.85 609.95 484.23 608.61 487.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1321.54 466.98C1322 468.03 1321.53 469.25 1320.48 469.72C1319.43 470.18 1318.21 469.71 1317.74 468.66C1317.27 467.61 1317.75 466.39 1318.8 465.92C1319.85 465.46 1321.07 465.93 1321.54 466.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M179.97 577.56C179.17 574.8 180.76 571.91 183.52 571.11C186.28 570.31 189.17 571.9 189.97 574.66C190.77 577.42 189.18 580.31 186.42 581.11C183.66 581.91 180.77 580.32 179.97 577.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1462.13 541.75C1460.27 541.42 1459.04 539.64 1459.37 537.79C1459.7 535.93 1461.48 534.7 1463.33 535.03C1465.19 535.36 1466.42 537.14 1466.09 538.99C1465.76 540.85 1463.98 542.08 1462.13 541.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1406.35 602.1C1409.66 599.41 1414.52 599.91 1417.21 603.21C1419.9 606.52 1419.4 611.38 1416.1 614.07C1412.79 616.76 1407.93 616.26 1405.24 612.96C1402.55 609.66 1403.05 604.79 1406.35 602.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M551.65 552.01C553.22 551.84 554.63 552.97 554.8 554.54C554.97 556.11 553.84 557.52 552.27 557.69C550.7 557.86 549.29 556.73 549.12 555.16C548.95 553.59 550.08 552.18 551.65 552.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1151.95 420.46C1151.83 416.58 1154.87 413.34 1158.75 413.21C1162.63 413.09 1165.87 416.13 1166 420.01C1166.13 423.89 1163.08 427.13 1159.2 427.26C1155.32 427.38 1152.08 424.34 1151.95 420.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M615.51 431.57C614.29 430.18 614.43 428.06 615.82 426.84C617.21 425.62 619.33 425.76 620.55 427.15C621.77 428.54 621.63 430.66 620.24 431.88C618.85 433.1 616.73 432.96 615.51 431.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M699.96 616.64C701.33 617.02 702.13 618.45 701.75 619.82C701.37 621.19 699.94 621.99 698.57 621.61C697.2 621.23 696.4 619.8 696.78 618.43C697.16 617.06 698.59 616.26 699.96 616.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M165.04 410.72C166.91 410.61 168.51 412.03 168.62 413.89C168.73 415.75 167.31 417.36 165.45 417.47C163.59 417.58 161.98 416.16 161.87 414.3C161.76 412.44 163.18 410.83 165.04 410.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M485.84 534.46C486.867 534.46 487.7 533.627 487.7 532.6C487.7 531.573 486.867 530.74 485.84 530.74C484.813 530.74 483.98 531.573 483.98 532.6C483.98 533.627 484.813 534.46 485.84 534.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1415.35 501.73C1416.38 501.73 1417.21 502.56 1417.21 503.59C1417.21 504.62 1416.38 505.45 1415.35 505.45C1414.32 505.45 1413.49 504.62 1413.49 503.59C1413.49 502.56 1414.33 501.73 1415.35 501.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M400.55 495.92C401.59 495.92 402.44 496.76 402.44 497.81C402.44 498.86 401.6 499.7 400.55 499.7C399.5 499.7 398.66 498.86 398.66 497.81C398.66 496.76 399.5 495.92 400.55 495.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1459.76 463.72C1460.8 463.72 1461.65 462.874 1461.65 461.83C1461.65 460.786 1460.8 459.94 1459.76 459.94C1458.72 459.94 1457.87 460.786 1457.87 461.83C1457.87 462.874 1458.72 463.72 1459.76 463.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M619.87 589.62C620.92 589.62 621.76 590.47 621.76 591.51C621.76 592.55 620.91 593.4 619.87 593.4C618.83 593.4 617.98 592.55 617.98 591.51C617.98 590.47 618.83 589.62 619.87 589.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M452.25 667.81C453.3 667.81 454.15 668.66 454.15 669.71C454.15 670.76 453.3 671.61 452.25 671.61C451.2 671.61 450.35 670.76 450.35 669.71C450.35 668.66 451.2 667.81 452.25 667.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M434.62 564.76C435.67 564.76 436.53 565.61 436.53 566.67C436.53 567.73 435.68 568.58 434.62 568.58C433.56 568.58 432.71 567.73 432.71 566.67C432.71 565.61 433.56 564.76 434.62 564.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1459.06 550.96C1460.12 550.96 1460.98 551.82 1460.98 552.88C1460.98 553.94 1460.12 554.8 1459.06 554.8C1458 554.8 1457.14 553.94 1457.14 552.88C1457.14 551.82 1458 550.96 1459.06 550.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M575.02 653.11C576.08 653.11 576.94 653.97 576.94 655.03C576.94 656.09 576.08 656.95 575.02 656.95C573.96 656.95 573.1 656.09 573.1 655.03C573.1 653.97 573.96 653.11 575.02 653.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193.41 626.65C194.47 626.65 195.33 627.51 195.33 628.57C195.33 629.63 194.47 630.49 193.41 630.49C192.35 630.49 191.49 629.63 191.49 628.57C191.49 627.51 192.35 626.65 193.41 626.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M831.45 552.63C832.516 552.63 833.38 551.766 833.38 550.7C833.38 549.634 832.516 548.77 831.45 548.77C830.384 548.77 829.52 549.634 829.52 550.7C829.52 551.766 830.384 552.63 831.45 552.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M716.73 529.33C717.8 529.33 718.66 530.19 718.66 531.26C718.66 532.33 717.8 533.19 716.73 533.19C715.66 533.19 714.8 532.33 714.8 531.26C714.8 530.19 715.66 529.33 716.73 529.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M714.94 554.2C716.006 554.2 716.87 553.336 716.87 552.27C716.87 551.204 716.006 550.34 714.94 550.34C713.874 550.34 713.01 551.204 713.01 552.27C713.01 553.336 713.874 554.2 714.94 554.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M733.33 586.72C734.4 586.72 735.26 587.59 735.26 588.65C735.26 589.71 734.39 590.58 733.33 590.58C732.27 590.58 731.4 589.71 731.4 588.65C731.4 587.59 732.27 586.72 733.33 586.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M233.69 502.55C234.76 502.55 235.63 503.42 235.63 504.49C235.63 505.56 234.76 506.43 233.69 506.43C232.62 506.43 231.75 505.56 231.75 504.49C231.75 503.42 232.62 502.55 233.69 502.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M544.32 485.17C545.39 485.17 546.26 486.04 546.26 487.11C546.26 488.18 545.39 489.05 544.32 489.05C543.25 489.05 542.38 488.18 542.38 487.11C542.38 486.04 543.25 485.17 544.32 485.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1424.33 590.25C1425.4 590.25 1426.27 591.12 1426.27 592.19C1426.27 593.26 1425.4 594.13 1424.33 594.13C1423.26 594.13 1422.39 593.26 1422.39 592.19C1422.39 591.12 1423.26 590.25 1424.33 590.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M746.01 540.19C747.082 540.19 747.95 539.321 747.95 538.25C747.95 537.179 747.082 536.31 746.01 536.31C744.939 536.31 744.07 537.179 744.07 538.25C744.07 539.321 744.939 540.19 746.01 540.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1332.58 430.91C1333.65 430.91 1334.52 431.78 1334.52 432.85C1334.52 433.92 1333.65 434.79 1332.58 434.79C1331.51 434.79 1330.64 433.92 1330.64 432.85C1330.64 431.78 1331.51 430.91 1332.58 430.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M692.93 439.38C694 439.38 694.87 440.25 694.87 441.32C694.87 442.39 694 443.26 692.93 443.26C691.86 443.26 690.99 442.39 690.99 441.32C690.99 440.25 691.86 439.38 692.93 439.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1493.17 557.15C1494.24 557.15 1495.12 558.02 1495.12 559.1C1495.12 560.18 1494.25 561.05 1493.17 561.05C1492.09 561.05 1491.22 560.18 1491.22 559.1C1491.22 558.02 1492.09 557.15 1493.17 557.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M732.41 398.19C733.49 398.19 734.36 399.06 734.36 400.14C734.36 401.22 733.49 402.09 732.41 402.09C731.33 402.09 730.46 401.22 730.46 400.14C730.46 399.06 731.33 398.19 732.41 398.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1258 478.31C1259.08 478.31 1259.95 477.437 1259.95 476.36C1259.95 475.283 1259.08 474.41 1258 474.41C1256.92 474.41 1256.05 475.283 1256.05 476.36C1256.05 477.437 1256.92 478.31 1258 478.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.88 439.91C374.957 439.91 375.83 439.037 375.83 437.96C375.83 436.883 374.957 436.01 373.88 436.01C372.803 436.01 371.93 436.883 371.93 437.96C371.93 439.037 372.803 439.91 373.88 439.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1192.9 475.61C1193.98 475.61 1194.85 476.48 1194.85 477.56C1194.85 478.64 1193.98 479.51 1192.9 479.51C1191.82 479.51 1190.95 478.64 1190.95 477.56C1190.95 476.48 1191.82 475.61 1192.9 475.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.81 566.26C266.887 566.26 267.76 565.387 267.76 564.31C267.76 563.233 266.887 562.36 265.81 562.36C264.733 562.36 263.86 563.233 263.86 564.31C263.86 565.387 264.733 566.26 265.81 566.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1472.58 592.62C1473.66 592.62 1474.53 593.49 1474.53 594.57C1474.53 595.65 1473.66 596.52 1472.58 596.52C1471.5 596.52 1470.63 595.65 1470.63 594.57C1470.63 593.49 1471.5 592.62 1472.58 592.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1498.57 476.02C1499.65 476.02 1500.52 476.89 1500.52 477.97C1500.52 479.05 1499.65 479.92 1498.57 479.92C1497.49 479.92 1496.62 479.05 1496.62 477.97C1496.62 476.89 1497.49 476.02 1498.57 476.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M392.29 416.69C393.37 416.69 394.24 417.56 394.24 418.64C394.24 419.72 393.37 420.59 392.29 420.59C391.21 420.59 390.34 419.72 390.34 418.64C390.34 417.56 391.21 416.69 392.29 416.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M688.69 621.14C689.77 621.14 690.65 622.02 690.65 623.1C690.65 624.18 689.77 625.06 688.69 625.06C687.61 625.06 686.73 624.18 686.73 623.1C686.73 622.02 687.61 621.14 688.69 621.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M602.34 561.48C603.42 561.48 604.3 562.36 604.3 563.44C604.3 564.52 603.42 565.4 602.34 565.4C601.26 565.4 600.38 564.52 600.38 563.44C600.38 562.36 601.26 561.48 602.34 561.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1475.3 467.22C1476.38 467.22 1477.26 468.1 1477.26 469.18C1477.26 470.26 1476.38 471.14 1475.3 471.14C1474.22 471.14 1473.34 470.26 1473.34 469.18C1473.34 468.1 1474.22 467.22 1475.3 467.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M614.45 369.87C615.53 369.87 616.41 370.75 616.41 371.83C616.41 372.91 615.53 373.79 614.45 373.79C613.37 373.79 612.49 372.91 612.49 371.83C612.49 370.75 613.37 369.87 614.45 369.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M360.13 511.2C361.213 511.2 362.09 510.322 362.09 509.24C362.09 508.158 361.213 507.28 360.13 507.28C359.048 507.28 358.17 508.158 358.17 509.24C358.17 510.322 359.048 511.2 360.13 511.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M546.95 535.57C548.03 535.57 548.91 536.45 548.91 537.53C548.91 538.61 548.03 539.49 546.95 539.49C545.87 539.49 544.99 538.61 544.99 537.53C544.99 536.45 545.87 535.57 546.95 535.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M630.26 437.37C631.34 437.37 632.22 438.25 632.22 439.33C632.22 440.41 631.34 441.29 630.26 441.29C629.18 441.29 628.3 440.41 628.3 439.33C628.3 438.25 629.18 437.37 630.26 437.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M708.21 491.98C709.29 491.98 710.17 492.86 710.17 493.94C710.17 495.02 709.29 495.9 708.21 495.9C707.13 495.9 706.25 495.02 706.25 493.94C706.25 492.86 707.13 491.98 708.21 491.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M671.42 637.79C672.5 637.79 673.38 638.67 673.38 639.75C673.38 640.83 672.5 641.71 671.42 641.71C670.34 641.71 669.46 640.83 669.46 639.75C669.46 638.67 670.34 637.79 671.42 637.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M560.75 476.47C561.84 476.47 562.72 477.35 562.72 478.44C562.72 479.53 561.84 480.41 560.75 480.41C559.66 480.41 558.78 479.53 558.78 478.44C558.78 477.35 559.66 476.47 560.75 476.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1524.39 593.75C1525.48 593.75 1526.36 594.63 1526.36 595.72C1526.36 596.81 1525.48 597.69 1524.39 597.69C1523.3 597.69 1522.42 596.81 1522.42 595.72C1522.42 594.63 1523.3 593.75 1524.39 593.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.47 650.13C274.56 650.13 275.44 651.01 275.44 652.1C275.44 653.19 274.56 654.07 273.47 654.07C272.38 654.07 271.5 653.19 271.5 652.1C271.5 651.01 272.38 650.13 273.47 650.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M195.85 609.11C196.94 609.11 197.82 609.99 197.82 611.08C197.82 612.17 196.94 613.05 195.85 613.05C194.76 613.05 193.88 612.17 193.88 611.08C193.88 609.99 194.76 609.11 195.85 609.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M489.76 419.94C490.848 419.94 491.73 419.058 491.73 417.97C491.73 416.882 490.848 416 489.76 416C488.672 416 487.79 416.882 487.79 417.97C487.79 419.058 488.672 419.94 489.76 419.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1419.13 624.14C1420.22 624.14 1421.1 625.02 1421.1 626.11C1421.1 627.2 1420.22 628.08 1419.13 628.08C1418.04 628.08 1417.16 627.2 1417.16 626.11C1417.16 625.02 1418.04 624.14 1419.13 624.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1318.34 638.22C1319.43 638.22 1320.31 639.1 1320.31 640.19C1320.31 641.28 1319.43 642.16 1318.34 642.16C1317.25 642.16 1316.37 641.28 1316.37 640.19C1316.37 639.1 1317.25 638.22 1318.34 638.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M506.76 499.94C507.85 499.94 508.73 500.82 508.73 501.91C508.73 503 507.85 503.88 506.76 503.88C505.67 503.88 504.79 503 504.79 501.91C504.79 500.82 505.67 499.94 506.76 499.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1075.32 374.03C1076.41 374.03 1077.29 374.91 1077.29 376C1077.29 377.09 1076.41 377.97 1075.32 377.97C1074.23 377.97 1073.35 377.09 1073.35 376C1073.35 374.91 1074.23 374.03 1075.32 374.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1356.22 550.49C1357.31 550.49 1358.19 549.608 1358.19 548.52C1358.19 547.432 1357.31 546.55 1356.22 546.55C1355.13 546.55 1354.25 547.432 1354.25 548.52C1354.25 549.608 1355.13 550.49 1356.22 550.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M662.19 626.9C663.283 626.9 664.17 626.013 664.17 624.92C664.17 623.826 663.283 622.94 662.19 622.94C661.096 622.94 660.21 623.826 660.21 624.92C660.21 626.013 661.096 626.9 662.19 626.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M414.57 394.99C415.66 394.99 416.55 395.88 416.55 396.97C416.55 398.06 415.66 398.95 414.57 398.95C413.48 398.95 412.59 398.06 412.59 396.97C412.59 395.88 413.48 394.99 414.57 394.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M585.82 648.46C586.91 648.46 587.8 649.35 587.8 650.44C587.8 651.53 586.91 652.42 585.82 652.42C584.73 652.42 583.84 651.53 583.84 650.44C583.84 649.35 584.73 648.46 585.82 648.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M706.39 431.05C707.483 431.05 708.37 430.164 708.37 429.07C708.37 427.976 707.483 427.09 706.39 427.09C705.296 427.09 704.41 427.976 704.41 429.07C704.41 430.164 705.296 431.05 706.39 431.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1273.84 552.61C1274.93 552.61 1275.82 551.724 1275.82 550.63C1275.82 549.536 1274.93 548.65 1273.84 548.65C1272.75 548.65 1271.86 549.536 1271.86 550.63C1271.86 551.724 1272.75 552.61 1273.84 552.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.97 404.59C308.07 404.59 308.95 405.48 308.95 406.57C308.95 407.66 308.06 408.55 306.97 408.55C305.88 408.55 304.99 407.66 304.99 406.57C304.99 405.48 305.88 404.59 306.97 404.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M641.8 488.14C642.9 488.14 643.78 489.03 643.78 490.12C643.78 491.21 642.89 492.1 641.8 492.1C640.71 492.1 639.82 491.21 639.82 490.12C639.82 489.03 640.71 488.14 641.8 488.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1408.53 401.26C1409.62 401.26 1410.51 400.373 1410.51 399.28C1410.51 398.186 1409.62 397.3 1408.53 397.3C1407.44 397.3 1406.55 398.186 1406.55 399.28C1406.55 400.373 1407.44 401.26 1408.53 401.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1414.55 442.95C1415.65 442.95 1416.54 443.84 1416.54 444.94C1416.54 446.04 1415.65 446.93 1414.55 446.93C1413.45 446.93 1412.56 446.04 1412.56 444.94C1412.56 443.84 1413.45 442.95 1414.55 442.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1402.57 417.21C1403.67 417.21 1404.56 418.1 1404.56 419.2C1404.56 420.3 1403.67 421.19 1402.57 421.19C1401.47 421.19 1400.58 420.3 1400.58 419.2C1400.58 418.1 1401.47 417.21 1402.57 417.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M550.4 655.15C551.5 655.15 552.39 656.04 552.39 657.14C552.39 658.24 551.5 659.13 550.4 659.13C549.3 659.13 548.41 658.24 548.41 657.14C548.41 656.04 549.3 655.15 550.4 655.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1234.04 414.69C1235.14 414.69 1236.03 413.799 1236.03 412.7C1236.03 411.601 1235.14 410.71 1234.04 410.71C1232.94 410.71 1232.05 411.601 1232.05 412.7C1232.05 413.799 1232.94 414.69 1234.04 414.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M893.01 388.99C894.11 388.99 895 389.88 895 390.98C895 392.08 894.11 392.97 893.01 392.97C891.91 392.97 891.02 392.08 891.02 390.98C891.02 389.88 891.91 388.99 893.01 388.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.77 560.88C352.87 560.88 353.76 561.77 353.76 562.87C353.76 563.97 352.87 564.86 351.77 564.86C350.67 564.86 349.78 563.97 349.78 562.87C349.78 561.77 350.67 560.88 351.77 560.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1414.9 627.35C1416 627.35 1416.89 626.459 1416.89 625.36C1416.89 624.261 1416 623.37 1414.9 623.37C1413.8 623.37 1412.91 624.261 1412.91 625.36C1412.91 626.459 1413.8 627.35 1414.9 627.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1449.17 581.07C1450.27 581.07 1451.17 581.96 1451.17 583.07C1451.17 584.18 1450.28 585.06 1449.17 585.06C1448.06 585.06 1447.18 584.17 1447.18 583.07C1447.18 581.97 1448.07 581.07 1449.17 581.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1468.98 635.22C1470.08 635.22 1470.98 634.325 1470.98 633.22C1470.98 632.115 1470.08 631.22 1468.98 631.22C1467.88 631.22 1466.98 632.115 1466.98 633.22C1466.98 634.325 1467.88 635.22 1468.98 635.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M692.21 424.32C693.31 424.32 694.21 425.21 694.21 426.32C694.21 427.43 693.32 428.32 692.21 428.32C691.1 428.32 690.21 427.43 690.21 426.32C690.21 425.21 691.1 424.32 692.21 424.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M484.05 551.01C485.155 551.01 486.05 550.115 486.05 549.01C486.05 547.905 485.155 547.01 484.05 547.01C482.945 547.01 482.05 547.905 482.05 549.01C482.05 550.115 482.945 551.01 484.05 551.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1358.47 619.43C1359.57 619.43 1360.47 620.32 1360.47 621.43C1360.47 622.54 1359.58 623.43 1358.47 623.43C1357.36 623.43 1356.47 622.54 1356.47 621.43C1356.47 620.32 1357.36 619.43 1358.47 619.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M874.48 609.44C875.58 609.44 876.48 610.33 876.48 611.44C876.48 612.55 875.59 613.44 874.48 613.44C873.37 613.44 872.48 612.55 872.48 611.44C872.48 610.33 873.37 609.44 874.48 609.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M933.34 430.35C934.445 430.35 935.34 429.455 935.34 428.35C935.34 427.245 934.445 426.35 933.34 426.35C932.235 426.35 931.34 427.245 931.34 428.35C931.34 429.455 932.235 430.35 933.34 430.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M395.63 572.57C396.73 572.57 397.63 573.47 397.63 574.57C397.63 575.67 396.73 576.57 395.63 576.57C394.53 576.57 393.63 575.67 393.63 574.57C393.63 573.47 394.53 572.57 395.63 572.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1070.31 510.39C1071.41 510.39 1072.31 509.495 1072.31 508.39C1072.31 507.285 1071.41 506.39 1070.31 506.39C1069.21 506.39 1068.31 507.285 1068.31 508.39C1068.31 509.495 1069.21 510.39 1070.31 510.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M823.2 573.5C824.305 573.5 825.2 572.605 825.2 571.5C825.2 570.395 824.305 569.5 823.2 569.5C822.095 569.5 821.2 570.395 821.2 571.5C821.2 572.605 822.095 573.5 823.2 573.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1059.1 595.22C1060.2 595.22 1061.1 596.12 1061.1 597.22C1061.1 598.32 1060.2 599.22 1059.1 599.22C1058 599.22 1057.1 598.32 1057.1 597.22C1057.1 596.12 1058 595.22 1059.1 595.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M581.51 676.16C582.615 676.16 583.51 675.264 583.51 674.16C583.51 673.055 582.615 672.16 581.51 672.16C580.405 672.16 579.51 673.055 579.51 674.16C579.51 675.264 580.405 676.16 581.51 676.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M192.5 453.73C193.61 453.73 194.5 454.63 194.5 455.73C194.5 456.83 193.6 457.73 192.5 457.73C191.4 457.73 190.5 456.83 190.5 455.73C190.5 454.63 191.4 453.73 192.5 453.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1162.23 611.83C1163.34 611.83 1164.23 612.73 1164.23 613.83C1164.23 614.93 1163.33 615.83 1162.23 615.83C1161.13 615.83 1160.23 614.93 1160.23 613.83C1160.23 612.73 1161.13 611.83 1162.23 611.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1009.64 406.48C1010.74 406.48 1011.64 405.585 1011.64 404.48C1011.64 403.375 1010.74 402.48 1009.64 402.48C1008.54 402.48 1007.64 403.375 1007.64 404.48C1007.64 405.585 1008.54 406.48 1009.64 406.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M727.89 553.26C729 553.26 729.9 552.36 729.9 551.25C729.9 550.14 729 549.24 727.89 549.24C726.78 549.24 725.88 550.14 725.88 551.25C725.88 552.36 726.78 553.26 727.89 553.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1137.93 526.72C1139.04 526.72 1139.94 527.62 1139.94 528.73C1139.94 529.84 1139.04 530.74 1137.93 530.74C1136.82 530.74 1135.92 529.84 1135.92 528.73C1135.92 527.62 1136.82 526.72 1137.93 526.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1404.5 565.85C1405.61 565.85 1406.51 566.75 1406.51 567.86C1406.51 568.97 1405.61 569.87 1404.5 569.87C1403.39 569.87 1402.49 568.97 1402.49 567.86C1402.49 566.75 1403.39 565.85 1404.5 565.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M571.5 528.96C572.61 528.96 573.51 528.06 573.51 526.95C573.51 525.84 572.61 524.94 571.5 524.94C570.39 524.94 569.49 525.84 569.49 526.95C569.49 528.06 570.39 528.96 571.5 528.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M788.2 658.05C789.31 658.05 790.21 658.95 790.21 660.06C790.21 661.17 789.31 662.07 788.2 662.07C787.09 662.07 786.19 661.17 786.19 660.06C786.19 658.95 787.09 658.05 788.2 658.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M343.62 407.19C344.73 407.19 345.63 408.09 345.63 409.2C345.63 410.31 344.73 411.21 343.62 411.21C342.51 411.21 341.61 410.31 341.61 409.2C341.61 408.09 342.51 407.19 343.62 407.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1223.55 592C1224.66 592 1225.56 591.1 1225.56 589.99C1225.56 588.88 1224.66 587.98 1223.55 587.98C1222.44 587.98 1221.54 588.88 1221.54 589.99C1221.54 591.1 1222.44 592 1223.55 592Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1383.36 586.01C1384.47 586.01 1385.37 586.91 1385.37 588.02C1385.37 589.13 1384.47 590.03 1383.36 590.03C1382.25 590.03 1381.35 589.13 1381.35 588.02C1381.35 586.91 1382.25 586.01 1383.36 586.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M208.98 528.37C210.09 528.37 210.99 529.27 210.99 530.39C210.99 531.51 210.09 532.41 208.98 532.41C207.87 532.41 206.96 531.51 206.96 530.39C206.96 529.27 207.86 528.37 208.98 528.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M822.33 479.42C823.44 479.42 824.35 480.32 824.35 481.44C824.35 482.56 823.45 483.46 822.33 483.46C821.21 483.46 820.31 482.56 820.31 481.44C820.31 480.32 821.21 479.42 822.33 479.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M751.3 455.29C752.41 455.29 753.32 456.19 753.32 457.31C753.32 458.43 752.42 459.33 751.3 459.33C750.18 459.33 749.28 458.43 749.28 457.31C749.28 456.19 750.18 455.29 751.3 455.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M875.15 584.41C876.266 584.41 877.17 583.506 877.17 582.39C877.17 581.274 876.266 580.37 875.15 580.37C874.034 580.37 873.13 581.274 873.13 582.39C873.13 583.506 874.034 584.41 875.15 584.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M385.42 547.2C386.53 547.2 387.44 548.1 387.44 549.22C387.44 550.34 386.54 551.24 385.42 551.24C384.3 551.24 383.4 550.34 383.4 549.22C383.4 548.1 384.3 547.2 385.42 547.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1101.51 494.2C1102.63 494.2 1103.53 495.1 1103.53 496.22C1103.53 497.34 1102.63 498.24 1101.51 498.24C1100.39 498.24 1099.49 497.34 1099.49 496.22C1099.49 495.1 1100.39 494.2 1101.51 494.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.03 613.5C251.15 613.5 252.05 614.4 252.05 615.52C252.05 616.64 251.15 617.54 250.03 617.54C248.91 617.54 248.01 616.64 248.01 615.52C248.01 614.4 248.91 613.5 250.03 613.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M567.35 662.19C568.47 662.19 569.37 663.09 569.37 664.21C569.37 665.33 568.47 666.23 567.35 666.23C566.23 666.23 565.33 665.33 565.33 664.21C565.33 663.09 566.23 662.19 567.35 662.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1144.6 361.16C1145.72 361.16 1146.62 362.07 1146.62 363.18C1146.62 364.29 1145.71 365.2 1144.6 365.2C1143.49 365.2 1142.58 364.29 1142.58 363.18C1142.58 362.07 1143.49 361.16 1144.6 361.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1230.64 648.03C1231.76 648.03 1232.67 647.121 1232.67 646C1232.67 644.879 1231.76 643.97 1230.64 643.97C1229.52 643.97 1228.61 644.879 1228.61 646C1228.61 647.121 1229.52 648.03 1230.64 648.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M825.37 490.25C826.49 490.25 827.4 491.16 827.4 492.28C827.4 493.4 826.49 494.31 825.37 494.31C824.25 494.31 823.34 493.4 823.34 492.28C823.34 491.16 824.25 490.25 825.37 490.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1115.11 590.41C1116.23 590.41 1117.14 591.32 1117.14 592.44C1117.14 593.56 1116.23 594.47 1115.11 594.47C1113.99 594.47 1113.08 593.56 1113.08 592.44C1113.08 591.32 1113.99 590.41 1115.11 590.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M535.81 592.87C536.931 592.87 537.84 591.961 537.84 590.84C537.84 589.719 536.931 588.81 535.81 588.81C534.689 588.81 533.78 589.719 533.78 590.84C533.78 591.961 534.689 592.87 535.81 592.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M867.92 610.62C869.04 610.62 869.95 611.53 869.95 612.65C869.95 613.77 869.04 614.68 867.92 614.68C866.8 614.68 865.89 613.77 865.89 612.65C865.89 611.53 866.8 610.62 867.92 610.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M771.72 394.08C772.84 394.08 773.75 394.99 773.75 396.11C773.75 397.23 772.84 398.14 771.72 398.14C770.6 398.14 769.69 397.23 769.69 396.11C769.69 394.99 770.6 394.08 771.72 394.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M889.04 634.17C890.16 634.17 891.07 635.08 891.07 636.2C891.07 637.32 890.16 638.23 889.04 638.23C887.92 638.23 887.01 637.32 887.01 636.2C887.01 635.08 887.92 634.17 889.04 634.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1228.26 524.41C1229.38 524.41 1230.29 523.501 1230.29 522.38C1230.29 521.259 1229.38 520.35 1228.26 520.35C1227.14 520.35 1226.23 521.259 1226.23 522.38C1226.23 523.501 1227.14 524.41 1228.26 524.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M834.18 503.55C835.3 503.55 836.21 504.46 836.21 505.58C836.21 506.7 835.3 507.61 834.18 507.61C833.06 507.61 832.15 506.7 832.15 505.58C832.15 504.46 833.06 503.55 834.18 503.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1318.18 516.54C1319.3 516.54 1320.21 517.45 1320.21 518.57C1320.21 519.69 1319.3 520.6 1318.18 520.6C1317.06 520.6 1316.15 519.69 1316.15 518.57C1316.15 517.45 1317.06 516.54 1318.18 516.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M763.16 492.83C764.28 492.83 765.19 493.74 765.19 494.86C765.19 495.98 764.28 496.89 763.16 496.89C762.04 496.89 761.13 495.98 761.13 494.86C761.13 493.74 762.04 492.83 763.16 492.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1437.87 526.25C1438.99 526.25 1439.9 527.16 1439.9 528.28C1439.9 529.4 1438.99 530.31 1437.87 530.31C1436.75 530.31 1435.84 529.4 1435.84 528.28C1435.84 527.16 1436.75 526.25 1437.87 526.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.35 405.19C212.471 405.19 213.38 404.281 213.38 403.16C213.38 402.039 212.471 401.13 211.35 401.13C210.229 401.13 209.32 402.039 209.32 403.16C209.32 404.281 210.229 405.19 211.35 405.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M517.79 588.33C518.91 588.33 519.83 589.24 519.83 590.36C519.83 591.48 518.92 592.39 517.79 592.39C516.66 592.39 515.76 591.48 515.76 590.36C515.76 589.24 516.67 588.33 517.79 588.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1050.88 528.31C1052.01 528.31 1052.92 529.22 1052.92 530.35C1052.92 531.48 1052.01 532.39 1050.88 532.39C1049.75 532.39 1048.84 531.48 1048.84 530.35C1048.84 529.22 1049.75 528.31 1050.88 528.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1260.98 460.18C1262.11 460.18 1263.02 459.267 1263.02 458.14C1263.02 457.013 1262.11 456.1 1260.98 456.1C1259.85 456.1 1258.94 457.013 1258.94 458.14C1258.94 459.267 1259.85 460.18 1260.98 460.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1029.18 486.28C1030.31 486.28 1031.22 487.19 1031.22 488.32C1031.22 489.45 1030.31 490.36 1029.18 490.36C1028.05 490.36 1027.14 489.45 1027.14 488.32C1027.14 487.19 1028.05 486.28 1029.18 486.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1110.15 588.9C1111.28 588.9 1112.19 589.81 1112.19 590.94C1112.19 592.07 1111.28 592.98 1110.15 592.98C1109.02 592.98 1108.11 592.07 1108.11 590.94C1108.11 589.81 1109.02 588.9 1110.15 588.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1229.25 565.05C1230.38 565.05 1231.29 564.137 1231.29 563.01C1231.29 561.883 1230.38 560.97 1229.25 560.97C1228.12 560.97 1227.21 561.883 1227.21 563.01C1227.21 564.137 1228.12 565.05 1229.25 565.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1416.44 492.75C1417.57 492.75 1418.48 493.66 1418.48 494.79C1418.48 495.92 1417.57 496.83 1416.44 496.83C1415.31 496.83 1414.4 495.92 1414.4 494.79C1414.4 493.66 1415.31 492.75 1416.44 492.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M992.64 572.89C993.767 572.89 994.68 571.977 994.68 570.85C994.68 569.723 993.767 568.81 992.64 568.81C991.513 568.81 990.6 569.723 990.6 570.85C990.6 571.977 991.513 572.89 992.64 572.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M328.69 504.53C329.82 504.53 330.73 505.44 330.73 506.57C330.73 507.7 329.82 508.61 328.69 508.61C327.56 508.61 326.65 507.7 326.65 506.57C326.65 505.44 327.56 504.53 328.69 504.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.88 507.68C343.01 507.68 343.92 508.59 343.92 509.72C343.92 510.85 343.01 511.76 341.88 511.76C340.75 511.76 339.84 510.85 339.84 509.72C339.84 508.59 340.75 507.68 341.88 507.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.08 414.28C140.207 414.28 141.12 413.367 141.12 412.24C141.12 411.113 140.207 410.2 139.08 410.2C137.953 410.2 137.04 411.113 137.04 412.24C137.04 413.367 137.953 414.28 139.08 414.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M483.28 423.72C484.41 423.72 485.32 424.64 485.32 425.76C485.32 426.88 484.4 427.8 483.28 427.8C482.16 427.8 481.24 426.88 481.24 425.76C481.24 424.64 482.16 423.72 483.28 423.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M223.04 372.08C224.17 372.08 225.08 373 225.08 374.12C225.08 375.24 224.16 376.16 223.04 376.16C221.92 376.16 221 375.24 221 374.12C221 373 221.92 372.08 223.04 372.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1058.61 635.4C1059.74 635.4 1060.66 636.32 1060.66 637.45C1060.66 638.58 1059.74 639.5 1058.61 639.5C1057.48 639.5 1056.56 638.58 1056.56 637.45C1056.56 636.32 1057.48 635.4 1058.61 635.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1365.09 608.71C1366.22 608.71 1367.14 609.63 1367.14 610.76C1367.14 611.89 1366.22 612.81 1365.09 612.81C1363.96 612.81 1363.04 611.89 1363.04 610.76C1363.04 609.63 1363.96 608.71 1365.09 608.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M687.49 408.4C688.622 408.4 689.54 407.482 689.54 406.35C689.54 405.218 688.622 404.3 687.49 404.3C686.358 404.3 685.44 405.218 685.44 406.35C685.44 407.482 686.358 408.4 687.49 408.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1407.61 646.35C1408.74 646.35 1409.66 645.432 1409.66 644.3C1409.66 643.168 1408.74 642.25 1407.61 642.25C1406.48 642.25 1405.56 643.168 1405.56 644.3C1405.56 645.432 1406.48 646.35 1407.61 646.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M952.04 607.18C953.17 607.18 954.09 608.1 954.09 609.23C954.09 610.36 953.17 611.28 952.04 611.28C950.91 611.28 949.99 610.36 949.99 609.23C949.99 608.1 950.91 607.18 952.04 607.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M855.43 604.21C856.562 604.21 857.48 603.292 857.48 602.16C857.48 601.028 856.562 600.11 855.43 600.11C854.298 600.11 853.38 601.028 853.38 602.16C853.38 603.292 854.298 604.21 855.43 604.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M468.82 662.17C469.95 662.17 470.87 663.09 470.87 664.22C470.87 665.35 469.95 666.27 468.82 666.27C467.69 666.27 466.77 665.35 466.77 664.22C466.77 663.09 467.69 662.17 468.82 662.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M913.26 469.56C914.39 469.56 915.31 470.48 915.31 471.61C915.31 472.74 914.39 473.66 913.26 473.66C912.13 473.66 911.21 472.74 911.21 471.61C911.21 470.48 912.13 469.56 913.26 469.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M834.08 432.1C835.21 432.1 836.13 433.02 836.13 434.15C836.13 435.28 835.21 436.2 834.08 436.2C832.95 436.2 832.03 435.28 832.03 434.15C832.03 433.02 832.95 432.1 834.08 432.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M959.3 547.31C960.432 547.31 961.35 546.392 961.35 545.26C961.35 544.128 960.432 543.21 959.3 543.21C958.168 543.21 957.25 544.128 957.25 545.26C957.25 546.392 958.168 547.31 959.3 547.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M941.42 379.01C942.558 379.01 943.48 378.088 943.48 376.95C943.48 375.812 942.558 374.89 941.42 374.89C940.282 374.89 939.36 375.812 939.36 376.95C939.36 378.088 940.282 379.01 941.42 379.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M691.39 435.42C692.53 435.42 693.45 436.34 693.45 437.48C693.45 438.62 692.53 439.54 691.39 439.54C690.25 439.54 689.33 438.62 689.33 437.48C689.33 436.34 690.25 435.42 691.39 435.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1116.86 418.81C1118 418.81 1118.92 419.73 1118.92 420.87C1118.92 422.01 1118 422.93 1116.86 422.93C1115.72 422.93 1114.8 422.01 1114.8 420.87C1114.8 419.73 1115.72 418.81 1116.86 418.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M548.01 525.49C549.148 525.49 550.07 524.568 550.07 523.43C550.07 522.292 549.148 521.37 548.01 521.37C546.872 521.37 545.95 522.292 545.95 523.43C545.95 524.568 546.872 525.49 548.01 525.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1218.5 612.12C1219.64 612.12 1220.56 613.04 1220.56 614.18C1220.56 615.32 1219.64 616.24 1218.5 616.24C1217.36 616.24 1216.44 615.32 1216.44 614.18C1216.44 613.04 1217.36 612.12 1218.5 612.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1050.18 571.18C1051.32 571.18 1052.24 572.1 1052.24 573.24C1052.24 574.38 1051.32 575.3 1050.18 575.3C1049.04 575.3 1048.12 574.38 1048.12 573.24C1048.12 572.1 1049.04 571.18 1050.18 571.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1076.87 539.42C1078.01 539.42 1078.94 540.34 1078.94 541.48C1078.94 542.62 1078.02 543.55 1076.87 543.55C1075.72 543.55 1074.8 542.63 1074.8 541.48C1074.8 540.33 1075.72 539.42 1076.87 539.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M883.76 576.55C884.9 576.55 885.83 577.47 885.83 578.62C885.83 579.77 884.91 580.69 883.76 580.69C882.61 580.69 881.69 579.77 881.69 578.62C881.69 577.47 882.61 576.55 883.76 576.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M863.94 616.54C865.08 616.54 866.01 617.47 866.01 618.61C866.01 619.75 865.09 620.68 863.94 620.68C862.79 620.68 861.87 619.75 861.87 618.61C861.87 617.47 862.8 616.54 863.94 616.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M900.4 457.57C901.54 457.57 902.47 458.5 902.47 459.64C902.47 460.78 901.54 461.71 900.4 461.71C899.26 461.71 898.33 460.78 898.33 459.64C898.33 458.5 899.26 457.57 900.4 457.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M888.94 515.37C890.08 515.37 891.01 516.3 891.01 517.44C891.01 518.58 890.08 519.51 888.94 519.51C887.8 519.51 886.87 518.58 886.87 517.44C886.87 516.3 887.8 515.37 888.94 515.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1191.44 480.02C1192.58 480.02 1193.51 479.093 1193.51 477.95C1193.51 476.807 1192.58 475.88 1191.44 475.88C1190.3 475.88 1189.37 476.807 1189.37 477.95C1189.37 479.093 1190.3 480.02 1191.44 480.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M624.13 373.47C625.27 373.47 626.2 374.4 626.2 375.54C626.2 376.68 625.27 377.61 624.13 377.61C622.99 377.61 622.06 376.68 622.06 375.54C622.06 374.4 622.99 373.47 624.13 373.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M572.13 468.69C573.273 468.69 574.2 467.763 574.2 466.62C574.2 465.477 573.273 464.55 572.13 464.55C570.987 464.55 570.06 465.477 570.06 466.62C570.06 467.763 570.987 468.69 572.13 468.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M968.97 378.54C970.11 378.54 971.04 379.47 971.04 380.61C971.04 381.75 970.11 382.68 968.97 382.68C967.83 382.68 966.9 381.75 966.9 380.61C966.9 379.47 967.83 378.54 968.97 378.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M705.81 382.67C706.953 382.67 707.88 381.743 707.88 380.6C707.88 379.457 706.953 378.53 705.81 378.53C704.667 378.53 703.74 379.457 703.74 380.6C703.74 381.743 704.667 382.67 705.81 382.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1510.83 578.79C1511.98 578.79 1512.9 579.72 1512.9 580.86C1512.9 582 1511.97 582.93 1510.83 582.93C1509.69 582.93 1508.76 582 1508.76 580.86C1508.76 579.72 1509.69 578.79 1510.83 578.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M338.07 369.84C339.22 369.84 340.14 370.77 340.14 371.91C340.14 373.05 339.21 373.98 338.07 373.98C336.93 373.98 336 373.05 336 371.91C336 370.77 336.93 369.84 338.07 369.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1007.81 617.98C1008.96 617.98 1009.88 618.91 1009.88 620.05C1009.88 621.19 1008.95 622.12 1007.81 622.12C1006.67 622.12 1005.74 621.19 1005.74 620.05C1005.74 618.91 1006.67 617.98 1007.81 617.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1014.57 407.49C1015.72 407.49 1016.65 406.559 1016.65 405.41C1016.65 404.261 1015.72 403.33 1014.57 403.33C1013.42 403.33 1012.49 404.261 1012.49 405.41C1012.49 406.559 1013.42 407.49 1014.57 407.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M828.06 484.11C829.21 484.11 830.14 485.04 830.14 486.19C830.14 487.34 829.21 488.27 828.06 488.27C826.91 488.27 825.98 487.34 825.98 486.19C825.98 485.04 826.91 484.11 828.06 484.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1069.83 514.16C1070.98 514.16 1071.91 515.09 1071.91 516.24C1071.91 517.39 1070.98 518.32 1069.83 518.32C1068.68 518.32 1067.75 517.39 1067.75 516.24C1067.75 515.09 1068.68 514.16 1069.83 514.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1281.87 482.36C1283.02 482.36 1283.95 483.29 1283.95 484.44C1283.95 485.59 1283.02 486.52 1281.87 486.52C1280.72 486.52 1279.79 485.59 1279.79 484.44C1279.79 483.29 1280.72 482.36 1281.87 482.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M811.92 513.88C813.07 513.88 814 514.81 814 515.96C814 517.11 813.07 518.04 811.92 518.04C810.77 518.04 809.84 517.11 809.84 515.96C809.84 514.81 810.77 513.88 811.92 513.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M812.97 441.99C814.12 441.99 815.05 442.92 815.05 444.07C815.05 445.22 814.12 446.15 812.97 446.15C811.82 446.15 810.89 445.22 810.89 444.07C810.89 442.92 811.82 441.99 812.97 441.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1541.26 546.87C1542.41 546.87 1543.34 545.939 1543.34 544.79C1543.34 543.641 1542.41 542.71 1541.26 542.71C1540.11 542.71 1539.18 543.641 1539.18 544.79C1539.18 545.939 1540.11 546.87 1541.26 546.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M802.61 480.98C803.76 480.98 804.69 481.91 804.69 483.06C804.69 484.21 803.76 485.14 802.61 485.14C801.46 485.14 800.53 484.21 800.53 483.06C800.53 481.91 801.46 480.98 802.61 480.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1035.81 459.69C1036.96 459.69 1037.9 460.62 1037.9 461.78C1037.9 462.94 1036.97 463.87 1035.81 463.87C1034.65 463.87 1033.72 462.94 1033.72 461.78C1033.72 460.62 1034.65 459.69 1035.81 459.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1137.93 465.1C1139.08 465.1 1140.02 464.164 1140.02 463.01C1140.02 461.856 1139.08 460.92 1137.93 460.92C1136.78 460.92 1135.84 461.856 1135.84 463.01C1135.84 464.164 1136.78 465.1 1137.93 465.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M912.7 516.57C913.85 516.57 914.79 517.51 914.79 518.66C914.79 519.81 913.85 520.75 912.7 520.75C911.55 520.75 910.61 519.81 910.61 518.66C910.61 517.51 911.55 516.57 912.7 516.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1413.21 466.47C1414.36 466.47 1415.3 465.534 1415.3 464.38C1415.3 463.226 1414.36 462.29 1413.21 462.29C1412.06 462.29 1411.12 463.226 1411.12 464.38C1411.12 465.534 1412.06 466.47 1413.21 466.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1225.58 597.48C1226.73 597.48 1227.67 596.544 1227.67 595.39C1227.67 594.236 1226.73 593.3 1225.58 593.3C1224.43 593.3 1223.49 594.236 1223.49 595.39C1223.49 596.544 1224.43 597.48 1225.58 597.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M846.1 574.32C847.26 574.32 848.2 575.26 848.2 576.42C848.2 577.58 847.26 578.52 846.1 578.52C844.94 578.52 844 577.58 844 576.42C844 575.26 844.94 574.32 846.1 574.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1351.28 581.94C1352.44 581.94 1353.38 582.88 1353.38 584.04C1353.38 585.2 1352.44 586.14 1351.28 586.14C1350.12 586.14 1349.18 585.2 1349.18 584.04C1349.18 582.88 1350.12 581.94 1351.28 581.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M700.21 578.18C701.37 578.18 702.31 579.12 702.31 580.28C702.31 581.44 701.37 582.38 700.21 582.38C699.05 582.38 698.11 581.44 698.11 580.28C698.11 579.12 699.05 578.18 700.21 578.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M878.56 633.75C879.72 633.75 880.66 634.69 880.66 635.85C880.66 637.01 879.72 637.95 878.56 637.95C877.4 637.95 876.46 637.01 876.46 635.85C876.46 634.69 877.4 633.75 878.56 633.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M620.66 452.49C621.82 452.49 622.76 451.55 622.76 450.39C622.76 449.23 621.82 448.29 620.66 448.29C619.5 448.29 618.56 449.23 618.56 450.39C618.56 451.55 619.5 452.49 620.66 452.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M540.4 387.88C541.56 387.88 542.5 388.82 542.5 389.98C542.5 391.14 541.56 392.08 540.4 392.08C539.24 392.08 538.3 391.14 538.3 389.98C538.3 388.82 539.24 387.88 540.4 387.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1153.56 550.04C1154.72 550.04 1155.67 550.98 1155.67 552.15C1155.67 553.32 1154.73 554.26 1153.56 554.26C1152.39 554.26 1151.45 553.32 1151.45 552.15C1151.45 550.98 1152.39 550.04 1153.56 550.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1170.96 558.66C1172.12 558.66 1173.07 559.6 1173.07 560.77C1173.07 561.94 1172.13 562.88 1170.96 562.88C1169.79 562.88 1168.85 561.94 1168.85 560.77C1168.85 559.6 1169.79 558.66 1170.96 558.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M677.17 373.07C678.33 373.07 679.28 374.01 679.28 375.18C679.28 376.35 678.34 377.29 677.17 377.29C676 377.29 675.06 376.35 675.06 375.18C675.06 374.01 676 373.07 677.17 373.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M975.64 513.42C976.8 513.42 977.75 514.36 977.75 515.53C977.75 516.7 976.81 517.64 975.64 517.64C974.47 517.64 973.53 516.7 973.53 515.53C973.53 514.36 974.47 513.42 975.64 513.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1241.72 632.09C1242.88 632.09 1243.83 633.03 1243.83 634.2C1243.83 635.37 1242.89 636.31 1241.72 636.31C1240.55 636.31 1239.61 635.37 1239.61 634.2C1239.61 633.03 1240.55 632.09 1241.72 632.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M909.38 436.45C910.545 436.45 911.49 435.505 911.49 434.34C911.49 433.175 910.545 432.23 909.38 432.23C908.215 432.23 907.27 433.175 907.27 434.34C907.27 435.505 908.215 436.45 909.38 436.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M83.83 491.53C85 491.53 85.95 492.48 85.95 493.65C85.95 494.82 85 495.77 83.83 495.77C82.66 495.77 81.71 494.82 81.71 493.65C81.71 492.48 82.66 491.53 83.83 491.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M626.65 520.73C627.82 520.73 628.77 521.68 628.77 522.85C628.77 524.02 627.82 524.97 626.65 524.97C625.48 524.97 624.53 524.02 624.53 522.85C624.53 521.68 625.48 520.73 626.65 520.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M996.92 468.18C998.09 468.18 999.04 469.13 999.04 470.3C999.04 471.47 998.09 472.42 996.92 472.42C995.75 472.42 994.8 471.47 994.8 470.3C994.8 469.13 995.75 468.18 996.92 468.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1122.28 408.05C1123.45 408.05 1124.4 409 1124.4 410.17C1124.4 411.34 1123.45 412.29 1122.28 412.29C1121.11 412.29 1120.16 411.34 1120.16 410.17C1120.16 409 1121.11 408.05 1122.28 408.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M920.29 421.13C921.46 421.13 922.41 422.08 922.41 423.25C922.41 424.42 921.46 425.37 920.29 425.37C919.12 425.37 918.17 424.42 918.17 423.25C918.17 422.08 919.12 421.13 920.29 421.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1449.52 551.04C1450.69 551.04 1451.64 551.99 1451.64 553.16C1451.64 554.33 1450.69 555.28 1449.52 555.28C1448.35 555.28 1447.4 554.33 1447.4 553.16C1447.4 551.99 1448.35 551.04 1449.52 551.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M434.59 440.87C435.766 440.87 436.72 439.916 436.72 438.74C436.72 437.564 435.766 436.61 434.59 436.61C433.414 436.61 432.46 437.564 432.46 438.74C432.46 439.916 433.414 440.87 434.59 440.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.37 470.57C243.55 470.57 244.5 471.52 244.5 472.7C244.5 473.88 243.55 474.83 242.37 474.83C241.19 474.83 240.24 473.88 240.24 472.7C240.24 471.52 241.19 470.57 242.37 470.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1496.7 635.53C1497.88 635.53 1498.83 636.48 1498.83 637.66C1498.83 638.84 1497.88 639.79 1496.7 639.79C1495.52 639.79 1494.57 638.84 1494.57 637.66C1494.57 636.48 1495.52 635.53 1496.7 635.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M264.57 376.67C265.75 376.67 266.7 377.63 266.7 378.8C266.7 379.97 265.74 380.93 264.57 380.93C263.4 380.93 262.44 379.97 262.44 378.8C262.44 377.63 263.4 376.67 264.57 376.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1235.05 623.32C1236.23 623.32 1237.19 624.28 1237.19 625.46C1237.19 626.64 1236.23 627.6 1235.05 627.6C1233.87 627.6 1232.91 626.64 1232.91 625.46C1232.91 624.28 1233.87 623.32 1235.05 623.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1154.41 587.87C1155.59 587.87 1156.55 586.912 1156.55 585.73C1156.55 584.548 1155.59 583.59 1154.41 583.59C1153.23 583.59 1152.27 584.548 1152.27 585.73C1152.27 586.912 1153.23 587.87 1154.41 587.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M525.44 421.93C526.622 421.93 527.58 420.972 527.58 419.79C527.58 418.608 526.622 417.65 525.44 417.65C524.258 417.65 523.3 418.608 523.3 419.79C523.3 420.972 524.258 421.93 525.44 421.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1382.35 613.52C1383.53 613.52 1384.49 614.48 1384.49 615.66C1384.49 616.84 1383.53 617.8 1382.35 617.8C1381.17 617.8 1380.21 616.84 1380.21 615.66C1380.21 614.48 1381.17 613.52 1382.35 613.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82.35 593.92C83.54 593.92 84.5 594.88 84.5 596.07C84.5 597.26 83.54 598.22 82.35 598.22C81.16 598.22 80.2 597.26 80.2 596.07C80.2 594.88 81.16 593.92 82.35 593.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M817.96 388.63C819.15 388.63 820.11 389.59 820.11 390.78C820.11 391.97 819.15 392.93 817.96 392.93C816.77 392.93 815.81 391.97 815.81 390.78C815.81 389.59 816.77 388.63 817.96 388.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M996.45 482.51C997.64 482.51 998.6 483.47 998.6 484.66C998.6 485.85 997.64 486.81 996.45 486.81C995.26 486.81 994.3 485.85 994.3 484.66C994.3 483.47 995.26 482.51 996.45 482.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1437.19 504.7C1438.38 504.7 1439.34 503.737 1439.34 502.55C1439.34 501.362 1438.38 500.4 1437.19 500.4C1436 500.4 1435.04 501.362 1435.04 502.55C1435.04 503.737 1436 504.7 1437.19 504.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1187.9 486.02C1189.09 486.02 1190.05 485.057 1190.05 483.87C1190.05 482.683 1189.09 481.72 1187.9 481.72C1186.71 481.72 1185.75 482.683 1185.75 483.87C1185.75 485.057 1186.71 486.02 1187.9 486.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M508.26 437.13C509.45 437.13 510.42 438.09 510.42 439.28C510.42 440.47 509.45 441.44 508.26 441.44C507.07 441.44 506.11 440.48 506.11 439.28C506.11 438.08 507.07 437.13 508.26 437.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.27 453.84C117.463 453.84 118.43 452.873 118.43 451.68C118.43 450.487 117.463 449.52 116.27 449.52C115.077 449.52 114.11 450.487 114.11 451.68C114.11 452.873 115.077 453.84 116.27 453.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.98 529.53C105.17 529.53 106.14 530.5 106.14 531.69C106.14 532.88 105.17 533.85 103.98 533.85C102.79 533.85 101.82 532.88 101.82 531.69C101.82 530.5 102.79 529.53 103.98 529.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1382.35 443.45C1383.55 443.45 1384.51 444.42 1384.51 445.61C1384.51 446.8 1383.54 447.77 1382.35 447.77C1381.16 447.77 1380.19 446.8 1380.19 445.61C1380.19 444.42 1381.16 443.45 1382.35 443.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.27 475.96C347.47 475.96 348.43 476.93 348.43 478.12C348.43 479.31 347.46 480.28 346.27 480.28C345.08 480.28 344.11 479.31 344.11 478.12C344.11 476.93 345.08 475.96 346.27 475.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1248.6 408.67C1249.8 408.67 1250.77 407.698 1250.77 406.5C1250.77 405.302 1249.8 404.33 1248.6 404.33C1247.4 404.33 1246.43 405.302 1246.43 406.5C1246.43 407.698 1247.4 408.67 1248.6 408.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1064.01 417.35C1065.21 417.35 1066.18 418.32 1066.18 419.52C1066.18 420.72 1065.21 421.69 1064.01 421.69C1062.81 421.69 1061.84 420.72 1061.84 419.52C1061.84 418.32 1062.81 417.35 1064.01 417.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1476.77 464.01C1477.97 464.01 1478.94 464.98 1478.94 466.18C1478.94 467.38 1477.97 468.35 1476.77 468.35C1475.57 468.35 1474.6 467.38 1474.6 466.18C1474.6 464.98 1475.57 464.01 1476.77 464.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1213.26 469.89C1214.46 469.89 1215.43 470.86 1215.43 472.06C1215.43 473.26 1214.46 474.23 1213.26 474.23C1212.06 474.23 1211.09 473.26 1211.09 472.06C1211.09 470.86 1212.06 469.89 1213.26 469.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M422.56 494.09C423.76 494.09 424.73 495.06 424.73 496.26C424.73 497.46 423.76 498.43 422.56 498.43C421.36 498.43 420.39 497.46 420.39 496.26C420.39 495.06 421.36 494.09 422.56 494.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M402.39 602.43C403.59 602.43 404.56 603.4 404.56 604.6C404.56 605.8 403.59 606.77 402.39 606.77C401.19 606.77 400.22 605.8 400.22 604.6C400.22 603.4 401.19 602.43 402.39 602.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M390.84 425.91C392.04 425.91 393.02 426.88 393.02 428.09C393.02 429.3 392.05 430.27 390.84 430.27C389.63 430.27 388.66 429.3 388.66 428.09C388.66 426.88 389.63 425.91 390.84 425.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M790.11 645.74C791.31 645.74 792.29 646.71 792.29 647.92C792.29 649.13 791.32 650.1 790.11 650.1C788.9 650.1 787.93 649.13 787.93 647.92C787.93 646.71 788.9 645.74 790.11 645.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M492.5 594.17C493.7 594.17 494.68 595.15 494.68 596.35C494.68 597.55 493.7 598.53 492.5 598.53C491.3 598.53 490.32 597.55 490.32 596.35C490.32 595.15 491.3 594.17 492.5 594.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M315.57 393.51C316.774 393.51 317.75 392.534 317.75 391.33C317.75 390.126 316.774 389.15 315.57 389.15C314.366 389.15 313.39 390.126 313.39 391.33C313.39 392.534 314.366 393.51 315.57 393.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M186.32 557.32C187.52 557.32 188.5 558.3 188.5 559.5C188.5 560.7 187.52 561.68 186.32 561.68C185.12 561.68 184.14 560.7 184.14 559.5C184.14 558.3 185.12 557.32 186.32 557.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M285.65 673.11C286.854 673.11 287.83 672.134 287.83 670.93C287.83 669.726 286.854 668.75 285.65 668.75C284.446 668.75 283.47 669.726 283.47 670.93C283.47 672.134 284.446 673.11 285.65 673.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M436.26 468.66C437.464 468.66 438.44 467.684 438.44 466.48C438.44 465.276 437.464 464.3 436.26 464.3C435.056 464.3 434.08 465.276 434.08 466.48C434.08 467.684 435.056 468.66 436.26 468.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1323.56 450.7C1324.77 450.7 1325.75 451.68 1325.75 452.89C1325.75 454.1 1324.77 455.08 1323.56 455.08C1322.35 455.08 1321.37 454.1 1321.37 452.89C1321.37 451.68 1322.35 450.7 1323.56 450.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1346.05 472.03C1347.26 472.03 1348.24 473.01 1348.24 474.22C1348.24 475.43 1347.26 476.41 1346.05 476.41C1344.84 476.41 1343.86 475.43 1343.86 474.22C1343.86 473.01 1344.84 472.03 1346.05 472.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.69 493.81C161.9 493.81 162.88 492.829 162.88 491.62C162.88 490.41 161.9 489.43 160.69 489.43C159.48 489.43 158.5 490.41 158.5 491.62C158.5 492.829 159.48 493.81 160.69 493.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.88 633.06C162.089 633.06 163.07 632.079 163.07 630.87C163.07 629.66 162.089 628.68 160.88 628.68C159.67 628.68 158.69 629.66 158.69 630.87C158.69 632.079 159.67 633.06 160.88 633.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1260.97 640.24C1262.18 640.24 1263.17 641.22 1263.17 642.44C1263.17 643.66 1262.19 644.64 1260.97 644.64C1259.75 644.64 1258.77 643.66 1258.77 642.44C1258.77 641.22 1259.75 640.24 1260.97 640.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.2 507.32C374.41 507.32 375.4 508.3 375.4 509.52C375.4 510.74 374.42 511.72 373.2 511.72C371.98 511.72 371 510.74 371 509.52C371 508.3 371.98 507.32 373.2 507.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1094.47 501.81C1095.69 501.81 1096.67 502.8 1096.67 504.01C1096.67 505.22 1095.68 506.21 1094.47 506.21C1093.26 506.21 1092.27 505.22 1092.27 504.01C1092.27 502.8 1093.26 501.81 1094.47 501.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.86 549.21C175.08 549.21 176.07 550.2 176.07 551.42C176.07 552.64 175.08 553.62 173.86 553.62C172.64 553.62 171.66 552.63 171.66 551.42C171.66 550.21 172.65 549.21 173.86 549.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M345.91 431.28C347.13 431.28 348.12 430.291 348.12 429.07C348.12 427.849 347.13 426.86 345.91 426.86C344.689 426.86 343.7 427.849 343.7 429.07C343.7 430.291 344.689 431.28 345.91 431.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M657.42 396.79C658.64 396.79 659.63 395.801 659.63 394.58C659.63 393.359 658.64 392.37 657.42 392.37C656.199 392.37 655.21 393.359 655.21 394.58C655.21 395.801 656.199 396.79 657.42 396.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M355.52 406.39C356.74 406.39 357.73 407.38 357.73 408.6C357.73 409.82 356.74 410.81 355.52 410.81C354.3 410.81 353.31 409.82 353.31 408.6C353.31 407.38 354.3 406.39 355.52 406.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1167.73 438.97C1168.95 438.97 1169.94 439.96 1169.94 441.18C1169.94 442.4 1168.95 443.39 1167.73 443.39C1166.51 443.39 1165.52 442.4 1165.52 441.18C1165.52 439.96 1166.51 438.97 1167.73 438.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1399.02 422.41C1400.24 422.41 1401.23 421.421 1401.23 420.2C1401.23 418.979 1400.24 417.99 1399.02 417.99C1397.8 417.99 1396.81 418.979 1396.81 420.2C1396.81 421.421 1397.8 422.41 1399.02 422.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M505.19 631.46C506.411 631.46 507.4 630.47 507.4 629.25C507.4 628.029 506.411 627.04 505.19 627.04C503.969 627.04 502.98 628.029 502.98 629.25C502.98 630.47 503.969 631.46 505.19 631.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M732.78 497.34C734.01 497.34 735 498.33 735 499.56C735 500.79 734.01 501.78 732.78 501.78C731.55 501.78 730.56 500.79 730.56 499.56C730.56 498.33 731.55 497.34 732.78 497.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M589.87 564.04C591.1 564.04 592.09 565.03 592.09 566.26C592.09 567.49 591.1 568.48 589.87 568.48C588.64 568.48 587.65 567.49 587.65 566.26C587.65 565.03 588.64 564.04 589.87 564.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1354.66 428.61C1355.89 428.61 1356.88 429.6 1356.88 430.83C1356.88 432.06 1355.89 433.05 1354.66 433.05C1353.43 433.05 1352.44 432.06 1352.44 430.83C1352.44 429.6 1353.43 428.61 1354.66 428.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1352.89 591.7C1354.12 591.7 1355.11 592.7 1355.11 593.92C1355.11 595.14 1354.11 596.14 1352.89 596.14C1351.67 596.14 1350.67 595.14 1350.67 593.92C1350.67 592.7 1351.67 591.7 1352.89 591.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M247.42 667.21C248.65 667.21 249.65 668.21 249.65 669.44C249.65 670.67 248.65 671.67 247.42 671.67C246.19 671.67 245.19 670.67 245.19 669.44C245.19 668.21 246.19 667.21 247.42 667.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.31 398.52C239.54 398.52 240.54 399.52 240.54 400.75C240.54 401.98 239.54 402.98 238.31 402.98C237.08 402.98 236.08 401.98 236.08 400.75C236.08 399.52 237.08 398.52 238.31 398.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.97 398.58C366.202 398.58 367.2 397.582 367.2 396.35C367.2 395.118 366.202 394.12 364.97 394.12C363.738 394.12 362.74 395.118 362.74 396.35C362.74 397.582 363.738 398.58 364.97 398.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M383.65 494.24C384.882 494.24 385.88 493.242 385.88 492.01C385.88 490.778 384.882 489.78 383.65 489.78C382.418 489.78 381.42 490.778 381.42 492.01C381.42 493.242 382.418 494.24 383.65 494.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M432.54 408.52C433.777 408.52 434.78 407.517 434.78 406.28C434.78 405.043 433.777 404.04 432.54 404.04C431.303 404.04 430.3 405.043 430.3 406.28C430.3 407.517 431.303 408.52 432.54 408.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M289.75 643.96C290.99 643.96 291.99 644.96 291.99 646.2C291.99 647.44 290.99 648.44 289.75 648.44C288.51 648.44 287.51 647.44 287.51 646.2C287.51 644.96 288.51 643.96 289.75 643.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1023.84 567.72C1025.08 567.72 1026.08 568.72 1026.08 569.96C1026.08 571.2 1025.08 572.2 1023.84 572.2C1022.6 572.2 1021.6 571.2 1021.6 569.96C1021.6 568.72 1022.6 567.72 1023.84 567.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1100.05 425.72C1101.29 425.72 1102.3 426.73 1102.3 427.97C1102.3 429.21 1101.29 430.22 1100.05 430.22C1098.81 430.22 1097.8 429.21 1097.8 427.97C1097.8 426.73 1098.81 425.72 1100.05 425.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.1899 575C95.4299 575 96.4399 576.01 96.4399 577.25C96.4399 578.49 95.4299 579.5 94.1899 579.5C92.9499 579.5 91.9399 578.49 91.9399 577.25C91.9399 576.01 92.9499 575 94.1899 575Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M643.11 499.35C644.35 499.35 645.36 500.36 645.36 501.6C645.36 502.84 644.35 503.85 643.11 503.85C641.87 503.85 640.86 502.84 640.86 501.6C640.86 500.36 641.87 499.35 643.11 499.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M476.33 516.31C477.573 516.31 478.58 515.303 478.58 514.06C478.58 512.817 477.573 511.81 476.33 511.81C475.087 511.81 474.08 512.817 474.08 514.06C474.08 515.303 475.087 516.31 476.33 516.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.6 629.86C320.84 629.86 321.85 630.87 321.85 632.11C321.85 633.35 320.84 634.36 319.6 634.36C318.36 634.36 317.35 633.35 317.35 632.11C317.35 630.87 318.36 629.86 319.6 629.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.05 493.4C251.293 493.4 252.3 492.393 252.3 491.15C252.3 489.907 251.293 488.9 250.05 488.9C248.807 488.9 247.8 489.907 247.8 491.15C247.8 492.393 248.807 493.4 250.05 493.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M206.44 425.65C207.69 425.65 208.7 426.66 208.7 427.91C208.7 429.16 207.69 430.17 206.44 430.17C205.19 430.17 204.18 429.16 204.18 427.91C204.18 426.66 205.19 425.65 206.44 425.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.48 474.65C139.73 474.65 140.74 475.66 140.74 476.91C140.74 478.16 139.73 479.17 138.48 479.17C137.23 479.17 136.22 478.16 136.22 476.91C136.22 475.66 137.23 474.65 138.48 474.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M296.79 488.9C298.04 488.9 299.06 489.91 299.06 491.17C299.06 492.43 298.05 493.44 296.79 493.44C295.53 493.44 294.52 492.43 294.52 491.17C294.52 489.91 295.53 488.9 296.79 488.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M327.52 628.05C328.774 628.05 329.79 627.034 329.79 625.78C329.79 624.526 328.774 623.51 327.52 623.51C326.266 623.51 325.25 624.526 325.25 625.78C325.25 627.034 326.266 628.05 327.52 628.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.35 531.51C307.6 531.51 308.62 532.53 308.62 533.78C308.62 535.03 307.6 536.05 306.35 536.05C305.1 536.05 304.08 535.03 304.08 533.78C304.08 532.53 305.1 531.51 306.35 531.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1152.89 529.59C1154.14 529.59 1155.16 528.574 1155.16 527.32C1155.16 526.066 1154.14 525.05 1152.89 525.05C1151.64 525.05 1150.62 526.066 1150.62 527.32C1150.62 528.574 1151.64 529.59 1152.89 529.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1045.26 555.05C1046.51 555.05 1047.53 556.07 1047.53 557.32C1047.53 558.57 1046.51 559.59 1045.26 559.59C1044.01 559.59 1042.99 558.57 1042.99 557.32C1042.99 556.07 1044.01 555.05 1045.26 555.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M498.19 623.57C499.44 623.57 500.46 624.59 500.46 625.84C500.46 627.09 499.44 628.11 498.19 628.11C496.94 628.11 495.92 627.09 495.92 625.84C495.92 624.59 496.94 623.57 498.19 623.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M542.87 661.05C544.12 661.05 545.14 662.07 545.14 663.32C545.14 664.57 544.12 665.59 542.87 665.59C541.62 665.59 540.6 664.57 540.6 663.32C540.6 662.07 541.62 661.05 542.87 661.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M999.31 457.3C1000.57 457.3 1001.59 456.279 1001.59 455.02C1001.59 453.761 1000.57 452.74 999.31 452.74C998.051 452.74 997.03 453.761 997.03 455.02C997.03 456.279 998.051 457.3 999.31 457.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M485.65 559.02C486.91 559.02 487.93 560.04 487.93 561.3C487.93 562.56 486.91 563.58 485.65 563.58C484.39 563.58 483.37 562.56 483.37 561.3C483.37 560.04 484.39 559.02 485.65 559.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M840.48 574.65C841.74 574.65 842.77 575.67 842.77 576.94C842.77 578.21 841.75 579.23 840.48 579.23C839.21 579.23 838.19 578.21 838.19 576.94C838.19 575.67 839.21 574.65 840.48 574.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M230.94 487.6C232.21 487.6 233.23 488.63 233.23 489.89C233.23 491.15 232.2 492.18 230.94 492.18C229.68 492.18 228.65 491.15 228.65 489.89C228.65 488.63 229.68 487.6 230.94 487.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M395.12 426.61C396.385 426.61 397.41 425.585 397.41 424.32C397.41 423.055 396.385 422.03 395.12 422.03C393.855 422.03 392.83 423.055 392.83 424.32C392.83 425.585 393.855 426.61 395.12 426.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.5 502.95C351.765 502.95 352.79 501.925 352.79 500.66C352.79 499.395 351.765 498.37 350.5 498.37C349.235 498.37 348.21 499.395 348.21 500.66C348.21 501.925 349.235 502.95 350.5 502.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M310.29 579.6C311.56 579.6 312.59 580.63 312.59 581.9C312.59 583.17 311.56 584.2 310.29 584.2C309.02 584.2 307.99 583.17 307.99 581.9C307.99 580.63 309.02 579.6 310.29 579.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.24 382.86C351.51 382.86 352.54 381.83 352.54 380.56C352.54 379.29 351.51 378.26 350.24 378.26C348.97 378.26 347.94 379.29 347.94 380.56C347.94 381.83 348.97 382.86 350.24 382.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M947.35 431.04C948.62 431.04 949.65 430.01 949.65 428.74C949.65 427.47 948.62 426.44 947.35 426.44C946.08 426.44 945.05 427.47 945.05 428.74C945.05 430.01 946.08 431.04 947.35 431.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M912.72 519.87C913.99 519.87 915.02 518.84 915.02 517.57C915.02 516.3 913.99 515.27 912.72 515.27C911.45 515.27 910.42 516.3 910.42 517.57C910.42 518.84 911.45 519.87 912.72 519.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1151.15 608.84C1152.42 608.84 1153.45 609.87 1153.45 611.14C1153.45 612.41 1152.42 613.44 1151.15 613.44C1149.88 613.44 1148.85 612.41 1148.85 611.14C1148.85 609.87 1149.88 608.84 1151.15 608.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.72 375.71C118.99 375.71 120.02 374.68 120.02 373.41C120.02 372.14 118.99 371.11 117.72 371.11C116.45 371.11 115.42 372.14 115.42 373.41C115.42 374.68 116.45 375.71 117.72 375.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M943.36 404.14C944.63 404.14 945.66 403.11 945.66 401.84C945.66 400.57 944.63 399.54 943.36 399.54C942.09 399.54 941.06 400.57 941.06 401.84C941.06 403.11 942.09 404.14 943.36 404.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M274.39 528.42C275.67 528.42 276.7 529.45 276.7 530.73C276.7 532.01 275.66 533.04 274.39 533.04C273.12 533.04 272.08 532.01 272.08 530.73C272.08 529.45 273.12 528.42 274.39 528.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M288.8 393.37C290.076 393.37 291.11 392.336 291.11 391.06C291.11 389.784 290.076 388.75 288.8 388.75C287.524 388.75 286.49 389.784 286.49 391.06C286.49 392.336 287.524 393.37 288.8 393.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M224.69 525.62C225.971 525.62 227.01 524.581 227.01 523.3C227.01 522.019 225.971 520.98 224.69 520.98C223.409 520.98 222.37 522.019 222.37 523.3C222.37 524.581 223.409 525.62 224.69 525.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1026.18 389.91C1027.46 389.91 1028.5 388.871 1028.5 387.59C1028.5 386.309 1027.46 385.27 1026.18 385.27C1024.9 385.27 1023.86 386.309 1023.86 387.59C1023.86 388.871 1024.9 389.91 1026.18 389.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M840.4 593.6C841.687 593.6 842.73 592.557 842.73 591.27C842.73 589.983 841.687 588.94 840.4 588.94C839.113 588.94 838.07 589.983 838.07 591.27C838.07 592.557 839.113 593.6 840.4 593.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M901.14 616.45C902.43 616.45 903.48 617.5 903.48 618.79C903.48 620.08 902.43 621.13 901.14 621.13C899.85 621.13 898.8 620.08 898.8 618.79C898.8 617.5 899.85 616.45 901.14 616.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.91 580.79C250.202 580.79 251.25 579.742 251.25 578.45C251.25 577.158 250.202 576.11 248.91 576.11C247.618 576.11 246.57 577.158 246.57 578.45C246.57 579.742 247.618 580.79 248.91 580.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M465.17 602.77C466.462 602.77 467.51 601.722 467.51 600.43C467.51 599.138 466.462 598.09 465.17 598.09C463.878 598.09 462.83 599.138 462.83 600.43C462.83 601.722 463.878 602.77 465.17 602.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1459.05 461.07L1414.64 502.83C1414.22 503.23 1414.21 503.89 1414.61 504.3C1415 504.71 1415.65 504.73 1416.07 504.35L1460.48 462.59C1460.9 462.19 1460.91 461.53 1460.51 461.12C1460.12 460.71 1459.47 460.69 1459.05 461.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M435.2 567.54L486.42 533.47C486.9 533.15 487.02 532.5 486.7 532.02C486.38 531.55 485.74 531.42 485.27 531.73L434.05 565.8C433.57 566.12 433.44 566.77 433.76 567.25C434.08 567.73 434.73 567.86 435.21 567.54H435.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M399.62 498.26L433.69 567.13C433.95 567.65 434.57 567.85 435.09 567.6C435.6 567.34 435.81 566.72 435.56 566.21L401.49 497.34C401.23 496.82 400.61 496.61 400.09 496.87C399.57 497.13 399.36 497.75 399.62 498.27V498.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M619.02 590.91L574.17 654.43C573.85 654.91 573.97 655.56 574.45 655.88C574.91 656.19 575.54 656.09 575.87 655.64L620.72 592.12C621.05 591.65 620.94 591 620.47 590.67C620 590.34 619.35 590.45 619.02 590.92V590.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1458.27 552.18L1423.54 591.5C1423.16 591.93 1423.2 592.59 1423.63 592.97C1424.06 593.35 1424.72 593.31 1425.1 592.88L1459.83 553.56C1460.21 553.13 1460.17 552.47 1459.74 552.09C1459.31 551.71 1458.65 551.75 1458.27 552.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1493.36 558.07L1459.25 551.85C1458.68 551.75 1458.14 552.12 1458.04 552.69C1457.94 553.26 1458.31 553.8 1458.88 553.9L1492.99 560.12C1493.56 560.22 1494.1 559.85 1494.2 559.28C1494.3 558.71 1493.93 558.17 1493.36 558.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M715.69 531.17L713.9 552.18C713.85 552.75 714.28 553.26 714.85 553.31C715.42 553.36 715.93 552.93 715.98 552.36L717.77 531.35C717.82 530.78 717.39 530.27 716.82 530.22C716.25 530.17 715.74 530.6 715.69 531.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M715.73 531.55L732.32 588.94C732.49 589.49 733.08 589.8 733.63 589.62C734.16 589.45 734.47 588.9 734.33 588.36L717.74 530.97C717.57 530.42 716.99 530.11 716.44 530.27C715.9 530.43 715.58 531 715.74 531.55H715.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1473.58 594.25L1460.05 552.55C1459.87 552 1459.28 551.7 1458.74 551.88C1458.19 552.06 1457.89 552.65 1458.07 553.19L1471.6 594.89C1471.78 595.44 1472.37 595.74 1472.91 595.56C1473.46 595.38 1473.76 594.79 1473.58 594.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M714.01 552.74L732.39 589.13C732.65 589.64 733.28 589.84 733.79 589.58C734.3 589.32 734.5 588.7 734.25 588.19L715.87 551.8C715.61 551.29 714.98 551.08 714.47 551.35C713.96 551.61 713.76 552.23 714.01 552.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M746.26 537.24L716.98 530.25C716.42 530.12 715.86 530.48 715.73 531.04C715.61 531.59 715.94 532.14 716.49 532.28L745.77 539.27C746.33 539.4 746.89 539.04 747.02 538.48C747.14 537.93 746.81 537.38 746.26 537.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M717.74 531L693.94 441.06C693.78 440.51 693.21 440.19 692.65 440.34C692.11 440.49 691.79 441.05 691.92 441.59L715.72 531.53C715.88 532.08 716.46 532.4 717.01 532.25C717.55 532.1 717.87 531.54 717.74 531Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M745.58 537.3L714.51 551.31C713.99 551.55 713.76 552.18 714.01 552.7C714.25 553.21 714.85 553.44 715.37 553.21L746.44 539.2C746.96 538.96 747.19 538.33 746.94 537.81C746.7 537.3 746.1 537.07 745.58 537.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M745 538L732.31 588.4C732.17 588.96 732.51 589.53 733.07 589.67C733.63 589.81 734.2 589.47 734.34 588.91L747.03 538.51C747.16 537.95 746.8 537.39 746.24 537.26C745.7 537.14 745.15 537.46 745.01 538H745Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1492.72 558.16L1423.88 591.25C1423.36 591.5 1423.14 592.12 1423.39 592.64C1423.64 593.16 1424.26 593.38 1424.78 593.13L1493.63 560.04C1494.15 559.79 1494.37 559.17 1494.12 558.65C1493.87 558.13 1493.25 557.91 1492.73 558.16H1492.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1452.35 674.63L1425.32 591.86C1425.14 591.31 1424.55 591.01 1424 591.19C1423.45 591.37 1423.15 591.96 1423.33 592.51L1450.36 675.28C1450.55 675.83 1451.14 676.12 1451.68 675.93C1452.22 675.75 1452.51 675.17 1452.34 674.63H1452.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M232.77 504.98L264.89 564.81C265.17 565.32 265.8 565.5 266.31 565.22C266.81 564.95 267 564.32 266.73 563.82L234.61 503.99C234.33 503.49 233.7 503.3 233.19 503.58C232.69 503.85 232.51 504.47 232.77 504.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M731.66 399.42L692.18 440.61C691.78 441.03 691.8 441.69 692.21 442.08C692.63 442.48 693.29 442.46 693.68 442.05L733.16 400.86C733.55 400.44 733.52 399.78 733.09 399.39C732.68 399.01 732.04 399.03 731.65 399.42H731.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M194.81 610.93L192.37 628.42C192.29 628.99 192.69 629.52 193.26 629.6C193.83 629.68 194.36 629.28 194.44 628.71L196.88 611.22C196.96 610.65 196.56 610.12 195.99 610.04C195.42 609.96 194.89 610.36 194.81 610.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1258.53 477.26L1333.11 433.74C1333.61 433.45 1333.78 432.81 1333.49 432.31C1333.2 431.81 1332.56 431.64 1332.06 431.93L1257.48 475.45C1256.99 475.75 1256.83 476.39 1257.13 476.88C1257.42 477.36 1258.04 477.52 1258.53 477.25V477.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1472.64 593.53L1424.38 591.15C1423.8 591.12 1423.32 591.57 1423.29 592.14C1423.26 592.72 1423.71 593.2 1424.28 593.23L1472.53 595.61C1473.11 595.62 1473.58 595.17 1473.6 594.6C1473.61 594.04 1473.19 593.57 1472.63 593.53H1472.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M713.97 551.91L687.72 622.74C687.52 623.28 687.8 623.88 688.34 624.08C688.88 624.28 689.48 624 689.68 623.46L715.93 552.63C716.13 552.09 715.85 551.49 715.31 551.29C714.77 551.09 714.17 551.37 713.97 551.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M689.33 623.92L733.96 589.48C734.41 589.12 734.49 588.47 734.13 588.02C733.78 587.58 733.14 587.5 732.69 587.83L688.06 622.27C687.6 622.62 687.52 623.28 687.87 623.73C688.22 624.19 688.88 624.27 689.33 623.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M707.19 494.17L715.72 531.49C715.85 532.05 716.41 532.4 716.97 532.27C717.53 532.14 717.88 531.58 717.75 531.02L709.22 493.7C709.09 493.14 708.53 492.79 707.97 492.92C707.41 493.05 707.06 493.61 707.19 494.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M585.42 649.48L574.62 654.07C574.09 654.3 573.86 654.92 574.09 655.45C574.32 655.96 574.91 656.2 575.43 655.99L586.23 651.4C586.76 651.18 587.01 650.56 586.78 650.03C586.55 649.5 585.94 649.25 585.41 649.48H585.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M707.17 494.06L713.91 552.39C713.98 552.96 714.49 553.37 715.07 553.31C715.64 553.24 716.05 552.73 715.99 552.15L709.25 493.82C709.18 493.25 708.67 492.84 708.09 492.9C707.51 492.96 707.11 493.48 707.17 494.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M672.08 640.56L733.99 589.46C734.43 589.09 734.5 588.44 734.13 587.99C733.76 587.54 733.11 587.48 732.66 587.85L670.75 638.95C670.31 639.33 670.26 639.98 670.64 640.42C671 640.84 671.64 640.9 672.08 640.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1492.27 558.57L1471.68 594.05C1471.39 594.55 1471.56 595.19 1472.06 595.48C1472.56 595.77 1473.2 595.6 1473.49 595.1L1494.08 559.62C1494.37 559.12 1494.2 558.48 1493.7 558.19C1493.2 557.9 1492.56 558.07 1492.27 558.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M547.99 537.48L545.36 487.06C545.33 486.48 544.84 486.04 544.26 486.07C543.68 486.1 543.24 486.59 543.27 487.17L545.9 537.59C545.94 538.16 546.44 538.6 547.01 538.56C547.57 538.52 548 538.05 547.98 537.48H547.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1494.21 559.16L1499.6 478.04C1499.6 477.46 1499.12 477 1498.55 477.01C1498.03 477.01 1497.6 477.4 1497.53 477.91L1492.14 559.03C1492.14 559.61 1492.61 560.07 1493.19 560.06C1493.71 560.06 1494.14 559.68 1494.21 559.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1257.98 475.32L1192.88 476.51C1192.3 476.52 1191.85 477 1191.86 477.57C1191.87 478.15 1192.35 478.6 1192.92 478.59L1258.02 477.4C1258.6 477.39 1259.05 476.91 1259.04 476.34C1259.03 475.76 1258.55 475.31 1257.98 475.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1471.58 594.31L1450.36 674.69C1450.21 675.25 1450.55 675.82 1451.1 675.96C1451.66 676.11 1452.23 675.77 1452.37 675.22L1473.59 594.84C1473.72 594.28 1473.38 593.72 1472.82 593.58C1472.28 593.45 1471.73 593.77 1471.58 594.3V594.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M746.81 537.58L709 493.27C708.62 492.84 707.96 492.8 707.53 493.18C707.11 493.55 707.06 494.19 707.42 494.62L745.23 538.93C745.61 539.36 746.27 539.4 746.7 539.02C747.12 538.65 747.17 538.01 746.81 537.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M630.23 440.37L692.9 442.36C693.48 442.38 693.96 441.92 693.97 441.35C693.99 440.78 693.54 440.3 692.96 440.28L630.29 438.29C629.71 438.27 629.23 438.73 629.22 439.3C629.2 439.87 629.65 440.35 630.23 440.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M709.21 493.65L693.94 441.03C693.78 440.48 693.2 440.16 692.65 440.32C692.1 440.48 691.78 441.06 691.94 441.61L707.21 494.23C707.37 494.78 707.95 495.1 708.5 494.94C709.05 494.78 709.37 494.2 709.21 493.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M391.53 417.92L373.13 437.24C372.73 437.66 372.75 438.32 373.17 438.71C373.59 439.11 374.25 439.09 374.64 438.67L393.04 419.35C393.43 418.93 393.4 418.27 392.97 417.88C392.56 417.5 391.92 417.52 391.53 417.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M560.26 477.52L543.83 486.19C543.32 486.46 543.13 487.09 543.39 487.6C543.66 488.11 544.29 488.3 544.8 488.04L561.23 479.37C561.74 479.1 561.93 478.47 561.67 477.96C561.4 477.45 560.77 477.26 560.26 477.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1494.19 558.89L1476.32 468.97C1476.21 468.41 1475.66 468.04 1475.09 468.15C1474.52 468.26 1474.16 468.81 1474.27 469.38L1492.14 559.3C1492.28 559.86 1492.84 560.2 1493.4 560.07C1493.93 559.94 1494.27 559.43 1494.19 558.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M488.94 418.62L543.51 487.76C543.87 488.21 544.52 488.29 544.97 487.93C545.42 487.57 545.5 486.92 545.14 486.47L490.57 417.33C490.21 416.88 489.56 416.8 489.11 417.16C488.66 417.52 488.58 418.17 488.94 418.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1420.16 626.27L1425.36 592.34C1425.45 591.77 1425.06 591.24 1424.49 591.15C1423.92 591.06 1423.39 591.45 1423.3 592.02L1418.1 625.95C1418.01 626.52 1418.4 627.05 1418.97 627.14C1419.54 627.23 1420.07 626.84 1420.16 626.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M361.16 509.44L374.91 438.16C375 437.59 374.62 437.06 374.05 436.96C373.5 436.87 372.98 437.22 372.86 437.76L359.11 509.04C359 509.61 359.37 510.15 359.94 510.26C360.51 510.37 361.05 510 361.16 509.43V509.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M507.14 502.88L544.71 488.08C545.25 487.87 545.51 487.26 545.3 486.73C545.09 486.19 544.48 485.93 543.95 486.14L506.38 500.94C505.84 501.15 505.58 501.76 505.79 502.29C506 502.83 506.61 503.09 507.14 502.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1355.66 549.4L1423.77 593.07C1424.25 593.38 1424.9 593.24 1425.21 592.76C1425.52 592.28 1425.38 591.63 1424.9 591.32L1356.79 547.65C1356.31 547.34 1355.66 547.48 1355.35 547.96C1355.04 548.44 1355.18 549.09 1355.66 549.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1498.93 477L1475.67 468.2C1475.13 468 1474.53 468.27 1474.33 468.81C1474.13 469.35 1474.4 469.95 1474.94 470.15L1498.2 478.95C1498.74 479.15 1499.34 478.88 1499.55 478.34C1499.76 477.8 1499.48 477.2 1498.94 476.99L1498.93 477Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M361.11 509.59L393.26 418.99C393.44 418.44 393.14 417.85 392.59 417.68C392.06 417.51 391.49 417.78 391.29 418.3L359.14 508.9C358.96 509.45 359.26 510.04 359.81 510.21C360.34 510.38 360.91 510.11 361.11 509.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1492.38 559.77L1523.6 596.4C1523.99 596.82 1524.65 596.84 1525.07 596.45C1525.47 596.08 1525.51 595.47 1525.18 595.05L1493.97 558.42C1493.6 557.98 1492.94 557.93 1492.5 558.3C1492.06 558.67 1492.01 559.33 1492.38 559.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1418.26 626.69L1450.49 675.53C1450.82 676 1451.47 676.12 1451.94 675.79C1452.4 675.47 1452.52 674.85 1452.23 674.38L1420 625.54C1419.68 625.06 1419.03 624.93 1418.55 625.25C1418.07 625.57 1417.94 626.21 1418.26 626.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M602.78 562.5L547.39 536.59C546.87 536.35 546.25 536.57 546 537.09C545.76 537.61 545.98 538.23 546.5 538.48L601.89 564.39C602.41 564.63 603.03 564.41 603.28 563.89C603.53 563.37 603.3 562.75 602.78 562.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1524.41 594.68L1472.6 593.53C1472.02 593.53 1471.56 594 1471.56 594.57C1471.56 595.13 1472 595.59 1472.56 595.61L1524.37 596.76C1524.95 596.76 1525.41 596.29 1525.41 595.71C1525.41 595.15 1524.97 594.7 1524.41 594.67V594.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M672.14 640.51L689.41 623.85C689.82 623.45 689.84 622.79 689.44 622.38C689.04 621.97 688.38 621.95 687.97 622.35L670.69 639.01C670.28 639.41 670.26 640.07 670.66 640.48C671.06 640.89 671.72 640.91 672.13 640.51H672.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M274.51 652.01L266.84 564.23C266.78 563.66 266.26 563.24 265.69 563.31C265.13 563.37 264.72 563.86 264.76 564.42L272.43 652.2C272.49 652.77 273.01 653.19 273.58 653.13C274.14 653.07 274.55 652.58 274.51 652.02V652.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M265.23 563.45L195.27 610.21C194.79 610.53 194.66 611.18 194.98 611.66C195.3 612.14 195.95 612.27 196.43 611.95L266.39 565.19C266.86 564.86 266.97 564.21 266.63 563.74C266.31 563.29 265.7 563.17 265.23 563.46V563.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1493 560.12L1553.73 570.14C1554.3 570.24 1554.84 569.85 1554.93 569.28C1555.02 568.71 1554.64 568.17 1554.07 568.08L1493.34 558.06C1492.77 557.96 1492.23 558.35 1492.14 558.92C1492.05 559.49 1492.43 560.03 1493 560.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M631.28 439.09L615.47 371.59C615.34 371.03 614.78 370.68 614.22 370.81C613.66 370.94 613.31 371.5 613.44 372.06L629.25 439.56C629.39 440.12 629.96 440.46 630.52 440.31C631.06 440.17 631.4 439.63 631.28 439.08V439.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M705.68 428.3L692.23 440.55C691.8 440.94 691.77 441.6 692.16 442.02C692.55 442.45 693.21 442.48 693.63 442.09L707.08 429.84C707.51 429.45 707.54 428.79 707.15 428.37C706.76 427.94 706.1 427.91 705.68 428.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1419.66 627.01L1473.12 595.47C1473.62 595.18 1473.78 594.54 1473.49 594.04C1473.2 593.54 1472.56 593.38 1472.06 593.67L1418.6 625.21C1418.11 625.51 1417.96 626.16 1418.27 626.65C1418.56 627.12 1419.18 627.28 1419.66 627.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M272.45 652.27L284.12 719.88C284.22 720.45 284.76 720.83 285.32 720.73C285.88 720.63 286.27 720.09 286.17 719.53L274.5 651.92C274.4 651.35 273.86 650.97 273.29 651.07C272.72 651.17 272.34 651.71 272.44 652.28L272.45 652.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M642.52 490.88L693.65 442.08C694.07 441.68 694.08 441.02 693.68 440.61C693.28 440.19 692.62 440.18 692.21 440.58L641.08 489.38C640.66 489.78 640.65 490.44 641.05 490.85C641.45 491.27 642.11 491.28 642.52 490.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M603.27 562.98L561.68 477.98C561.42 477.47 560.79 477.27 560.28 477.53C559.78 477.79 559.58 478.39 559.81 478.89L601.4 563.89C601.65 564.41 602.28 564.62 602.79 564.37C603.31 564.12 603.52 563.49 603.27 562.97V562.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1553.58 568.12L1472.27 593.58C1471.72 593.75 1471.41 594.34 1471.59 594.89C1471.77 595.44 1472.35 595.75 1472.9 595.57L1554.21 570.11C1554.76 569.94 1555.06 569.35 1554.89 568.8C1554.72 568.25 1554.13 567.95 1553.58 568.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M413.83 396.24L373.15 437.23C372.75 437.65 372.76 438.31 373.18 438.7C373.59 439.09 374.23 439.09 374.63 438.7L415.31 397.71C415.72 397.3 415.71 396.64 415.31 396.24C414.9 395.83 414.24 395.84 413.84 396.24H413.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M707.16 429.77L733.19 400.83C733.57 400.39 733.52 399.74 733.09 399.36C732.67 398.99 732.03 399.03 731.64 399.44L705.61 428.38C705.23 428.81 705.28 429.47 705.71 429.85C706.13 430.22 706.77 430.18 707.16 429.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M559.74 478.2L545.94 537.29C545.81 537.85 546.16 538.41 546.72 538.54C547.28 538.67 547.84 538.32 547.97 537.76L561.77 478.67C561.9 478.11 561.55 477.55 560.99 477.42C560.43 477.29 559.87 477.64 559.74 478.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1317.93 641.15L1332.98 647.61C1333.51 647.83 1334.12 647.58 1334.34 647.04C1334.55 646.52 1334.32 645.92 1333.8 645.69L1318.75 639.23C1318.22 639 1317.61 639.25 1317.38 639.78C1317.15 640.31 1317.4 640.92 1317.93 641.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M629.75 438.42L560.24 477.53C559.74 477.82 559.58 478.46 559.87 478.96C560.15 479.44 560.77 479.61 561.26 479.35L630.77 440.24C631.27 439.96 631.45 439.32 631.17 438.82C630.89 438.32 630.25 438.14 629.75 438.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1256.98 476.58L1272.82 550.85C1272.94 551.41 1273.5 551.77 1274.06 551.64C1274.62 551.52 1274.97 550.97 1274.86 550.41L1259.02 476.14C1258.9 475.58 1258.34 475.22 1257.78 475.35C1257.22 475.47 1256.87 476.02 1256.98 476.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M413.84 396.22L391.56 417.89C391.16 418.3 391.17 418.96 391.58 419.36C391.98 419.75 392.6 419.75 393.01 419.38L415.29 397.71C415.7 397.3 415.7 396.64 415.29 396.24C414.89 395.84 414.24 395.83 413.83 396.22H413.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1448.81 582.08L1423.97 591.21C1423.43 591.42 1423.16 592.02 1423.37 592.56C1423.57 593.09 1424.16 593.36 1424.69 593.17L1449.53 584.04C1450.07 583.83 1450.34 583.23 1450.13 582.69C1449.93 582.16 1449.34 581.89 1448.81 582.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M662.26 625.96L688.77 624.13C689.34 624.09 689.78 623.59 689.74 623.02C689.7 622.45 689.2 622.01 688.63 622.05L662.12 623.88C661.55 623.93 661.12 624.43 661.17 625.01C661.22 625.57 661.7 625.99 662.26 625.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M306.53 407.51L373.44 438.9C373.96 439.14 374.58 438.92 374.83 438.4C375.08 437.88 374.85 437.26 374.33 437.01L307.42 405.62C306.89 405.39 306.28 405.63 306.05 406.16C305.83 406.67 306.05 407.26 306.54 407.51H306.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M662.93 624.19L603.08 562.71C602.67 562.3 602.01 562.3 601.61 562.71C601.21 563.11 601.2 563.76 601.59 564.17L661.44 625.65C661.85 626.06 662.51 626.06 662.91 625.65C663.31 625.25 663.32 624.6 662.93 624.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1350.17 713.75L1319.3 639.79C1319.08 639.26 1318.47 639.01 1317.94 639.23C1317.41 639.45 1317.16 640.06 1317.38 640.59L1348.25 714.55C1348.49 715.08 1349.1 715.31 1349.63 715.07C1350.14 714.84 1350.37 714.26 1350.18 713.74L1350.17 713.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M506.07 502.69L546.26 538.31C546.7 538.69 547.35 538.64 547.73 538.2C548.1 537.77 548.06 537.13 547.64 536.75L507.45 501.13C507.01 500.75 506.36 500.8 505.98 501.24C505.61 501.67 505.65 502.31 506.07 502.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M489.08 418.76L560.07 479.23C560.51 479.6 561.17 479.53 561.54 479.09C561.9 478.66 561.85 478.01 561.42 477.64L490.43 417.17C489.99 416.8 489.33 416.85 488.96 417.29C488.59 417.73 488.64 418.39 489.08 418.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M645.2 697.5L689.59 623.63C689.88 623.13 689.71 622.49 689.21 622.21C688.72 621.93 688.1 622.08 687.8 622.56L643.41 696.43C643.11 696.92 643.27 697.56 643.77 697.86C644.27 698.16 644.9 698 645.2 697.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M601.31 563.25L584.8 650.24C584.69 650.81 585.06 651.35 585.63 651.46C586.2 651.57 586.74 651.2 586.85 650.63L603.36 563.64C603.47 563.07 603.1 562.53 602.53 562.42C601.96 562.31 601.42 562.68 601.31 563.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M273.96 651.17L196.33 610.15C195.82 609.89 195.19 610.1 194.93 610.61C194.68 611.11 194.87 611.72 195.36 611.99L272.99 653.01C273.5 653.28 274.13 653.08 274.4 652.57C274.67 652.06 274.47 651.43 273.96 651.16V651.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M691.17 426.37L691.9 441.38C691.94 441.95 692.44 442.39 693.02 442.34C693.57 442.3 694 441.83 693.99 441.28L693.26 426.27C693.23 425.69 692.74 425.25 692.17 425.28C691.59 425.31 691.15 425.8 691.18 426.37H691.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M306.83 407.6L392.14 419.67C392.71 419.75 393.24 419.35 393.32 418.78C393.4 418.21 393 417.68 392.43 417.6L307.12 405.53C306.55 405.46 306.03 405.86 305.96 406.44C305.89 407 306.28 407.51 306.83 407.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M661.3 625.47L670.53 640.31C670.83 640.8 671.48 640.95 671.97 640.65C672.46 640.35 672.61 639.7 672.31 639.21L663.08 624.37C662.78 623.88 662.13 623.73 661.64 624.04C661.15 624.34 661 624.99 661.31 625.48L661.3 625.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1233.06 413.07L1257.02 476.73C1257.22 477.27 1257.82 477.54 1258.36 477.34C1258.9 477.14 1259.17 476.54 1258.97 476L1235.01 412.34C1234.79 411.81 1234.19 411.55 1233.65 411.76C1233.13 411.97 1232.87 412.55 1233.06 413.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1233.16 412.14L1192.02 477C1191.72 477.49 1191.87 478.13 1192.36 478.44C1192.84 478.74 1193.48 478.6 1193.79 478.12L1234.93 413.26C1235.24 412.77 1235.09 412.13 1234.6 411.82C1234.12 411.52 1233.48 411.66 1233.17 412.14H1233.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M507.17 502.87L561.16 479.4C561.69 479.17 561.93 478.56 561.7 478.03C561.47 477.5 560.86 477.26 560.33 477.49L506.34 500.96C505.81 501.19 505.57 501.8 505.8 502.33C506.03 502.86 506.64 503.1 507.17 502.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M507.78 501.71L490.78 417.77C490.66 417.21 490.1 416.85 489.54 416.97C488.99 417.09 488.63 417.63 488.74 418.18L505.74 502.12C505.86 502.68 506.42 503.04 506.98 502.92C507.53 502.8 507.89 502.26 507.78 501.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M585.95 651.47L671.54 640.79C672.11 640.7 672.5 640.17 672.42 639.6C672.34 639.05 671.84 638.66 671.29 638.72L585.69 649.4C585.12 649.47 584.71 649.99 584.78 650.56C584.85 651.13 585.37 651.54 585.94 651.47H585.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1492.68 558.18L1448.67 582.15C1448.17 582.43 1447.99 583.07 1448.27 583.57C1448.55 584.06 1449.17 584.25 1449.67 583.98L1493.67 560.01C1494.16 559.71 1494.31 559.06 1494.01 558.57C1493.73 558.12 1493.16 557.95 1492.68 558.17V558.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M670.48 639.31L643.37 696.52C643.14 697.05 643.37 697.66 643.9 697.9C644.41 698.13 645.01 697.91 645.26 697.42L672.37 640.21C672.6 639.68 672.37 639.07 671.84 638.83C671.33 638.6 670.73 638.82 670.48 639.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1525.09 596.49L1554.59 569.88C1555.02 569.49 1555.05 568.83 1554.67 568.41C1554.29 567.99 1553.62 567.95 1553.2 568.33L1523.7 594.94C1523.27 595.33 1523.24 595.99 1523.62 596.41C1524.01 596.84 1524.67 596.87 1525.09 596.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M603.26 563.94L642.73 490.62C643 490.11 642.8 489.48 642.3 489.21C641.8 488.94 641.17 489.13 640.9 489.63L601.43 562.95C601.16 563.46 601.35 564.09 601.86 564.36C602.37 564.63 603 564.44 603.27 563.94H603.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1468.02 632.82L1450.4 674.55C1450.18 675.08 1450.42 675.69 1450.96 675.92C1451.49 676.14 1452.1 675.89 1452.33 675.36L1469.95 633.63C1470.17 633.1 1469.93 632.49 1469.39 632.26C1468.86 632.04 1468.25 632.28 1468.02 632.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M706.25 428.04L630.13 438.3C629.56 438.38 629.17 438.91 629.25 439.48C629.33 440.04 629.85 440.44 630.41 440.37L706.53 430.11C707.1 430.03 707.5 429.51 707.42 428.94C707.34 428.37 706.82 427.97 706.25 428.05V428.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M705.34 429.1L707.16 493.97C707.18 494.55 707.67 494.99 708.25 494.97C708.81 494.95 709.26 494.48 709.25 493.91L707.43 429.04C707.41 428.46 706.92 428.02 706.34 428.04C705.78 428.06 705.33 428.53 705.34 429.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1414.16 445.91L1474.92 470.15C1475.46 470.35 1476.06 470.07 1476.26 469.53C1476.45 469.01 1476.2 468.43 1475.69 468.21L1414.93 443.97C1414.39 443.77 1413.79 444.05 1413.59 444.59C1413.4 445.11 1413.65 445.69 1414.16 445.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1523.98 596.68L1571.53 617.39C1572.07 617.58 1572.67 617.3 1572.86 616.76C1573.04 616.27 1572.82 615.72 1572.35 615.48L1524.81 594.77C1524.28 594.54 1523.67 594.79 1523.44 595.32C1523.22 595.84 1523.45 596.45 1523.97 596.68H1523.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1401.98 420.06L1474.72 470.03C1475.19 470.36 1475.84 470.24 1476.17 469.76C1476.5 469.29 1476.38 468.64 1475.9 468.31L1403.16 418.34C1402.68 418.02 1402.03 418.15 1401.71 418.62C1401.39 419.09 1401.51 419.73 1401.98 420.05V420.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M738.77 688.74L689.53 622.47C689.19 622.01 688.53 621.91 688.07 622.25C687.61 622.59 687.51 623.25 687.85 623.71L737.09 689.98C737.44 690.44 738.09 690.53 738.55 690.18C739 689.84 739.09 689.2 738.76 688.74H738.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M490.04 416.97L414.85 395.97C414.3 395.82 413.72 396.14 413.57 396.69C413.42 397.24 413.74 397.82 414.29 397.97L489.48 418.97C490.04 419.12 490.61 418.78 490.75 418.23C490.89 417.69 490.58 417.13 490.04 416.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M629.25 439.56L640.79 490.35C640.92 490.91 641.48 491.26 642.04 491.14C642.6 491.01 642.95 490.45 642.83 489.89L631.29 439.1C631.16 438.54 630.6 438.19 630.04 438.31C629.48 438.44 629.13 439 629.25 439.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M708.27 492.9L641.87 489.08C641.3 489.05 640.8 489.49 640.77 490.06C640.74 490.63 641.18 491.13 641.75 491.16L708.15 494.98C708.72 495.01 709.22 494.57 709.25 494C709.28 493.42 708.84 492.93 708.27 492.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1448.71 584L1472.12 595.51C1472.64 595.76 1473.26 595.55 1473.52 595.03C1473.77 594.51 1473.56 593.89 1473.04 593.63L1449.63 582.12C1449.11 581.87 1448.49 582.08 1448.24 582.6C1447.99 583.11 1448.2 583.73 1448.71 583.99V584Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1471.55 594.48L1467.94 633.13C1467.9 633.7 1468.33 634.2 1468.91 634.24C1469.47 634.28 1469.96 633.87 1470.02 633.32L1473.63 594.67C1473.67 594.1 1473.24 593.6 1472.67 593.55C1472.11 593.51 1471.62 593.92 1471.56 594.47L1471.55 594.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M359.1 509.08L350.74 562.72C350.66 563.29 351.05 563.82 351.62 563.9C352.18 563.98 352.7 563.6 352.8 563.04L361.16 509.4C361.24 508.83 360.85 508.3 360.28 508.22C359.72 508.14 359.2 508.52 359.1 509.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M738.56 688.53L672.04 638.92C671.57 638.59 670.92 638.7 670.59 639.17C670.27 639.62 670.36 640.25 670.8 640.59L737.32 690.2C737.78 690.54 738.44 690.45 738.78 689.99C739.12 689.53 739.03 688.87 738.57 688.53H738.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1426.37 703.81L1420.16 626.03C1420.11 625.46 1419.61 625.03 1419.04 625.07C1418.47 625.12 1418.04 625.62 1418.08 626.19L1424.29 703.97C1424.34 704.54 1424.84 704.97 1425.41 704.93C1425.98 704.88 1426.41 704.38 1426.37 703.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M560.6 479.47L641.65 491.15C642.22 491.23 642.75 490.84 642.83 490.27C642.91 489.7 642.52 489.17 641.95 489.09L560.9 477.41C560.33 477.34 559.81 477.75 559.74 478.32C559.67 478.87 560.05 479.38 560.6 479.48V479.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M661.86 623.93L585.5 649.45C584.95 649.63 584.66 650.22 584.84 650.77C585.02 651.32 585.61 651.61 586.16 651.43L662.52 625.91C663.07 625.73 663.36 625.14 663.18 624.59C663 624.04 662.41 623.75 661.86 623.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M661.17 624.67L643.29 696.72C643.16 697.28 643.5 697.84 644.06 697.98C644.61 698.11 645.17 697.78 645.31 697.23L663.19 625.18C663.32 624.62 662.98 624.06 662.42 623.92C661.87 623.79 661.31 624.12 661.17 624.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1356.19 547.48L1273.81 549.59C1273.23 549.62 1272.79 550.1 1272.81 550.68C1272.83 551.24 1273.3 551.68 1273.86 551.68L1356.24 549.57C1356.82 549.56 1357.27 549.08 1357.26 548.5C1357.25 547.92 1356.77 547.47 1356.19 547.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1357.73 620.69L1332.66 645.91C1332.27 646.33 1332.29 646.99 1332.71 647.38C1333.11 647.76 1333.74 647.75 1334.14 647.38L1359.21 622.16C1359.62 621.75 1359.61 621.09 1359.21 620.69C1358.8 620.28 1358.14 620.29 1357.74 620.69H1357.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M585.17 651.25L643.65 697.78C644.1 698.14 644.76 698.06 645.12 697.61C645.48 697.16 645.4 696.5 644.95 696.14L586.47 649.61C586.01 649.26 585.36 649.34 585.01 649.8C584.66 650.25 584.74 650.89 585.17 651.24V651.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M359.22 509.74L394.71 575.07C394.99 575.58 395.62 575.76 396.12 575.49C396.63 575.21 396.81 574.58 396.54 574.08L361.05 508.75C360.77 508.24 360.14 508.06 359.64 508.33C359.13 508.6 358.95 509.24 359.22 509.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M630.48 440.35L692.42 427.34C692.98 427.21 693.33 426.65 693.2 426.09C693.07 425.54 692.54 425.19 691.99 425.3L630.05 438.31C629.49 438.44 629.14 439 629.27 439.56C629.4 440.11 629.93 440.46 630.48 440.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M709.22 493.7L693.22 426.08C693.08 425.52 692.51 425.18 691.96 425.32C691.41 425.46 691.07 426.01 691.2 426.56L707.2 494.18C707.34 494.74 707.9 495.08 708.46 494.94C709.01 494.8 709.35 494.25 709.23 493.7H709.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M484.23 550.04L547.13 538.56C547.7 538.46 548.07 537.91 547.97 537.35C547.87 536.78 547.32 536.41 546.76 536.51L483.86 547.99C483.29 548.09 482.92 548.64 483.02 549.2C483.12 549.77 483.67 550.14 484.23 550.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M342.91 409.96L373.17 438.72C373.59 439.11 374.25 439.08 374.64 438.66C375.02 438.25 375 437.61 374.6 437.21L344.34 408.45C343.92 408.05 343.26 408.07 342.87 408.49C342.47 408.91 342.49 409.57 342.91 409.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1524.56 594.69L1449.35 582.03C1448.78 581.94 1448.25 582.33 1448.16 582.9C1448.07 583.46 1448.45 583.98 1449 584.08L1524.22 596.74C1524.79 596.82 1525.32 596.43 1525.4 595.86C1525.48 595.31 1525.11 594.79 1524.56 594.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1523.81 594.86L1468.4 632.36C1467.92 632.68 1467.8 633.33 1468.12 633.81C1468.44 634.29 1469.09 634.41 1469.57 634.09L1524.98 596.59C1525.45 596.25 1525.55 595.6 1525.22 595.14C1524.9 594.69 1524.28 594.57 1523.81 594.87V594.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M343.43 410.22L392.09 419.66C392.66 419.76 393.2 419.38 393.3 418.81C393.4 418.26 393.04 417.73 392.49 417.61L343.83 408.17C343.26 408.07 342.72 408.45 342.62 409.02C342.52 409.57 342.88 410.1 343.43 410.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1419.31 625.09L1415.08 624.34C1414.51 624.25 1413.98 624.64 1413.89 625.21C1413.8 625.76 1414.17 626.29 1414.72 626.4L1418.95 627.15C1419.52 627.25 1420.06 626.87 1420.16 626.31C1420.26 625.74 1419.88 625.2 1419.31 625.1V625.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M570.7 527.62L601.54 564.12C601.93 564.55 602.58 564.58 603.01 564.2C603.42 563.83 603.47 563.21 603.13 562.78L572.29 526.28C571.9 525.85 571.24 525.82 570.82 526.2C570.41 526.57 570.36 527.19 570.7 527.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1419.98 626.71L1450.02 583.66C1450.35 583.19 1450.23 582.54 1449.76 582.21C1449.29 581.88 1448.64 582 1448.31 582.47L1418.27 625.52C1417.95 626 1418.08 626.65 1418.56 626.97C1419.02 627.28 1419.65 627.17 1419.98 626.72V626.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1418.98 627.15L1468.83 634.26C1469.4 634.34 1469.93 633.94 1470.01 633.37C1470.09 632.8 1469.69 632.28 1469.13 632.19L1419.28 625.08C1418.71 625 1418.18 625.4 1418.11 625.97C1418.03 626.54 1418.42 627.06 1418.99 627.14L1418.98 627.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M585.63 649.41L550.21 656.11C549.65 656.23 549.28 656.78 549.4 657.34C549.51 657.89 550.04 658.25 550.6 658.16L586.02 651.46C586.58 651.35 586.95 650.8 586.84 650.23C586.73 649.67 586.19 649.31 585.64 649.41H585.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1419.21 625.07L1358.55 620.38C1357.98 620.34 1357.48 620.77 1357.44 621.35C1357.4 621.92 1357.82 622.41 1358.39 622.46L1419.05 627.15C1419.62 627.19 1420.12 626.76 1420.16 626.18C1420.2 625.61 1419.78 625.12 1419.21 625.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M728.88 550.91L709.2 493.6C709 493.06 708.4 492.78 707.86 492.98C707.33 493.17 707.06 493.75 707.23 494.28L726.91 551.59C727.11 552.13 727.71 552.4 728.25 552.2C728.77 552.01 729.05 551.44 728.88 550.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1358.02 620.48L1317.9 639.24C1317.39 639.5 1317.18 640.12 1317.43 640.64C1317.68 641.14 1318.27 641.35 1318.78 641.13L1358.9 622.37C1359.42 622.13 1359.65 621.51 1359.4 620.98C1359.16 620.46 1358.54 620.23 1358.01 620.48H1358.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M571.09 525.99L546.54 536.58C546.02 536.82 545.79 537.44 546.02 537.96C546.25 538.47 546.84 538.7 547.36 538.49L571.91 527.9C572.43 527.66 572.66 527.04 572.42 526.52C572.19 526.01 571.6 525.78 571.08 525.99H571.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M505.82 501.46L483.11 548.56C482.86 549.08 483.08 549.7 483.6 549.95C484.12 550.2 484.74 549.98 484.99 549.46L507.7 502.36C507.95 501.84 507.73 501.22 507.21 500.97C506.69 500.72 506.07 500.94 505.82 501.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1524 596.69L1570.35 615.51C1570.89 615.71 1571.49 615.43 1571.69 614.89C1571.88 614.37 1571.64 613.8 1571.13 613.58L1524.78 594.76C1524.24 594.56 1523.64 594.84 1523.44 595.38C1523.25 595.9 1523.49 596.47 1524 596.7V596.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1407.5 399.41L1413.51 445.07C1413.59 445.64 1414.11 446.04 1414.68 445.97C1415.25 445.89 1415.65 445.37 1415.58 444.8L1409.57 399.14C1409.49 398.57 1408.97 398.17 1408.4 398.24C1407.83 398.32 1407.43 398.84 1407.5 399.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1407.54 398.98L1401.57 418.9C1401.42 419.46 1401.75 420.03 1402.31 420.18C1402.84 420.32 1403.4 420.03 1403.57 419.5L1409.54 399.58C1409.71 399.03 1409.39 398.45 1408.84 398.28C1408.29 398.11 1407.71 398.43 1407.54 398.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1355.18 548.55L1357.43 621.46C1357.45 622.04 1357.93 622.49 1358.51 622.47C1359.08 622.45 1359.53 621.97 1359.52 621.4L1357.27 548.49C1357.25 547.91 1356.77 547.46 1356.19 547.48C1355.62 547.5 1355.17 547.98 1355.18 548.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1415.49 444.5L1403.51 418.76C1403.26 418.24 1402.64 418.02 1402.12 418.27C1401.61 418.52 1401.39 419.12 1401.62 419.64L1413.6 445.38C1413.85 445.9 1414.47 446.12 1414.99 445.87C1415.5 445.62 1415.72 445.02 1415.49 444.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M572.52 526.72L561.77 478.21C561.63 477.65 561.07 477.31 560.51 477.45C559.97 477.58 559.63 478.12 559.74 478.66L570.49 527.17C570.61 527.73 571.17 528.09 571.73 527.96C572.29 527.84 572.65 527.28 572.52 526.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1426.37 703.76L1415.93 625.23C1415.85 624.66 1415.33 624.26 1414.76 624.33C1414.19 624.4 1413.79 624.93 1413.86 625.5L1424.3 704.03C1424.38 704.6 1424.9 705 1425.47 704.93C1426.04 704.86 1426.44 704.33 1426.37 703.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1426.22 704.44L1469.87 633.77C1470.17 633.28 1470.02 632.64 1469.53 632.33C1469.04 632.03 1468.4 632.18 1468.09 632.67L1424.45 703.34C1424.16 703.84 1424.32 704.48 1424.82 704.77C1425.3 705.05 1425.92 704.91 1426.22 704.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1010.06 405.43L1075.73 376.96C1076.26 376.72 1076.49 376.11 1076.25 375.58C1076.02 375.07 1075.42 374.83 1074.9 375.05L1009.23 403.52C1008.7 403.75 1008.46 404.36 1008.69 404.89C1008.92 405.42 1009.53 405.66 1010.06 405.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1420.14 625.86L1405.52 567.61C1405.38 567.05 1404.81 566.71 1404.26 566.85C1403.7 566.99 1403.36 567.56 1403.5 568.11L1418.12 626.36C1418.26 626.92 1418.83 627.26 1419.38 627.12C1419.94 626.98 1420.28 626.41 1420.14 625.85V625.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M706.59 428.05L692.41 425.29C691.84 425.19 691.3 425.56 691.2 426.13C691.1 426.69 691.46 427.22 692.01 427.34L706.19 430.1C706.76 430.2 707.3 429.83 707.4 429.26C707.5 428.7 707.14 428.17 706.59 428.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M750.62 456.51L707.53 493.14C707.1 493.52 707.05 494.18 707.43 494.61C707.8 495.04 708.45 495.09 708.88 494.73L751.97 458.1C752.4 457.71 752.43 457.06 752.05 456.63C751.68 456.22 751.05 456.17 750.62 456.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M506.38 502.88L571.12 527.91C571.66 528.12 572.26 527.85 572.47 527.31C572.68 526.77 572.41 526.17 571.87 525.96L507.13 500.93C506.59 500.73 505.99 501.01 505.8 501.56C505.61 502.08 505.87 502.67 506.38 502.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M582.53 674.35L586.85 650.63C586.95 650.06 586.58 649.52 586.01 649.42C585.44 649.32 584.9 649.69 584.8 650.26L580.48 673.98C580.39 674.55 580.78 675.08 581.35 675.17C581.9 675.26 582.42 674.9 582.53 674.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1134.45 672.25L1163.16 614.29C1163.41 613.77 1163.2 613.15 1162.68 612.9C1162.17 612.65 1161.55 612.86 1161.29 613.37L1132.58 671.33C1132.34 671.85 1132.56 672.47 1133.08 672.72C1133.59 672.96 1134.19 672.75 1134.45 672.26V672.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M581.15 675.14L643.95 697.95C644.49 698.15 645.09 697.87 645.29 697.33C645.49 696.79 645.21 696.19 644.67 695.99L581.87 673.18C581.33 672.98 580.73 673.26 580.53 673.8C580.33 674.34 580.61 674.94 581.15 675.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1355.83 549.49L1404.11 568.83C1404.64 569.04 1405.25 568.78 1405.47 568.25C1405.68 567.72 1405.42 567.11 1404.89 566.89L1356.61 547.55C1356.07 547.35 1355.47 547.62 1355.27 548.16C1355.07 548.68 1355.32 549.27 1355.84 549.49H1355.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M691.39 425.67L640.99 489.47C640.64 489.93 640.72 490.58 641.18 490.93C641.63 491.28 642.27 491.2 642.63 490.76L693.03 426.96C693.39 426.51 693.31 425.85 692.86 425.5C692.41 425.14 691.75 425.22 691.4 425.67H691.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1382.6 588.73L1418.37 626.83C1418.77 627.25 1419.43 627.27 1419.84 626.87C1420.26 626.48 1420.28 625.82 1419.89 625.4L1384.12 587.3C1383.71 586.89 1383.05 586.89 1382.65 587.3C1382.26 587.69 1382.24 588.32 1382.6 588.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1058.13 596.84L1024.96 681C1024.75 681.54 1025.01 682.14 1025.55 682.35C1026.09 682.56 1026.69 682.3 1026.9 681.76L1060.07 597.6C1060.28 597.06 1060.02 596.46 1059.48 596.25C1058.94 596.04 1058.34 596.3 1058.13 596.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1384.22 587.43L1357.08 547.93C1356.74 547.46 1356.09 547.36 1355.62 547.7C1355.17 548.03 1355.06 548.65 1355.36 549.11L1382.5 588.61C1382.84 589.08 1383.49 589.18 1383.96 588.84C1384.41 588.51 1384.52 587.89 1384.22 587.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M549.53 656.56L504.44 725.81C504.13 726.3 504.28 726.94 504.76 727.25C505.24 727.55 505.87 727.42 506.18 726.95L551.27 657.7C551.58 657.22 551.45 656.57 550.97 656.26C550.49 655.95 549.84 656.08 549.53 656.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M249.15 616.08L272.59 652.66C272.9 653.14 273.55 653.28 274.03 652.97C274.51 652.66 274.65 652.02 274.34 651.54L250.9 614.96C250.59 614.48 249.94 614.33 249.46 614.64C248.98 614.95 248.83 615.6 249.14 616.08H249.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M250.12 614.48L195.94 610.03C195.37 609.99 194.87 610.43 194.83 611C194.79 611.56 195.21 612.05 195.77 612.11L249.95 616.56C250.52 616.6 251.02 616.16 251.06 615.58C251.1 615.02 250.68 614.53 250.12 614.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1214.52 651.13L1162.84 612.99C1162.37 612.66 1161.72 612.77 1161.39 613.24C1161.07 613.7 1161.16 614.32 1161.6 614.66L1213.28 652.8C1213.75 653.13 1214.4 653.02 1214.73 652.55C1215.05 652.09 1214.96 651.47 1214.52 651.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M414.39 395.94L343.45 408.17C342.88 408.27 342.5 408.81 342.6 409.37C342.7 409.94 343.24 410.32 343.8 410.22L414.74 397.99C415.31 397.89 415.69 397.35 415.59 396.79C415.49 396.22 414.95 395.84 414.39 395.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M934.05 427.59L893.72 390.21C893.3 389.82 892.64 389.84 892.25 390.27C891.86 390.7 891.88 391.35 892.31 391.74L932.64 429.12C933.07 429.5 933.73 429.47 934.11 429.04C934.49 428.62 934.46 427.98 934.05 427.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M582.01 673.24L550.91 656.21C550.4 655.94 549.77 656.14 549.5 656.66C549.24 657.15 549.42 657.76 549.9 658.04L581 675.07C581.51 675.35 582.14 675.16 582.42 674.66C582.7 674.16 582.51 673.52 582.01 673.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1448.36 582.41L1414.09 624.71C1413.73 625.16 1413.8 625.81 1414.24 626.18C1414.68 626.55 1415.34 626.47 1415.71 626.03L1449.98 583.73C1450.34 583.28 1450.27 582.63 1449.82 582.26C1449.37 581.9 1448.72 581.97 1448.36 582.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1414.75 626.4L1468.83 634.26C1469.4 634.34 1469.92 633.93 1470 633.36C1470.07 632.8 1469.69 632.28 1469.13 632.19L1415.05 624.33C1414.48 624.25 1413.96 624.66 1413.88 625.23C1413.81 625.79 1414.19 626.31 1414.75 626.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1448.2 583.45L1468.01 633.61C1468.23 634.14 1468.83 634.4 1469.37 634.19C1469.9 633.98 1470.16 633.38 1469.95 632.85L1450.14 582.69C1449.93 582.15 1449.32 581.89 1448.79 582.11C1448.26 582.32 1448 582.93 1448.21 583.46L1448.2 583.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.5 563.88L395.36 575.57C395.92 575.72 396.49 575.39 396.64 574.83C396.79 574.27 396.46 573.7 395.9 573.55L352.04 561.86C351.48 561.72 350.92 562.06 350.78 562.62C350.64 563.17 350.97 563.72 351.51 563.87L351.5 563.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M571.99 527.87L642.29 491.04C642.8 490.77 643 490.14 642.73 489.63C642.46 489.12 641.83 488.92 641.32 489.19L571.02 526.02C570.51 526.29 570.31 526.92 570.58 527.43C570.85 527.94 571.48 528.14 571.99 527.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1413.86 625.31L1410.12 701.08C1410.09 701.66 1410.53 702.14 1411.11 702.17C1411.69 702.2 1412.17 701.76 1412.2 701.18L1415.94 625.41C1415.97 624.83 1415.53 624.35 1414.95 624.32C1414.37 624.29 1413.89 624.73 1413.86 625.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1468.18 632.55L1410.36 700.46C1409.99 700.9 1410.04 701.56 1410.48 701.93C1410.92 702.3 1411.58 702.25 1411.95 701.81L1469.77 633.9C1470.14 633.46 1470.09 632.8 1469.65 632.43C1469.21 632.06 1468.55 632.11 1468.18 632.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1414.97 624.32L1358.54 620.38C1357.97 620.35 1357.47 620.79 1357.44 621.36C1357.41 621.92 1357.83 622.41 1358.39 622.46L1414.82 626.4C1415.4 626.43 1415.89 625.99 1415.92 625.42C1415.95 624.86 1415.53 624.37 1414.97 624.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M776.66 600.97L823.74 572.38C824.23 572.07 824.37 571.43 824.06 570.94C823.76 570.47 823.14 570.32 822.66 570.6L775.58 599.19C775.09 599.5 774.95 600.14 775.26 600.63C775.56 601.1 776.18 601.25 776.66 600.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1224.19 590.81L1274.48 551.45C1274.93 551.09 1275.01 550.44 1274.66 549.99C1274.3 549.54 1273.65 549.46 1273.2 549.81L1222.91 589.17C1222.46 589.53 1222.4 590.19 1222.76 590.64C1223.11 591.07 1223.75 591.15 1224.19 590.82V590.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M343.7 408.16L307.05 405.53C306.47 405.51 305.99 405.95 305.96 406.53C305.94 407.08 306.35 407.55 306.9 407.61L343.55 410.24C344.12 410.28 344.62 409.85 344.66 409.27C344.7 408.7 344.27 408.2 343.69 408.16H343.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1214.94 652.13L1224.59 590.15C1224.67 589.58 1224.28 589.05 1223.71 588.97C1223.15 588.89 1222.63 589.27 1222.53 589.83L1212.88 651.81C1212.79 652.38 1213.18 652.91 1213.75 653C1214.32 653.09 1214.85 652.7 1214.94 652.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M705.83 429.96L750.74 458.19C751.23 458.5 751.87 458.35 752.18 457.86C752.49 457.37 752.34 456.73 751.85 456.42L706.94 428.19C706.45 427.88 705.81 428.03 705.5 428.52C705.19 429.01 705.34 429.65 705.83 429.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M787.68 659.16L737.41 688.47C736.91 688.76 736.75 689.4 737.04 689.9C737.33 690.39 737.96 690.56 738.46 690.27L788.73 660.96C789.23 660.67 789.4 660.03 789.1 659.53C788.81 659.03 788.17 658.86 787.67 659.16H787.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M483.76 548.01L395.34 573.56C394.79 573.73 394.48 574.32 394.65 574.87C394.82 575.4 395.37 575.71 395.91 575.57L484.33 550.02C484.88 549.86 485.2 549.28 485.04 548.73C484.88 548.18 484.3 547.86 483.75 548.02L483.76 548.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M585.2 649.6L566.73 663.37C566.28 663.73 566.2 664.38 566.55 664.83C566.89 665.27 567.52 665.36 567.97 665.04L586.44 651.27C586.89 650.91 586.97 650.26 586.62 649.81C586.28 649.37 585.65 649.28 585.2 649.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M875.12 610.62L823.84 570.68C823.38 570.34 822.72 570.44 822.38 570.9C822.05 571.35 822.13 571.97 822.56 572.33L873.84 612.27C874.29 612.62 874.95 612.54 875.3 612.09C875.65 611.64 875.57 610.98 875.12 610.63V610.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1069.28 508.26L1058.06 597.09C1057.99 597.66 1058.39 598.18 1058.96 598.25C1059.53 598.32 1060.05 597.92 1060.12 597.35L1071.34 508.52C1071.4 507.95 1070.99 507.43 1070.41 507.37C1069.85 507.31 1069.35 507.7 1069.27 508.26H1069.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M580.67 674.78L634.26 746.35C634.61 746.81 635.26 746.9 635.72 746.56C636.18 746.22 636.27 745.56 635.93 745.1L582.34 673.53C581.99 673.07 581.34 672.98 580.88 673.32C580.42 673.67 580.33 674.32 580.67 674.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M580.92 673.3L504.72 725.53C504.24 725.86 504.12 726.5 504.45 726.98C504.78 727.46 505.42 727.58 505.9 727.25L582.1 675.02C582.57 674.68 582.68 674.03 582.34 673.57C582.01 673.12 581.39 673 580.92 673.31V673.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1415.92 625.18L1405.52 567.68C1405.41 567.11 1404.86 566.75 1404.3 566.86C1403.75 566.97 1403.38 567.5 1403.47 568.05L1413.87 625.55C1413.98 626.12 1414.53 626.48 1415.09 626.37C1415.64 626.26 1416.01 625.73 1415.92 625.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1449.51 582.08L1404.84 566.88C1404.29 566.71 1403.71 567.01 1403.53 567.56C1403.36 568.09 1403.64 568.66 1404.17 568.85L1448.84 584.05C1449.39 584.22 1449.97 583.92 1450.15 583.37C1450.32 582.84 1450.04 582.27 1449.51 582.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M933.65 429.35L1009.95 405.47C1010.5 405.3 1010.81 404.71 1010.63 404.16C1010.46 403.61 1009.87 403.3 1009.32 403.48L933.02 427.36C932.47 427.53 932.16 428.12 932.34 428.67C932.52 429.22 933.1 429.53 933.65 429.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1359.26 622.11L1405.3 568.54C1405.67 568.1 1405.61 567.44 1405.17 567.07C1404.74 566.71 1404.09 566.76 1403.72 567.18L1357.68 620.75C1357.3 621.19 1357.35 621.84 1357.79 622.22C1358.23 622.6 1358.89 622.55 1359.26 622.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1317.54 519.39L1355.58 549.34C1356.03 549.7 1356.69 549.62 1357.04 549.17C1357.4 548.72 1357.32 548.06 1356.87 547.71L1318.83 517.76C1318.38 517.4 1317.72 517.48 1317.37 517.93C1317.01 518.38 1317.09 519.04 1317.54 519.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M484.3 550.02L571.75 527.95C572.31 527.81 572.65 527.24 572.51 526.68C572.37 526.12 571.8 525.78 571.24 525.92L483.79 547.99C483.23 548.13 482.89 548.7 483.03 549.26C483.17 549.82 483.74 550.16 484.3 550.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1382.56 588.69L1414.1 626.04C1414.47 626.48 1415.13 626.54 1415.57 626.16C1416.01 625.79 1416.07 625.13 1415.69 624.69L1384.15 587.35C1383.77 586.92 1383.11 586.87 1382.68 587.25C1382.26 587.62 1382.2 588.26 1382.56 588.7V588.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1383.44 589.06L1449.25 584.1C1449.82 584.05 1450.24 583.54 1450.19 582.96C1450.14 582.4 1449.65 581.99 1449.09 582.02L1383.28 586.98C1382.71 587.03 1382.29 587.54 1382.34 588.12C1382.39 588.68 1382.88 589.09 1383.44 589.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1138.23 527.73L1070.62 507.4C1070.07 507.24 1069.49 507.57 1069.33 508.12C1069.18 508.66 1069.48 509.23 1070.02 509.4L1137.63 529.73C1138.18 529.89 1138.76 529.56 1138.92 529.01C1139.07 528.47 1138.77 527.9 1138.23 527.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M550 658.1L566.95 665.17C567.49 665.38 568.09 665.11 568.3 664.57C568.5 664.05 568.26 663.47 567.76 663.24L550.81 656.16C550.28 655.94 549.67 656.19 549.45 656.72C549.23 657.25 549.48 657.86 550.01 658.08L550 658.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1136.92 529.01L1161.22 614.12C1161.38 614.67 1161.97 614.99 1162.52 614.82C1163.06 614.66 1163.38 614.09 1163.23 613.55L1138.93 528.44C1138.77 527.89 1138.18 527.57 1137.63 527.74C1137.09 527.9 1136.77 528.47 1136.92 529.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M385.03 548.26L351.38 561.91C350.85 562.13 350.59 562.73 350.81 563.27C351.03 563.8 351.63 564.06 352.17 563.84L385.82 550.19C386.35 549.97 386.6 549.35 386.38 548.82C386.16 548.3 385.57 548.05 385.04 548.25L385.03 548.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1382.53 587.4L1357.63 620.81C1357.29 621.27 1357.38 621.93 1357.84 622.27C1358.3 622.61 1358.96 622.52 1359.3 622.06L1384.2 588.65C1384.54 588.19 1384.45 587.53 1383.99 587.19C1383.53 586.85 1382.87 586.94 1382.53 587.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M789.07 660.65L837.49 589.93C837.81 589.45 837.68 588.8 837.2 588.48C836.73 588.17 836.09 588.28 835.77 588.75L787.35 659.47C787.03 659.95 787.16 660.6 787.64 660.92C788.11 661.23 788.74 661.11 789.07 660.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1063.61 683.98L1060.14 597.18C1060.12 596.6 1059.63 596.16 1059.06 596.18C1058.48 596.2 1058.04 596.69 1058.06 597.26L1061.54 684.06C1061.57 684.63 1062.07 685.07 1062.64 685.04C1063.2 685.01 1063.63 684.54 1063.62 683.98H1063.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1227.71 523.26L1273.29 551.51C1273.78 551.8 1274.42 551.64 1274.72 551.15C1275.01 550.67 1274.86 550.04 1274.39 549.74L1228.81 521.49C1228.32 521.19 1227.68 521.34 1227.37 521.83C1227.06 522.32 1227.22 522.96 1227.71 523.27V523.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M534.8 591.06L549.39 657.35C549.52 657.91 550.08 658.26 550.64 658.13C551.19 658 551.54 657.46 551.42 656.91L536.83 590.62C536.71 590.06 536.15 589.7 535.59 589.83C535.03 589.95 534.67 590.51 534.8 591.07V591.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1317.57 517.72L1273.23 549.78C1272.77 550.13 1272.68 550.78 1273.02 551.24C1273.36 551.69 1273.99 551.79 1274.45 551.47L1318.79 519.41C1319.25 519.06 1319.34 518.41 1318.99 517.95C1318.65 517.51 1318.03 517.41 1317.57 517.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M751.78 456.39L692.69 425.4C692.18 425.14 691.55 425.34 691.29 425.85C691.03 426.35 691.22 426.97 691.72 427.24L750.81 458.23C751.32 458.49 751.95 458.29 752.21 457.77C752.47 457.27 752.27 456.65 751.78 456.38V456.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1223.17 589.02L1161.85 612.86C1161.31 613.07 1161.05 613.67 1161.26 614.21C1161.47 614.75 1162.07 615.01 1162.61 614.8L1223.93 590.96C1224.46 590.74 1224.72 590.13 1224.5 589.6C1224.29 589.08 1223.7 588.82 1223.18 589.02H1223.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M821.29 481.45L822.16 571.51C822.16 572.09 822.64 572.55 823.21 572.54C823.79 572.54 824.25 572.06 824.24 571.49L823.37 481.43C823.37 480.85 822.89 480.39 822.32 480.4C821.74 480.4 821.28 480.88 821.29 481.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M874.11 582.37L873.43 611.42C873.42 612 873.87 612.47 874.45 612.49C875.03 612.5 875.5 612.05 875.52 611.47L876.2 582.42C876.2 581.84 875.74 581.38 875.16 581.38C874.6 581.38 874.14 581.82 874.12 582.38L874.11 582.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M210 530.16L193.52 455.52C193.4 454.96 192.84 454.6 192.28 454.73C191.72 454.85 191.36 455.41 191.49 455.97L207.97 530.61C208.09 531.17 208.65 531.53 209.21 531.4C209.77 531.27 210.13 530.72 210 530.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M875.37 581.37L823.41 570.48C822.84 570.37 822.3 570.75 822.19 571.31C822.09 571.86 822.44 572.39 822.98 572.52L874.94 583.41C875.51 583.52 876.05 583.15 876.16 582.58C876.27 582.03 875.92 581.49 875.37 581.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M384.45 549.61L394.65 574.95C394.87 575.48 395.49 575.73 396.02 575.51C396.54 575.29 396.79 574.7 396.59 574.18L386.39 548.84C386.17 548.31 385.55 548.06 385.02 548.29C384.5 548.51 384.25 549.1 384.45 549.62V549.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1101.13 495.24L1069.93 507.41C1069.4 507.63 1069.14 508.23 1069.36 508.77C1069.57 509.29 1070.16 509.55 1070.69 509.35L1101.89 497.18C1102.42 496.96 1102.68 496.36 1102.46 495.82C1102.25 495.3 1101.66 495.04 1101.13 495.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1384.08 588.77L1405.22 568.61C1405.63 568.2 1405.63 567.54 1405.22 567.14C1404.83 566.74 1404.19 566.73 1403.78 567.11L1382.64 587.27C1382.22 587.67 1382.21 588.33 1382.6 588.74C1383 589.16 1383.66 589.17 1384.07 588.78L1384.08 588.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M506.05 727.12L568.09 664.94C568.5 664.53 568.5 663.87 568.09 663.47C567.68 663.06 567.02 663.06 566.62 663.47L504.58 725.65C504.17 726.06 504.17 726.72 504.58 727.12C504.99 727.53 505.65 727.53 506.05 727.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1229.52 564.02L1274.12 551.64C1274.67 551.48 1274.99 550.9 1274.83 550.35C1274.67 549.81 1274.11 549.49 1273.56 549.63L1228.96 562.01C1228.4 562.16 1228.08 562.74 1228.23 563.29C1228.38 563.85 1228.96 564.17 1229.51 564.02H1229.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M874.54 610.4L786.62 604.83C786.05 604.8 785.55 605.24 785.52 605.81C785.49 606.38 785.92 606.87 786.49 606.91L874.41 612.48C874.99 612.51 875.48 612.07 875.51 611.5C875.54 610.93 875.11 610.44 874.54 610.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1491.56 670.4L1469.88 632.7C1469.59 632.2 1468.96 632.03 1468.46 632.32C1467.96 632.61 1467.79 633.24 1468.08 633.74L1489.76 671.44C1490.08 671.92 1490.72 672.06 1491.2 671.74C1491.64 671.45 1491.8 670.87 1491.56 670.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M516.86 590.82L549.47 657.59C549.72 658.11 550.35 658.32 550.86 658.07C551.38 657.82 551.59 657.19 551.34 656.68L518.73 589.91C518.48 589.39 517.85 589.18 517.34 589.43C516.82 589.68 516.61 590.31 516.86 590.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M582.11 673.31L567.95 663.36C567.47 663.04 566.83 663.16 566.5 663.64C566.18 664.11 566.29 664.74 566.75 665.07L580.91 675.02C581.38 675.35 582.03 675.24 582.36 674.77C582.69 674.3 582.58 673.65 582.11 673.32V673.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M728.9 551.5L752.31 457.56C752.45 457 752.11 456.44 751.55 456.3C750.99 456.16 750.43 456.5 750.29 457.06L726.88 551C726.74 551.56 727.08 552.12 727.64 552.26C728.2 552.4 728.76 552.06 728.9 551.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M771.34 395.13L691.83 425.34C691.29 425.54 691.02 426.15 691.23 426.69C691.44 427.23 692.04 427.5 692.58 427.29L772.09 397.08C772.62 396.86 772.88 396.25 772.66 395.72C772.45 395.21 771.87 394.95 771.35 395.13H771.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M536.47 590.03L484.7 548.2C484.25 547.84 483.6 547.91 483.23 548.36C482.87 548.81 482.94 549.46 483.39 549.83L535.16 591.66C535.61 592.02 536.26 591.95 536.63 591.5C536.99 591.05 536.92 590.4 536.47 590.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M874.29 610.42L867.73 611.63C867.16 611.73 866.79 612.28 866.89 612.84C866.99 613.41 867.54 613.78 868.1 613.68L874.66 612.47C875.22 612.35 875.58 611.79 875.46 611.23C875.34 610.69 874.83 610.34 874.28 610.42H874.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M822.48 570.74L785.84 605.11C785.43 605.52 785.43 606.18 785.84 606.58C786.23 606.97 786.86 606.99 787.27 606.63L823.91 572.26C824.33 571.87 824.35 571.21 823.96 570.79C823.57 570.37 822.91 570.35 822.49 570.74H822.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M824.33 492.25L822.16 571.47C822.14 572.05 822.6 572.53 823.17 572.54C823.75 572.56 824.23 572.1 824.24 571.53L826.41 492.31C826.41 491.73 825.95 491.26 825.38 491.26C824.82 491.26 824.35 491.7 824.33 492.26V492.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1115.02 591.4L1059.01 596.19C1058.44 596.25 1058.03 596.77 1058.09 597.34C1058.15 597.89 1058.63 598.3 1059.19 598.26L1115.2 593.47C1115.77 593.4 1116.18 592.89 1116.12 592.32C1116.06 591.77 1115.58 591.36 1115.02 591.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M868.63 611.88L823.91 570.73C823.48 570.35 822.82 570.4 822.44 570.83C822.08 571.25 822.1 571.88 822.5 572.26L867.22 613.41C867.64 613.8 868.3 613.77 868.69 613.35C869.08 612.93 869.05 612.27 868.63 611.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1233.14 413.23L1260.08 458.67C1260.39 459.16 1261.03 459.3 1261.52 458.99C1261.99 458.7 1262.14 458.09 1261.87 457.6L1234.93 412.16C1234.64 411.66 1234 411.5 1233.5 411.79C1233 412.08 1232.84 412.72 1233.13 413.22L1233.14 413.23Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1100.82 496.99L1137.24 529.5C1137.67 529.88 1138.33 529.85 1138.71 529.42C1139.09 528.99 1139.06 528.33 1138.63 527.95L1102.21 495.44C1101.78 495.06 1101.12 495.09 1100.74 495.52C1100.36 495.95 1100.39 496.61 1100.82 496.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1417.48 494.75L1415.58 444.9C1415.56 444.32 1415.07 443.88 1414.5 443.9C1413.92 443.92 1413.48 444.41 1413.5 444.98L1415.4 494.83C1415.44 495.4 1415.93 495.84 1416.5 495.81C1417.06 495.78 1417.49 495.31 1417.48 494.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1231.09 645.05L1162.67 612.88C1162.15 612.63 1161.53 612.86 1161.28 613.38C1161.04 613.9 1161.26 614.52 1161.78 614.77L1230.2 646.94C1230.72 647.18 1231.34 646.96 1231.59 646.44C1231.84 645.92 1231.61 645.3 1231.09 645.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1199.43 649.45L1162.96 613.09C1162.55 612.69 1161.89 612.7 1161.49 613.12C1161.1 613.52 1161.1 614.16 1161.49 614.57L1197.96 650.93C1198.37 651.34 1199.03 651.34 1199.43 650.93C1199.84 650.52 1199.84 649.86 1199.43 649.46V649.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1114.67 593.39L1161.79 614.78C1162.32 615.01 1162.93 614.78 1163.17 614.25C1163.4 613.73 1163.17 613.12 1162.66 612.88L1115.54 591.49C1115.02 591.25 1114.4 591.49 1114.16 592.01C1113.92 592.53 1114.16 593.15 1114.68 593.39H1114.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1436.85 528.49L1448.15 583.27C1448.27 583.83 1448.82 584.2 1449.38 584.08C1449.94 583.96 1450.31 583.41 1450.19 582.85L1438.89 528.07C1438.77 527.51 1438.22 527.14 1437.66 527.26C1437.1 527.38 1436.73 527.93 1436.85 528.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M889.94 635.67L875.38 610.91C875.09 610.41 874.45 610.25 873.95 610.54C873.45 610.83 873.29 611.47 873.58 611.97L888.14 636.72C888.43 637.22 889.07 637.38 889.57 637.09C890.07 636.8 890.23 636.16 889.94 635.66V635.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M824.23 571.67L835.21 505.76C835.29 505.19 834.89 504.66 834.32 504.58C833.77 504.5 833.26 504.87 833.15 505.41L822.17 571.32C822.08 571.89 822.46 572.43 823.03 572.52C823.6 572.61 824.14 572.23 824.23 571.66V571.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M483.24 549.67L516.98 591.02C517.34 591.47 518 591.53 518.45 591.17C518.9 590.81 518.96 590.15 518.6 589.7L484.86 548.35C484.5 547.9 483.84 547.84 483.39 548.2C482.94 548.56 482.88 549.22 483.24 549.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1136.94 528.37L1114.12 592.08C1113.93 592.62 1114.21 593.22 1114.76 593.41C1115.3 593.6 1115.89 593.32 1116.09 592.78L1138.91 529.07C1139.1 528.53 1138.82 527.93 1138.28 527.74C1137.74 527.55 1137.14 527.83 1136.95 528.37H1136.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M536.72 591.35L572.41 527.46C572.69 526.96 572.51 526.32 572.01 526.04C571.51 525.76 570.87 525.94 570.59 526.44L534.9 590.33C534.62 590.83 534.8 591.47 535.3 591.75C535.8 592.03 536.44 591.85 536.72 591.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M327.72 506.97L350.8 563.27C351.03 563.8 351.65 564.04 352.17 563.8C352.68 563.58 352.92 562.99 352.72 562.48L329.64 506.18C329.42 505.65 328.81 505.39 328.28 505.61C327.75 505.83 327.49 506.44 327.71 506.97H327.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M340.86 509.92L350.75 563.07C350.86 563.63 351.41 564 351.98 563.89C352.53 563.78 352.9 563.25 352.8 562.69L342.91 509.54C342.8 508.98 342.25 508.61 341.68 508.72C341.13 508.83 340.76 509.36 340.86 509.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M208.04 530.83L249.09 615.97C249.35 616.48 249.98 616.69 250.49 616.43C250.99 616.18 251.2 615.57 250.97 615.06L209.91 529.92C209.65 529.41 209.02 529.21 208.51 529.47C208.02 529.72 207.81 530.32 208.04 530.82V530.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M210.37 402.81L191.52 455.39C191.34 455.94 191.63 456.53 192.18 456.71C192.71 456.89 193.28 456.61 193.48 456.1L212.33 403.52C212.52 402.98 212.24 402.38 211.7 402.19C211.16 402 210.56 402.28 210.37 402.82V402.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1231.68 645.86L1224.59 589.86C1224.51 589.29 1223.99 588.89 1223.42 588.97C1222.85 589.05 1222.46 589.56 1222.52 590.13L1229.61 646.13C1229.69 646.7 1230.21 647.1 1230.79 647.02C1231.35 646.94 1231.75 646.43 1231.68 645.87V645.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M581.83 753.8L582.55 674.17C582.55 673.59 582.09 673.12 581.52 673.12C580.94 673.12 580.47 673.58 580.47 674.15L579.75 753.78C579.75 754.36 580.21 754.83 580.78 754.83C581.35 754.83 581.83 754.37 581.83 753.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1051.66 531.04L1071.09 509.08C1071.47 508.65 1071.43 507.99 1071 507.61C1070.57 507.23 1069.91 507.27 1069.53 507.7L1050.1 529.66C1049.73 530.1 1049.79 530.76 1050.23 531.13C1050.65 531.48 1051.28 531.45 1051.66 531.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1199.66 650.58L1224.52 590.39C1224.73 589.85 1224.47 589.25 1223.93 589.04C1223.41 588.83 1222.82 589.08 1222.59 589.6L1197.73 649.79C1197.52 650.33 1197.79 650.93 1198.33 651.14C1198.85 651.34 1199.43 651.1 1199.65 650.59L1199.66 650.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1049.85 530.47L1058.06 597.35C1058.14 597.92 1058.66 598.32 1059.23 598.25C1059.79 598.18 1060.19 597.66 1060.13 597.1L1051.92 530.22C1051.84 529.65 1051.32 529.25 1050.75 529.33C1050.19 529.41 1049.79 529.91 1049.85 530.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1138 529.76L1228.34 523.41C1228.91 523.37 1229.35 522.87 1229.31 522.3C1229.27 521.73 1228.77 521.29 1228.2 521.33L1137.86 527.68C1137.29 527.73 1136.86 528.23 1136.9 528.8C1136.95 529.37 1137.44 529.79 1138 529.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1028.72 489.26L1069.86 509.33C1070.38 509.58 1071 509.37 1071.25 508.85C1071.5 508.33 1071.29 507.71 1070.77 507.46L1029.63 487.39C1029.11 487.14 1028.49 487.35 1028.24 487.87C1027.99 488.39 1028.2 489.01 1028.72 489.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M728.77 551.8L764.04 495.42C764.34 494.93 764.18 494.29 763.68 493.99C763.2 493.7 762.57 493.84 762.27 494.31L727 550.69C726.7 551.18 726.86 551.82 727.35 552.12C727.83 552.41 728.46 552.27 728.76 551.8H728.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1364.8 611.76L1414.61 626.37C1415.16 626.53 1415.74 626.2 1415.9 625.65C1416.05 625.1 1415.74 624.54 1415.2 624.37L1365.39 609.76C1364.84 609.6 1364.26 609.93 1364.1 610.48C1363.95 611.03 1364.26 611.59 1364.8 611.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1110.02 589.91L1058.97 596.19C1058.4 596.26 1057.99 596.78 1058.06 597.35C1058.13 597.92 1058.65 598.33 1059.22 598.26L1110.27 591.98C1110.84 591.91 1111.25 591.39 1111.18 590.82C1111.11 590.25 1110.59 589.84 1110.02 589.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M821.32 481.72L824.36 492.56C824.52 493.11 825.09 493.44 825.65 493.28C826.2 493.12 826.53 492.55 826.37 491.99L823.33 481.15C823.17 480.6 822.6 480.27 822.04 480.43C821.48 480.59 821.16 481.16 821.32 481.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1408.58 644.67L1415.87 625.74C1416.07 625.2 1415.79 624.6 1415.25 624.4C1414.72 624.21 1414.13 624.47 1413.92 624.99L1406.63 643.92C1406.42 644.46 1406.69 645.06 1407.23 645.27C1407.77 645.48 1408.37 645.21 1408.58 644.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1437.07 527.61L1403.7 567.19C1403.33 567.63 1403.4 568.29 1403.84 568.66C1404.28 569.02 1404.92 568.96 1405.29 568.54L1438.66 528.96C1439.03 528.51 1438.96 527.86 1438.52 527.49C1438.08 527.13 1437.44 527.19 1437.07 527.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M874.89 581.38L786.29 604.86C785.73 605.01 785.4 605.58 785.55 606.13C785.7 606.69 786.27 607.02 786.82 606.87L875.42 583.39C875.97 583.24 876.3 582.66 876.15 582.11C876 581.56 875.44 581.24 874.89 581.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M686.48 406.58L691.19 426.55C691.34 427.11 691.91 427.44 692.46 427.29C693 427.15 693.33 426.61 693.22 426.07L688.51 406.1C688.36 405.54 687.79 405.21 687.24 405.36C686.7 405.5 686.37 406.04 686.48 406.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1406.57 644.36L1410.12 701.2C1410.16 701.77 1410.66 702.21 1411.24 702.16C1411.81 702.12 1412.23 701.63 1412.2 701.07L1408.65 644.23C1408.61 643.66 1408.11 643.22 1407.53 643.27C1406.96 643.31 1406.54 643.8 1406.57 644.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1109.73 591.89L1161.81 614.78C1162.34 615.01 1162.95 614.78 1163.18 614.25C1163.41 613.72 1163.18 613.11 1162.65 612.88L1110.57 589.99C1110.04 589.76 1109.43 589.99 1109.2 590.52C1108.97 591.05 1109.2 591.66 1109.73 591.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M570.7 526.27L516.99 589.69C516.63 590.14 516.7 590.79 517.15 591.16C517.58 591.51 518.22 591.46 518.59 591.04L572.3 527.62C572.67 527.18 572.62 526.52 572.18 526.15C571.74 525.78 571.08 525.83 570.71 526.27H570.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1010.68 404.55L1014.29 354.37C1014.33 353.8 1013.9 353.3 1013.32 353.26C1012.74 353.22 1012.25 353.65 1012.21 354.23L1008.6 404.41C1008.56 404.98 1008.99 405.48 1009.57 405.52C1010.14 405.56 1010.64 405.13 1010.68 404.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M341.08 510.39L394.83 575.23C395.2 575.67 395.85 575.73 396.3 575.37C396.75 575.01 396.8 574.34 396.44 573.9L342.69 509.06C342.32 508.62 341.66 508.56 341.22 508.93C340.78 509.3 340.72 509.95 341.08 510.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1364.2 610.21L1357.58 620.88C1357.28 621.37 1357.44 622.01 1357.93 622.31C1358.42 622.6 1359.05 622.46 1359.35 621.98L1365.97 611.31C1366.27 610.82 1366.11 610.18 1365.62 609.88C1365.14 609.59 1364.5 609.73 1364.2 610.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M992.26 571.82L1058.72 598.19C1059.26 598.39 1059.86 598.12 1060.06 597.58C1060.26 597.05 1060 596.46 1059.48 596.25L993.02 569.87C992.48 569.67 991.88 569.94 991.68 570.48C991.48 571.01 991.74 571.6 992.26 571.81V571.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1227.22 522.3L1222.51 589.92C1222.47 590.49 1222.9 590.99 1223.48 591.03C1224.05 591.07 1224.55 590.64 1224.59 590.06L1229.3 522.45C1229.33 521.88 1228.9 521.38 1228.32 521.35C1227.75 521.32 1227.26 521.74 1227.22 522.31V522.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M874.14 582.15L866.91 612.41C866.78 612.97 867.14 613.53 867.7 613.66C868.25 613.78 868.8 613.45 868.94 612.9L876.17 582.64C876.3 582.08 875.94 581.52 875.38 581.39C874.83 581.27 874.28 581.6 874.14 582.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M752.29 457.64L772.71 396.44C772.89 395.89 772.6 395.3 772.05 395.12C771.5 394.94 770.91 395.23 770.73 395.78L750.31 456.98C750.14 457.53 750.44 458.12 750.99 458.29C751.53 458.46 752.1 458.17 752.29 457.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1137.91 527.68L1050.87 529.3C1050.29 529.33 1049.85 529.81 1049.87 530.39C1049.89 530.94 1050.35 531.38 1050.9 531.39L1137.94 529.77C1138.52 529.74 1138.96 529.26 1138.94 528.68C1138.92 528.12 1138.46 527.69 1137.91 527.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1100.48 496.36L1114.08 592.58C1114.17 593.15 1114.71 593.54 1115.27 593.45C1115.82 593.36 1116.21 592.85 1116.14 592.29L1102.54 496.07C1102.45 495.5 1101.92 495.11 1101.35 495.2C1100.79 495.29 1100.41 495.8 1100.48 496.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M854.97 603.09L874.02 612.37C874.54 612.62 875.16 612.41 875.41 611.89C875.66 611.37 875.45 610.75 874.93 610.5L855.88 601.22C855.36 600.97 854.74 601.18 854.49 601.7C854.24 602.22 854.45 602.84 854.97 603.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1059.65 637.46L1060.13 597.23C1060.13 596.65 1059.65 596.2 1059.07 596.21C1058.52 596.21 1058.07 596.66 1058.05 597.21L1057.57 637.44C1057.57 638.02 1058.02 638.49 1058.6 638.5C1059.18 638.5 1059.65 638.05 1059.65 637.47V637.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1384.13 588.72L1438.64 528.98C1439.02 528.55 1438.98 527.89 1438.55 527.51C1438.13 527.14 1437.49 527.17 1437.1 527.58L1382.59 587.32C1382.2 587.75 1382.23 588.4 1382.66 588.79C1383.09 589.18 1383.74 589.15 1384.13 588.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M747.81 477.5L822.26 482.48C822.83 482.52 823.33 482.08 823.37 481.51C823.41 480.94 822.97 480.44 822.4 480.4L747.95 475.42C747.37 475.39 746.89 475.84 746.86 476.42C746.84 476.98 747.25 477.45 747.81 477.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M138.42 413.05L191.84 456.55C192.3 456.9 192.95 456.81 193.3 456.35C193.63 455.91 193.57 455.3 193.16 454.94L139.74 411.44C139.29 411.08 138.64 411.14 138.27 411.59C137.9 412.04 137.97 412.69 138.42 413.06V413.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M770.51 553.06L822.83 572.48C823.37 572.68 823.97 572.41 824.17 571.87C824.37 571.33 824.1 570.73 823.56 570.53L771.24 551.11C770.7 550.91 770.1 551.18 769.9 551.72C769.7 552.26 769.98 552.86 770.51 553.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M534.86 591.25L566.4 664.62C566.63 665.15 567.24 665.39 567.77 665.17C568.3 664.94 568.54 664.33 568.32 663.8L536.78 590.43C536.55 589.9 535.94 589.66 535.41 589.88C534.88 590.11 534.64 590.72 534.86 591.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1111.1 591.37L1138.88 529.15C1139.1 528.62 1138.86 528.01 1138.33 527.78C1137.81 527.56 1137.22 527.78 1136.98 528.3L1109.2 590.52C1108.97 591.05 1109.22 591.66 1109.75 591.89C1110.27 592.11 1110.86 591.89 1111.1 591.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M821.39 481.9L833.24 506.05C833.49 506.57 834.12 506.78 834.64 506.53C835.16 506.28 835.37 505.65 835.12 505.13L823.27 480.98C823.02 480.46 822.39 480.25 821.87 480.5C821.35 480.75 821.14 481.38 821.39 481.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M874.14 582.65L888.02 636.45C888.16 637.01 888.73 637.34 889.29 637.2C889.85 637.06 890.18 636.49 890.04 635.93L876.16 582.13C876.02 581.57 875.45 581.24 874.89 581.38C874.33 581.52 874 582.09 874.14 582.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M932.39 427.92L912.32 471.18C912.08 471.7 912.32 472.32 912.84 472.56C913.36 472.79 913.97 472.57 914.21 472.06L934.29 428.8C934.53 428.28 934.29 427.66 933.77 427.42C933.25 427.19 932.64 427.41 932.4 427.92H932.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M876.07 581.9L835.1 505.09C834.82 504.59 834.18 504.41 833.68 504.7C833.2 504.97 833.01 505.58 833.26 506.07L874.23 582.88C874.5 583.39 875.13 583.58 875.64 583.31C876.15 583.04 876.34 582.41 876.07 581.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1415.41 494.62L1403.47 567.69C1403.38 568.26 1403.76 568.79 1404.33 568.89C1404.9 568.98 1405.43 568.6 1405.53 568.03L1417.47 494.96C1417.56 494.39 1417.18 493.86 1416.61 493.76C1416.04 493.66 1415.51 494.05 1415.41 494.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M868.01 611.61L786.64 604.83C786.07 604.78 785.56 605.21 785.51 605.78C785.46 606.35 785.89 606.86 786.46 606.91L867.83 613.69C868.4 613.73 868.9 613.3 868.95 612.73C868.99 612.16 868.57 611.67 868.01 611.62V611.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M750.31 457.62L762.17 495.18C762.35 495.73 762.94 496.02 763.49 495.84C764.04 495.66 764.32 495.09 764.16 494.55L752.3 456.99C752.13 456.44 751.54 456.14 750.99 456.31C750.44 456.48 750.14 457.07 750.31 457.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1224.57 590.21L1230.27 563.23C1230.39 562.67 1230.03 562.11 1229.47 561.99C1228.91 561.87 1228.35 562.23 1228.23 562.79L1222.53 589.77C1222.41 590.33 1222.77 590.89 1223.33 591.01C1223.89 591.13 1224.45 590.77 1224.57 590.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1365.86 611.46L1405.27 568.56C1405.66 568.14 1405.63 567.48 1405.21 567.09C1404.79 566.7 1404.13 566.73 1403.74 567.15L1364.33 610.05C1363.94 610.47 1363.97 611.13 1364.39 611.52C1364.81 611.91 1365.47 611.88 1365.86 611.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M516.93 590.94L566.49 664.79C566.81 665.27 567.46 665.4 567.94 665.07C568.42 664.75 568.55 664.1 568.22 663.62L518.66 589.77C518.33 589.3 517.67 589.19 517.21 589.53C516.76 589.85 516.64 590.47 516.93 590.93V590.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M581.81 753.64L568.38 664.06C568.29 663.49 567.76 663.1 567.19 663.18C566.62 663.27 566.23 663.8 566.31 664.37L579.74 753.95C579.83 754.52 580.36 754.91 580.93 754.82C581.5 754.73 581.89 754.21 581.8 753.64H581.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M747.67 477.48L825.16 493.3C825.72 493.42 826.27 493.05 826.39 492.49C826.51 491.93 826.14 491.37 825.58 491.26L748.09 475.44C747.52 475.34 746.98 475.72 746.88 476.28C746.78 476.83 747.13 477.36 747.67 477.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1100.93 495.35L1050.3 529.48C1049.82 529.8 1049.7 530.45 1050.02 530.93C1050.34 531.41 1050.99 531.53 1051.47 531.21L1102.1 497.08C1102.57 496.75 1102.69 496.1 1102.36 495.63C1102.04 495.17 1101.41 495.05 1100.94 495.35H1100.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1057.57 637.54L1061.53 684.11C1061.58 684.68 1062.08 685.11 1062.66 685.06C1063.23 685.01 1063.66 684.51 1063.61 683.93L1059.65 637.36C1059.6 636.79 1059.1 636.36 1058.52 636.41C1057.95 636.46 1057.52 636.96 1057.57 637.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M889.81 635.5L868.69 611.95C868.3 611.53 867.64 611.5 867.22 611.89C866.8 612.27 866.77 612.92 867.14 613.34L888.26 636.89C888.64 637.32 889.3 637.35 889.73 636.97C890.16 636.59 890.19 635.93 889.81 635.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M824.5 492.85L833.31 506.16C833.63 506.64 834.27 506.77 834.76 506.45C835.24 506.13 835.37 505.49 835.05 505.01L826.24 491.7C825.92 491.22 825.28 491.09 824.79 491.41C824.3 491.73 824.18 492.37 824.5 492.86V492.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M692.43 437.56L693.25 426.39C693.28 425.81 692.83 425.33 692.26 425.3C691.71 425.27 691.23 425.69 691.17 426.24L690.35 437.4C690.32 437.98 690.77 438.46 691.34 438.49C691.89 438.52 692.37 438.1 692.43 437.55V437.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1382.55 587.37L1364.28 610.11C1363.92 610.56 1363.99 611.22 1364.44 611.58C1364.89 611.94 1365.54 611.87 1365.91 611.42L1384.18 588.68C1384.53 588.22 1384.44 587.57 1383.99 587.22C1383.55 586.88 1382.92 586.95 1382.56 587.38L1382.55 587.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M934.37 428.52L942.45 377.12C942.54 376.55 942.15 376.02 941.58 375.93C941.01 375.84 940.48 376.23 940.39 376.8L932.31 428.2C932.23 428.77 932.64 429.29 933.21 429.37C933.76 429.44 934.27 429.07 934.37 428.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1101.62 495.18L1029.29 487.29C1028.72 487.24 1028.21 487.66 1028.15 488.23C1028.1 488.79 1028.5 489.29 1029.06 489.36L1101.39 497.25C1101.96 497.3 1102.47 496.88 1102.53 496.31C1102.58 495.75 1102.18 495.24 1101.62 495.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M1382.4 588.43L1406.64 644.71C1406.87 645.24 1407.48 645.48 1408.01 645.26C1408.54 645.03 1408.78 644.42 1408.56 643.89L1384.31 587.61C1384.07 587.09 1383.45 586.86 1382.93 587.1C1382.42 587.33 1382.19 587.92 1382.4 588.44V588.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M770.68 396.02L762.12 494.78C762.07 495.35 762.49 495.86 763.07 495.91C763.64 495.96 764.15 495.54 764.2 494.96L772.75 396.2C772.77 395.62 772.32 395.14 771.75 395.12C771.21 395.1 770.75 395.49 770.68 396.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M535.84 589.8L517.82 589.32C517.24 589.3 516.76 589.76 516.75 590.34C516.73 590.92 517.19 591.39 517.76 591.41L535.78 591.89C536.36 591.91 536.83 591.45 536.85 590.87C536.87 590.29 536.41 589.82 535.84 589.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M771.72 552.69L823.17 482.05C823.5 481.58 823.39 480.93 822.92 480.6C822.46 480.27 821.82 480.37 821.48 480.82L770.02 551.46C769.68 551.93 769.78 552.58 770.25 552.92C770.72 553.26 771.37 553.16 771.71 552.69H771.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M328.06 507.41L384.79 550.05C385.25 550.4 385.9 550.3 386.25 549.84C386.6 549.38 386.5 548.73 386.04 548.38L329.31 505.74C328.84 505.4 328.19 505.5 327.85 505.97C327.52 506.43 327.61 507.06 328.05 507.41H328.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M341.18 510.5L384.72 549.99C385.15 550.37 385.81 550.33 386.19 549.9C386.57 549.48 386.54 548.83 386.12 548.44L342.58 508.95C342.15 508.57 341.49 508.61 341.11 509.04C340.73 509.46 340.76 510.11 341.18 510.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M751.95 456.49L688.15 405.53C687.7 405.17 687.04 405.24 686.68 405.69C686.32 406.14 686.39 406.8 686.84 407.16L750.64 458.12C751.09 458.48 751.75 458.41 752.11 457.96C752.47 457.51 752.4 456.85 751.95 456.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M873.89 610.58L863.35 617.74C862.88 618.07 862.77 618.72 863.1 619.19C863.42 619.65 864.06 619.77 864.53 619.46L875.07 612.3C875.54 611.97 875.66 611.32 875.32 610.85C875 610.39 874.36 610.27 873.89 610.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M747.55 477.44L833.85 506.57C834.4 506.75 834.99 506.46 835.17 505.92C835.35 505.37 835.06 504.78 834.52 504.6L748.22 475.47C747.67 475.29 747.08 475.58 746.9 476.12C746.72 476.67 747.01 477.26 747.55 477.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M941.03 377.92L1009.26 405.44C1009.79 405.66 1010.4 405.4 1010.62 404.86C1010.84 404.33 1010.58 403.72 1010.04 403.5L941.81 375.98C941.28 375.76 940.67 376.02 940.45 376.56C940.23 377.09 940.49 377.7 941.03 377.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1318.14 517.53L1228.22 521.34C1227.64 521.37 1227.21 521.86 1227.24 522.44C1227.27 523 1227.75 523.44 1228.31 523.42L1318.23 519.61C1318.81 519.58 1319.24 519.09 1319.21 518.51C1319.18 517.95 1318.7 517.51 1318.14 517.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M874.42 581.65L854.69 601.41C854.29 601.82 854.3 602.48 854.72 602.88C855.12 603.27 855.76 603.27 856.17 602.88L875.9 583.12C876.3 582.71 876.29 582.05 875.87 581.65C875.47 581.26 874.82 581.26 874.42 581.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M888.3 636.93L929.56 678.71C929.97 679.11 930.63 679.11 931.03 678.7C931.42 678.3 931.43 677.66 931.03 677.25L889.77 635.47C889.37 635.06 888.7 635.06 888.3 635.47C887.89 635.87 887.89 636.54 888.3 636.94V636.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1231.69 645.98L1230.29 562.99C1230.29 562.41 1229.81 561.96 1229.23 561.97C1228.65 561.97 1228.2 562.45 1228.21 563.03L1229.61 646.02C1229.61 646.6 1230.09 647.05 1230.67 647.04C1231.25 647.04 1231.7 646.56 1231.69 645.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1199.68 650.53L1230.23 563.36C1230.41 562.81 1230.12 562.22 1229.57 562.04C1229.04 561.86 1228.46 562.14 1228.26 562.67L1197.71 649.85C1197.52 650.39 1197.81 650.99 1198.35 651.18C1198.89 651.37 1199.49 651.08 1199.68 650.54V650.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1109.85 591.94L1114.81 593.43C1115.37 593.58 1115.94 593.26 1116.09 592.7C1116.24 592.16 1115.94 591.61 1115.41 591.43L1110.45 589.93C1109.9 589.76 1109.32 590.08 1109.15 590.63C1108.98 591.18 1109.3 591.76 1109.85 591.93V591.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M833.06 433.9L821.31 481.19C821.18 481.75 821.52 482.31 822.08 482.45C822.63 482.58 823.19 482.25 823.33 481.7L835.08 434.41C835.22 433.85 834.87 433.29 834.31 433.15C833.76 433.02 833.2 433.35 833.05 433.91L833.06 433.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1229.19 522.85L1261.9 458.61C1262.15 458.09 1261.93 457.47 1261.41 457.22C1260.91 456.98 1260.3 457.17 1260.04 457.67L1227.33 521.91C1227.07 522.42 1227.28 523.05 1227.79 523.31C1228.3 523.57 1228.92 523.37 1229.19 522.86V522.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M547.86 524.46L571.35 527.98C571.92 528.07 572.45 527.67 572.54 527.1C572.63 526.53 572.23 526 571.66 525.91L548.17 522.39C547.6 522.3 547.07 522.7 546.98 523.27C546.89 523.84 547.29 524.37 547.86 524.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M866.89 612.51L856.99 686.92C856.91 687.49 857.32 688.02 857.89 688.09C858.46 688.16 858.99 687.76 859.06 687.19L868.96 612.78C869.04 612.21 868.63 611.68 868.06 611.61C867.49 611.53 866.96 611.94 866.89 612.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1114.46 591.62L1057.97 636.63C1057.52 636.99 1057.45 637.65 1057.8 638.1C1058.16 638.55 1058.82 638.62 1059.27 638.27L1115.76 593.26C1116.2 592.89 1116.27 592.24 1115.9 591.79C1115.54 591.36 1114.91 591.29 1114.46 591.63V591.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1318.94 517.85L1261.73 457.42C1261.33 457.01 1260.67 457 1260.26 457.4C1259.86 457.79 1259.84 458.44 1260.22 458.85L1317.43 519.28C1317.83 519.69 1318.49 519.7 1318.9 519.3C1319.3 518.91 1319.32 518.26 1318.94 517.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1227.22 522.4L1228.2 563.03C1228.23 563.61 1228.71 564.05 1229.29 564.03C1229.85 564.01 1230.29 563.54 1230.29 562.98L1229.31 522.35C1229.3 521.77 1228.82 521.32 1228.24 521.33C1227.66 521.34 1227.21 521.82 1227.22 522.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1137.71 527.7L1076.65 540.46C1076.09 540.59 1075.74 541.15 1075.87 541.71C1076 542.25 1076.53 542.6 1077.08 542.5L1138.13 529.74C1138.69 529.61 1139.04 529.05 1138.9 528.49C1138.77 527.95 1138.24 527.61 1137.7 527.7H1137.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M855.37 601.11L786.5 604.83C785.92 604.86 785.48 605.35 785.51 605.93C785.54 606.51 786.03 606.95 786.61 606.92L855.48 603.2C856.05 603.16 856.49 602.67 856.45 602.09C856.41 601.52 855.93 601.09 855.37 601.12V601.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M771.64 552.78L826.14 492.98C826.53 492.55 826.5 491.9 826.07 491.51C825.64 491.12 824.99 491.15 824.6 491.58L770.1 551.38C769.72 551.81 769.76 552.47 770.19 552.85C770.61 553.22 771.25 553.19 771.64 552.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M687.62 407.38L771.84 397.14C772.41 397.06 772.81 396.53 772.72 395.96C772.64 395.41 772.14 395.02 771.59 395.07L687.36 405.31C686.79 405.39 686.39 405.92 686.47 406.49C686.55 407.05 687.05 407.44 687.61 407.38H687.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1490.98 669.93L1407.93 643.3C1407.38 643.12 1406.79 643.43 1406.62 643.97C1406.44 644.52 1406.75 645.11 1407.29 645.28L1490.35 671.91C1490.9 672.09 1491.49 671.78 1491.66 671.23C1491.83 670.68 1491.53 670.09 1490.98 669.92V669.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1317.72 517.63L1228.78 562.07C1228.27 562.33 1228.06 562.96 1228.32 563.47C1228.58 563.98 1229.2 564.19 1229.71 563.93L1318.65 519.49C1319.17 519.23 1319.37 518.61 1319.12 518.09C1318.86 517.57 1318.24 517.37 1317.72 517.62V517.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M854.76 602.95L867.25 613.44C867.7 613.8 868.36 613.73 868.72 613.28C869.07 612.85 869.01 612.21 868.6 611.85L856.11 601.36C855.67 600.99 855.01 601.05 854.64 601.49C854.27 601.93 854.33 602.59 854.77 602.96L854.76 602.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M968.44 381.52L1009.11 405.38C1009.61 405.67 1010.25 405.49 1010.53 404.99C1010.81 404.5 1010.65 403.87 1010.16 403.58L969.49 379.72C968.99 379.43 968.35 379.6 968.07 380.1C967.79 380.59 967.95 381.22 968.44 381.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1219.52 614.39L1224.58 590.2C1224.7 589.64 1224.34 589.08 1223.77 588.97C1223.21 588.85 1222.65 589.21 1222.54 589.78L1217.48 613.97C1217.36 614.53 1217.72 615.09 1218.29 615.2C1218.85 615.32 1219.41 614.96 1219.52 614.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M888.15 635.65L857.13 686.51C856.84 687.01 857.01 687.65 857.51 687.93C857.99 688.21 858.61 688.06 858.91 687.59L889.93 636.73C890.22 636.24 890.06 635.6 889.57 635.3C889.08 635.01 888.45 635.16 888.15 635.64V635.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M888.8 637.21L941.75 649.96C942.31 650.08 942.87 649.73 942.99 649.16C943.11 648.61 942.78 648.07 942.24 647.93L889.29 635.18C888.73 635.06 888.17 635.41 888.05 635.98C887.93 636.53 888.26 637.07 888.8 637.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1415.56 495.35L1436.99 528.84C1437.3 529.33 1437.95 529.47 1438.43 529.16C1438.92 528.85 1439.06 528.2 1438.75 527.72L1417.32 494.23C1416.99 493.75 1416.35 493.63 1415.87 493.96C1415.42 494.27 1415.28 494.88 1415.56 495.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1051.81 529.87L1030.1 487.85C1029.84 487.34 1029.21 487.14 1028.7 487.4C1028.19 487.66 1027.99 488.29 1028.25 488.8L1049.96 530.82C1050.23 531.33 1050.87 531.51 1051.37 531.24C1051.86 530.97 1052.06 530.37 1051.81 529.86V529.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1110.9 590.21L1051.63 529.62C1051.22 529.21 1050.56 529.22 1050.16 529.62C1049.76 530.02 1049.76 530.67 1050.14 531.07L1109.41 591.66C1109.81 592.07 1110.47 592.08 1110.88 591.68C1111.29 591.28 1111.3 590.62 1110.9 590.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M833.04 434L824.33 492.13C824.24 492.7 824.64 493.23 825.21 493.32C825.78 493.41 826.31 493.01 826.4 492.44L835.11 434.31C835.2 433.74 834.8 433.21 834.23 433.12C833.66 433.03 833.13 433.43 833.04 434Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1009.45 405.5L1014.38 406.43C1014.95 406.53 1015.49 406.15 1015.59 405.59C1015.69 405.03 1015.32 404.5 1014.77 404.38L1009.84 403.45C1009.27 403.35 1008.73 403.73 1008.63 404.29C1008.53 404.85 1008.9 405.38 1009.45 405.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M889.78 635.46L856.17 601.42C855.77 601.01 855.1 601.01 854.7 601.42C854.29 601.82 854.29 602.49 854.7 602.89L888.31 636.93C888.71 637.34 889.38 637.34 889.78 636.93C890.19 636.53 890.19 635.86 889.78 635.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M138.71 411.26L49.01 444.78C48.47 444.99 48.21 445.6 48.43 446.13C48.64 446.65 49.22 446.91 49.74 446.73L139.44 413.21C139.97 413 140.24 412.39 140.02 411.86C139.81 411.34 139.24 411.08 138.71 411.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M691.06 438.47L750.97 458.3C751.52 458.48 752.11 458.18 752.29 457.64C752.47 457.09 752.17 456.5 751.63 456.32L691.72 436.49C691.17 436.31 690.58 436.61 690.4 437.15C690.22 437.7 690.52 438.29 691.06 438.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.21 413.27L211.48 404.19C212.05 404.11 212.44 403.58 212.36 403.01C212.28 402.46 211.78 402.07 211.22 402.13L138.95 411.21C138.38 411.28 137.97 411.8 138.05 412.37C138.12 412.94 138.64 413.35 139.21 413.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.31 403.55L224 374.52C224.22 373.99 223.96 373.38 223.42 373.16C222.89 372.94 222.28 373.2 222.06 373.74L210.37 402.77C210.16 403.31 210.43 403.91 210.97 404.12C211.5 404.32 212.09 404.07 212.31 403.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M771.49 552.92L834.8 506.42C835.26 506.08 835.36 505.43 835.02 504.96C834.68 504.5 834.03 504.4 833.56 504.74L770.25 551.24C769.79 551.58 769.69 552.23 770.03 552.7C770.37 553.17 771.02 553.26 771.49 552.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1050.29 529.49L992.05 569.99C991.58 570.33 991.48 570.98 991.82 571.45C992.15 571.9 992.77 572.01 993.24 571.71L1051.48 531.21C1051.95 530.87 1052.05 530.22 1051.71 529.75C1051.38 529.3 1050.76 529.19 1050.29 529.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M951.04 608.91L929.3 677.67C929.13 678.22 929.43 678.8 929.98 678.98C930.53 679.16 931.11 678.85 931.29 678.3L953.03 609.54C953.19 608.99 952.87 608.41 952.31 608.25C951.78 608.1 951.22 608.39 951.04 608.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1115.84 420.67L1100.49 496.01C1100.38 496.57 1100.74 497.12 1101.3 497.24C1101.86 497.35 1102.41 496.99 1102.53 496.43L1117.88 421.09C1117.99 420.53 1117.63 419.98 1117.07 419.86C1116.51 419.74 1115.96 420.11 1115.84 420.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1028.22 487.9L991.68 570.43C991.45 570.96 991.7 571.57 992.22 571.8C992.74 572.03 993.35 571.8 993.58 571.27L1030.12 488.75C1030.35 488.22 1030.12 487.61 1029.59 487.37C1029.06 487.14 1028.45 487.37 1028.21 487.9H1028.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M875.57 583.35L884.18 579.57C884.7 579.33 884.93 578.71 884.69 578.19C884.46 577.68 883.86 577.44 883.34 577.66L874.73 581.44C874.2 581.67 873.96 582.29 874.2 582.81C874.44 583.33 875.05 583.58 875.57 583.34V583.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M912.85 470.65L833.76 504.62C833.24 504.86 833 505.47 833.24 506C833.47 506.51 834.07 506.75 834.58 506.54L913.66 472.57C914.19 472.34 914.43 471.73 914.21 471.2C913.98 470.67 913.37 470.43 912.84 470.65H912.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M874.16 582.08L862.94 618.29C862.77 618.84 863.08 619.42 863.63 619.59C864.18 619.76 864.76 619.45 864.93 618.9L876.15 582.69C876.32 582.14 876.01 581.56 875.46 581.39C874.91 581.22 874.33 581.53 874.16 582.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M337.04 372.07L342.59 409.36C342.68 409.93 343.21 410.32 343.78 410.23C344.34 410.14 344.73 409.62 344.65 409.06L339.1 371.77C339.01 371.2 338.48 370.81 337.91 370.9C337.35 370.99 336.96 371.51 337.04 372.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1100.59 495.72L1075.95 540.99C1075.68 541.5 1075.88 542.13 1076.39 542.4C1076.89 542.66 1077.51 542.48 1077.79 541.99L1102.43 496.72C1102.71 496.21 1102.52 495.58 1102.01 495.31C1101.5 495.03 1100.87 495.22 1100.6 495.73L1100.59 495.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1117.8 421.33L1145.54 363.64C1145.79 363.12 1145.57 362.5 1145.05 362.25C1144.53 362 1143.91 362.22 1143.66 362.74L1115.92 420.43C1115.68 420.95 1115.91 421.57 1116.43 421.81C1116.94 422.05 1117.55 421.83 1117.8 421.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M833.03 434.15L833.13 505.58C833.13 506.16 833.6 506.62 834.17 506.62C834.75 506.62 835.21 506.15 835.21 505.58L835.11 434.15C835.11 433.57 834.64 433.11 834.07 433.11C833.49 433.11 833.03 433.58 833.03 434.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1109.45 590.17L1057.91 636.68C1057.48 637.07 1057.45 637.73 1057.83 638.15C1058.22 638.58 1058.88 638.61 1059.3 638.23L1110.84 591.72C1111.27 591.33 1111.3 590.67 1110.92 590.25C1110.53 589.82 1109.87 589.79 1109.45 590.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M469.69 664.8L518.66 590.94C518.98 590.46 518.85 589.81 518.37 589.49C517.89 589.17 517.24 589.3 516.92 589.78L467.95 663.64C467.63 664.12 467.77 664.77 468.25 665.08C468.73 665.4 469.37 665.27 469.69 664.79V664.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M328.45 507.59L341.64 510.74C342.2 510.86 342.76 510.5 342.88 509.94C343 509.39 342.66 508.85 342.12 508.71L328.93 505.56C328.37 505.43 327.81 505.79 327.68 506.35C327.56 506.9 327.89 507.45 328.44 507.59H328.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M991.77 570.28L941.12 648.38C940.81 648.87 940.96 649.51 941.45 649.82C941.93 650.12 942.56 649.99 942.87 649.52L993.52 571.42C993.83 570.94 993.7 570.29 993.21 569.98C992.72 569.67 992.08 569.8 991.77 570.29V570.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1231.62 645.62L1219.47 613.8C1219.26 613.26 1218.65 613 1218.12 613.22C1217.59 613.43 1217.33 614.02 1217.53 614.55L1229.68 646.36C1229.89 646.89 1230.5 647.16 1231.03 646.94C1231.55 646.73 1231.82 646.14 1231.62 645.61V645.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1217.58 613.68L1197.78 649.68C1197.51 650.19 1197.71 650.82 1198.22 651.09C1198.72 651.35 1199.33 651.17 1199.61 650.69L1219.41 614.69C1219.68 614.18 1219.48 613.55 1218.98 613.28C1218.48 613.02 1217.87 613.2 1217.59 613.68H1217.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1049.88 574.24L1114.81 593.44C1115.36 593.6 1115.94 593.29 1116.11 592.74C1116.27 592.19 1115.96 591.61 1115.41 591.44L1050.48 572.24C1049.92 572.09 1049.35 572.43 1049.21 572.98C1049.07 573.51 1049.37 574.06 1049.89 574.24H1049.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M139.51 413.19L223.47 375.08C223.99 374.84 224.23 374.22 223.99 373.7C223.75 373.18 223.13 372.94 222.61 373.18L138.65 411.29C138.13 411.53 137.9 412.15 138.14 412.67C138.38 413.19 138.99 413.42 139.51 413.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1059.35 636.72L993.38 570.12C992.97 569.72 992.31 569.73 991.91 570.14C991.52 570.54 991.51 571.18 991.91 571.59L1057.88 638.19C1058.29 638.59 1058.95 638.59 1059.35 638.17C1059.74 637.77 1059.75 637.13 1059.35 636.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M546.99 523.24L534.79 590.65C534.69 591.22 535.08 591.76 535.64 591.85C536.2 591.95 536.73 591.58 536.84 591.02L549.04 523.61C549.14 523.04 548.76 522.5 548.19 522.4C547.63 522.3 547.09 522.67 546.99 523.23V523.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M952.75 609.98L993.35 571.61C993.76 571.2 993.75 570.54 993.35 570.14C992.96 569.75 992.33 569.73 991.92 570.1L951.32 608.47C950.9 608.87 950.88 609.53 951.28 609.94C951.68 610.36 952.34 610.38 952.75 609.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M828.73 485.38L822.99 480.63C822.55 480.26 821.89 480.33 821.52 480.77C821.15 481.21 821.22 481.87 821.66 482.24L827.4 486.99C827.85 487.35 828.51 487.27 828.86 486.81C829.2 486.37 829.14 485.75 828.73 485.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1076.04 542.11L1114.27 593.06C1114.62 593.52 1115.27 593.61 1115.73 593.26C1116.19 592.91 1116.28 592.27 1115.94 591.81L1077.7 540.86C1077.35 540.4 1076.7 540.31 1076.24 540.65C1075.78 540.99 1075.69 541.65 1076.03 542.11H1076.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M951.03 608.97L940.98 648.69C940.84 649.25 941.18 649.81 941.74 649.95C942.29 650.09 942.85 649.75 943 649.2L953.05 609.48C953.17 608.92 952.82 608.36 952.26 608.24C951.72 608.12 951.19 608.44 951.03 608.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M882.82 578.17L866.98 612.21C866.74 612.74 866.98 613.35 867.5 613.59C868.02 613.82 868.62 613.6 868.87 613.09L884.71 579.05C884.95 578.52 884.71 577.91 884.19 577.67C883.67 577.44 883.07 577.66 882.82 578.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1364.19 611.28L1405.54 681.69C1405.84 682.18 1406.48 682.33 1406.97 682.03C1407.45 681.74 1407.61 681.12 1407.33 680.63L1365.98 610.22C1365.69 609.72 1365.05 609.56 1364.55 609.85C1364.05 610.14 1363.89 610.78 1364.18 611.28H1364.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M854.39 602.19L856.99 687.09C857.01 687.67 857.5 688.11 858.07 688.09C858.64 688.07 859.08 687.59 859.07 687.03L856.47 602.13C856.45 601.55 855.96 601.11 855.39 601.13C854.82 601.15 854.37 601.63 854.39 602.2V602.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1364.44 611.57L1406.96 645.11C1407.41 645.47 1408.07 645.39 1408.42 644.94C1408.78 644.49 1408.7 643.83 1408.25 643.48L1365.73 609.94C1365.28 609.58 1364.62 609.66 1364.27 610.11C1363.91 610.56 1363.99 611.22 1364.44 611.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M867.06 612.07L863.08 618.02C862.77 618.5 862.91 619.15 863.39 619.46C863.86 619.76 864.49 619.64 864.81 619.18L868.79 613.23C869.1 612.75 868.96 612.1 868.48 611.79C868.01 611.49 867.38 611.61 867.06 612.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1407.48 681.2L1408.64 644.33C1408.65 643.75 1408.2 643.28 1407.62 643.26C1407.05 643.25 1406.57 643.69 1406.55 644.26L1405.39 681.13C1405.37 681.71 1405.82 682.19 1406.4 682.2C1406.98 682.22 1407.46 681.77 1407.47 681.19L1407.48 681.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1028.52 487.52L958.65 544.45C958.21 544.82 958.16 545.48 958.54 545.92C958.9 546.34 959.53 546.41 959.97 546.07L1029.84 489.14C1030.28 488.77 1030.33 488.11 1029.95 487.67C1029.59 487.25 1028.96 487.18 1028.52 487.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M690.74 438.3L762.51 495.69C762.96 496.05 763.62 495.97 763.97 495.52C764.33 495.07 764.25 494.42 763.81 494.06L692.04 436.67C691.59 436.31 690.93 436.39 690.58 436.85C690.23 437.3 690.3 437.94 690.74 438.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M882.72 578.71L888 636.29C888.05 636.86 888.56 637.29 889.13 637.23C889.7 637.18 890.13 636.67 890.07 636.1L884.79 578.51C884.74 577.94 884.23 577.51 883.66 577.57C883.09 577.63 882.66 578.13 882.72 578.7V578.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M811.96 444.33L821.31 481.7C821.45 482.26 822.02 482.59 822.58 482.45C823.13 482.31 823.47 481.75 823.33 481.19L813.98 443.82C813.84 443.26 813.27 442.92 812.71 443.06C812.15 443.2 811.81 443.77 811.95 444.33H811.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M958.67 546.08L992.01 571.67C992.47 572.02 993.12 571.92 993.47 571.46C993.81 571.01 993.73 570.36 993.28 570.01L959.94 544.42C959.48 544.08 958.82 544.17 958.48 544.64C958.15 545.09 958.23 545.73 958.67 546.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M889.64 635.34L864.54 617.75C864.07 617.42 863.42 617.53 863.09 618.01C862.76 618.49 862.87 619.13 863.35 619.46L888.45 637.05C888.92 637.38 889.57 637.27 889.9 636.79C890.23 636.32 890.12 635.67 889.64 635.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1100.95 495.33L1069.27 515.35C1068.78 515.66 1068.64 516.3 1068.95 516.79C1069.26 517.28 1069.9 517.42 1070.39 517.11L1102.07 497.09C1102.55 496.77 1102.69 496.13 1102.37 495.65C1102.06 495.18 1101.44 495.04 1100.96 495.33H1100.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M547.06 523L516.84 589.93C516.61 590.46 516.85 591.07 517.38 591.3C517.9 591.52 518.5 591.3 518.74 590.79L548.96 523.86C549.2 523.34 548.96 522.72 548.44 522.48C547.92 522.24 547.3 522.48 547.06 523Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M573.09 727.91L568.39 664.13C568.35 663.56 567.85 663.12 567.27 663.17C566.7 663.21 566.26 663.71 566.31 664.29L571.01 728.07C571.07 728.64 571.58 729.06 572.15 729C572.7 728.95 573.12 728.47 573.09 727.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M705.57 381.62L771.48 397.12C772.04 397.25 772.6 396.91 772.73 396.35C772.86 395.79 772.52 395.23 771.96 395.1L706.05 379.6C705.49 379.47 704.93 379.82 704.8 380.38C704.67 380.94 705.02 381.5 705.58 381.63L705.57 381.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1057.73 647.5L1115.82 593.2C1116.24 592.81 1116.26 592.15 1115.87 591.73C1115.48 591.31 1114.82 591.29 1114.4 591.68L1056.31 645.98C1055.89 646.37 1055.87 647.03 1056.26 647.45C1056.65 647.87 1057.31 647.89 1057.73 647.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M941.73 377.94L1013.57 355.29C1014.12 355.11 1014.41 354.52 1014.23 353.97C1014.05 353.43 1013.48 353.14 1012.94 353.3L941.1 375.96C940.55 376.14 940.26 376.73 940.44 377.28C940.62 377.81 941.19 378.11 941.73 377.95V377.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M889.16 516.42L834.41 504.57C833.85 504.45 833.29 504.81 833.17 505.37C833.05 505.93 833.41 506.49 833.97 506.61L888.72 518.46C889.28 518.58 889.84 518.22 889.96 517.66C890.08 517.1 889.72 516.54 889.16 516.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1190.64 478.61L1227.46 523.04C1227.83 523.48 1228.49 523.54 1228.93 523.17C1229.37 522.8 1229.43 522.15 1229.07 521.71L1192.25 477.28C1191.88 476.84 1191.22 476.78 1190.78 477.15C1190.35 477.52 1190.28 478.16 1190.64 478.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M958.27 545.14L951 609.1C950.93 609.67 951.35 610.19 951.92 610.25C952.49 610.32 953.01 609.9 953.07 609.33L960.34 545.37C960.4 544.8 959.98 544.29 959.41 544.23C958.85 544.17 958.34 544.58 958.27 545.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1051.22 573.26L1051.92 530.37C1051.92 529.79 1051.44 529.33 1050.87 529.34C1050.32 529.34 1049.86 529.78 1049.84 530.34L1049.14 573.23C1049.14 573.81 1049.59 574.28 1050.17 574.29C1050.75 574.29 1051.22 573.84 1051.23 573.26H1051.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M827.11 485.76L824.42 491.85C824.19 492.38 824.42 492.99 824.95 493.22C825.48 493.45 826.09 493.22 826.33 492.69L829.02 486.6C829.24 486.07 828.99 485.46 828.46 485.24C827.94 485.03 827.35 485.25 827.11 485.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1077.28 540.52L1051.29 529.38C1050.76 529.15 1050.15 529.4 1049.92 529.93C1049.69 530.46 1049.94 531.07 1050.47 531.3L1076.46 542.44C1076.99 542.67 1077.6 542.42 1077.83 541.89C1078.06 541.36 1077.81 540.75 1077.28 540.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1110.45 589.94L1050.48 572.24C1049.93 572.08 1049.35 572.39 1049.18 572.95C1049.02 573.5 1049.33 574.08 1049.89 574.25L1109.86 591.95C1110.41 592.1 1110.99 591.78 1111.14 591.23C1111.29 590.69 1110.98 590.12 1110.45 589.95V589.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1219.52 614.4L1230.27 563.23C1230.38 562.67 1230.02 562.12 1229.45 562C1228.89 561.89 1228.35 562.24 1228.23 562.8L1217.48 613.97C1217.36 614.53 1217.72 615.09 1218.29 615.2C1218.85 615.32 1219.41 614.96 1219.52 614.39V614.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M833.63 435.09L912.82 472.55C913.34 472.79 913.96 472.57 914.21 472.04C914.45 471.52 914.23 470.91 913.72 470.66L834.53 433.2C834.01 432.96 833.39 433.18 833.14 433.7C832.9 434.22 833.12 434.83 833.63 435.08V435.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1077.65 540.79L1029.96 487.63C1029.58 487.2 1028.92 487.17 1028.49 487.55C1028.06 487.93 1028.03 488.59 1028.41 489.02L1076.1 542.18C1076.5 542.6 1077.16 542.61 1077.57 542.22C1077.97 541.84 1078 541.21 1077.65 540.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M912.38 472.16L958.42 545.81C958.72 546.3 959.37 546.45 959.86 546.14C960.35 545.84 960.5 545.19 960.19 544.7L914.15 471.05C913.84 470.56 913.2 470.42 912.71 470.72C912.23 471.03 912.08 471.67 912.38 472.15V472.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1111.01 590.36L1077.73 540.9C1077.41 540.42 1076.76 540.3 1076.28 540.62C1075.8 540.94 1075.68 541.59 1076 542.07L1109.28 591.53C1109.6 592.01 1110.25 592.13 1110.73 591.81C1111.21 591.49 1111.33 590.84 1111.01 590.37V590.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M812.83 516.48L826.28 492.79C826.56 492.29 826.39 491.65 825.89 491.37C825.39 491.09 824.75 491.26 824.47 491.76L811.02 515.45C810.75 515.96 810.94 516.59 811.44 516.86C811.93 517.13 812.55 516.96 812.83 516.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1050.22 572.2L992.68 569.81C992.1 569.79 991.62 570.23 991.59 570.81C991.57 571.39 992.01 571.87 992.59 571.9L1050.13 574.29C1050.71 574.31 1051.19 573.87 1051.22 573.29C1051.24 572.71 1050.8 572.23 1050.22 572.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M811.96 444.33L824.36 492.54C824.51 493.1 825.08 493.43 825.63 493.28C826.18 493.13 826.52 492.57 826.38 492.02L813.98 443.81C813.83 443.25 813.26 442.92 812.71 443.07C812.16 443.22 811.82 443.78 811.96 444.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1217.47 613.99L1201.2 700.4C1201.09 700.97 1201.47 701.51 1202.03 701.62C1202.6 701.73 1203.14 701.35 1203.25 700.79L1219.52 614.38C1219.63 613.81 1219.25 613.27 1218.69 613.16C1218.12 613.05 1217.58 613.43 1217.47 613.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1191.73 478.95L1261.26 459.14C1261.81 458.97 1262.12 458.39 1261.95 457.84C1261.79 457.31 1261.23 457 1260.69 457.14L1191.16 476.95C1190.61 477.11 1190.29 477.68 1190.44 478.24C1190.6 478.79 1191.17 479.11 1191.73 478.96V478.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M827.07 486.5L833.19 505.9C833.36 506.45 833.95 506.75 834.5 506.58C835.05 506.41 835.35 505.82 835.18 505.27L829.06 485.87C828.88 485.32 828.29 485.03 827.74 485.21C827.21 485.39 826.91 485.96 827.07 486.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M692.42 437.35L688.53 406.21C688.44 405.64 687.91 405.25 687.34 405.33C686.79 405.41 686.4 405.91 686.46 406.46L690.35 437.6C690.43 438.17 690.97 438.56 691.53 438.48C692.08 438.4 692.47 437.9 692.41 437.34L692.42 437.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1076.53 540.5L992.3 569.87C991.76 570.06 991.47 570.65 991.66 571.2C991.85 571.74 992.44 572.03 992.99 571.84L1077.22 542.47C1077.76 542.28 1078.05 541.69 1077.86 541.14C1077.67 540.6 1077.08 540.31 1076.53 540.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1411.38 712.26L1408.65 644.26C1408.63 643.68 1408.14 643.24 1407.57 643.26C1406.99 643.28 1406.55 643.77 1406.57 644.34L1409.3 712.34C1409.33 712.91 1409.83 713.35 1410.4 713.32C1410.96 713.29 1411.39 712.82 1411.38 712.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1049.15 573.38L1057.58 637.59C1057.66 638.16 1058.18 638.56 1058.75 638.49C1059.32 638.42 1059.72 637.89 1059.65 637.32L1051.22 573.11C1051.14 572.54 1050.62 572.14 1050.05 572.21C1049.48 572.29 1049.08 572.81 1049.15 573.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1190.49 478.37L1228.29 563.43C1228.52 563.96 1229.14 564.19 1229.67 563.96C1230.2 563.73 1230.43 563.11 1230.2 562.58L1192.4 477.52C1192.17 476.99 1191.55 476.76 1191.02 476.99C1190.49 477.22 1190.26 477.84 1190.49 478.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M969.5 381.51L1013.79 355.19C1014.28 354.9 1014.45 354.26 1014.15 353.76C1013.85 353.26 1013.22 353.1 1012.72 353.4L968.43 379.72C967.94 380.02 967.78 380.66 968.08 381.15C968.38 381.63 969 381.79 969.49 381.51H969.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M859.06 687.15L864.98 618.69C865.03 618.12 864.6 617.61 864.03 617.56C863.46 617.51 862.95 617.94 862.9 618.51L856.98 686.97C856.93 687.54 857.36 688.05 857.93 688.1C858.5 688.15 859.01 687.72 859.06 687.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M863.56 619.57L941.61 649.91C942.15 650.12 942.75 649.85 942.96 649.32C943.17 648.79 942.9 648.18 942.37 647.97L864.32 617.63C863.78 617.42 863.18 617.69 862.97 618.22C862.76 618.76 863.03 619.36 863.56 619.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M940.42 376.65L912.27 471.31C912.11 471.86 912.43 472.44 912.98 472.6C913.53 472.76 914.1 472.45 914.27 471.9L942.42 377.24C942.58 376.69 942.26 376.11 941.71 375.95C941.16 375.79 940.59 376.1 940.42 376.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1281.27 483.59L1227.67 521.53C1227.2 521.87 1227.1 522.52 1227.43 522.98C1227.76 523.44 1228.41 523.55 1228.87 523.23L1282.47 485.29C1282.94 484.96 1283.05 484.31 1282.72 483.84C1282.39 483.37 1281.74 483.26 1281.27 483.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M883.34 579.56L951.61 610.17C952.14 610.4 952.75 610.17 952.98 609.63C953.21 609.11 952.98 608.5 952.46 608.26L884.19 577.65C883.66 577.42 883.05 577.65 882.82 578.19C882.59 578.71 882.82 579.32 883.34 579.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1281.15 485.2L1317.46 519.33C1317.88 519.72 1318.54 519.7 1318.93 519.28C1319.32 518.86 1319.3 518.2 1318.88 517.81L1282.57 483.68C1282.15 483.29 1281.49 483.31 1281.1 483.74C1280.71 484.16 1280.73 484.81 1281.14 485.2H1281.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M812.36 516.91L834.62 506.53C835.14 506.29 835.37 505.67 835.12 505.14C834.88 504.62 834.26 504.39 833.73 504.64L811.47 515.02C810.95 515.26 810.72 515.88 810.97 516.41C811.21 516.93 811.83 517.16 812.36 516.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M883.1 577.81L854.76 601.35C854.32 601.72 854.26 602.38 854.63 602.82C855 603.26 855.66 603.32 856.1 602.95L884.43 579.41C884.87 579.03 884.92 578.38 884.54 577.94C884.17 577.51 883.54 577.46 883.1 577.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1109.39 590.22L1056.26 646.01C1055.87 646.43 1055.9 647.09 1056.33 647.48C1056.74 647.86 1057.38 647.84 1057.77 647.44L1110.9 591.65C1111.3 591.23 1111.28 590.57 1110.86 590.18C1110.44 589.78 1109.78 589.8 1109.39 590.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M811.99 444.41L833.2 505.92C833.4 506.46 834 506.73 834.54 506.53C835.06 506.34 835.34 505.77 835.17 505.24L813.96 443.73C813.77 443.19 813.18 442.9 812.63 443.08C812.09 443.27 811.8 443.86 811.98 444.41H811.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1012.21 354.32L1013.53 405.43C1013.54 406.01 1014.02 406.46 1014.6 406.45C1015.18 406.44 1015.63 405.96 1015.62 405.38L1014.3 354.27C1014.28 353.69 1013.79 353.25 1013.21 353.27C1012.65 353.29 1012.21 353.76 1012.21 354.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1030.2 488.14L1015.59 405.22C1015.49 404.65 1014.95 404.27 1014.38 404.37C1013.81 404.47 1013.43 405.01 1013.53 405.58L1028.14 488.5C1028.24 489.07 1028.78 489.45 1029.35 489.35C1029.92 489.25 1030.3 488.71 1030.2 488.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M854.5 602.64L863.01 619.08C863.28 619.59 863.92 619.78 864.42 619.5C864.91 619.23 865.11 618.62 864.86 618.12L856.35 601.67C856.09 601.16 855.46 600.96 854.94 601.22C854.43 601.48 854.23 602.11 854.49 602.63L854.5 602.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1069.21 515.4L1050.26 529.51C1049.8 529.85 1049.7 530.51 1050.05 530.97C1050.4 531.43 1051.05 531.53 1051.51 531.18L1070.46 517.07C1070.92 516.72 1071 516.06 1070.65 515.61C1070.31 515.17 1069.68 515.07 1069.22 515.4H1069.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1343.98 650.86L1366 611.26C1366.28 610.76 1366.1 610.12 1365.6 609.84C1365.1 609.56 1364.46 609.74 1364.18 610.24L1342.16 649.84C1341.88 650.34 1342.06 650.98 1342.56 651.26C1343.06 651.54 1343.7 651.36 1343.98 650.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M623.67 376.48L687.04 407.29C687.56 407.54 688.18 407.33 688.43 406.81C688.68 406.29 688.47 405.67 687.95 405.42L624.58 374.61C624.06 374.36 623.44 374.57 623.19 375.09C622.94 375.61 623.15 376.23 623.67 376.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1008.8 619.75L993.64 570.54C993.46 569.99 992.87 569.69 992.33 569.87C991.8 570.04 991.5 570.61 991.65 571.15L1006.81 620.36C1006.99 620.91 1007.58 621.21 1008.12 621.03C1008.65 620.86 1008.95 620.29 1008.8 619.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1343.17 651.39L1407.7 645.33C1408.27 645.27 1408.69 644.75 1408.62 644.18C1408.56 643.62 1408.06 643.21 1407.5 643.25L1342.97 649.31C1342.4 649.37 1341.98 649.89 1342.05 650.46C1342.11 651.02 1342.61 651.43 1343.17 651.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1231.68 645.89L1226.62 595.28C1226.55 594.71 1226.03 594.3 1225.46 594.36C1224.9 594.43 1224.49 594.92 1224.54 595.48L1229.61 646.09C1229.67 646.66 1230.18 647.08 1230.75 647.02C1231.32 646.96 1231.74 646.45 1231.68 645.88V645.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1070.42 515.37L1029.77 487.46C1029.29 487.15 1028.64 487.28 1028.33 487.77C1028.03 488.24 1028.14 488.85 1028.59 489.18L1069.24 517.09C1069.71 517.42 1070.36 517.3 1070.69 516.82C1071.02 516.34 1070.9 515.7 1070.42 515.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1425.38 654.59L1365.71 609.93C1365.25 609.58 1364.6 609.68 1364.25 610.14C1363.9 610.6 1364 611.25 1364.46 611.6L1424.13 656.26C1424.59 656.61 1425.24 656.51 1425.59 656.05C1425.94 655.59 1425.84 654.94 1425.38 654.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M802.31 482.07L762.86 493.87C762.31 494.04 762 494.63 762.18 495.18C762.35 495.72 762.92 496.03 763.46 495.87L802.91 484.07C803.46 483.9 803.77 483.32 803.61 482.77C803.44 482.22 802.86 481.91 802.31 482.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M913.98 470.85L901.12 458.87C900.69 458.49 900.03 458.52 899.65 458.95C899.28 459.37 899.3 460 899.7 460.39L912.56 472.37C912.98 472.76 913.64 472.74 914.03 472.32C914.42 471.9 914.4 471.24 913.98 470.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M704.96 380L686.65 405.74C686.32 406.21 686.43 406.86 686.9 407.19C687.37 407.52 688.02 407.41 688.35 406.94L706.66 381.2C706.99 380.73 706.87 380.08 706.39 379.75C705.93 379.43 705.29 379.54 704.96 379.99V380Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1007.39 619.1L941.57 647.99C941.04 648.22 940.8 648.84 941.03 649.36C941.26 649.89 941.88 650.13 942.4 649.9L1008.22 621.01C1008.74 620.77 1008.97 620.15 1008.73 619.63C1008.5 619.12 1007.9 618.89 1007.38 619.1H1007.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1425.32 654.55L1408.17 643.43C1407.68 643.13 1407.04 643.28 1406.73 643.77C1406.44 644.24 1406.57 644.87 1407.03 645.18L1424.18 656.31C1424.66 656.62 1425.31 656.49 1425.62 656C1425.93 655.52 1425.8 654.87 1425.31 654.56L1425.32 654.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M889.86 517.93L914.19 472.1C914.46 471.59 914.27 470.96 913.76 470.69C913.25 470.42 912.62 470.61 912.35 471.12L888.02 516.95C887.76 517.46 887.96 518.09 888.48 518.35C888.98 518.6 889.59 518.42 889.86 517.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1282.68 483.79L1261.79 457.49C1261.43 457.04 1260.78 456.97 1260.32 457.32C1259.87 457.68 1259.8 458.33 1260.15 458.78L1281.04 485.08C1281.4 485.53 1282.06 485.6 1282.51 485.24C1282.95 484.88 1283.03 484.23 1282.68 483.78V483.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1058.04 646.91L1059.64 637.63C1059.73 637.06 1059.35 636.53 1058.78 636.43C1058.22 636.34 1057.69 636.71 1057.58 637.27L1055.98 646.55C1055.89 647.12 1056.27 647.65 1056.84 647.75C1057.4 647.84 1057.93 647.47 1058.04 646.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1007.47 621.04L1058.28 638.44C1058.83 638.62 1059.42 638.32 1059.6 637.78C1059.78 637.24 1059.49 636.66 1058.96 636.47L1008.15 619.07C1007.6 618.89 1007.01 619.19 1006.83 619.73C1006.65 620.27 1006.94 620.85 1007.47 621.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M833.7 435.12L900.03 460.6C900.57 460.8 901.17 460.53 901.37 459.99C901.57 459.46 901.31 458.86 900.77 458.65L834.44 433.17C833.9 432.97 833.3 433.24 833.1 433.78C832.9 434.31 833.16 434.91 833.69 435.12H833.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1008 619.03L952.23 608.2C951.66 608.09 951.12 608.46 951.01 609.02C950.9 609.59 951.27 610.13 951.83 610.24L1007.6 621.07C1008.17 621.17 1008.71 620.79 1008.81 620.22C1008.91 619.67 1008.55 619.14 1008 619.02V619.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M888.55 518.41L958.92 546.23C959.46 546.44 960.06 546.17 960.27 545.64C960.48 545.11 960.22 544.51 959.69 544.3L889.32 516.48C888.78 516.27 888.18 516.54 887.97 517.07C887.76 517.6 888.02 518.2 888.55 518.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M771.66 552.76L828.85 486.86C829.22 486.42 829.17 485.76 828.73 485.39C828.3 485.03 827.66 485.07 827.28 485.49L770.09 551.39C769.71 551.83 769.76 552.48 770.19 552.86C770.63 553.24 771.28 553.19 771.66 552.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1034.79 462L1049.86 530.57C1050 531.13 1050.56 531.47 1051.12 531.34C1051.66 531.21 1052.01 530.67 1051.9 530.12L1036.83 461.55C1036.71 460.99 1036.15 460.63 1035.59 460.76C1035.03 460.88 1034.67 461.44 1034.8 462H1034.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1412.24 464.75L1436.9 528.65C1437.12 529.18 1437.73 529.43 1438.26 529.21C1438.77 529 1439.02 528.42 1438.84 527.9L1414.18 464C1413.97 463.46 1413.37 463.19 1412.83 463.4C1412.29 463.61 1412.02 464.21 1412.23 464.75H1412.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1034.8 461.52L1028.17 488.07C1028.04 488.63 1028.39 489.19 1028.95 489.32C1029.5 489.45 1030.05 489.12 1030.19 488.57L1036.82 462.02C1036.95 461.46 1036.6 460.9 1036.04 460.77C1035.49 460.64 1034.94 460.97 1034.79 461.52H1034.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M828.24 487.21L913.44 472.64C914.01 472.54 914.39 472 914.29 471.44C914.19 470.88 913.65 470.49 913.09 470.59L827.89 485.16C827.32 485.26 826.94 485.8 827.04 486.36C827.14 486.92 827.68 487.31 828.24 487.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M940.48 376.49L899.46 459.17C899.2 459.69 899.41 460.31 899.93 460.57C900.45 460.83 901.07 460.62 901.33 460.1L942.35 377.42C942.61 376.9 942.4 376.28 941.88 376.02C941.36 375.76 940.74 375.97 940.48 376.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1008.68 619.49L960.18 544.69C959.86 544.21 959.21 544.08 958.73 544.4C958.26 544.71 958.12 545.35 958.43 545.82L1006.93 620.62C1007.25 621.1 1007.9 621.23 1008.38 620.91C1008.85 620.6 1008.98 619.97 1008.68 619.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M811.23 515.18L770.18 551.3C769.75 551.68 769.71 552.34 770.09 552.77C770.47 553.2 771.13 553.24 771.56 552.86L812.61 516.74C813.04 516.36 813.08 515.7 812.7 515.27C812.32 514.84 811.66 514.8 811.23 515.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1076.07 540.81L1049.38 572.57C1049.01 573.01 1049.07 573.67 1049.51 574.04C1049.95 574.41 1050.61 574.35 1050.98 573.91L1077.67 542.15C1078.04 541.71 1077.98 541.05 1077.54 540.68C1077.1 540.31 1076.44 540.37 1076.07 540.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M833.04 434.03L827.03 486.06C826.96 486.63 827.37 487.15 827.95 487.22C828.52 487.29 829.04 486.88 829.11 486.3L835.12 434.27C835.19 433.7 834.78 433.18 834.2 433.11C833.62 433.04 833.11 433.45 833.04 434.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M969.11 379.58L941.56 375.91C940.99 375.83 940.46 376.24 940.39 376.81C940.32 377.38 940.72 377.91 941.29 377.98L968.84 381.64C969.41 381.7 969.93 381.29 969.99 380.72C970.05 380.17 969.67 379.66 969.11 379.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M882.83 578.15L863.01 618.14C862.76 618.66 862.97 619.28 863.49 619.53C864 619.78 864.62 619.57 864.88 619.06L884.7 579.07C884.95 578.55 884.74 577.93 884.22 577.68C883.71 577.43 883.09 577.64 882.83 578.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1116.22 421.7L1190.81 478.77C1191.27 479.12 1191.92 479.03 1192.27 478.58C1192.62 478.13 1192.53 477.47 1192.08 477.12L1117.49 420.05C1117.03 419.7 1116.38 419.79 1116.03 420.24C1115.68 420.69 1115.77 421.35 1116.22 421.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1412.17 464.49L1415.41 494.9C1415.49 495.47 1416.01 495.87 1416.58 495.79C1417.13 495.72 1417.52 495.23 1417.48 494.68L1414.25 464.27C1414.19 463.7 1413.67 463.28 1413.1 463.34C1412.53 463.4 1412.11 463.92 1412.17 464.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M1226.62 595.51L1230.28 563.13C1230.34 562.56 1229.92 562.05 1229.35 561.99C1228.79 561.93 1228.28 562.34 1228.21 562.9L1224.54 595.28C1224.47 595.85 1224.89 596.37 1225.46 596.44C1226.03 596.51 1226.55 596.09 1226.62 595.52V595.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M692.09 436.71L624.83 374.77C624.4 374.38 623.74 374.42 623.36 374.84C622.98 375.26 623 375.91 623.42 376.3L690.68 438.24C691.11 438.62 691.77 438.57 692.15 438.14C692.51 437.72 692.49 437.09 692.09 436.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M887.9 517.35L882.73 578.52C882.68 579.09 883.11 579.6 883.68 579.65C884.25 579.7 884.76 579.27 884.81 578.7L889.98 517.53C890.03 516.96 889.6 516.45 889.03 516.4C888.46 516.35 887.95 516.78 887.9 517.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M737.18 409.73L833.81 435.16C834.37 435.3 834.93 434.96 835.07 434.4C835.21 433.85 834.88 433.29 834.34 433.14L737.71 407.71C737.15 407.57 736.59 407.91 736.45 408.47C736.31 409.02 736.64 409.58 737.18 409.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M571.17 466.21L547.05 523.02C546.82 523.55 547.07 524.16 547.6 524.39C548.13 524.61 548.74 524.37 548.97 523.84L573.09 467.03C573.32 466.5 573.07 465.89 572.54 465.66C572.01 465.44 571.4 465.68 571.17 466.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M704.8 380.35L690.38 437.23C690.25 437.79 690.61 438.35 691.17 438.48C691.71 438.6 692.25 438.28 692.4 437.75L706.82 380.87C706.96 380.31 706.62 379.74 706.07 379.6C705.52 379.46 704.94 379.8 704.8 380.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M812.93 516.24L835.08 434.43C835.23 433.87 834.9 433.3 834.35 433.15C833.79 433 833.22 433.33 833.07 433.88L810.92 515.69C810.77 516.25 811.1 516.82 811.65 516.97C812.21 517.12 812.78 516.79 812.93 516.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M889.96 517.64L901.43 459.84C901.54 459.27 901.17 458.73 900.61 458.61C900.05 458.49 899.5 458.87 899.38 459.43L887.91 517.23C887.8 517.79 888.17 518.34 888.73 518.46C889.29 518.57 889.84 518.2 889.96 517.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M813.42 445.02L834.52 435.1C835.04 434.85 835.26 434.23 835.02 433.71C834.78 433.19 834.15 432.97 833.63 433.21L812.53 443.13C812.01 443.38 811.78 444 812.03 444.52C812.27 445.04 812.9 445.27 813.42 445.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M941.04 377.92L1014.19 406.38C1014.73 406.59 1015.33 406.32 1015.54 405.79C1015.75 405.25 1015.48 404.65 1014.95 404.44L941.8 375.98C941.26 375.77 940.66 376.04 940.45 376.57C940.24 377.1 940.51 377.71 941.04 377.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1049.14 573.34L1055.98 646.83C1056.05 647.4 1056.56 647.81 1057.13 647.75C1057.68 647.69 1058.09 647.2 1058.05 646.64L1051.21 573.15C1051.16 572.58 1050.65 572.15 1050.08 572.21C1049.51 572.26 1049.08 572.77 1049.14 573.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1008.58 620.75L1050.95 573.94C1051.34 573.51 1051.3 572.85 1050.88 572.47C1050.45 572.08 1049.79 572.12 1049.41 572.54L1007.04 619.36C1006.65 619.79 1006.69 620.45 1007.11 620.83C1007.53 621.21 1008.2 621.18 1008.58 620.76V620.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M1117.01 419.85L1014.73 404.38C1014.16 404.31 1013.64 404.71 1013.56 405.28C1013.49 405.83 1013.87 406.34 1014.41 406.44L1116.69 421.91C1117.26 421.98 1117.78 421.58 1117.86 421.01C1117.93 420.46 1117.55 419.95 1117.01 419.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M913.75 518.67L914.31 471.62C914.31 471.04 913.86 470.57 913.28 470.56C912.7 470.56 912.23 471.01 912.22 471.59L911.65 518.64C911.65 519.22 912.13 519.68 912.7 519.68C913.26 519.68 913.72 519.23 913.74 518.67H913.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1051.17 573.58L1070.82 516.58C1071.01 516.04 1070.72 515.44 1070.17 515.25C1069.63 515.06 1069.03 515.35 1068.84 515.9L1049.19 572.9C1049.01 573.45 1049.3 574.04 1049.85 574.22C1050.39 574.4 1050.97 574.12 1051.16 573.58H1051.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M912.18 519.56L958.78 546.16C959.28 546.44 959.92 546.26 960.2 545.75C960.47 545.26 960.3 544.63 959.82 544.35L913.22 517.75C912.72 517.47 912.08 517.65 911.8 518.15C911.52 518.65 911.7 519.27 912.19 519.56H912.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M828.42 487.16L900.76 460.61C901.3 460.4 901.56 459.79 901.35 459.26C901.15 458.74 900.57 458.48 900.04 458.66L827.7 485.21C827.16 485.41 826.88 486.01 827.08 486.55C827.28 487.09 827.88 487.37 828.42 487.17V487.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M705.87 379.56L624.19 374.5C623.61 374.47 623.13 374.91 623.1 375.49C623.07 376.06 623.5 376.54 624.06 376.58L705.74 381.64C706.32 381.67 706.8 381.23 706.83 380.65C706.86 380.08 706.43 379.6 705.87 379.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M889.41 516.51L828.54 485.25C828.03 484.99 827.4 485.19 827.14 485.7C826.88 486.21 827.08 486.84 827.59 487.1L888.46 518.35C888.97 518.61 889.6 518.41 889.86 517.9C890.12 517.39 889.92 516.76 889.41 516.5V516.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1077.87 541.2L1070.83 515.95C1070.66 515.4 1070.08 515.09 1069.53 515.26C1069 515.42 1068.69 515.97 1068.82 516.51L1075.86 541.76C1076.03 542.31 1076.61 542.62 1077.16 542.45C1077.69 542.29 1078.01 541.74 1077.87 541.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1170.92 561.82L1229.21 564.05C1229.79 564.05 1230.26 563.6 1230.27 563.02C1230.27 562.46 1229.85 562 1229.29 561.96L1171 559.71C1170.42 559.69 1169.93 560.14 1169.91 560.72C1169.89 561.3 1170.34 561.79 1170.92 561.81V561.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M877.58 635.46L857.06 686.67C856.85 687.2 857.1 687.81 857.64 688.03C858.17 688.24 858.78 687.98 859 687.45L879.54 636.25C879.76 635.71 879.49 635.1 878.96 634.88C878.42 634.66 877.81 634.93 877.59 635.46H877.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M811.24 516.75L883.08 579.4C883.52 579.77 884.18 579.71 884.55 579.26C884.91 578.83 884.86 578.2 884.45 577.83L812.61 515.18C812.18 514.8 811.52 514.85 811.14 515.28C810.76 515.71 810.81 516.37 811.24 516.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M968.47 381.53L1014.07 406.32C1014.58 406.6 1015.21 406.41 1015.48 405.9C1015.76 405.39 1015.57 404.76 1015.06 404.49L969.46 379.7C968.95 379.43 968.32 379.63 968.05 380.14C967.79 380.64 967.97 381.26 968.46 381.53H968.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M878.34 636.88L941.77 649.96C942.34 650.06 942.88 649.68 942.98 649.12C943.08 648.57 942.73 648.05 942.19 647.92L878.76 634.82C878.19 634.72 877.64 635.1 877.54 635.67C877.44 636.22 877.79 636.75 878.33 636.88H878.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M845.12 576.78L854.45 602.51C854.65 603.05 855.24 603.33 855.79 603.14C856.33 602.94 856.61 602.35 856.42 601.8L847.1 576.06C846.9 575.51 846.3 575.23 845.75 575.43C845.2 575.63 844.92 576.23 845.12 576.77V576.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1007.31 620.97L1056.52 647.65C1057.03 647.92 1057.66 647.72 1057.93 647.21C1058.19 646.71 1058.01 646.1 1057.52 645.82L1008.31 619.14C1007.8 618.87 1007.17 619.07 1006.9 619.58C1006.64 620.08 1006.82 620.69 1007.31 620.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1350.34 584.53L1364.16 611.23C1364.43 611.74 1365.07 611.93 1365.57 611.65C1366.06 611.38 1366.26 610.77 1366.01 610.27L1352.2 583.56C1351.93 583.04 1351.3 582.84 1350.78 583.11C1350.26 583.38 1350.06 584.01 1350.33 584.53H1350.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M811.9 517.01L888.91 518.48C889.49 518.48 889.95 518.01 889.95 517.43C889.95 516.87 889.51 516.42 888.95 516.39L811.94 514.92C811.36 514.91 810.89 515.37 810.88 515.94C810.87 516.52 811.33 516.99 811.9 517V517.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1116.39 419.95L1035.35 460.85C1034.84 461.12 1034.65 461.76 1034.93 462.26C1035.19 462.75 1035.79 462.95 1036.29 462.71L1117.33 421.81C1117.84 421.54 1118.03 420.91 1117.76 420.4C1117.5 419.91 1116.89 419.71 1116.39 419.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M812.79 445.1L900.22 460.66C900.79 460.76 901.33 460.38 901.43 459.82C901.53 459.25 901.15 458.71 900.59 458.61L813.16 443.05C812.59 442.95 812.05 443.33 811.95 443.89C811.85 444.46 812.23 445 812.79 445.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M878.91 636.84L952.39 610.2C952.93 610 953.2 609.4 953 608.86C952.8 608.33 952.21 608.06 951.68 608.24L878.2 634.86C877.65 635.06 877.37 635.66 877.57 636.21C877.77 636.76 878.37 637.04 878.92 636.84H878.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1281.94 483.4L1191.52 476.91C1190.95 476.87 1190.45 477.3 1190.41 477.88C1190.37 478.45 1190.8 478.95 1191.37 478.99L1281.8 485.48C1282.37 485.52 1282.87 485.09 1282.91 484.51C1282.95 483.94 1282.52 483.44 1281.94 483.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M974.63 515.84L991.64 571.16C991.83 571.71 992.42 572 992.96 571.81C993.48 571.63 993.78 571.08 993.63 570.55L976.64 515.23C976.45 514.68 975.86 514.38 975.31 514.57C974.78 514.75 974.48 515.31 974.63 515.85V515.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M879.42 635.26L856.28 601.57C855.95 601.1 855.31 600.97 854.83 601.3C854.36 601.63 854.23 602.27 854.56 602.75L877.68 636.45C878.02 636.92 878.68 637.03 879.15 636.69C879.61 636.36 879.72 635.73 879.42 635.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1115.92 421.34L1136.99 463.48C1137.25 463.99 1137.88 464.2 1138.39 463.94C1138.9 463.68 1139.11 463.06 1138.85 462.55L1117.77 420.41C1117.51 419.9 1116.89 419.69 1116.37 419.94C1115.85 420.2 1115.65 420.82 1115.9 421.34H1115.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1077.8 541L1036.74 461.29C1036.47 460.78 1035.84 460.59 1035.33 460.86C1034.83 461.13 1034.63 461.74 1034.89 462.25L1075.95 541.95C1076.22 542.46 1076.86 542.64 1077.36 542.37C1077.85 542.1 1078.05 541.5 1077.8 541Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1396.95 649.34L1365.91 610.11C1365.55 609.66 1364.9 609.58 1364.45 609.94C1364 610.3 1363.92 610.95 1364.28 611.4L1395.3 650.65C1395.67 651.1 1396.33 651.17 1396.78 650.8C1397.22 650.44 1397.3 649.79 1396.95 649.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M676.17 375.51L686.5 406.67C686.69 407.21 687.29 407.5 687.83 407.3C688.36 407.11 688.64 406.54 688.48 406.01L678.17 374.84C677.99 374.29 677.39 373.99 676.84 374.17C676.29 374.35 675.99 374.95 676.17 375.5V375.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1396.59 650.94L1408.07 645.23C1408.58 644.96 1408.78 644.33 1408.51 643.82C1408.25 643.33 1407.65 643.12 1407.14 643.36L1395.65 649.05C1395.13 649.32 1394.93 649.95 1395.2 650.47C1395.46 650.97 1396.08 651.18 1396.59 650.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M884.7 579.06L913.64 519.11C913.89 518.59 913.67 517.97 913.15 517.72C912.63 517.47 912.01 517.69 911.76 518.21L882.82 578.17C882.58 578.69 882.81 579.31 883.33 579.55C883.84 579.78 884.44 579.57 884.7 579.07V579.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1219.47 614.55L1226.55 595.76C1226.75 595.22 1226.48 594.62 1225.94 594.41C1225.4 594.2 1224.8 594.48 1224.59 595.02L1217.51 613.81C1217.31 614.35 1217.58 614.95 1218.12 615.15C1218.66 615.35 1219.26 615.08 1219.46 614.54L1219.47 614.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M913.72 518.44L901.42 459.42C901.3 458.86 900.75 458.49 900.19 458.61C899.63 458.73 899.26 459.28 899.38 459.84L911.68 518.86C911.81 519.42 912.37 519.77 912.93 519.64C913.47 519.51 913.82 518.98 913.72 518.43V518.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M888.88 518.48L912.65 519.7C913.23 519.73 913.72 519.29 913.75 518.71C913.78 518.13 913.34 517.64 912.76 517.61L888.99 516.39C888.41 516.37 887.93 516.82 887.92 517.4C887.9 517.96 888.33 518.43 888.89 518.47L888.88 518.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1511.63 581.53L1542.05 545.46C1542.42 545.02 1542.36 544.36 1541.92 543.99C1541.48 543.62 1540.82 543.68 1540.45 544.12L1510.03 580.19C1509.66 580.63 1509.72 581.29 1510.16 581.66C1510.6 582.03 1511.26 581.97 1511.63 581.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M812.84 516.46L828.98 486.68C829.25 486.17 829.07 485.54 828.56 485.27C828.05 485 827.42 485.18 827.15 485.69L811.01 515.47C810.74 515.98 810.92 516.61 811.43 516.88C811.94 517.15 812.57 516.97 812.84 516.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1137.65 464.02L1191.16 478.95C1191.72 479.1 1192.29 478.76 1192.43 478.21C1192.57 477.67 1192.26 477.11 1191.72 476.95L1138.21 462.01C1137.65 461.86 1137.08 462.19 1136.93 462.74C1136.78 463.29 1137.1 463.86 1137.65 464.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M811.99 444.42L827.08 486.53C827.28 487.07 827.87 487.35 828.41 487.16C828.95 486.97 829.23 486.37 829.04 485.83L813.95 443.72C813.75 443.18 813.16 442.9 812.61 443.09C812.07 443.28 811.79 443.88 811.98 444.42H811.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M974.71 515.02L958.39 544.75C958.11 545.25 958.3 545.89 958.8 546.17C959.3 546.45 959.94 546.26 960.22 545.76L976.56 516.04C976.83 515.52 976.63 514.89 976.11 514.62C975.61 514.36 975 514.54 974.71 515.03V515.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M908.33 434.45L912.23 471.72C912.3 472.29 912.81 472.7 913.39 472.63C913.95 472.56 914.36 472.06 914.31 471.5L910.44 434.23C910.37 433.65 909.85 433.24 909.27 433.3C908.7 433.37 908.29 433.87 908.34 434.45H908.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1036.79 461.41L1015.55 405.04C1015.35 404.5 1014.75 404.23 1014.21 404.43C1013.67 404.63 1013.4 405.23 1013.6 405.77L1034.84 462.14C1035.04 462.68 1035.65 462.95 1036.18 462.75C1036.71 462.55 1036.99 461.94 1036.79 461.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1541.74 545.72L1608.09 511.6C1608.59 511.31 1608.76 510.67 1608.47 510.18C1608.2 509.72 1607.63 509.53 1607.14 509.75L1540.78 543.87C1540.27 544.13 1540.07 544.76 1540.33 545.28C1540.59 545.79 1541.22 545.99 1541.74 545.73V545.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M813.42 443.13L737.9 407.78C737.38 407.54 736.76 407.76 736.51 408.28C736.27 408.8 736.49 409.42 737.01 409.67L812.53 445.02C813.05 445.26 813.67 445.04 813.92 444.52C814.16 444 813.94 443.38 813.42 443.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M811.93 444.06L810.88 515.95C810.88 516.53 811.36 516.99 811.94 516.98C812.49 516.98 812.94 516.53 812.97 515.98L814.02 444.09C814.02 443.51 813.54 443.05 812.96 443.06C812.41 443.06 811.96 443.51 811.93 444.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.79 492.59L69.72 493.09C69.14 493.11 68.69 493.59 68.71 494.17C68.73 494.75 69.21 495.2 69.79 495.18L83.86 494.71C84.44 494.69 84.9 494.2 84.88 493.62C84.86 493.04 84.37 492.58 83.79 492.6V492.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M913.07 517.68L828.43 485.21C827.89 485 827.29 485.27 827.08 485.81C826.87 486.35 827.14 486.95 827.68 487.16L912.32 519.63C912.86 519.82 913.46 519.54 913.65 518.99C913.83 518.47 913.58 517.89 913.07 517.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1034.93 462.33L1068.95 516.79C1069.27 517.27 1069.91 517.4 1070.39 517.09C1070.86 516.78 1071 516.17 1070.71 515.69L1036.69 461.23C1036.38 460.75 1035.73 460.61 1035.25 460.92C1034.78 461.23 1034.63 461.85 1034.92 462.33H1034.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M846.04 577.47L883.7 579.65C884.28 579.68 884.77 579.24 884.8 578.67C884.83 578.09 884.39 577.6 883.82 577.57L846.16 575.37C845.58 575.35 845.09 575.8 845.07 576.38C845.05 576.94 845.47 577.42 846.03 577.46L846.04 577.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M620.85 451.42L691.57 438.5C692.13 438.39 692.5 437.84 692.38 437.27C692.27 436.72 691.74 436.36 691.19 436.45L620.46 449.35C619.89 449.47 619.53 450.03 619.65 450.59C619.76 451.14 620.29 451.5 620.84 451.41L620.85 451.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M845.14 576.83L862.98 619.01C863.21 619.54 863.82 619.78 864.35 619.56C864.87 619.33 865.12 618.73 864.9 618.2L847.07 576.02C846.84 575.49 846.22 575.24 845.69 575.47C845.16 575.7 844.92 576.31 845.14 576.84V576.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1137.29 462.19L1069.19 515.41C1068.74 515.76 1068.66 516.42 1069.01 516.87C1069.36 517.32 1070.02 517.4 1070.47 517.05L1138.57 463.83C1139.02 463.47 1139.1 462.81 1138.74 462.36C1138.39 461.91 1137.74 461.83 1137.29 462.18V462.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M846.95 577.04L889.77 518.05C890.1 517.58 889.98 516.93 889.51 516.6C889.05 516.28 888.42 516.38 888.08 516.83L845.24 575.81C844.9 576.28 845 576.94 845.47 577.28C845.94 577.62 846.6 577.52 846.94 577.05L846.95 577.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1260.17 664.15L1219.31 613.53C1218.94 613.09 1218.28 613.03 1217.84 613.4C1217.41 613.76 1217.34 614.4 1217.69 614.84L1258.54 665.47C1258.91 665.91 1259.58 665.97 1260.02 665.6C1260.45 665.24 1260.52 664.6 1260.17 664.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1152.83 552.91L1217.77 614.94C1218.19 615.34 1218.85 615.32 1219.24 614.91C1219.64 614.49 1219.62 613.83 1219.21 613.44L1154.28 551.4C1153.86 551 1153.19 551.01 1152.79 551.43C1152.39 551.85 1152.4 552.52 1152.82 552.92L1152.83 552.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1170.17 561.47L1217.72 614.88C1218.1 615.31 1218.76 615.35 1219.19 614.97C1219.62 614.59 1219.66 613.93 1219.28 613.5L1171.75 560.08C1171.36 559.65 1170.7 559.61 1170.26 559.99C1169.83 560.38 1169.79 561.04 1170.17 561.48V561.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M676.15 375.41L690.38 437.71C690.51 438.27 691.07 438.62 691.63 438.49C692.19 438.36 692.54 437.8 692.41 437.24L678.21 374.93C678.08 374.36 677.52 374.01 676.95 374.14C676.38 374.27 676.03 374.83 676.16 375.4L676.15 375.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M879.36 635.17L864.74 617.92C864.37 617.48 863.71 617.43 863.27 617.8C862.83 618.17 862.78 618.83 863.15 619.27L877.76 636.53C878.14 636.97 878.8 637.02 879.24 636.64C879.67 636.27 879.73 635.61 879.36 635.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1153.71 551.1L1077.02 540.44C1076.45 540.36 1075.92 540.76 1075.84 541.33C1075.76 541.9 1076.16 542.43 1076.73 542.51L1153.42 553.19C1154 553.27 1154.53 552.87 1154.61 552.29C1154.69 551.71 1154.29 551.18 1153.71 551.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M974.99 516.36L1049.54 574.06C1050 574.4 1050.66 574.3 1051 573.84C1051.33 573.39 1051.25 572.76 1050.82 572.41L976.29 514.69C975.83 514.33 975.17 514.42 974.81 514.88C974.45 515.34 974.54 516 975 516.36H974.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M910.3 434.85L942.33 377.46C942.6 376.95 942.41 376.32 941.91 376.05C941.41 375.78 940.79 375.96 940.51 376.45L908.46 433.83C908.18 434.34 908.36 434.98 908.87 435.27C909.38 435.56 910.02 435.37 910.31 434.86L910.3 434.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1242.41 633.4L1219.18 613.39C1218.74 613.01 1218.09 613.06 1217.71 613.5C1217.33 613.94 1217.38 614.59 1217.82 614.97L1241.03 635C1241.47 635.38 1242.14 635.33 1242.52 634.89C1242.9 634.45 1242.85 633.78 1242.41 633.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1350.23 583.92L1342.04 650.23C1341.97 650.8 1342.38 651.32 1342.95 651.39C1343.52 651.46 1344.04 651.06 1344.11 650.48L1352.32 584.17C1352.39 583.59 1351.98 583.07 1351.41 583C1350.83 582.93 1350.31 583.34 1350.24 583.91L1350.23 583.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M621.71 450.44L625.17 375.59C625.2 375.01 624.75 374.53 624.18 374.5C623.6 374.47 623.12 374.92 623.09 375.49L619.62 450.34C619.61 450.92 620.06 451.4 620.64 451.42C621.2 451.43 621.68 451 621.72 450.44H621.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M620.33 449.39L571.81 465.63C571.26 465.81 570.97 466.4 571.15 466.95C571.33 467.5 571.92 467.79 572.47 467.61L621 451.39C621.55 451.21 621.85 450.61 621.66 450.06C621.48 449.51 620.88 449.21 620.33 449.4V449.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1154.5 552.63L1192.37 478.42C1192.63 477.91 1192.43 477.28 1191.92 477.02C1191.41 476.76 1190.78 476.96 1190.52 477.47L1152.63 551.67C1152.37 552.19 1152.57 552.82 1153.09 553.09C1153.61 553.36 1154.24 553.15 1154.51 552.63H1154.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1137.94 461.97L1035.82 460.74C1035.24 460.74 1034.77 461.19 1034.76 461.77C1034.76 462.35 1035.21 462.82 1035.79 462.83L1137.91 464.07C1138.49 464.07 1138.96 463.61 1138.97 463.04C1138.97 462.46 1138.52 461.99 1137.94 461.98V461.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1171.98 561.02L1192.46 478.19C1192.6 477.63 1192.26 477.07 1191.7 476.93C1191.14 476.79 1190.58 477.13 1190.44 477.69L1169.94 560.51C1169.8 561.07 1170.14 561.65 1170.71 561.78C1171.28 561.91 1171.85 561.58 1171.98 561.01V561.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M540.58 391.02L624.3 376.56C624.87 376.46 625.25 375.92 625.15 375.36C625.05 374.79 624.51 374.41 623.95 374.51L540.22 388.95C539.65 389.05 539.26 389.59 539.36 390.17C539.46 390.74 540 391.13 540.58 391.03V391.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M539.43 390.39L571.17 467.02C571.39 467.55 572 467.8 572.53 467.58C573.06 467.36 573.31 466.75 573.09 466.22L541.37 389.58C541.15 389.04 540.53 388.79 540 389.01C539.46 389.23 539.21 389.85 539.43 390.38V390.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M847.13 576.21L829.08 485.97C828.96 485.41 828.4 485.05 827.84 485.17C827.29 485.29 826.93 485.82 827.03 486.38L845.06 576.62C845.17 577.19 845.73 577.56 846.3 577.44C846.87 577.33 847.24 576.77 847.12 576.2L847.13 576.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M677.17 374.12L624.12 374.49C623.54 374.49 623.08 374.96 623.08 375.54C623.08 376.12 623.55 376.58 624.13 376.58L677.18 376.23C677.76 376.23 678.23 375.75 678.23 375.17C678.23 374.59 677.75 374.12 677.17 374.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M908.38 433.98L899.42 459.28C899.23 459.82 899.51 460.42 900.05 460.61C900.59 460.8 901.19 460.52 901.38 459.98L910.37 434.69C910.57 434.14 910.28 433.54 909.73 433.34C909.18 433.14 908.58 433.43 908.38 433.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M908.35 434.09L887.92 517.19C887.79 517.75 888.14 518.31 888.7 518.44C889.25 518.57 889.8 518.23 889.94 517.69L910.4 434.59C910.54 434.02 910.19 433.45 909.63 433.31C909.06 433.17 908.49 433.52 908.35 434.08V434.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M676.98 376.21L705.62 381.62C706.19 381.72 706.73 381.34 706.83 380.78C706.93 380.22 706.56 379.69 706.01 379.57L677.38 374.14C676.81 374.03 676.26 374.41 676.15 374.98C676.04 375.55 676.42 376.1 676.99 376.21H676.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M847.02 575.9L812.83 515.45C812.54 514.95 811.9 514.78 811.4 515.07C810.91 515.35 810.74 515.98 811.01 516.47L845.19 576.93C845.48 577.43 846.12 577.61 846.62 577.33C847.12 577.05 847.3 576.4 847.02 575.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M921.25 423.69L942.37 377.38C942.61 376.86 942.37 376.24 941.85 376C941.33 375.76 940.71 376 940.47 376.52L919.32 422.81C919.08 423.34 919.32 423.97 919.85 424.22C920.38 424.46 921.01 424.22 921.26 423.69H921.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M910.09 435.12L969.67 381.39C970.1 381 970.13 380.35 969.75 379.92C969.36 379.49 968.7 379.46 968.28 379.84L908.68 433.55C908.25 433.94 908.22 434.61 908.61 435.04C909 435.47 909.66 435.5 910.09 435.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1153.97 551.18L1070.24 515.28C1069.71 515.06 1069.1 515.31 1068.88 515.85C1068.67 516.37 1068.9 516.97 1069.42 517.2L1153.14 553.12C1153.68 553.34 1154.29 553.07 1154.51 552.53C1154.72 552.01 1154.48 551.42 1153.97 551.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1121.34 409.69L1115.93 420.4C1115.67 420.91 1115.87 421.54 1116.39 421.8C1116.9 422.06 1117.53 421.86 1117.79 421.34L1123.23 410.64C1123.49 410.12 1123.29 409.48 1122.76 409.21C1122.23 408.94 1121.6 409.15 1121.33 409.68L1121.34 409.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M975.63 516.58L1069.83 517.27C1070.41 517.27 1070.88 516.81 1070.88 516.24C1070.88 515.66 1070.42 515.19 1069.85 515.19L975.65 514.47C975.07 514.47 974.59 514.93 974.59 515.52C974.59 516.1 975.05 516.58 975.64 516.58H975.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M846.79 577.21L913.38 519.44C913.82 519.06 913.86 518.4 913.48 517.97C913.1 517.54 912.44 517.49 912.01 517.87L845.41 575.63C844.97 576.01 844.92 576.67 845.3 577.11C845.68 577.55 846.34 577.6 846.78 577.22L846.79 577.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M919.35 422.74L899.48 459.13C899.21 459.64 899.4 460.27 899.91 460.54C900.41 460.81 901.03 460.62 901.31 460.13L921.21 423.76C921.49 423.25 921.3 422.6 920.79 422.32C920.28 422.04 919.63 422.23 919.35 422.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1154.6 551.96L1138.96 462.83C1138.85 462.26 1138.3 461.9 1137.73 462.01C1137.18 462.12 1136.82 462.64 1136.9 463.19L1152.52 552.33C1152.62 552.9 1153.17 553.29 1153.74 553.19C1154.31 553.09 1154.7 552.54 1154.59 551.97L1154.6 551.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M968.28 379.83L919.58 422.45C919.14 422.84 919.11 423.51 919.5 423.95C919.88 424.38 920.54 424.42 920.98 424.05L969.65 381.4C970.08 381.01 970.11 380.36 969.73 379.93C969.35 379.51 968.71 379.47 968.28 379.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M976.34 516.32L1036.51 462.56C1036.93 462.17 1036.96 461.51 1036.56 461.09C1036.18 460.68 1035.54 460.64 1035.12 461.01L974.94 514.75C974.51 515.14 974.47 515.8 974.86 516.24C975.25 516.67 975.91 516.71 976.35 516.32H976.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1449.09 554.13L1510.41 581.81C1510.93 582.05 1511.55 581.81 1511.79 581.29C1512.03 580.77 1511.79 580.15 1511.27 579.91L1449.96 552.2C1449.43 551.96 1448.8 552.2 1448.56 552.73C1448.32 553.26 1448.56 553.89 1449.09 554.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M997.94 470.58L1015.58 405.68C1015.73 405.12 1015.4 404.55 1014.85 404.4C1014.29 404.25 1013.72 404.58 1013.57 405.13L995.9 470.02C995.75 470.59 996.08 471.17 996.65 471.32C997.22 471.47 997.8 471.14 997.95 470.57L997.94 470.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M912.75 519.7L975.69 516.58C976.27 516.54 976.71 516.03 976.66 515.45C976.62 514.89 976.14 514.46 975.58 514.48L912.64 517.62C912.06 517.65 911.62 518.15 911.66 518.72C911.69 519.29 912.18 519.73 912.74 519.7H912.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1260.3 664.35L1226.52 594.94C1226.26 594.42 1225.63 594.21 1225.12 594.47C1224.61 594.72 1224.4 595.34 1224.64 595.85L1258.41 665.27C1258.67 665.79 1259.3 666 1259.82 665.75C1260.34 665.49 1260.55 664.87 1260.3 664.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1235.65 624.57L1219.08 613.32C1218.6 613 1217.96 613.12 1217.63 613.59C1217.31 614.07 1217.43 614.71 1217.9 615.04L1234.44 626.33C1234.93 626.65 1235.59 626.52 1235.92 626.02C1236.24 625.54 1236.11 624.89 1235.64 624.56L1235.65 624.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1153.02 553.05L1225.04 596.29C1225.54 596.58 1226.18 596.42 1226.47 595.92C1226.76 595.43 1226.6 594.8 1226.11 594.5L1154.1 551.25C1153.6 550.96 1152.95 551.14 1152.66 551.64C1152.38 552.13 1152.54 552.75 1153.01 553.05H1153.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1170.39 561.66L1225.01 596.28C1225.5 596.58 1226.15 596.43 1226.45 595.94C1226.75 595.46 1226.61 594.82 1226.13 594.51L1171.51 559.88C1171.01 559.58 1170.37 559.73 1170.06 560.23C1169.76 560.72 1169.9 561.35 1170.38 561.66H1170.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M996.35 471.2L1069.27 517.12C1069.76 517.42 1070.4 517.26 1070.7 516.77C1070.99 516.29 1070.85 515.66 1070.38 515.35L997.48 469.4C996.98 469.09 996.33 469.24 996.02 469.73C995.71 470.23 995.86 470.88 996.35 471.19V471.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M908.33 434.38L911.66 518.7C911.68 519.28 912.17 519.73 912.74 519.7C913.32 519.68 913.77 519.19 913.74 518.62L910.43 434.3C910.39 433.72 909.89 433.28 909.31 433.31C908.75 433.34 908.31 433.82 908.32 434.38H908.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1242.69 633.8L1226.54 594.99C1226.31 594.46 1225.69 594.22 1225.16 594.45C1224.64 594.68 1224.4 595.27 1224.61 595.79L1240.74 634.6C1240.97 635.13 1241.6 635.38 1242.13 635.14C1242.65 634.91 1242.9 634.32 1242.69 633.79V633.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M845.18 576.92L877.63 636.35C877.91 636.86 878.55 637.05 879.06 636.77C879.57 636.49 879.76 635.85 879.48 635.34L847.03 575.91C846.75 575.4 846.11 575.21 845.6 575.49C845.09 575.77 844.9 576.41 845.18 576.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1497.74 637.91L1511.83 581.11C1511.95 580.55 1511.6 579.99 1511.04 579.87C1510.5 579.75 1509.96 580.08 1509.81 580.61L1495.66 637.4C1495.52 637.97 1495.87 638.55 1496.44 638.69C1497.01 638.83 1497.59 638.48 1497.73 637.91H1497.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M264.67 379.87L338.17 372.95C338.74 372.89 339.16 372.37 339.09 371.8C339.03 371.24 338.53 370.83 337.97 370.87L264.47 377.74C263.88 377.8 263.45 378.32 263.51 378.9C263.56 379.49 264.09 379.92 264.67 379.86V379.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M984.38 654.25L1008.65 620.67C1008.99 620.2 1008.88 619.55 1008.42 619.21C1007.95 618.87 1007.3 618.98 1006.96 619.44L982.65 653C982.3 653.48 982.41 654.14 982.89 654.49C983.37 654.84 984.03 654.73 984.38 654.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M621.29 449.55L541.03 389.15C540.56 388.81 539.9 388.92 539.56 389.39C539.23 389.85 539.32 390.48 539.76 390.83L620.02 451.23C620.49 451.57 621.15 451.47 621.49 451C621.83 450.54 621.74 449.9 621.28 449.55H621.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M997.14 471.34L1036.03 462.8C1036.59 462.66 1036.93 462.1 1036.8 461.54C1036.67 461 1036.13 460.66 1035.59 460.76L996.69 469.27C996.12 469.4 995.76 469.97 995.89 470.54C996.02 471.11 996.58 471.46 997.15 471.34H997.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1121.27 410.47L1136.93 463.31C1137.1 463.86 1137.69 464.17 1138.24 464C1138.78 463.83 1139.09 463.26 1138.94 462.72L1123.31 409.87C1123.14 409.31 1122.55 408.99 1121.99 409.15C1121.43 409.32 1121.11 409.91 1121.27 410.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1350.41 584.64L1395.25 650.59C1395.59 651.06 1396.25 651.17 1396.72 650.83C1397.18 650.5 1397.3 649.88 1396.99 649.4L1352.15 583.45C1351.82 582.97 1351.17 582.85 1350.69 583.17C1350.21 583.5 1350.09 584.15 1350.41 584.63V584.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M676.33 374.54L619.82 449.75C619.47 450.21 619.56 450.87 620.03 451.22C620.49 451.57 621.15 451.48 621.5 451.01L678.01 375.8C678.36 375.33 678.26 374.67 677.79 374.33C677.33 373.99 676.68 374.08 676.33 374.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M802.02 483.93L860.42 524.33C860.9 524.66 861.57 524.54 861.9 524.06C862.23 523.58 862.11 522.91 861.63 522.58L803.21 482.22C802.74 481.89 802.09 482.01 801.76 482.48C801.43 482.95 801.55 483.6 802.02 483.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1153.09 553.09L1170.49 561.71C1171.02 561.95 1171.64 561.72 1171.89 561.2C1172.13 560.69 1171.92 560.09 1171.43 559.83L1154.03 551.21C1153.51 550.96 1152.88 551.18 1152.62 551.7C1152.37 552.22 1152.58 552.84 1153.09 553.1V553.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M919.23 423.17L911.66 518.58C911.62 519.16 912.06 519.65 912.64 519.69C913.2 519.72 913.69 519.31 913.74 518.75L921.34 423.35C921.39 422.77 920.95 422.25 920.37 422.21C919.79 422.17 919.27 422.6 919.23 423.18V423.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1240.8 634.73L1258.43 665.33C1258.72 665.83 1259.36 666.01 1259.87 665.72C1260.38 665.43 1260.55 664.79 1260.26 664.28L1242.63 633.68C1242.34 633.18 1241.69 633 1241.19 633.29C1240.69 633.58 1240.51 634.23 1240.8 634.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1242.48 633.47L1171.72 560.04C1171.31 559.62 1170.65 559.62 1170.23 560.02C1169.82 560.42 1169.81 561.08 1170.2 561.5L1240.96 634.94C1241.37 635.35 1242.04 635.36 1242.45 634.94C1242.86 634.54 1242.87 633.89 1242.48 633.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M908.56 435L974.82 516.19C975.2 516.64 975.86 516.69 976.31 516.32C976.75 515.95 976.81 515.31 976.46 514.86L910.2 433.67C909.83 433.22 909.16 433.17 908.71 433.54C908.27 433.91 908.21 434.56 908.56 435Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M625.99 523.69L699.56 581.12C700.02 581.47 700.68 581.38 701.03 580.92C701.37 580.47 701.29 579.82 700.85 579.47L627.29 522.03C626.82 521.68 626.16 521.77 625.8 522.24C625.45 522.7 625.53 523.35 625.98 523.7L625.99 523.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M619.61 450.48L625.59 522.94C625.65 523.52 626.17 523.95 626.75 523.89C627.32 523.83 627.74 523.34 627.7 522.77L621.71 450.31C621.66 449.73 621.15 449.3 620.58 449.35C620.01 449.4 619.57 449.91 619.62 450.48H619.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1236.07 625.13L1226.58 595.07C1226.41 594.52 1225.82 594.21 1225.27 594.39C1224.72 594.57 1224.41 595.15 1224.59 595.7L1234.04 625.77C1234.22 626.33 1234.82 626.64 1235.38 626.47C1235.94 626.29 1236.25 625.69 1236.08 625.13H1236.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.81 508.02L84.45 494.5C84.92 494.15 85.0101 493.48 84.6501 493.02C84.3101 492.57 83.67 492.47 83.21 492.79L64.57 506.31C64.11 506.66 64.0201 507.33 64.3701 507.79C64.7101 508.24 65.35 508.34 65.81 508.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1154.26 586.79L1225.43 596.43C1226 596.5 1226.53 596.1 1226.6 595.52C1226.67 594.95 1226.28 594.44 1225.71 594.35L1154.54 584.67C1153.96 584.59 1153.42 585 1153.34 585.58C1153.26 586.16 1153.67 586.7 1154.25 586.78L1154.26 586.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M995.96 469.85L974.69 515.08C974.44 515.61 974.67 516.24 975.19 516.48C975.72 516.73 976.35 516.5 976.59 515.97L997.88 470.75C998.13 470.22 997.9 469.59 997.37 469.34C996.84 469.09 996.21 469.32 995.96 469.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M908.98 435.31L996.52 471.28C997.07 471.49 997.68 471.22 997.89 470.68C998.1 470.15 997.85 469.55 997.32 469.32L909.78 433.36C909.24 433.14 908.62 433.4 908.4 433.94C908.18 434.48 908.44 435.1 908.98 435.32V435.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M910.13 435.08L921.04 424C921.44 423.57 921.42 422.9 921 422.5C920.59 422.11 919.94 422.11 919.53 422.51L908.63 433.6C908.22 434.02 908.23 434.68 908.64 435.09C909.05 435.5 909.72 435.49 910.13 435.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M996.99 485.59L1036.33 462.68C1036.82 462.38 1036.98 461.74 1036.68 461.25C1036.39 460.77 1035.77 460.61 1035.28 460.88L995.9 483.73C995.39 484.03 995.21 484.69 995.51 485.2C995.81 485.71 996.47 485.89 996.98 485.59H996.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1234.14 626.02L1258.45 665.36C1258.76 665.85 1259.4 666.01 1259.9 665.7C1260.4 665.39 1260.55 664.75 1260.24 664.25L1235.95 624.89C1235.63 624.39 1234.97 624.24 1234.48 624.56C1233.99 624.87 1233.84 625.51 1234.14 626.01V626.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1155.47 585.71L1154.61 552.12C1154.6 551.54 1154.11 551.08 1153.53 551.09C1152.95 551.1 1152.49 551.59 1152.5 552.17L1153.33 585.76C1153.36 586.35 1153.86 586.8 1154.45 586.77C1155.02 586.74 1155.46 586.27 1155.46 585.7L1155.47 585.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1235.81 624.7L1171.71 560.02C1171.29 559.61 1170.63 559.62 1170.22 560.04C1169.83 560.45 1169.82 561.09 1170.22 561.5L1234.3 626.2C1234.72 626.61 1235.4 626.61 1235.81 626.2C1236.22 625.79 1236.22 625.12 1235.81 624.71V624.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1155.3 586.32L1171.84 561.35C1172.16 560.87 1172.03 560.21 1171.54 559.89C1171.06 559.57 1170.4 559.7 1170.08 560.19L1153.52 585.15C1153.19 585.64 1153.33 586.3 1153.82 586.63C1154.31 586.96 1154.97 586.82 1155.3 586.33V586.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1438.11 501.98L1414.1 463.82C1413.79 463.33 1413.15 463.18 1412.66 463.49C1412.17 463.8 1412.02 464.44 1412.33 464.93L1436.29 503.12C1436.61 503.62 1437.27 503.78 1437.77 503.46C1438.27 503.14 1438.43 502.48 1438.11 501.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1242.55 633.56L1235.89 624.8C1235.53 624.33 1234.86 624.25 1234.39 624.61C1233.93 624.97 1233.84 625.63 1234.19 626.09L1240.87 634.83C1241.23 635.29 1241.89 635.37 1242.35 635.01C1242.8 634.66 1242.89 634.01 1242.55 633.55V633.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1242.23 633.28L1154.93 584.8C1154.41 584.53 1153.76 584.74 1153.49 585.26C1153.23 585.76 1153.41 586.38 1153.89 586.67L1241.21 635.13C1241.72 635.4 1242.36 635.21 1242.64 634.7C1242.91 634.2 1242.73 633.58 1242.24 633.29L1242.23 633.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M919.73 424.16L996.36 471.21C996.86 471.51 997.52 471.34 997.81 470.83C998.1 470.34 997.95 469.71 997.47 469.4L920.84 422.35C920.33 422.05 919.68 422.22 919.39 422.73C919.1 423.22 919.25 423.85 919.73 424.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1350.53 584.78L1381.59 616.41C1382.01 616.83 1382.68 616.83 1383.11 616.41C1383.53 616 1383.53 615.32 1383.12 614.9L1352.03 583.3C1351.61 582.9 1350.94 582.91 1350.54 583.33C1350.16 583.73 1350.15 584.36 1350.53 584.77V584.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M526.4 420.27L541.35 390.45C541.61 389.93 541.4 389.3 540.88 389.04C540.36 388.78 539.73 388.99 539.47 389.51L524.49 419.31C524.24 419.85 524.47 420.48 525.01 420.73C525.52 420.97 526.14 420.77 526.4 420.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1381.36 616.06L1395.15 650.38C1395.37 650.92 1395.99 651.17 1396.53 650.95C1397.06 650.73 1397.31 650.13 1397.11 649.6L1383.36 615.26C1383.14 614.71 1382.52 614.44 1381.97 614.66C1381.42 614.88 1381.15 615.5 1381.37 616.05L1381.36 616.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1240.66 634.25L1243.31 694.66C1243.34 695.25 1243.84 695.71 1244.43 695.68C1245.02 695.65 1245.48 695.15 1245.45 694.56L1242.76 634.15C1242.73 633.57 1242.23 633.13 1241.65 633.16C1241.08 633.19 1240.64 633.67 1240.66 634.24V634.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1381.78 446.54L1412.66 465.27C1413.15 465.57 1413.8 465.41 1414.1 464.92C1414.4 464.43 1414.24 463.78 1413.75 463.48L1382.91 444.69C1382.4 444.38 1381.73 444.54 1381.42 445.05C1381.11 445.56 1381.27 446.23 1381.78 446.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1448.6 553.68L1495.78 638.17C1496.07 638.69 1496.72 638.87 1497.23 638.58C1497.75 638.29 1497.93 637.64 1497.64 637.13L1450.45 552.64C1450.16 552.13 1449.51 551.96 1449 552.25C1448.5 552.54 1448.32 553.17 1448.6 553.67V553.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M64.15 507.37L81.29 596.28C81.4 596.86 81.96 597.24 82.55 597.13C83.13 597.02 83.51 596.45 83.4 595.87L66.22 506.97C66.1 506.4 65.55 506.03 64.97 506.14C64.41 506.25 64.04 506.8 64.14 507.37H64.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M509.16 439.87L541.28 390.56C541.58 390.06 541.43 389.42 540.93 389.11C540.45 388.82 539.84 388.95 539.52 389.41L507.35 438.69C507.03 439.19 507.17 439.86 507.66 440.18C508.16 440.51 508.83 440.36 509.15 439.87H509.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1186.93 483.39L1152.62 551.67C1152.36 552.19 1152.58 552.82 1153.1 553.08C1153.61 553.33 1154.23 553.13 1154.5 552.62L1188.86 484.36C1189.13 483.83 1188.91 483.18 1188.38 482.91C1187.85 482.64 1187.2 482.86 1186.93 483.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M58.8 527.86L84.67 494.29C85.03 493.83 84.94 493.16 84.48 492.81C84.02 492.45 83.35 492.54 83 493L57.11 526.55C56.75 527.02 56.84 527.69 57.3 528.05C57.77 528.41 58.44 528.32 58.8 527.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M995.56 484.06L974.76 514.94C974.44 515.43 974.58 516.08 975.07 516.4C975.55 516.71 976.18 516.59 976.51 516.12L997.34 485.26C997.67 484.77 997.54 484.1 997.05 483.77C996.56 483.44 995.89 483.57 995.56 484.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1186.84 483.64L1169.92 560.54C1169.79 561.11 1170.15 561.67 1170.72 561.8C1171.29 561.93 1171.85 561.57 1171.98 561L1188.94 484.11C1189.07 483.53 1188.7 482.95 1188.12 482.83C1187.54 482.7 1186.96 483.07 1186.84 483.65V483.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1240.68 634.02L1226.14 713.91C1226.03 714.5 1226.42 715.06 1227.01 715.16C1227.6 715.26 1228.16 714.88 1228.26 714.29L1242.75 634.39C1242.85 633.82 1242.47 633.27 1241.9 633.16C1241.33 633.06 1240.78 633.44 1240.67 634.01L1240.68 634.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M263.53 378.56L241.33 472.46C241.2 473.03 241.56 473.6 242.13 473.74C242.7 473.87 243.27 473.52 243.4 472.95L265.6 379.05C265.74 378.48 265.38 377.9 264.81 377.77C264.24 377.63 263.66 377.99 263.53 378.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1383.08 616.45L1450.25 553.94C1450.67 553.53 1450.68 552.86 1450.27 552.44C1449.87 552.03 1449.22 552.01 1448.8 552.39L1381.62 614.88C1381.19 615.28 1381.16 615.96 1381.57 616.39C1381.97 616.82 1382.65 616.85 1383.08 616.44V616.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M115.48 450.95L64.41 506.45C64.01 506.88 64.04 507.55 64.47 507.94C64.9 508.33 65.57 508.31 65.96 507.88L117.06 452.41C117.46 451.97 117.43 451.29 117 450.89C116.56 450.49 115.88 450.52 115.48 450.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M104.56 530.77L65.7599 506.27C65.2599 505.97 64.6099 506.14 64.3099 506.64C64.0199 507.12 64.1599 507.75 64.6299 508.06L103.41 532.6C103.91 532.92 104.58 532.77 104.9 532.26C105.22 531.75 105.07 531.09 104.56 530.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M525.22 418.75L434.38 437.7C433.81 437.83 433.45 438.41 433.59 438.98C433.72 439.53 434.26 439.89 434.82 439.78L525.67 420.85C526.25 420.72 526.62 420.15 526.49 419.58C526.37 419.01 525.81 418.64 525.23 418.76L525.22 418.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M115.42 451.02L82.99 493C82.64 493.47 82.73 494.13 83.2 494.48C83.66 494.83 84.31 494.74 84.67 494.29L117.13 452.34C117.49 451.87 117.41 451.19 116.94 450.83C116.47 450.47 115.79 450.55 115.43 451.02H115.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1235.52 624.5L1154.88 584.78C1154.35 584.52 1153.71 584.74 1153.45 585.27C1153.19 585.8 1153.41 586.44 1153.94 586.7L1234.58 626.42C1235.11 626.68 1235.75 626.46 1236.01 625.93C1236.27 625.4 1236.05 624.76 1235.52 624.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M104.93 531.18L84.7599 493.15C84.4899 492.63 83.8499 492.44 83.3299 492.71C82.8099 492.98 82.6199 493.62 82.8899 494.14L103.03 532.19C103.32 532.71 103.97 532.9 104.5 532.61C105.01 532.33 105.2 531.69 104.94 531.18H104.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M997.53 484.69L997.98 470.33C997.99 469.74 997.52 469.26 996.94 469.25C996.37 469.24 995.89 469.69 995.86 470.26L995.38 484.61C995.36 485.2 995.83 485.7 996.42 485.72C997.01 485.74 997.51 485.27 997.53 484.68V484.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1496.1 638.53L1536.29 666.48C1536.78 666.82 1537.45 666.7 1537.79 666.21C1538.13 665.72 1538.01 665.05 1537.52 664.71L1497.32 636.78C1496.84 636.44 1496.17 636.56 1495.84 637.04C1495.5 637.52 1495.62 638.19 1496.1 638.52V638.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1450.55 552.91L1438.24 502.29C1438.09 501.71 1437.5 501.37 1436.93 501.52C1436.37 501.67 1436.02 502.23 1436.15 502.8L1448.49 553.41C1448.63 553.98 1449.2 554.33 1449.77 554.19C1450.34 554.05 1450.69 553.48 1450.55 552.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1233.99 625.6L1243.32 694.76C1243.42 695.34 1243.97 695.74 1244.55 695.64C1245.11 695.55 1245.5 695.04 1245.44 694.47L1236.1 625.31C1236.02 624.73 1235.48 624.32 1234.9 624.39C1234.32 624.47 1233.91 625.01 1233.98 625.59L1233.99 625.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M508.27 438.2L434.61 437.67C434.02 437.67 433.54 438.14 433.54 438.73C433.54 439.32 434.01 439.8 434.6 439.8L508.26 440.36C508.85 440.36 509.34 439.88 509.34 439.28C509.34 438.69 508.87 438.21 508.28 438.2H508.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1063.36 418.65L996.28 469.46C995.82 469.82 995.73 470.48 996.09 470.95C996.44 471.41 997.1 471.5 997.56 471.15L1064.67 420.38C1065.15 420.02 1065.24 419.34 1064.88 418.86C1064.52 418.38 1063.84 418.29 1063.36 418.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1064.18 420.59L1122.45 411.22C1123.03 411.13 1123.42 410.58 1123.33 410C1123.24 409.42 1122.69 409.03 1122.11 409.12L1063.83 418.44C1063.24 418.54 1062.84 419.09 1062.93 419.68C1063.03 420.27 1063.58 420.67 1064.17 420.58L1064.18 420.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M56.9399 527.56L81.3399 596.42C81.5399 596.98 82.1499 597.27 82.7099 597.07C83.2699 596.87 83.5599 596.26 83.3599 595.7L58.9599 526.84C58.7599 526.28 58.1499 525.99 57.5899 526.19C57.0299 526.39 56.7399 527 56.9399 527.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1233.98 625.36L1226.12 714C1226.07 714.59 1226.51 715.12 1227.1 715.17C1227.69 715.22 1228.22 714.78 1228.27 714.19L1236.11 625.54C1236.16 624.95 1235.73 624.43 1235.14 624.38C1234.55 624.33 1234.03 624.76 1233.98 625.35V625.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1475.73 465.85L1448.51 552.85C1448.33 553.41 1448.65 554.01 1449.21 554.18C1449.77 554.36 1450.37 554.04 1450.54 553.48L1477.81 466.5C1477.99 465.93 1477.67 465.32 1477.1 465.14C1476.53 464.96 1475.92 465.28 1475.74 465.85H1475.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M81.61 595.29L38.16 637.09C37.73 637.5 37.72 638.18 38.13 638.61C38.54 639.04 39.22 639.05 39.65 638.64L83.1 596.84C83.53 596.43 83.54 595.75 83.13 595.32C82.72 594.89 82.04 594.88 81.61 595.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M346.71 479.11L435.03 439.71C435.56 439.46 435.78 438.82 435.53 438.29C435.29 437.78 434.69 437.55 434.16 437.77L345.83 477.14C345.29 477.39 345.05 478.04 345.31 478.58C345.56 479.11 346.18 479.35 346.72 479.12L346.71 479.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M524.64 419.09L507.45 438.57C507.07 439.02 507.12 439.7 507.58 440.09C508.02 440.46 508.68 440.42 509.07 440L526.25 420.51C526.64 420.07 526.6 419.39 526.16 419C525.72 418.61 525.04 418.65 524.65 419.1L524.64 419.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M423.62 496.48L435.64 438.96C435.76 438.38 435.39 437.82 434.82 437.7C434.24 437.58 433.68 437.95 433.56 438.52L421.5 496.04C421.38 496.63 421.75 497.2 422.34 497.32C422.93 497.44 423.5 497.07 423.62 496.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M115.42 451.02L57.0999 526.55C56.7399 527.02 56.8199 527.69 57.2899 528.05C57.7599 528.41 58.4299 528.33 58.7899 527.86L117.12 452.34C117.48 451.86 117.37 451.19 116.9 450.83C116.43 450.48 115.78 450.57 115.42 451.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.84 528.27L103.87 532.76C104.46 532.81 104.98 532.36 105.03 531.77C105.08 531.19 104.66 530.68 104.08 530.61L58.04 526.14C57.45 526.09 56.93 526.53 56.89 527.12C56.84 527.7 57.26 528.2 57.84 528.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M102.96 531.34L81.3399 595.73C81.1499 596.29 81.4499 596.9 82.0199 597.09C82.5799 597.28 83.1899 596.98 83.3799 596.41L105.02 532.03C105.21 531.46 104.91 530.85 104.34 530.66C103.77 530.47 103.16 530.77 102.97 531.34H102.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M390.58 429.14L434.34 439.77C434.91 439.91 435.49 439.56 435.63 438.99C435.77 438.42 435.42 437.84 434.85 437.7L391.1 427.03C390.51 426.89 389.93 427.26 389.79 427.84C389.66 428.42 390.01 429 390.58 429.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M38.22 638.69L115.36 702.56C115.82 702.94 116.5 702.88 116.88 702.42C117.26 701.96 117.2 701.28 116.74 700.9L39.59 637.04C39.13 636.67 38.45 636.73 38.08 637.19C37.71 637.64 37.77 638.31 38.22 638.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.02 600.94L82.51 597.13C83.1 597.04 83.5 596.5 83.41 595.91C83.32 595.32 82.78 594.92 82.19 595.01L56.7 598.8C56.11 598.9 55.71 599.45 55.81 600.04C55.9 600.62 56.44 601.02 57.02 600.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M437.35 466.42L435.65 438.67C435.61 438.08 435.11 437.64 434.52 437.67C433.94 437.71 433.49 438.21 433.52 438.79L435.16 466.54C435.2 467.14 435.73 467.59 436.33 467.55C436.92 467.51 437.37 467 437.34 466.41L437.35 466.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.31 379.84L315.31 392.39C315.89 392.53 316.48 392.18 316.63 391.59C316.78 391 316.42 390.42 315.83 390.27L264.82 377.76C264.24 377.63 263.67 377.99 263.55 378.57C263.43 379.13 263.76 379.69 264.32 379.83L264.31 379.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M115.21 451.51L102.92 531.52C102.83 532.11 103.23 532.66 103.82 532.75C104.41 532.84 104.96 532.44 105.05 531.85L117.34 451.84C117.42 451.25 117.01 450.71 116.42 450.62C115.84 450.54 115.31 450.93 115.21 451.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1381.57 446.37L1436.42 503.3C1436.83 503.73 1437.51 503.74 1437.94 503.33C1438.37 502.92 1438.38 502.24 1437.97 501.81L1383.13 444.87C1382.71 444.44 1382.03 444.44 1381.6 444.86C1381.18 445.27 1381.17 445.95 1381.57 446.38V446.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M103.09 531.07L55.9699 599.25C55.6299 599.74 55.7499 600.41 56.2499 600.75C56.7399 601.09 57.4099 600.97 57.7499 600.47L104.87 532.29C105.21 531.8 105.09 531.13 104.6 530.79C104.11 530.45 103.44 530.57 103.1 531.06L103.09 531.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M997.2 485.43L1064.76 420.29C1065.19 419.87 1065.2 419.19 1064.79 418.76C1064.37 418.33 1063.69 418.32 1063.26 418.73L995.71 483.88C995.3 484.31 995.31 484.99 995.73 485.4C996.14 485.79 996.78 485.81 997.2 485.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M242.13 471.66L160.44 490.55C159.85 490.69 159.48 491.28 159.62 491.86C159.76 492.45 160.35 492.82 160.93 492.68L242.6 473.73C243.17 473.59 243.52 473.02 243.38 472.44C243.24 471.88 242.68 471.53 242.12 471.65L242.13 471.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1476.03 465.38L1436.46 501.76C1436.02 502.16 1436 502.85 1436.41 503.28C1436.81 503.71 1437.49 503.74 1437.92 503.34L1477.5 466.97C1477.94 466.56 1477.97 465.88 1477.56 465.44C1477.15 465 1476.47 464.97 1476.03 465.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1247.74 405.83L1187.05 483.21C1186.68 483.68 1186.76 484.36 1187.23 484.72C1187.7 485.09 1188.38 485.01 1188.74 484.54L1249.44 407.17C1249.81 406.7 1249.72 406.02 1249.25 405.65C1248.78 405.29 1248.11 405.37 1247.74 405.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M285.06 671.84L318.13 693.25C318.63 693.57 319.29 693.43 319.61 692.93C319.93 692.43 319.79 691.77 319.29 691.45L286.25 670.01C285.74 669.68 285.07 669.83 284.74 670.33C284.41 670.84 284.56 671.51 285.06 671.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1212.8 471.08L1187.44 482.9C1186.9 483.15 1186.67 483.79 1186.92 484.33C1187.17 484.87 1187.81 485.1 1188.35 484.85L1213.71 473.04C1214.25 472.78 1214.47 472.13 1214.2 471.59C1213.94 471.07 1213.32 470.84 1212.79 471.08H1212.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M507.66 438.38L421.96 495.35C421.47 495.69 421.34 496.36 421.68 496.86C422.01 497.34 422.67 497.48 423.16 497.16L508.86 440.18C509.35 439.84 509.47 439.17 509.12 438.68C508.79 438.21 508.15 438.08 507.66 438.39V438.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1261.57 641.52L1235.63 624.56C1235.14 624.24 1234.47 624.37 1234.15 624.87C1233.83 625.36 1233.96 626.03 1234.46 626.35L1260.37 643.36C1260.88 643.69 1261.56 643.55 1261.89 643.04C1262.22 642.53 1262.08 641.85 1261.57 641.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1477 465.12L1382.58 444.56C1381.99 444.44 1381.42 444.82 1381.3 445.4C1381.18 445.97 1381.54 446.54 1382.12 446.67L1476.54 467.23C1477.13 467.35 1477.7 466.97 1477.81 466.38C1477.92 465.81 1477.56 465.25 1477 465.11V465.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M346.02 479.18L422.31 497.31C422.89 497.45 423.48 497.09 423.62 496.51C423.76 495.93 423.4 495.34 422.82 495.2L346.53 477.07C345.95 476.94 345.37 477.31 345.24 477.89C345.11 478.46 345.46 479.03 346.03 479.18H346.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1247.64 405.99L1212.3 471.55C1212.02 472.08 1212.21 472.73 1212.74 473.02C1213.27 473.31 1213.92 473.11 1214.21 472.58L1249.55 407.02C1249.82 406.49 1249.61 405.83 1249.08 405.56C1248.56 405.29 1247.93 405.48 1247.64 405.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M436.65 467.5L508.64 440.28C509.19 440.05 509.45 439.42 509.23 438.87C509.01 438.34 508.42 438.08 507.88 438.26L435.88 465.45C435.32 465.68 435.05 466.31 435.28 466.87C435.5 467.41 436.1 467.68 436.65 467.49V467.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M284.57 670.84L277.73 752.48C277.69 753.07 278.14 753.59 278.74 753.62C279.32 753.66 279.82 753.23 279.88 752.66L286.75 671.02C286.8 670.42 286.35 669.89 285.75 669.85C285.16 669.8 284.63 670.24 284.58 670.84H284.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1259.93 642.11L1243.37 694.29C1243.21 694.86 1243.54 695.45 1244.11 695.61C1244.65 695.76 1245.22 695.47 1245.41 694.94L1262.02 642.77C1262.19 642.19 1261.85 641.58 1261.27 641.41C1260.71 641.25 1260.12 641.55 1259.93 642.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M103.64 532.71L185.98 560.54C186.55 560.73 187.17 560.42 187.36 559.85C187.55 559.28 187.25 558.67 186.68 558.47L104.34 530.66C103.77 530.47 103.16 530.78 102.98 531.35C102.8 531.91 103.09 532.51 103.65 532.71H103.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1345.73 475.26L1436.87 503.58C1437.44 503.74 1438.04 503.41 1438.2 502.84C1438.36 502.29 1438.05 501.71 1437.51 501.52L1346.38 473.17C1345.8 472.99 1345.19 473.32 1345.01 473.9C1344.83 474.47 1345.15 475.08 1345.73 475.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M390.02 427.36L345.45 477.4C345.05 477.85 345.09 478.53 345.54 478.93C345.99 479.33 346.67 479.29 347.07 478.84L391.64 428.81C392.03 428.35 391.97 427.66 391.51 427.28C391.07 426.91 390.41 426.95 390.02 427.37V427.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M347.29 477.76L316.6 390.97C316.4 390.4 315.78 390.1 315.21 390.31C314.64 390.52 314.34 391.13 314.55 391.7L345.25 478.49C345.45 479.05 346.07 479.35 346.63 479.15C347.19 478.95 347.49 478.33 347.29 477.77V477.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1561.73 634.21L1536.08 664.91C1535.7 665.36 1535.76 666.04 1536.22 666.42C1536.67 666.8 1537.35 666.74 1537.73 666.29L1563.42 635.62C1563.81 635.15 1563.75 634.46 1563.28 634.07C1562.81 633.68 1562.12 633.74 1561.73 634.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M436.12 465.4L346.12 477.05C345.53 477.13 345.11 477.67 345.18 478.26C345.26 478.85 345.8 479.27 346.39 479.2L436.39 467.57C436.99 467.48 437.39 466.92 437.3 466.33C437.21 465.76 436.69 465.35 436.11 465.41L436.12 465.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M389.85 428.55L421.57 496.72C421.82 497.26 422.47 497.5 423.01 497.25C423.55 497 423.79 496.35 423.54 495.81L391.82 427.64C391.56 427.1 390.91 426.87 390.37 427.14C389.84 427.4 389.61 428.02 389.85 428.56V428.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M115.55 452.48L159.95 492.43C160.4 492.83 161.09 492.8 161.5 492.35C161.9 491.9 161.87 491.21 161.42 490.8L116.99 450.87C116.54 450.48 115.86 450.52 115.47 450.97C115.08 451.41 115.12 452.08 115.55 452.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M104.6 532.57L161.32 492.52C161.81 492.17 161.93 491.49 161.58 490.99C161.23 490.5 160.55 490.38 160.05 490.73L103.35 530.81C102.86 531.15 102.75 531.83 103.09 532.31C103.43 532.8 104.11 532.91 104.59 532.57H104.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1382.21 444.54L1323.42 451.8C1322.82 451.89 1322.41 452.45 1322.5 453.05C1322.59 453.62 1323.11 454.03 1323.68 453.97L1382.47 446.69C1383.06 446.61 1383.48 446.07 1383.4 445.48C1383.32 444.89 1382.79 444.48 1382.2 444.55L1382.21 444.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1259.98 641.97L1226.23 713.64C1225.98 714.18 1226.21 714.82 1226.75 715.07C1227.29 715.32 1227.93 715.09 1228.18 714.55L1261.97 642.9C1262.22 642.35 1261.97 641.7 1261.41 641.45C1260.87 641.21 1260.25 641.44 1259.98 641.96V641.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M159.96 630.29L115.14 701.16C114.82 701.66 114.97 702.33 115.48 702.65C115.98 702.97 116.65 702.82 116.97 702.31L161.82 631.46C162.14 630.94 161.98 630.27 161.46 629.95C160.95 629.64 160.29 629.79 159.97 630.29H159.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1346.73 475.08L1383.02 446.47C1383.48 446.09 1383.56 445.41 1383.18 444.95C1382.81 444.49 1382.15 444.42 1381.68 444.77L1345.38 473.36C1344.91 473.73 1344.82 474.42 1345.2 474.9C1345.57 475.37 1346.26 475.46 1346.74 475.08H1346.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M492.4 595.26L402.29 603.53C401.69 603.59 401.25 604.11 401.31 604.71C401.37 605.31 401.89 605.75 402.49 605.69L492.6 597.43C493.2 597.36 493.63 596.83 493.56 596.23C493.5 595.65 492.98 595.22 492.4 595.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M435.27 466.03L421.57 495.8C421.33 496.35 421.58 496.99 422.13 497.23C422.66 497.46 423.28 497.23 423.54 496.71L437.25 466.94C437.49 466.39 437.25 465.74 436.7 465.5C436.16 465.26 435.53 465.5 435.27 466.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1248.03 407.42L1322.99 453.81C1323.51 454.11 1324.18 453.93 1324.48 453.41C1324.77 452.91 1324.62 452.27 1324.14 451.95L1249.17 405.57C1248.66 405.26 1247.99 405.42 1247.68 405.93C1247.37 406.44 1247.52 407.1 1248.03 407.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1381.29 615.55L1375.27 669.28C1375.2 669.89 1375.64 670.43 1376.25 670.5C1376.86 670.57 1377.4 670.13 1377.47 669.52L1383.42 615.78C1383.48 615.19 1383.05 614.67 1382.46 614.61C1381.88 614.55 1381.36 614.97 1381.29 615.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M391.31 427.11L316.05 390.36C315.51 390.1 314.86 390.32 314.59 390.86C314.32 391.4 314.55 392.05 315.09 392.32L390.36 429.07C390.9 429.33 391.55 429.11 391.82 428.57C392.08 428.03 391.86 427.38 391.32 427.11H391.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M436.97 465.65L391.54 427.26C391.08 426.87 390.39 426.93 390.01 427.39C389.62 427.85 389.68 428.54 390.14 428.92L435.57 467.32C436.03 467.71 436.72 467.65 437.11 467.19C437.5 466.73 437.44 466.04 436.98 465.65H436.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M345.45 478.83L372.38 510.24C372.79 510.69 373.48 510.72 373.93 510.31C374.36 509.92 374.41 509.26 374.04 508.81L347.09 477.42C346.7 476.97 346.02 476.91 345.56 477.3C345.11 477.69 345.05 478.37 345.44 478.83H345.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M103.69 532.72L173.56 552.47C174.15 552.64 174.76 552.29 174.92 551.71C175.09 551.12 174.74 550.51 174.16 550.35L104.27 530.65C103.69 530.49 103.1 530.83 102.94 531.41C102.78 531.98 103.11 532.57 103.68 532.73L103.69 532.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M1352.23 594.82L1381.71 616.53C1382.19 616.87 1382.86 616.75 1383.2 616.27C1383.53 615.8 1383.43 615.16 1382.98 614.81L1353.55 593.03C1353.06 592.67 1352.36 592.77 1351.99 593.26C1351.63 593.75 1351.73 594.45 1352.22 594.82H1352.23Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M422.28 495.21L372.92 508.46C372.33 508.62 371.99 509.22 372.14 509.81C372.29 510.4 372.9 510.74 373.49 510.59L422.84 497.31C423.41 497.14 423.74 496.53 423.57 495.96C423.41 495.41 422.84 495.08 422.28 495.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1166.73 441.65L1186.92 484.33C1187.17 484.87 1187.82 485.1 1188.35 484.84C1188.88 484.58 1189.12 483.94 1188.86 483.41L1168.72 440.7C1168.45 440.15 1167.78 439.93 1167.24 440.21C1166.71 440.47 1166.48 441.11 1166.72 441.65H1166.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1095.5 503.64L1065.03 419.15C1064.82 418.59 1064.19 418.31 1063.63 418.52C1063.08 418.73 1062.79 419.33 1062.99 419.89L1093.43 504.39C1093.64 504.96 1094.27 505.26 1094.84 505.05C1095.41 504.84 1095.71 504.21 1095.5 503.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M372.16 509.84L401.36 604.92C401.54 605.49 402.14 605.82 402.72 605.64C403.29 605.46 403.62 604.86 403.44 604.28L374.27 509.19C374.09 508.61 373.48 508.28 372.9 508.46C372.32 508.64 371.99 509.25 372.17 509.83L372.16 509.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M344.81 429.08L345.18 478.13C345.19 478.73 345.69 479.2 346.29 479.19C346.87 479.18 347.34 478.7 347.35 478.12L347.02 429.07C347.02 428.46 346.52 427.97 345.91 427.97C345.3 427.97 344.81 428.47 344.81 429.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M159.66 492.01L185.3 559.89C185.51 560.45 186.14 560.74 186.7 560.52C187.26 560.31 187.55 559.68 187.33 559.12L161.7 491.24C161.49 490.67 160.85 490.39 160.29 490.6C159.72 490.81 159.44 491.45 159.65 492.01H159.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M389.77 427.86L372.13 509.29C372.01 509.88 372.39 510.46 372.99 510.58C373.57 510.7 374.15 510.33 374.28 509.75L391.9 428.32C392.02 427.73 391.64 427.16 391.06 427.03C390.48 426.91 389.91 427.28 389.78 427.86H389.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M185.29 559.13L159.85 630.5C159.66 631.07 159.96 631.7 160.54 631.89C161.1 632.08 161.71 631.79 161.92 631.24L187.35 559.87C187.54 559.3 187.23 558.68 186.66 558.49C186.11 558.31 185.51 558.59 185.3 559.14L185.29 559.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M57.51 589.95L82.05 597.1C82.62 597.26 83.21 596.93 83.37 596.35C83.53 595.79 83.2099 595.21 82.65 595.04L58.1299 587.81C57.5399 587.65 56.92 588 56.76 588.59C56.6 589.17 56.9299 589.76 57.4999 589.94L57.51 589.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1346.81 473.42L1324.31 452.09C1323.87 451.67 1323.18 451.69 1322.76 452.13C1322.34 452.57 1322.36 453.26 1322.8 453.68L1345.3 475.01C1345.75 475.42 1346.44 475.39 1346.84 474.94C1347.24 474.51 1347.22 473.84 1346.8 473.42H1346.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M354.42 408.45L345.2 477.98C345.13 478.57 345.56 479.11 346.15 479.18C346.73 479.25 347.26 478.84 347.35 478.27L356.62 408.75C356.69 408.14 356.25 407.59 355.65 407.53C355.06 407.46 354.52 407.87 354.43 408.46L354.42 408.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1398.1 419.6L1381.45 445.03C1381.12 445.53 1381.26 446.2 1381.76 446.53C1382.26 446.86 1382.93 446.72 1383.26 446.22L1399.95 420.82C1400.27 420.3 1400.11 419.62 1399.59 419.3C1399.09 418.99 1398.43 419.12 1398.1 419.61V419.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M435.65 465.58L372.59 508.61C372.09 508.95 371.96 509.64 372.3 510.14C372.64 510.64 373.33 510.77 373.83 510.43L436.88 467.39C437.38 467.05 437.51 466.37 437.17 465.87C436.83 465.37 436.15 465.24 435.65 465.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1168.17 442.2L1249.03 407.5C1249.58 407.26 1249.83 406.63 1249.6 406.08C1249.37 405.53 1248.73 405.28 1248.18 405.51L1167.3 440.17C1166.74 440.41 1166.48 441.06 1166.72 441.62C1166.96 442.18 1167.61 442.44 1168.17 442.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1167.11 442.09L1212.65 472.96C1213.15 473.29 1213.82 473.16 1214.15 472.66C1214.48 472.17 1214.35 471.5 1213.86 471.17L1168.35 440.27C1167.84 439.94 1167.15 440.08 1166.82 440.59C1166.49 441.09 1166.62 441.76 1167.11 442.1V442.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1398.46 421.15L1476.22 467.11C1476.74 467.41 1477.4 467.24 1477.7 466.72C1478 466.21 1477.83 465.55 1477.32 465.24L1399.58 419.25C1399.05 418.94 1398.37 419.12 1398.07 419.65C1397.77 420.17 1397.94 420.84 1398.46 421.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M345.94 430.18L390.86 429.18C391.46 429.17 391.94 428.67 391.92 428.07C391.9 427.47 391.41 426.99 390.81 427.01L345.89 427.98C345.28 427.99 344.8 428.5 344.81 429.11C344.82 429.72 345.33 430.2 345.94 430.19V430.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1354.14 431.81L1381.84 446.56C1382.37 446.84 1383.02 446.64 1383.3 446.12C1383.58 445.59 1383.38 444.94 1382.86 444.66L1355.18 429.85C1354.64 429.56 1353.97 429.77 1353.68 430.31C1353.39 430.85 1353.6 431.52 1354.14 431.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.26 552.34L185.73 560.42C186.23 560.75 186.91 560.6 187.24 560.1C187.57 559.6 187.42 558.92 186.92 558.59L174.47 550.49C173.96 550.16 173.28 550.3 172.94 550.81C172.6 551.32 172.75 552 173.26 552.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M346.77 428.38L316.42 390.65C316.04 390.18 315.36 390.11 314.89 390.48C314.42 390.86 314.35 391.54 314.72 392.01L345.05 429.76C345.44 430.23 346.14 430.29 346.6 429.9C347.05 429.52 347.13 428.85 346.77 428.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M354.98 409.57L390.31 429.04C390.84 429.33 391.5 429.14 391.79 428.61C392.08 428.08 391.89 427.42 391.36 427.13L356.05 407.63C355.52 407.34 354.84 407.53 354.55 408.06C354.26 408.59 354.45 409.27 354.98 409.56V409.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M345.49 430.09L435.84 467.49C436.4 467.7 437.03 467.42 437.25 466.86C437.45 466.32 437.2 465.71 436.68 465.48L346.33 428.06C345.77 427.83 345.12 428.09 344.89 428.66C344.66 429.23 344.92 429.87 345.49 430.1V430.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M355.95 407.59L316 390.34C315.44 390.11 314.81 390.37 314.57 390.92C314.34 391.47 314.59 392.1 315.13 392.34L355.07 409.62C355.63 409.86 356.28 409.6 356.52 409.04C356.76 408.48 356.5 407.83 355.94 407.59H355.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M491.48 596.74L504.16 629.65C504.39 630.22 505.04 630.48 505.61 630.25C506.16 630.02 506.43 629.41 506.23 628.85L493.52 595.95C493.3 595.39 492.66 595.12 492.11 595.34C491.56 595.56 491.28 596.18 491.49 596.73L491.48 596.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M354.87 409.5L435.63 467.37C436.12 467.72 436.8 467.61 437.15 467.12C437.5 466.63 437.39 465.95 436.9 465.6L356.16 407.7C355.66 407.36 354.97 407.49 354.62 407.99C354.29 408.48 354.4 409.14 354.87 409.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M174.94 551.18L161.76 491.39C161.63 490.8 161.05 490.43 160.45 490.56C159.85 490.69 159.49 491.27 159.62 491.87L172.79 551.66C172.92 552.25 173.51 552.63 174.1 552.5C174.69 552.37 175.07 551.78 174.94 551.19V551.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M88.17 694.7L161.6 631.7C162.05 631.29 162.09 630.6 161.68 630.15C161.29 629.72 160.63 629.67 160.17 630.03L86.73 693.02C86.27 693.42 86.21 694.11 86.61 694.57C87.01 695.03 87.7 695.09 88.16 694.69L88.17 694.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M172.77 551.24L159.8 630.7C159.7 631.3 160.11 631.86 160.71 631.96C161.31 632.06 161.87 631.65 161.97 631.05L174.95 551.59C175.05 550.99 174.64 550.42 174.04 550.32C173.44 550.22 172.87 550.63 172.77 551.23V551.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M345.89 479.14L383.26 493.06C383.84 493.26 384.48 492.96 384.68 492.37C384.88 491.8 384.59 491.18 384.04 490.96L346.65 477.1C346.09 476.9 345.47 477.2 345.27 477.77C345.08 478.32 345.35 478.92 345.89 479.13V479.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1398.58 419.19L1323.12 451.89C1322.57 452.13 1322.32 452.78 1322.56 453.33C1322.8 453.88 1323.44 454.13 1323.98 453.89L1399.45 421.22C1400.01 420.98 1400.27 420.33 1400.03 419.76C1399.79 419.2 1399.14 418.94 1398.57 419.18L1398.58 419.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1398.23 419.43L1345.27 473.46C1344.85 473.9 1344.87 474.59 1345.31 475.01C1345.74 475.42 1346.41 475.41 1346.83 474.99L1399.81 420.98C1400.24 420.54 1400.23 419.84 1399.79 419.41C1399.35 418.98 1398.65 418.99 1398.22 419.43H1398.23Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M344.87 429.43L372.17 509.88C372.36 510.45 372.99 510.76 373.56 510.57C374.13 510.38 374.44 509.75 374.25 509.18L346.96 428.73C346.76 428.15 346.14 427.84 345.56 428.04C344.98 428.24 344.67 428.86 344.87 429.44V429.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M422.68 495.18L383.77 490.9C383.16 490.84 382.61 491.29 382.55 491.91C382.49 492.51 382.92 493.05 383.52 493.12L422.43 497.33C423.03 497.4 423.56 496.96 423.63 496.37C423.7 495.77 423.26 495.24 422.67 495.17L422.68 495.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1354.02 429.93L1322.93 452C1322.44 452.35 1322.33 453.04 1322.69 453.53C1323.04 454.01 1323.71 454.12 1324.2 453.79L1355.31 431.75C1355.81 431.4 1355.93 430.7 1355.57 430.2C1355.21 429.7 1354.52 429.58 1354.02 429.94V429.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M103.96 690.05L161.66 631.65C162.08 631.21 162.06 630.52 161.62 630.1C161.19 629.69 160.52 629.7 160.1 630.1L102.38 688.49C101.95 688.92 101.95 689.63 102.38 690.06C102.81 690.49 103.52 690.49 103.95 690.06L103.96 690.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1347.13 474.43L1355.75 431.05C1355.85 430.45 1355.44 429.87 1354.84 429.77C1354.26 429.67 1353.71 430.04 1353.57 430.62L1344.98 474.01C1344.86 474.6 1345.25 475.18 1345.84 475.3C1346.43 475.42 1347.01 475.03 1347.13 474.44V474.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M364.1 397.06L389.99 428.78C390.37 429.25 391.06 429.32 391.52 428.94C391.99 428.56 392.06 427.87 391.68 427.41L365.83 395.66C365.44 395.18 364.73 395.12 364.26 395.51C363.79 395.9 363.72 396.6 364.1 397.07V397.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M354.43 408.79L372.13 509.71C372.23 510.31 372.8 510.71 373.4 510.6C374 510.5 374.4 509.93 374.29 509.33L356.61 408.41C356.5 407.81 355.92 407.41 355.32 407.52C354.73 407.63 354.33 408.19 354.43 408.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M238.45 401.86L315.7 392.42C316.3 392.35 316.72 391.8 316.65 391.21C316.58 390.61 316.03 390.19 315.44 390.26L238.18 399.65C237.57 399.72 237.13 400.28 237.21 400.89C237.28 401.5 237.84 401.94 238.45 401.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M247.37 670.56L285.61 672.02C286.21 672.04 286.72 671.57 286.74 670.97C286.76 670.37 286.29 669.86 285.69 669.84L247.45 668.33C246.83 668.31 246.32 668.79 246.3 669.41C246.28 670.02 246.75 670.53 247.37 670.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M365.08 395.24L315.68 390.25C315.08 390.2 314.55 390.64 314.5 391.24C314.45 391.83 314.87 392.35 315.46 392.42L364.86 397.46C365.47 397.51 366.01 397.05 366.06 396.43C366.11 395.84 365.68 395.31 365.09 395.24H365.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M432.02 405.29L390.33 427.12C389.8 427.4 389.59 428.06 389.87 428.59C390.15 429.12 390.81 429.33 391.34 429.05L433.06 407.27C433.61 406.98 433.81 406.3 433.52 405.76C433.23 405.22 432.56 405.01 432.02 405.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1167.01 440.34L1093.75 503.18C1093.3 503.59 1093.26 504.28 1093.66 504.73C1094.05 505.17 1094.72 505.22 1095.18 504.85L1168.45 442.02C1168.91 441.62 1168.97 440.92 1168.57 440.46C1168.17 440 1167.47 439.94 1167.01 440.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M435.79 465.5L383.16 491C382.61 491.28 382.39 491.95 382.66 492.5C382.93 493.04 383.58 493.27 384.13 493.01L436.74 467.46C437.28 467.2 437.51 466.54 437.24 466C436.98 465.46 436.32 465.23 435.78 465.5H435.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.51 408.13L344.91 428.6C344.65 429.15 344.89 429.81 345.44 430.07C345.99 430.33 346.65 430.09 346.91 429.54L356.51 409.07C356.76 408.51 356.51 407.86 355.96 407.6C355.41 407.35 354.77 407.58 354.5 408.13H354.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M286.73 671.11L290.85 646.38C290.95 645.77 290.54 645.19 289.93 645.09C289.32 644.99 288.74 645.4 288.64 646.01L284.57 670.75C284.48 671.35 284.89 671.9 285.49 671.99C286.07 672.08 286.62 671.69 286.73 671.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M431.43 406.35L435.18 466.55C435.22 467.15 435.73 467.61 436.34 467.57C436.94 467.53 437.4 467.02 437.36 466.41L433.67 406.21C433.63 405.59 433.1 405.12 432.48 405.16C431.86 405.2 431.39 405.73 431.43 406.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M382.69 491.44L372.26 508.96C371.95 509.48 372.12 510.16 372.64 510.47C373.16 510.78 373.84 510.61 374.15 510.09L384.61 492.59C384.93 492.06 384.75 491.37 384.22 491.06C383.69 490.74 383 490.92 382.69 491.45V491.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M318.75 631.37L284.83 670.21C284.44 670.67 284.5 671.36 284.96 671.75C285.41 672.13 286.08 672.08 286.47 671.65L320.45 632.86C320.86 632.39 320.8 631.68 320.33 631.27C319.86 630.87 319.16 630.91 318.75 631.38V631.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M589.21 565.37L504.54 628.37C504.05 628.74 503.95 629.43 504.31 629.92C504.67 630.41 505.37 630.51 505.86 630.15L590.54 567.16C591.02 566.78 591.11 566.09 590.74 565.6C590.37 565.13 589.7 565.03 589.22 565.38L589.21 565.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1398.76 419.13L1354.4 429.76C1353.8 429.9 1353.44 430.5 1353.58 431.1C1353.72 431.7 1354.32 432.06 1354.92 431.92L1399.28 421.28C1399.87 421.13 1400.23 420.52 1400.08 419.93C1399.93 419.35 1399.35 419 1398.77 419.13H1398.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1351.83 594.25L1375.31 669.72C1375.49 670.3 1376.11 670.63 1376.7 670.44C1377.28 670.26 1377.61 669.64 1377.43 669.06L1353.97 593.58C1353.79 592.99 1353.16 592.67 1352.58 592.85C1351.99 593.03 1351.67 593.66 1351.85 594.24L1351.83 594.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364 395.79L344.96 428.52C344.65 429.05 344.83 429.72 345.36 430.03C345.89 430.34 346.56 430.16 346.87 429.63L365.93 396.92C366.23 396.38 366.03 395.7 365.5 395.4C364.98 395.11 364.32 395.28 364.01 395.79H364Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M344.97 429.64L382.69 492.59C383.01 493.12 383.69 493.29 384.22 492.97C384.75 492.65 384.92 491.97 384.6 491.44L346.85 428.51C346.53 427.99 345.85 427.84 345.33 428.16C344.83 428.47 344.66 429.13 344.96 429.64H344.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M93.49 578.12L160.2 631.72C160.68 632.09 161.37 632.01 161.74 631.53C162.11 631.06 162.03 630.39 161.57 630.01L94.89 576.36C94.41 575.97 93.7 576.05 93.31 576.53C92.92 577.01 93 577.72 93.48 578.11L93.49 578.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M432.26 405.2L345.64 428.01C345.05 428.17 344.7 428.77 344.85 429.36C345.01 429.95 345.61 430.3 346.2 430.15L432.83 407.37C433.43 407.21 433.78 406.6 433.63 406C433.48 405.4 432.86 405.05 432.26 405.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M1093.72 503.21L1023.08 569.14C1022.63 569.57 1022.62 570.28 1023.05 570.73C1023.47 571.17 1024.16 571.19 1024.61 570.78L1095.22 504.81C1095.66 504.4 1095.69 503.7 1095.27 503.25C1094.86 502.81 1094.16 502.78 1093.71 503.2L1093.72 503.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.08 395.67L354.64 407.92C354.27 408.41 354.37 409.1 354.86 409.47C355.34 409.83 356.02 409.74 356.39 409.27L365.85 397.03C366.23 396.54 366.14 395.84 365.65 395.46C365.16 395.08 364.46 395.17 364.08 395.66V395.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1095.56 504.09L1101.17 428.05C1101.22 427.43 1100.75 426.89 1100.13 426.85C1099.51 426.81 1098.97 427.27 1098.93 427.89L1093.37 503.94C1093.34 504.55 1093.8 505.07 1094.41 505.1C1095 505.13 1095.52 504.69 1095.57 504.1L1095.56 504.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M354.47 408.95L382.59 492.36C382.79 492.94 383.42 493.26 384.01 493.06C384.59 492.86 384.91 492.23 384.71 491.64L356.57 408.23C356.37 407.65 355.75 407.34 355.17 407.54C354.59 407.74 354.28 408.36 354.48 408.94L354.47 408.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M137.85 477.85L160.08 492.53C160.58 492.86 161.26 492.73 161.6 492.22C161.94 491.71 161.8 491.04 161.29 490.7L139.1 475.96C138.57 475.63 137.88 475.79 137.54 476.31C137.22 476.82 137.35 477.49 137.85 477.84V477.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M432.51 405.16L355.48 407.49C354.87 407.51 354.39 408.02 354.41 408.63C354.43 409.24 354.94 409.72 355.55 409.7L432.58 407.39C433.2 407.37 433.68 406.86 433.66 406.24C433.64 405.62 433.13 405.14 432.51 405.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M552.09 679.79L506.02 628.51C505.61 628.06 504.91 628.02 504.46 628.43C504.01 628.84 503.97 629.54 504.38 629.99L550.43 681.28C550.85 681.73 551.56 681.76 552.01 681.34C552.45 680.93 552.49 680.24 552.09 679.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M173.52 550.36L93.84 576.17C93.25 576.37 92.94 577.01 93.14 577.6C93.34 578.17 93.95 578.48 94.53 578.31L174.19 552.46C174.77 552.27 175.09 551.65 174.9 551.07C174.71 550.49 174.09 550.17 173.51 550.36H173.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M103.95 688.47L39.09 625.17C38.64 624.75 37.93 624.77 37.51 625.23C37.1 625.67 37.11 626.35 37.53 626.78L102.41 690.06C102.85 690.49 103.55 690.48 103.98 690.04C104.41 689.6 104.4 688.9 103.96 688.47H103.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1167.94 440.09L1100.27 426.86C1099.66 426.74 1099.07 427.15 1098.96 427.75C1098.85 428.35 1099.24 428.94 1099.84 429.06L1167.52 442.26C1168.12 442.38 1168.7 441.99 1168.82 441.39C1168.94 440.79 1168.55 440.21 1167.95 440.09H1167.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M137.46 477.39L172.87 551.88C173.14 552.43 173.8 552.66 174.34 552.39C174.88 552.13 175.11 551.48 174.86 550.93L139.5 476.42C139.22 475.86 138.54 475.64 137.99 475.92C137.45 476.19 137.22 476.84 137.47 477.39H137.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M363.87 396.57L382.55 492.23C382.68 492.83 383.27 493.22 383.88 493.09C384.47 492.96 384.85 492.4 384.75 491.8L366.07 396.14C365.95 395.53 365.37 395.14 364.76 395.26C364.16 395.38 363.76 395.96 363.88 396.57H363.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M247.95 670.42L290.28 647.17C290.81 646.86 290.99 646.17 290.68 645.64C290.38 645.13 289.73 644.94 289.2 645.21L246.87 668.46C246.33 668.76 246.13 669.43 246.43 669.97C246.73 670.51 247.4 670.71 247.94 670.41L247.95 670.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M364.81 397.46L432.38 407.39C432.99 407.48 433.56 407.06 433.65 406.45C433.74 405.84 433.32 405.27 432.71 405.18L365.14 395.25C364.53 395.16 363.96 395.58 363.87 396.19C363.78 396.8 364.2 397.37 364.81 397.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M732.76 498.45L643.09 500.48C642.47 500.51 641.99 501.03 642.01 501.65C642.03 502.26 642.53 502.73 643.14 502.73L732.81 500.67C733.42 500.66 733.91 500.15 733.89 499.54C733.88 498.93 733.37 498.44 732.76 498.46V498.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M642.24 500.88L589.01 565.55C588.62 566.02 588.69 566.72 589.16 567.11C589.63 567.5 590.33 567.43 590.72 566.96L643.98 502.31C644.38 501.83 644.31 501.12 643.83 500.72C643.35 500.32 642.64 500.39 642.24 500.87V500.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M431.57 405.73L382.68 491.46C382.38 492 382.58 492.68 383.12 492.98C383.65 493.27 384.31 493.09 384.62 492.57L433.52 406.84C433.83 406.3 433.64 405.62 433.1 405.31C432.56 405 431.88 405.19 431.57 405.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M23.33 636.31L102.55 690.18C103.06 690.51 103.75 690.36 104.08 689.85C104.4 689.35 104.27 688.7 103.8 688.35L24.61 634.44C24.09 634.09 23.39 634.22 23.04 634.74C22.69 635.26 22.82 635.96 23.34 636.31H23.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.16 589.94L94.5299 578.31C95.1199 578.12 95.4399 577.48 95.25 576.89C95.06 576.3 94.4299 575.98 93.8399 576.16L57.48 587.81C56.89 588 56.57 588.63 56.76 589.21C56.95 589.8 57.58 590.12 58.16 589.93V589.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.93 670.44L320.12 633.12C320.67 632.83 320.89 632.15 320.6 631.6C320.31 631.05 319.63 630.83 319.08 631.12L246.9 668.46C246.36 668.75 246.16 669.43 246.45 669.97C246.74 670.5 247.39 670.7 247.92 670.44H247.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M497.69 626.86L504.71 630.25C505.26 630.52 505.92 630.29 506.19 629.74C506.46 629.19 506.23 628.53 505.68 628.26L498.68 624.82C498.12 624.55 497.44 624.78 497.16 625.34C496.89 625.9 497.12 626.58 497.68 626.86H497.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M543.63 662.48L505.93 628.43C505.48 628.02 504.78 628.06 504.37 628.51C503.96 628.96 504 629.66 504.45 630.07L542.11 664.16C542.58 664.58 543.29 664.54 543.71 664.08C544.13 663.61 544.09 662.9 543.63 662.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M251.17 491.01L239.42 400.61C239.34 400 238.78 399.57 238.17 399.65C237.56 399.73 237.13 400.29 237.21 400.9L248.94 491.31C249.03 491.93 249.6 492.35 250.22 492.26C250.82 492.17 251.24 491.62 251.18 491.02L251.17 491.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M476.59 512.96L383.91 490.92C383.31 490.79 382.71 491.18 382.59 491.78C382.47 492.36 382.82 492.94 383.4 493.09L476.08 515.15C476.69 515.29 477.29 514.92 477.44 514.32C477.58 513.71 477.21 513.11 476.6 512.96H476.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M207.18 428.76L239.04 401.59C239.5 401.18 239.53 400.47 239.12 400.01C238.72 399.57 238.06 399.52 237.6 399.89L205.72 427.03C205.25 427.43 205.19 428.15 205.59 428.62C205.99 429.09 206.71 429.15 207.18 428.75V428.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.12 631.1L289.27 645.19C288.72 645.47 288.5 646.14 288.78 646.69C289.05 647.22 289.68 647.45 290.23 647.21L320.09 633.14C320.65 632.87 320.88 632.19 320.6 631.63C320.33 631.08 319.68 630.85 319.13 631.1H319.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M93.4499 576.4L37.5599 625.13C37.0999 625.54 37.0499 626.25 37.4599 626.71C37.8699 627.17 38.5699 627.22 39.0299 626.82L94.9199 578.09C95.3899 577.68 95.4299 576.97 95.0199 576.5C94.6099 576.04 93.91 575.99 93.4399 576.39L93.4499 576.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M484.55 561.61L504.13 629.56C504.3 630.15 504.91 630.49 505.5 630.32C506.09 630.15 506.43 629.54 506.26 628.95L486.75 560.99C486.58 560.38 485.94 560.03 485.34 560.21C484.74 560.39 484.38 561.02 484.56 561.62L484.55 561.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M247.95 670.42L328.06 626.77C328.61 626.47 328.81 625.78 328.51 625.23C328.21 624.68 327.52 624.48 326.97 624.78L246.88 668.46C246.34 668.75 246.14 669.43 246.43 669.97C246.72 670.51 247.4 670.71 247.94 670.42H247.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M296.78 492.3L383.63 493.13C384.25 493.12 384.74 492.61 384.73 491.99C384.72 491.4 384.25 490.92 383.66 490.89L296.81 490.02C296.18 490.02 295.68 490.54 295.69 491.16C295.69 491.77 296.18 492.26 296.79 492.28L296.78 492.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M383.12 491.03L305.81 532.78C305.26 533.08 305.05 533.77 305.35 534.32C305.65 534.87 306.34 535.08 306.89 534.78L384.18 493C384.72 492.71 384.93 492.03 384.63 491.49C384.34 490.95 383.66 490.74 383.12 491.04V491.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M326.98 624.78L289.22 645.21C288.68 645.5 288.47 646.18 288.77 646.73C289.06 647.27 289.74 647.48 290.29 647.18L328.07 626.78C328.61 626.47 328.8 625.78 328.49 625.23C328.19 624.71 327.53 624.51 326.99 624.78H326.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M137.44 476.45L93.16 576.79C92.92 577.36 93.2 578.02 93.77 578.26C94.32 578.49 94.96 578.24 95.21 577.7L139.5 477.37C139.74 476.8 139.48 476.13 138.9 475.89C138.34 475.65 137.69 475.9 137.43 476.46L137.44 476.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M349.11 380.77L354.43 408.8C354.55 409.4 355.14 409.78 355.74 409.66C356.32 409.54 356.7 408.98 356.61 408.39L351.38 380.34C351.25 379.72 350.64 379.32 350.02 379.46C349.42 379.59 349.03 380.16 349.12 380.77H349.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M24.69 636.25L94.91 578.11C95.38 577.7 95.43 576.99 95.03 576.52C94.64 576.06 93.95 576 93.48 576.37L23.26 634.5C22.79 634.91 22.74 635.62 23.15 636.09C23.55 636.55 24.23 636.61 24.7 636.24L24.69 636.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M552.06 679.76L499 625.05C498.56 624.6 497.84 624.59 497.39 625.03C496.94 625.47 496.93 626.19 497.37 626.64L550.45 681.33C550.88 681.77 551.59 681.78 552.03 681.35C552.47 680.92 552.48 680.21 552.05 679.77L552.06 679.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M552.26 680.05L543.89 662.82C543.62 662.26 542.94 662.02 542.37 662.3C541.81 662.57 541.57 663.25 541.85 663.82L550.25 681.03C550.53 681.58 551.21 681.8 551.76 681.52C552.3 681.25 552.52 680.6 552.27 680.05H552.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M250.98 490.51L207.37 427.26C207.01 426.75 206.31 426.62 205.8 426.98C205.29 427.33 205.17 428.03 205.51 428.54L249.12 491.79C249.48 492.3 250.19 492.41 250.69 492.05C251.18 491.7 251.31 491.02 250.97 490.51H250.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1024.41 570.93L1045.83 558.3C1046.37 557.98 1046.55 557.29 1046.23 556.75C1045.91 556.21 1045.22 556.03 1044.68 556.35L1023.27 569C1022.74 569.31 1022.56 570 1022.87 570.54C1023.18 571.08 1023.87 571.25 1024.41 570.94V570.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M-13.63 601.34L94.42 578.34C95.03 578.2 95.4 577.6 95.27 576.99C95.13 576.4 94.55 576.02 93.96 576.14L-14.1 599.13C-14.71 599.26 -15.1 599.86 -14.97 600.47C-14.84 601.08 -14.24 601.47 -13.63 601.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M205.78 426.99L137.81 476C137.3 476.36 137.19 477.07 137.55 477.58C137.91 478.09 138.62 478.2 139.13 477.84L207.1 428.83C207.61 428.47 207.72 427.76 207.36 427.25C207 426.74 206.29 426.63 205.78 426.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3801 630.29L94.8301 578.17C95.3401 577.81 95.4501 577.11 95.0901 576.6C94.7401 576.1 94.0501 575.98 93.5501 576.32L18.0901 628.43C17.5701 628.79 17.4401 629.49 17.8001 630.01C18.1601 630.53 18.8601 630.66 19.3801 630.3V630.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M320.3 632.99L328.22 626.66C328.71 626.27 328.79 625.56 328.4 625.07C328.01 624.58 327.3 624.5 326.81 624.89L318.9 631.23C318.41 631.62 318.34 632.33 318.72 632.81C319.11 633.3 319.82 633.37 320.3 632.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.05 492.28H296.79C297.42 492.28 297.91 491.76 297.9 491.13C297.89 490.53 297.4 490.04 296.79 490.02H250.05C249.43 490.02 248.92 490.52 248.92 491.14C248.92 491.76 249.42 492.27 250.05 492.27V492.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M999.61 456.11L1100.35 429.05C1100.95 428.88 1101.29 428.26 1101.12 427.66C1100.95 427.08 1100.35 426.73 1099.77 426.88L999.02 453.92C998.42 454.1 998.08 454.73 998.26 455.34C998.43 455.92 999.03 456.26 999.61 456.12V456.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M320.72 631.97L307.48 533.63C307.4 533.01 306.82 532.57 306.2 532.66C305.58 532.74 305.14 533.32 305.23 533.94L318.49 632.28C318.59 632.89 319.16 633.31 319.78 633.22C320.37 633.13 320.79 632.58 320.72 631.98V631.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M249.37 492.05L305.66 534.68C306.16 535.05 306.87 534.94 307.25 534.44C307.61 533.95 307.52 533.25 307.03 532.87L250.73 490.26C250.23 489.88 249.53 489.98 249.15 490.48C248.77 490.98 248.87 491.68 249.37 492.06V492.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M364.21 397.17L394.34 425.16C394.8 425.59 395.53 425.56 395.96 425.1C396.39 424.64 396.36 423.91 395.9 423.48L365.73 395.54C365.27 395.13 364.56 395.17 364.15 395.63C363.75 396.08 363.78 396.76 364.21 397.18V397.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M393.99 424.13L382.54 491.83C382.44 492.44 382.85 493.01 383.45 493.12C384.06 493.22 384.63 492.81 384.74 492.21L396.24 424.52C396.35 423.9 395.93 423.3 395.3 423.2C394.68 423.09 394.08 423.51 393.98 424.14L393.99 424.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M350.79 501.77L383.93 493.09C384.53 492.93 384.89 492.32 384.73 491.73C384.57 491.14 383.96 490.78 383.37 490.93L350.22 499.55C349.61 499.71 349.24 500.34 349.4 500.95C349.56 501.56 350.19 501.93 350.8 501.77H350.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M365.78 395.59L351.08 379.78C350.64 379.32 349.91 379.31 349.46 379.75C349.01 380.18 348.99 380.89 349.4 381.35L364.15 397.12C364.57 397.57 365.28 397.6 365.73 397.17C366.18 396.75 366.21 396.04 365.78 395.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M318.72 632.82L370.76 697.28C371.16 697.77 371.87 697.85 372.36 697.45C372.85 697.05 372.93 696.34 372.53 695.85L320.47 631.4C320.08 630.92 319.37 630.84 318.89 631.23C318.41 631.62 318.33 632.33 318.72 632.81V632.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M432.06 405.27L394.63 423.28C394.06 423.56 393.84 424.25 394.12 424.82C394.4 425.37 395.06 425.61 395.63 425.35L433.04 407.29C433.6 407.02 433.83 406.35 433.56 405.8C433.29 405.24 432.62 405.01 432.07 405.28L432.06 405.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M309.2 581.55L288.68 645.86C288.49 646.45 288.82 647.08 289.41 647.26C290 647.45 290.62 647.12 290.81 646.54L311.38 582.25C311.56 581.64 311.22 581 310.61 580.82C310.02 580.64 309.39 580.97 309.2 581.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M349.9 381.66L432.21 407.35C432.8 407.53 433.43 407.21 433.61 406.62C433.79 406.03 433.47 405.4 432.88 405.22L350.59 379.47C349.98 379.29 349.34 379.64 349.16 380.25C348.98 380.85 349.31 381.47 349.9 381.67V381.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M295.69 491.41L305.24 534.02C305.38 534.63 305.99 535.01 306.6 534.86C307.2 534.72 307.58 534.12 307.45 533.52L297.89 490.91C297.75 490.3 297.15 489.92 296.54 490.05C295.93 490.19 295.55 490.79 295.68 491.4L295.69 491.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M475.22 514.28L484.52 561.52C484.64 562.14 485.24 562.54 485.86 562.42C486.48 562.3 486.88 561.7 486.76 561.08L477.43 513.84C477.3 513.23 476.7 512.84 476.1 512.97C475.5 513.1 475.11 513.67 475.23 514.28H475.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M328.62 625.52L307.45 533.52C307.31 532.91 306.7 532.53 306.09 532.67C305.48 532.81 305.1 533.42 305.24 534.03L326.41 626.03C326.55 626.64 327.16 627.02 327.77 626.88C328.38 626.74 328.76 626.13 328.62 625.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1150 611.14L1150.37 681.1C1150.37 681.72 1150.88 682.22 1151.49 682.21C1152.11 682.21 1152.61 681.7 1152.6 681.09L1152.29 611.13C1152.29 610.5 1151.77 609.98 1151.13 609.99C1150.5 609.99 1149.98 610.51 1149.99 611.15L1150 611.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1152.58 526.23L1044.96 556.23C1044.36 556.4 1044.01 557.03 1044.18 557.63C1044.35 558.22 1044.97 558.57 1045.57 558.41L1153.19 528.41C1153.79 528.23 1154.14 527.6 1153.96 527C1153.79 526.41 1153.18 526.06 1152.58 526.22V526.23Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M543.6 662.45L498.91 624.97C498.43 624.57 497.71 624.63 497.31 625.11C496.91 625.59 496.97 626.31 497.45 626.71L542.14 664.19C542.63 664.58 543.34 664.5 543.74 664.01C544.12 663.54 544.06 662.85 543.6 662.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M372.62 695.97L328.48 625.18C328.14 624.65 327.44 624.5 326.91 624.84C326.39 625.17 326.24 625.85 326.55 626.38L370.68 697.17C371.02 697.7 371.72 697.85 372.25 697.51C372.77 697.18 372.93 696.49 372.61 695.96L372.62 695.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M998.27 455.48L1044.22 557.78C1044.48 558.35 1045.15 558.61 1045.72 558.35C1046.29 558.09 1046.55 557.42 1046.29 556.85L1000.34 454.55C1000.08 453.98 999.41 453.72 998.84 453.98C998.27 454.24 998.01 454.91 998.27 455.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.13 490.03L231.02 488.75C230.39 488.72 229.85 489.21 229.83 489.85C229.8 490.46 230.26 490.99 230.87 491.04L249.98 492.29C250.6 492.32 251.13 491.83 251.15 491.21C251.18 490.61 250.72 490.09 250.13 490.04V490.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M320.71 631.91L311.42 581.69C311.29 581.07 310.69 580.67 310.07 580.79C309.46 580.91 309.06 581.49 309.17 582.1L318.5 632.32C318.61 632.93 319.2 633.34 319.81 633.22C320.42 633.1 320.83 632.52 320.71 631.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M232.01 489.47L207.49 427.49C207.26 426.91 206.61 426.63 206.03 426.86C205.45 427.09 205.17 427.74 205.4 428.32L229.88 490.31C230.13 490.89 230.8 491.17 231.38 490.92C231.95 490.68 232.22 490.04 232.01 489.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M231.1 488.75L138.63 475.79C138.01 475.7 137.44 476.13 137.36 476.75C137.27 477.37 137.7 477.94 138.32 478.02L230.78 491.02C231.41 491.1 231.98 490.66 232.06 490.03C232.14 489.41 231.71 488.85 231.1 488.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M484.53 561.52L497.07 626.06C497.19 626.68 497.79 627.08 498.4 626.96C499.01 626.84 499.42 626.24 499.3 625.63L486.77 561.09C486.63 560.47 486.03 560.09 485.41 560.22C484.82 560.35 484.43 560.92 484.53 561.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230.92 491.04L296.77 492.3C297.4 492.3 297.91 491.81 297.91 491.18C297.91 490.56 297.43 490.05 296.81 490.04L230.96 488.75C230.33 488.75 229.82 489.28 229.83 489.91C229.83 490.52 230.31 491.01 230.92 491.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M296.6 492.28L350.31 501.8C350.93 501.91 351.53 501.49 351.64 500.87C351.75 500.25 351.33 499.65 350.71 499.54L297 490.05C296.38 489.94 295.8 490.35 295.69 490.97C295.58 491.59 295.99 492.17 296.61 492.28H296.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M117.11 374.4L205.85 428.87C206.39 429.18 207.08 429 207.39 428.47C207.7 427.95 207.54 427.28 207.03 426.95L118.32 372.44C117.78 372.11 117.07 372.28 116.74 372.82C116.41 373.36 116.58 374.07 117.12 374.4H117.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M230.37 490.88L305.78 534.75C306.32 535.07 307.02 534.88 307.33 534.34C307.64 533.8 307.46 533.1 306.92 532.79L231.52 488.9C230.97 488.59 230.27 488.79 229.96 489.34C229.66 489.88 229.84 490.56 230.37 490.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M295.67 491.33L309.15 582.07C309.24 582.7 309.83 583.13 310.45 583.04C311.08 582.95 311.51 582.36 311.42 581.74L297.91 491.01C297.82 490.39 297.24 489.96 296.62 490.06C296 490.16 295.57 490.73 295.67 491.35V491.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1025.63 388.6L1099.52 428.95C1100.06 429.25 1100.75 429.05 1101.04 428.5C1101.34 427.96 1101.14 427.27 1100.59 426.98L1026.74 386.57C1026.18 386.26 1025.47 386.47 1025.17 387.03C1024.86 387.59 1025.07 388.3 1025.63 388.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M328.57 625.37L311.36 581.48C311.13 580.89 310.46 580.6 309.87 580.83C309.28 581.06 308.99 581.73 309.22 582.32L326.46 626.2C326.7 626.78 327.36 627.06 327.94 626.82C328.51 626.59 328.79 625.94 328.57 625.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M349.81 499.75L305.66 532.87C305.16 533.25 305.07 533.97 305.46 534.46C305.84 534.94 306.53 535.04 307.02 534.68L351.18 501.58C351.69 501.2 351.79 500.48 351.41 499.97C351.03 499.46 350.31 499.36 349.8 499.74L349.81 499.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M305.22 533.87L309.15 581.99C309.2 582.62 309.76 583.09 310.39 583.04C311.02 582.99 311.49 582.43 311.44 581.8L307.48 533.68C307.43 533.06 306.88 532.59 306.26 532.64C305.64 532.69 305.17 533.24 305.22 533.86V533.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M249.09 491.74L273.4 531.33C273.75 531.87 274.46 532.02 275 531.68C275.52 531.34 275.68 530.66 275.37 530.12L251.01 490.56C250.68 490.03 249.99 489.86 249.46 490.19C248.93 490.52 248.76 491.21 249.09 491.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1070.3 655.11L1046.36 557.05C1046.19 556.45 1045.57 556.09 1044.97 556.26C1044.39 556.42 1044.03 557 1044.16 557.59L1068.07 655.66C1068.22 656.28 1068.84 656.65 1069.46 656.5C1070.08 656.35 1070.45 655.73 1070.3 655.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1151.75 527.3L1150 611.12C1150 611.75 1150.52 612.27 1151.15 612.27C1151.77 612.27 1152.27 611.78 1152.3 611.17L1154.03 527.35C1154.04 526.72 1153.55 526.21 1152.92 526.19C1152.29 526.18 1151.78 526.67 1151.76 527.3H1151.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M249.17 490.46L223.78 522.59C223.38 523.09 223.47 523.82 223.97 524.22C224.47 524.62 225.2 524.53 225.6 524.03L250.94 491.86C251.33 491.37 251.24 490.66 250.75 490.28C250.26 489.89 249.55 489.98 249.17 490.47V490.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M999.83 454L947.88 427.71C947.31 427.42 946.62 427.65 946.34 428.22C946.05 428.79 946.28 429.48 946.85 429.76L998.82 456.02C999.39 456.29 1000.07 456.06 1000.34 455.49C1000.61 454.94 1000.39 454.28 999.85 453.99L999.83 454Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M913.39 518.5L999.98 455.94C1000.48 455.56 1000.58 454.85 1000.2 454.35C999.83 453.87 999.15 453.76 998.65 454.1L912.05 516.64C911.54 517.02 911.44 517.74 911.82 518.25C912.19 518.75 912.89 518.86 913.4 518.5H913.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M295.81 490.6L273.39 530.16C273.08 530.72 273.27 531.42 273.83 531.74C274.39 532.06 275.09 531.86 275.41 531.3L297.79 491.72C298.09 491.17 297.89 490.48 297.34 490.18C296.8 489.89 296.13 490.07 295.82 490.6H295.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M287.65 391.15L295.66 491.25C295.71 491.87 296.26 492.34 296.88 492.29C297.5 492.24 297.97 491.69 297.92 491.07L289.95 390.97C289.89 390.33 289.32 389.87 288.68 389.94C288.06 390 287.61 390.54 287.64 391.16L287.65 391.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M942.56 402.68L998.52 455.84C998.98 456.27 999.7 456.24 1000.13 455.77C1000.55 455.32 1000.53 454.62 1000.09 454.19L944.15 401.01C943.68 400.58 942.95 400.61 942.52 401.08C942.1 401.54 942.12 402.25 942.56 402.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M274.28 531.88L306.24 534.9C306.86 534.96 307.42 534.5 307.48 533.88C307.54 533.26 307.08 532.7 306.46 532.64L274.51 529.57C273.87 529.51 273.31 529.98 273.25 530.61C273.19 531.24 273.66 531.81 274.29 531.87L274.28 531.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M225.16 524.36L297.26 492.2C297.83 491.94 298.08 491.27 297.82 490.7C297.56 490.14 296.91 489.89 296.34 490.13L224.22 522.25C223.64 522.52 223.39 523.21 223.66 523.79C223.92 524.35 224.59 524.61 225.16 524.37V524.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M224.54 524.45L306.2 534.9C306.82 534.98 307.39 534.54 307.47 533.92C307.55 533.3 307.11 532.73 306.49 532.65L224.83 522.16C224.19 522.09 223.62 522.56 223.56 523.19C223.5 523.8 223.93 524.36 224.54 524.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M911.99 516.68L839.76 576.05C839.27 576.45 839.2 577.17 839.6 577.66C840 578.15 840.72 578.22 841.21 577.82L913.45 518.46C913.93 518.05 914 517.33 913.59 516.84C913.19 516.36 912.48 516.29 911.99 516.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M394.13 423.74L349.51 500.09C349.2 500.64 349.4 501.34 349.95 501.65C350.49 501.95 351.17 501.77 351.49 501.25L396.11 424.9C396.43 424.35 396.25 423.65 395.7 423.33C395.15 423.01 394.45 423.19 394.13 423.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M349.44 381.39L394.32 425.14C394.78 425.58 395.5 425.56 395.94 425.1C396.37 424.65 396.36 423.94 395.92 423.5L351.04 379.74C350.59 379.3 349.86 379.31 349.42 379.76C348.98 380.21 348.99 380.94 349.44 381.38V381.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M349.47 500.16L309.26 581.39C308.99 581.96 309.24 582.65 309.81 582.92C310.37 583.18 311.03 582.96 311.31 582.41L351.52 501.18C351.8 500.61 351.57 499.92 351 499.64C350.43 499.36 349.74 499.59 349.46 500.16H349.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M839.34 576.87L835.52 648.17C835.49 648.81 835.98 649.34 836.62 649.37C837.25 649.4 837.79 648.92 837.82 648.29L841.63 576.99C841.66 576.36 841.17 575.83 840.54 575.8C839.92 575.77 839.39 576.25 839.35 576.87H839.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1150.09 610.69L1113.02 698.69C1112.77 699.27 1113.05 699.95 1113.63 700.19C1114.21 700.44 1114.89 700.16 1115.13 699.58L1152.21 611.58C1152.45 610.99 1152.17 610.32 1151.59 610.08C1151.01 609.84 1150.34 610.11 1150.09 610.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1025.11 387.16L998.26 454.6C998.04 455.19 998.34 455.84 998.93 456.06C999.5 456.27 1000.13 456 1000.37 455.44L1027.26 388.02C1027.49 387.42 1027.19 386.75 1026.59 386.52C1026 386.29 1025.34 386.58 1025.1 387.16H1025.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1150.6 610.13L1068.64 654.37C1068.08 654.67 1067.87 655.37 1068.17 655.93C1068.47 656.49 1069.17 656.7 1069.73 656.39L1151.69 612.15C1152.24 611.84 1152.44 611.14 1152.12 610.58C1151.82 610.04 1151.14 609.84 1150.59 610.12L1150.6 610.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M913.79 517.99L948.43 429.16C948.65 428.56 948.35 427.9 947.75 427.68C947.17 427.46 946.52 427.75 946.29 428.32L911.65 517.15C911.43 517.74 911.72 518.41 912.32 518.63C912.91 518.85 913.56 518.56 913.79 517.98V517.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M942.22 402.01L946.22 428.91C946.31 429.54 946.9 429.97 947.53 429.88C948.16 429.79 948.59 429.2 948.5 428.57L944.51 401.67C944.42 401.04 943.83 400.61 943.2 400.7C942.57 400.79 942.14 401.38 942.23 402.01H942.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M230.16 490.72L273.6 531.57C274.07 532 274.8 531.97 275.23 531.49C275.65 531.03 275.63 530.32 275.18 529.88L231.72 489.05C231.26 488.62 230.53 488.64 230.1 489.1C229.67 489.56 229.69 490.29 230.15 490.72H230.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M288.46 392.16L394.78 425.41C395.39 425.6 396.03 425.25 396.21 424.65C396.39 424.05 396.06 423.41 395.46 423.22L289.14 389.95C288.53 389.77 287.89 390.12 287.71 390.73C287.54 391.33 287.86 391.95 288.45 392.15L288.46 392.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M274.82 531.81L350.93 501.74C351.52 501.51 351.81 500.84 351.58 500.25C351.35 499.66 350.68 499.37 350.09 499.6L273.98 529.66C273.39 529.91 273.12 530.59 273.36 531.17C273.6 531.74 274.25 532.02 274.83 531.81H274.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M273.44 531.39L309.34 582.55C309.7 583.07 310.42 583.19 310.94 582.83C311.46 582.47 311.58 581.75 311.22 581.23L275.33 530.06C274.96 529.54 274.24 529.41 273.72 529.78C273.2 530.15 273.07 530.87 273.44 531.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M289 392.2L350.43 381.69C351.05 381.58 351.47 380.98 351.36 380.36C351.25 379.74 350.66 379.32 350.04 379.43L288.6 389.92C287.97 390.03 287.55 390.63 287.66 391.25C287.77 391.88 288.37 392.3 288.99 392.19L289 392.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.81 489.68L223.54 523.09C223.42 523.72 223.84 524.32 224.47 524.44C225.1 524.56 225.7 524.14 225.82 523.51L232.06 490.09C232.18 489.47 231.77 488.87 231.14 488.75C230.52 488.63 229.92 489.04 229.8 489.67L229.81 489.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M249.63 579.38L307.04 534.67C307.53 534.28 307.6 533.56 307.2 533.07C306.82 532.6 306.13 532.51 305.64 532.88L248.18 577.53C247.67 577.93 247.58 578.66 247.98 579.17C248.38 579.68 249.11 579.77 249.62 579.37L249.63 579.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.03 524.26L309.64 582.84C310.17 583.19 310.88 583.05 311.23 582.53C311.58 582.01 311.45 581.31 310.93 580.95L225.33 522.35C224.79 522 224.08 522.16 223.73 522.69C223.4 523.21 223.52 523.9 224.02 524.26H224.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M464.45 601.36L497.49 626.74C497.99 627.12 498.7 627.02 499.08 626.52C499.45 626.03 499.36 625.33 498.87 624.94L465.87 599.51C465.35 599.12 464.62 599.23 464.23 599.75C463.85 600.26 463.94 600.98 464.44 601.37L464.45 601.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M839.33 576.93L839.23 591.26C839.23 591.9 839.76 592.42 840.4 592.42C841.03 592.42 841.55 591.91 841.56 591.28L841.62 576.95C841.62 576.32 841.11 575.8 840.48 575.8C839.85 575.8 839.33 576.31 839.33 576.94V576.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1025.65 386.56L946.82 427.73C946.26 428.03 946.06 428.73 946.36 429.29C946.66 429.83 947.33 430.04 947.88 429.77L1026.72 388.62C1027.29 388.32 1027.51 387.62 1027.21 387.06C1026.91 386.49 1026.21 386.27 1025.65 386.57V386.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M750.88 563.06L840.29 578.07C840.91 578.17 841.5 577.74 841.6 577.12C841.7 576.5 841.28 575.92 840.67 575.82L751.26 560.77C750.62 560.66 750.02 561.09 749.92 561.73C749.81 562.37 750.24 562.97 750.88 563.07V563.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M943.55 402.98L1026.38 388.73C1027.01 388.62 1027.43 388.02 1027.33 387.39C1027.22 386.76 1026.62 386.34 1025.99 386.44L943.17 400.71C942.54 400.83 942.13 401.43 942.25 402.05C942.36 402.66 942.95 403.07 943.56 402.98H943.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M911.89 516.77L839.56 590.46C839.12 590.93 839.14 591.66 839.61 592.1C840.06 592.53 840.78 592.52 841.22 592.08L913.53 518.37C913.97 517.92 913.97 517.19 913.51 516.74C913.06 516.3 912.33 516.3 911.88 516.75L911.89 516.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M484.63 560.77L464.12 599.89C463.82 600.46 464.04 601.17 464.62 601.47C465.19 601.77 465.9 601.55 466.2 600.97L486.65 561.82C486.93 561.26 486.7 560.57 486.14 560.29C485.59 560.01 484.92 560.22 484.63 560.76V560.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M224.52 524.45L274.22 531.87C274.85 531.96 275.44 531.53 275.53 530.89C275.62 530.26 275.19 529.68 274.56 529.58L224.86 522.15C224.23 522.07 223.64 522.51 223.56 523.15C223.48 523.77 223.9 524.34 224.52 524.44V524.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M901.81 617.83L841.13 576C840.61 575.64 839.9 575.77 839.54 576.29C839.18 576.81 839.31 577.52 839.83 577.88L900.48 619.76C901.02 620.12 901.74 619.98 902.1 619.44C902.45 618.91 902.32 618.2 901.8 617.83H901.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M837.81 648.31L841.56 591.34C841.59 590.7 841.09 590.15 840.45 590.12C839.83 590.09 839.29 590.56 839.24 591.18L835.52 648.15C835.48 648.78 835.96 649.33 836.59 649.38C837.22 649.43 837.77 648.94 837.82 648.31H837.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M229.82 490.12L247.76 578.69C247.89 579.32 248.52 579.73 249.15 579.59C249.78 579.46 250.18 578.85 250.06 578.22L232.06 489.66C231.92 489.04 231.31 488.65 230.69 488.79C230.09 488.92 229.7 489.51 229.81 490.12H229.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M248.85 579.62L310.23 583.04C310.86 583.08 311.4 582.59 311.44 581.96C311.48 581.33 310.99 580.78 310.36 580.75L248.98 577.28C248.33 577.24 247.78 577.74 247.74 578.38C247.7 579.03 248.2 579.58 248.84 579.62H248.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M900.66 617.73L836.19 647.19C835.62 647.47 835.38 648.16 835.66 648.73C835.93 649.28 836.58 649.52 837.14 649.28L901.63 619.86C902.21 619.58 902.46 618.89 902.19 618.3C901.92 617.73 901.24 617.47 900.66 617.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M273.37 530.19L247.88 577.9C247.58 578.47 247.79 579.18 248.36 579.49C248.93 579.79 249.64 579.58 249.95 579.01L275.41 531.28C275.7 530.71 275.48 530.02 274.91 529.72C274.35 529.43 273.67 529.64 273.37 530.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M223.63 523.77L247.84 578.92C248.1 579.51 248.79 579.78 249.38 579.52C249.97 579.26 250.24 578.57 249.98 577.98L225.74 522.84C225.47 522.26 224.79 522 224.2 522.27C223.63 522.53 223.37 523.19 223.62 523.77H223.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M750.7 563.02L840.03 592.38C840.64 592.58 841.3 592.25 841.5 591.64C841.7 591.03 841.37 590.37 840.76 590.17L751.43 560.81C750.82 560.62 750.16 560.96 749.97 561.57C749.78 562.17 750.11 562.82 750.71 563.03L750.7 563.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M37.44 422.95L118.31 374.4C118.86 374.07 119.03 373.37 118.7 372.82C118.37 372.27 117.66 372.1 117.12 372.43L36.22 420.93C35.66 421.26 35.48 421.99 35.81 422.55C36.14 423.11 36.87 423.29 37.43 422.96L37.44 422.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M901.63 617.72L840.88 590.2C840.29 589.94 839.61 590.21 839.35 590.8C839.1 591.38 839.35 592.05 839.92 592.32L900.66 619.85C901.25 620.12 901.94 619.85 902.21 619.27C902.48 618.68 902.21 617.99 901.63 617.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1064.97 354.69L1025.45 386.69C1024.96 387.1 1024.9 387.83 1025.31 388.32C1025.71 388.8 1026.42 388.87 1026.91 388.49L1066.45 356.52C1066.95 356.1 1067.01 355.36 1066.59 354.86C1066.18 354.38 1065.46 354.3 1064.96 354.69H1064.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M773.86 622.47L836.21 649.29C836.79 649.54 837.47 649.27 837.72 648.69C837.97 648.11 837.7 647.43 837.12 647.18L774.8 620.28C774.2 620.02 773.49 620.3 773.23 620.9C772.97 621.5 773.25 622.21 773.85 622.47H773.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M774.82 622.46L840.88 592.33C841.46 592.06 841.72 591.37 841.45 590.79C841.18 590.21 840.5 589.96 839.92 590.22L773.84 620.3C773.24 620.57 772.98 621.28 773.25 621.88C773.52 622.48 774.23 622.74 774.83 622.47L774.82 622.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1174.09 847.18C1175.17 850.19 1173.61 853.51 1170.6 854.6C1167.59 855.69 1164.27 854.12 1163.18 851.11C1162.1 848.1 1163.66 844.78 1166.67 843.69C1169.68 842.61 1173 844.17 1174.09 847.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M629.59 855.17C633.86 859.3 633.98 866.12 629.84 870.39C625.71 874.66 618.89 874.78 614.62 870.64C610.35 866.51 610.23 859.69 614.37 855.42C618.5 851.15 625.32 851.03 629.59 855.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1191.88 376.02C1199.7 379.72 1203.04 389.05 1199.34 396.87C1195.64 404.69 1186.31 408.03 1178.49 404.33C1170.67 400.63 1167.33 391.3 1171.03 383.48C1174.73 375.66 1184.06 372.32 1191.88 376.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M1842.17 365.59C1834.44 364.75 1828.86 357.8 1829.7 350.07C1830.54 342.34 1837.49 336.76 1845.22 337.6C1852.95 338.44 1858.53 345.39 1857.69 353.12C1856.85 360.85 1849.9 366.43 1842.17 365.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1497.22 391.46C1494.67 388.43 1495.06 383.9 1498.09 381.35C1501.12 378.8 1505.65 379.19 1508.2 382.22C1510.75 385.25 1510.36 389.78 1507.33 392.33C1504.3 394.88 1499.77 394.49 1497.22 391.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M384.74 719.11C380.01 719.37 375.96 715.75 375.7 711.02C375.44 706.29 379.06 702.24 383.79 701.98C388.52 701.72 392.57 705.34 392.83 710.07C393.09 714.8 389.47 718.85 384.74 719.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M812.23 527.67C812.51 530.36 810.56 532.78 807.87 533.06C805.18 533.34 802.76 531.39 802.48 528.7C802.2 526.01 804.15 523.59 806.84 523.31C809.53 523.03 811.95 524.98 812.23 527.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1727.52 622.54C1724.5 623.13 1721.57 621.16 1720.98 618.14C1720.39 615.12 1722.36 612.19 1725.38 611.6C1728.4 611.01 1731.33 612.98 1731.92 616C1732.51 619.02 1730.54 621.95 1727.52 622.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M482.1 781.4C475.93 781.32 471 776.25 471.09 770.08C471.17 763.91 476.24 758.98 482.41 759.07C488.58 759.15 493.51 764.22 493.42 770.39C493.33 776.56 488.27 781.49 482.1 781.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1203.62 812.78C1209.91 810.56 1216.81 813.86 1219.04 820.15C1221.26 826.44 1217.96 833.34 1211.67 835.57C1205.38 837.79 1198.48 834.49 1196.25 828.2C1194.03 821.91 1197.33 815.01 1203.62 812.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M144.85 654.95C147.12 655.43 148.58 657.66 148.11 659.93C147.63 662.2 145.4 663.66 143.13 663.19C140.86 662.71 139.4 660.48 139.87 658.21C140.35 655.94 142.58 654.48 144.85 654.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M595.83 364.82C599.79 362.05 605.24 363.01 608.01 366.96C610.78 370.92 609.82 376.37 605.87 379.14C601.91 381.91 596.46 380.95 593.69 377C590.92 373.04 591.88 367.59 595.83 364.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M1757.68 792.79C1761.89 797.49 1761.48 804.72 1756.78 808.92C1752.08 813.12 1744.85 812.72 1740.65 808.02C1736.45 803.32 1736.85 796.09 1741.55 791.89C1746.25 787.68 1753.48 788.09 1757.68 792.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M57.16 770.49C54.81 763.39 47.15 759.53 40.05 761.88C36.88 762.93 34.41 765.07 32.79 767.71V781.82C36.01 787.05 42.47 789.61 48.55 787.6C55.65 785.25 59.51 777.59 57.16 770.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M586.82 287.2C588.9 288.63 589.43 291.49 588 293.57C586.57 295.65 583.71 296.18 581.63 294.75C579.55 293.32 579.02 290.46 580.45 288.38C581.88 286.3 584.74 285.77 586.82 287.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M202.02 318.05C201.2 322.18 197.18 324.85 193.06 324.03C188.94 323.21 186.26 319.19 187.08 315.07C187.9 310.95 191.92 308.27 196.04 309.09C200.16 309.91 202.84 313.93 202.02 318.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M423.28 352.53C421.25 354.88 417.69 355.15 415.34 353.11C412.99 351.08 412.72 347.52 414.76 345.17C416.79 342.82 420.35 342.55 422.7 344.59C425.05 346.62 425.32 350.18 423.28 352.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1792.76 653.16C1787.52 653.05 1783.36 648.7 1783.47 643.46C1783.58 638.22 1787.93 634.06 1793.17 634.17C1798.41 634.28 1802.57 638.63 1802.46 643.87C1802.35 649.11 1798 653.27 1792.76 653.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M777.2 667.68C777.29 670.02 775.46 671.98 773.12 672.07C770.78 672.16 768.82 670.33 768.73 667.99C768.64 665.65 770.47 663.69 772.81 663.6C775.15 663.51 777.11 665.34 777.2 667.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M1101.6 231.75C1104.8 233.26 1106.17 237.08 1104.66 240.28C1103.15 243.48 1099.33 244.85 1096.13 243.34C1092.93 241.83 1091.56 238.01 1093.07 234.81C1094.58 231.61 1098.4 230.24 1101.6 231.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M909.01 303.75C911.36 305.72 911.66 309.22 909.69 311.57C907.72 313.92 904.22 314.22 901.87 312.25C899.52 310.28 899.22 306.78 901.19 304.43C903.16 302.08 906.66 301.78 909.01 303.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M98.54 448.88C103.07 453.81 102.73 461.48 97.8 466.01C92.87 470.54 85.2 470.2 80.67 465.27C76.14 460.34 76.48 452.67 81.41 448.14C86.34 443.61 94.01 443.95 98.54 448.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M119.72 782.69C113.01 780.38 109.45 773.08 111.75 766.37C114.05 759.66 121.36 756.1 128.07 758.4C134.78 760.7 138.34 768.01 136.04 774.72C133.73 781.43 126.43 784.99 119.72 782.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M619.65 463.55C616.27 468.75 609.31 470.21 604.12 466.83C598.92 463.45 597.46 456.49 600.84 451.29C604.22 446.09 611.18 444.63 616.37 448.01C621.57 451.39 623.03 458.35 619.65 463.54V463.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M461.35 522.73C458.66 523.77 455.64 522.43 454.6 519.75C453.56 517.06 454.9 514.04 457.58 513C460.27 511.96 463.29 513.3 464.33 515.98C465.37 518.67 464.03 521.69 461.35 522.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M1230.15 306.85C1225.35 308.65 1219.99 306.22 1218.19 301.42C1216.39 296.62 1218.82 291.26 1223.62 289.46C1228.42 287.66 1233.78 290.09 1235.58 294.89C1237.38 299.69 1234.95 305.04 1230.15 306.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M211.04 667.92C215.4 663.53 222.5 663.5 226.89 667.87C231.28 672.23 231.31 679.33 226.94 683.72C222.58 688.11 215.48 688.14 211.09 683.77C206.7 679.41 206.67 672.31 211.04 667.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M140.57 467.24C142.48 469.09 142.53 472.13 140.68 474.03C138.83 475.94 135.79 475.99 133.89 474.14C131.98 472.29 131.93 469.25 133.78 467.35C135.63 465.44 138.67 465.39 140.57 467.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M727.3 310.56C724.35 304.17 727.13 296.6 733.52 293.65C739.91 290.7 747.48 293.48 750.43 299.87C753.38 306.26 750.6 313.83 744.21 316.78C737.82 319.73 730.25 316.95 727.3 310.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M1148.12 876.16C1152.13 879.77 1152.45 885.94 1148.85 889.94C1145.24 893.95 1139.07 894.27 1135.07 890.67C1131.06 887.06 1130.74 880.89 1134.34 876.89C1137.95 872.88 1144.12 872.56 1148.12 876.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1442.34 495.89C1439.53 493.12 1439.49 488.59 1442.26 485.78C1445.03 482.97 1449.56 482.93 1452.37 485.7C1455.18 488.47 1455.22 493 1452.45 495.81C1449.68 498.62 1445.15 498.66 1442.34 495.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M882.49 529.91C883.36 524.41 888.52 520.66 894.02 521.53C899.52 522.4 903.27 527.56 902.4 533.06C901.53 538.56 896.37 542.31 890.87 541.44C885.37 540.57 881.62 535.41 882.49 529.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1188.27 682.59C1190.39 674.31 1198.82 669.32 1207.1 671.44C1215.38 673.56 1220.37 681.99 1218.25 690.27C1216.13 698.55 1207.7 703.54 1199.42 701.42C1191.14 699.3 1186.15 690.87 1188.27 682.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1292.65 791.25C1289.58 784.2 1292.8 775.98 1299.86 772.91C1306.91 769.84 1315.13 773.06 1318.2 780.12C1321.27 787.18 1318.05 795.39 1310.99 798.46C1303.93 801.53 1295.72 798.31 1292.65 791.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M1440.01 593.1C1440.72 588.37 1445.12 585.11 1449.85 585.81C1454.58 586.52 1457.84 590.92 1457.14 595.65C1456.43 600.38 1452.03 603.64 1447.3 602.94C1442.57 602.23 1439.31 597.83 1440.01 593.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1105.65 624.27C1107.85 618.47 1114.33 615.56 1120.13 617.76C1125.93 619.96 1128.84 626.44 1126.64 632.24C1124.44 638.04 1117.96 640.95 1112.16 638.75C1106.36 636.55 1103.45 630.07 1105.65 624.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M386.46 522.62C390.8 517.89 398.14 517.57 402.87 521.91C407.6 526.25 407.92 533.59 403.58 538.32C399.24 543.05 391.9 543.37 387.17 539.03C382.44 534.69 382.12 527.35 386.46 522.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M274.67 513C274.99 515.81 272.97 518.36 270.16 518.68C267.35 519 264.8 516.98 264.48 514.17C264.16 511.36 266.18 508.81 268.99 508.49C271.8 508.17 274.35 510.19 274.67 513Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1154.58 302.74C1151.89 300.8 1151.28 297.05 1153.22 294.35C1155.16 291.66 1158.91 291.05 1161.61 292.99C1164.3 294.93 1164.91 298.68 1162.97 301.38C1161.03 304.07 1157.28 304.68 1154.58 302.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1408.85 722.5C1410.77 720.18 1414.22 719.85 1416.54 721.77C1418.86 723.69 1419.19 727.14 1417.27 729.46C1415.35 731.78 1411.9 732.11 1409.58 730.18C1407.26 728.26 1406.93 724.81 1408.86 722.49L1408.85 722.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1456.27 296.06C1454.49 300.75 1449.24 303.11 1444.55 301.33C1439.86 299.55 1437.5 294.3 1439.28 289.61C1441.06 284.92 1446.31 282.56 1451 284.34C1455.69 286.12 1458.05 291.37 1456.27 296.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M826.64 391.3C832.83 396.81 833.38 406.3 827.87 412.49C822.36 418.68 812.87 419.23 806.68 413.72C800.49 408.21 799.94 398.72 805.45 392.53C810.96 386.34 820.45 385.79 826.64 391.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1629.62 334.95C1631.88 334.23 1634.3 335.49 1635.02 337.76C1635.73 340.02 1634.48 342.44 1632.21 343.16C1629.95 343.88 1627.53 342.62 1626.81 340.35C1626.09 338.09 1627.35 335.67 1629.62 334.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M1244.3 455.72C1240.81 457.75 1236.33 456.57 1234.3 453.09C1232.27 449.6 1233.45 445.12 1236.93 443.09C1240.42 441.06 1244.9 442.24 1246.93 445.72C1248.96 449.21 1247.78 453.69 1244.3 455.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1495.53 821.37C1494.42 827 1488.95 830.67 1483.32 829.55C1477.69 828.44 1474.02 822.97 1475.14 817.34C1476.25 811.71 1481.72 808.04 1487.35 809.16C1492.98 810.27 1496.65 815.74 1495.53 821.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M791.42 480.63C789.24 481.62 786.67 480.66 785.68 478.48C784.69 476.3 785.65 473.73 787.83 472.74C790.01 471.75 792.58 472.71 793.57 474.89C794.56 477.07 793.6 479.64 791.42 480.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1331.61 327.69C1325.19 331.25 1317.1 328.94 1313.53 322.52C1309.97 316.1 1312.28 308.01 1318.7 304.44C1325.12 300.88 1333.21 303.19 1336.78 309.61C1340.34 316.03 1338.03 324.12 1331.61 327.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1010.51 748.83C1010.09 756.8 1003.28 762.92 995.31 762.49C987.34 762.07 981.22 755.26 981.65 747.29C982.07 739.32 988.88 733.2 996.85 733.63C1004.82 734.05 1010.94 740.86 1010.51 748.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M161.5 738.59C164.11 738.42 166.36 740.39 166.54 743C166.72 745.61 164.74 747.86 162.13 748.04C159.52 748.21 157.27 746.24 157.09 743.63C156.92 741.02 158.89 738.77 161.5 738.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1754.55 267.98C1761.17 264.76 1769.15 267.52 1772.37 274.15C1775.59 280.77 1772.83 288.75 1766.2 291.97C1759.58 295.19 1751.6 292.43 1748.38 285.8C1745.16 279.18 1747.92 271.2 1754.55 267.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1652.61 773.79C1648.3 776.01 1643 774.32 1640.78 770.01C1638.56 765.7 1640.25 760.4 1644.56 758.18C1648.87 755.96 1654.17 757.65 1656.39 761.96C1658.61 766.27 1656.92 771.57 1652.61 773.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M409.93 542.92C411.82 544.24 412.29 546.84 410.97 548.73C409.65 550.62 407.05 551.09 405.16 549.77C403.27 548.45 402.8 545.85 404.12 543.96C405.44 542.07 408.04 541.6 409.93 542.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M35.2101 565.31C34.4001 562.79 35.7901 560.08 38.3101 559.27C40.8301 558.46 43.5401 559.85 44.3501 562.37C45.1601 564.89 43.7701 567.6 41.2501 568.41C38.7301 569.22 36.0201 567.83 35.2101 565.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M1295.69 543.06C1291.13 547.81 1283.59 547.96 1278.85 543.41C1274.1 538.85 1273.95 531.31 1278.5 526.57C1283.06 521.82 1290.6 521.67 1295.34 526.22C1300.08 530.77 1300.24 538.32 1295.69 543.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1317.83 635.66C1315.95 634.13 1315.67 631.37 1317.2 629.49C1318.73 627.61 1321.49 627.33 1323.37 628.86C1325.25 630.39 1325.53 633.15 1324 635.03C1322.47 636.91 1319.71 637.19 1317.83 635.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1368.04 407.31C1368.95 409.38 1368.02 411.8 1365.95 412.71C1363.88 413.62 1361.46 412.69 1360.55 410.62C1359.64 408.55 1360.57 406.13 1362.64 405.22C1364.71 404.31 1367.13 405.24 1368.04 407.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1645.5 554.88C1641.84 554.23 1639.39 550.72 1640.05 547.06C1640.7 543.39 1644.21 540.95 1647.87 541.61C1651.53 542.26 1653.98 545.77 1653.32 549.43C1652.67 553.1 1649.16 555.54 1645.5 554.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1535.42 673.97C1541.95 668.66 1551.55 669.64 1556.86 676.17C1562.17 682.7 1561.19 692.3 1554.66 697.61C1548.13 702.92 1538.53 701.94 1533.22 695.41C1527.91 688.88 1528.89 679.28 1535.42 673.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1033.34 315.49C1033.09 307.84 1039.1 301.43 1046.75 301.18C1054.4 300.93 1060.81 306.94 1061.06 314.59C1061.31 322.24 1055.3 328.65 1047.65 328.9C1040 329.15 1033.59 323.14 1033.34 315.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M141.35 702.66C144.06 703.42 145.64 706.22 144.88 708.93C144.12 711.64 141.32 713.22 138.61 712.46C135.9 711.7 134.32 708.9 135.08 706.19C135.84 703.48 138.64 701.9 141.35 702.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1553.17 483.24C1555.2 483.24 1556.85 481.592 1556.85 479.56C1556.85 477.528 1555.2 475.88 1553.17 475.88C1551.14 475.88 1549.49 477.528 1549.49 479.56C1549.49 481.592 1551.14 483.24 1553.17 483.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1640.81 400.88C1642.87 400.88 1644.54 399.21 1644.54 397.15C1644.54 395.09 1642.87 393.42 1640.81 393.42C1638.75 393.42 1637.08 395.09 1637.08 397.15C1637.08 399.21 1638.75 400.88 1640.81 400.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1639.42 573.04C1641.51 573.04 1643.2 574.73 1643.2 576.82C1643.2 578.91 1641.51 580.6 1639.42 580.6C1637.33 580.6 1635.64 578.91 1635.64 576.82C1635.64 574.73 1637.33 573.04 1639.42 573.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M400.85 568.73C402.95 568.73 404.65 570.43 404.65 572.53C404.65 574.63 402.95 576.33 400.85 576.33C398.75 576.33 397.05 574.63 397.05 572.53C397.05 570.43 398.75 568.73 400.85 568.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.45 530.36C176.55 530.36 178.26 532.07 178.26 534.17C178.26 536.27 176.55 537.98 174.45 537.98C172.35 537.98 170.64 536.27 170.64 534.17C170.64 532.07 172.35 530.36 174.45 530.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M170.92 579.44C173.024 579.44 174.73 577.734 174.73 575.63C174.73 573.526 173.024 571.82 170.92 571.82C168.816 571.82 167.11 573.526 167.11 575.63C167.11 577.734 168.816 579.44 170.92 579.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M207.2 643.62C209.31 643.62 211.02 645.33 211.02 647.44C211.02 649.55 209.31 651.26 207.2 651.26C205.09 651.26 203.38 649.55 203.38 647.44C203.38 645.33 205.09 643.62 207.2 643.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1570.89 650.59C1573 650.59 1574.71 652.3 1574.71 654.41C1574.71 656.52 1573 658.23 1570.89 658.23C1568.78 658.23 1567.07 656.52 1567.07 654.41C1567.07 652.3 1568.78 650.59 1570.89 650.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M232.23 544.15C234.34 544.15 236.05 545.86 236.05 547.97C236.05 550.08 234.34 551.79 232.23 551.79C230.12 551.79 228.41 550.08 228.41 547.97C228.41 545.86 230.12 544.15 232.23 544.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1389.83 336.12C1391.94 336.12 1393.66 337.83 1393.66 339.95C1393.66 342.07 1391.95 343.78 1389.83 343.78C1387.71 343.78 1386 342.07 1386 339.95C1386 337.83 1387.71 336.12 1389.83 336.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.48 352.85C129.6 352.85 131.31 354.56 131.31 356.68C131.31 358.8 129.6 360.51 127.48 360.51C125.36 360.51 123.65 358.8 123.65 356.68C123.65 354.56 125.36 352.85 127.48 352.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1706.74 585.26C1708.86 585.26 1710.58 586.98 1710.58 589.1C1710.58 591.22 1708.86 592.94 1706.74 592.94C1704.62 592.94 1702.9 591.22 1702.9 589.1C1702.9 586.98 1704.62 585.26 1706.74 585.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M205.4 271.55C207.52 271.55 209.24 273.27 209.24 275.39C209.24 277.51 207.52 279.23 205.4 279.23C203.28 279.23 201.56 277.51 201.56 275.39C201.56 273.27 203.28 271.55 205.4 271.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1242.64 421.98C1244.76 421.98 1246.49 423.7 1246.49 425.83C1246.49 427.96 1244.77 429.68 1242.64 429.68C1240.51 429.68 1238.79 427.96 1238.79 425.83C1238.79 423.7 1240.51 421.98 1242.64 421.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1114.16 432.03C1116.29 432.03 1118.01 430.306 1118.01 428.18C1118.01 426.054 1116.29 424.33 1114.16 424.33C1112.03 424.33 1110.31 426.054 1110.31 428.18C1110.31 430.306 1112.03 432.03 1114.16 432.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1666.12 655.26C1668.25 655.26 1669.97 656.99 1669.97 659.11C1669.97 661.23 1668.25 662.96 1666.12 662.96C1663.99 662.96 1662.27 661.24 1662.27 659.11C1662.27 656.98 1663.99 655.26 1666.12 655.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1717.4 425.15C1719.53 425.15 1721.25 426.88 1721.25 429C1721.25 431.12 1719.52 432.85 1717.4 432.85C1715.28 432.85 1713.55 431.12 1713.55 429C1713.55 426.88 1715.28 425.15 1717.4 425.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.12 711.54C121.25 711.54 122.98 713.27 122.98 715.4C122.98 717.53 121.25 719.26 119.12 719.26C116.99 719.26 115.26 717.53 115.26 715.4C115.26 713.27 116.99 711.54 119.12 711.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1671.48 407.78C1673.61 407.78 1675.34 409.51 1675.34 411.64C1675.34 413.77 1673.61 415.5 1671.48 415.5C1669.35 415.5 1667.62 413.77 1667.62 411.64C1667.62 409.51 1669.35 407.78 1671.48 407.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M157.62 456.65C159.76 456.65 161.49 458.38 161.49 460.52C161.49 462.66 159.76 464.39 157.62 464.39C155.48 464.39 153.75 462.66 153.75 460.52C153.75 458.38 155.48 456.65 157.62 456.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.02 744.41C87.16 744.41 88.89 746.14 88.89 748.28C88.89 750.42 87.16 752.15 85.02 752.15C82.88 752.15 81.15 750.42 81.15 748.28C81.15 746.14 82.88 744.41 85.02 744.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1768.36 665.26C1770.5 665.26 1772.24 663.523 1772.24 661.38C1772.24 659.237 1770.5 657.5 1768.36 657.5C1766.22 657.5 1764.48 659.237 1764.48 661.38C1764.48 663.523 1766.22 665.26 1768.36 665.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1560.63 717.47C1562.78 717.47 1564.52 719.21 1564.52 721.36C1564.52 723.51 1562.78 725.25 1560.63 725.25C1558.48 725.25 1556.74 723.51 1556.74 721.36C1556.74 719.21 1558.48 717.47 1560.63 717.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1361.73 745.25C1363.88 745.25 1365.62 746.99 1365.62 749.14C1365.62 751.29 1363.88 753.03 1361.73 753.03C1359.58 753.03 1357.84 751.29 1357.84 749.14C1357.84 746.99 1359.58 745.25 1361.73 745.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M882.11 223.88C884.26 223.88 886 225.62 886 227.77C886 229.92 884.26 231.66 882.11 231.66C879.96 231.66 878.22 229.92 878.22 227.77C878.22 225.62 879.96 223.88 882.11 223.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1436.48 564.33C1438.63 564.33 1440.37 566.07 1440.37 568.22C1440.37 570.37 1438.63 572.11 1436.48 572.11C1434.33 572.11 1432.59 570.37 1432.59 568.22C1432.59 566.07 1434.33 564.33 1436.48 564.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.8 715.11C68.95 715.11 70.7 716.86 70.7 719.01C70.7 721.16 68.95 722.91 66.8 722.91C64.65 722.91 62.9 721.16 62.9 719.01C62.9 716.86 64.64 715.11 66.8 715.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.03 328.6C156.19 328.6 157.94 330.35 157.94 332.51C157.94 334.67 156.19 336.42 154.03 336.42C151.87 336.42 150.12 334.67 150.12 332.51C150.12 330.35 151.87 328.6 154.03 328.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1273.91 568.48C1276.07 568.48 1277.82 570.23 1277.82 572.39C1277.82 574.55 1276.07 576.3 1273.91 576.3C1271.75 576.3 1270 574.55 1270 572.39C1270 570.23 1271.75 568.48 1273.91 568.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1539.72 277.62C1541.88 277.62 1543.64 275.865 1543.64 273.7C1543.64 271.535 1541.88 269.78 1539.72 269.78C1537.56 269.78 1535.8 271.535 1535.8 273.7C1535.8 275.865 1537.56 277.62 1539.72 277.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1551.58 359.89C1553.74 359.89 1555.5 361.64 1555.5 363.81C1555.5 365.98 1553.75 367.73 1551.58 367.73C1549.41 367.73 1547.66 365.98 1547.66 363.81C1547.66 361.64 1549.41 359.89 1551.58 359.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1527.94 309.1C1530.1 309.1 1531.86 310.85 1531.86 313.02C1531.86 315.19 1530.11 316.94 1527.94 316.94C1525.77 316.94 1524.02 315.19 1524.02 313.02C1524.02 310.85 1525.77 309.1 1527.94 309.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1195.35 304.12C1197.52 304.12 1199.28 302.36 1199.28 300.19C1199.28 298.02 1197.52 296.26 1195.35 296.26C1193.18 296.26 1191.42 298.02 1191.42 300.19C1191.42 302.36 1193.18 304.12 1195.35 304.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M522.34 253.4C524.51 253.4 526.27 255.16 526.27 257.33C526.27 259.5 524.51 261.26 522.34 261.26C520.17 261.26 518.41 259.5 518.41 257.33C518.41 255.16 520.17 253.4 522.34 253.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1552.28 715.94C1554.45 715.94 1556.22 717.7 1556.22 719.88C1556.22 722.06 1554.46 723.82 1552.28 723.82C1550.1 723.82 1548.34 722.06 1548.34 719.88C1548.34 717.7 1550.1 715.94 1552.28 715.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1619.92 632.46C1622.09 632.46 1623.86 634.22 1623.86 636.4C1623.86 638.58 1622.1 640.34 1619.92 640.34C1617.74 640.34 1615.98 638.58 1615.98 636.4C1615.98 634.22 1617.74 632.46 1619.92 632.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1659.01 739.33C1661.19 739.33 1662.95 737.566 1662.95 735.39C1662.95 733.214 1661.19 731.45 1659.01 731.45C1656.83 731.45 1655.07 733.214 1655.07 735.39C1655.07 737.566 1656.83 739.33 1659.01 739.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.05 323.12C128.23 323.12 129.99 324.88 129.99 327.06C129.99 329.24 128.23 331 126.05 331C123.87 331 122.11 329.24 122.11 327.06C122.11 324.88 123.87 323.12 126.05 323.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1440.91 708.17C1443.09 708.17 1444.85 709.94 1444.85 712.11C1444.85 714.28 1443.08 716.05 1440.91 716.05C1438.74 716.05 1436.97 714.28 1436.97 712.11C1436.97 709.94 1438.74 708.17 1440.91 708.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M485.76 688.46C487.94 688.46 489.7 690.23 489.7 692.4C489.7 694.57 487.93 696.34 485.76 696.34C483.59 696.34 481.82 694.57 481.82 692.4C481.82 690.23 483.59 688.46 485.76 688.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M601.92 327.14C604.1 327.14 605.86 328.91 605.86 331.08C605.86 333.25 604.09 335.02 601.92 335.02C599.75 335.02 597.98 333.25 597.98 331.08C597.98 328.91 599.75 327.14 601.92 327.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M872.24 485.08C874.42 485.08 876.19 486.85 876.19 489.03C876.19 491.21 874.42 492.98 872.24 492.98C870.06 492.98 868.29 491.21 868.29 489.03C868.29 486.85 870.06 485.08 872.24 485.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M384.56 609.63C386.74 609.63 388.51 611.4 388.51 613.58C388.51 615.76 386.74 617.53 384.56 617.53C382.38 617.53 380.61 615.76 380.61 613.58C380.61 611.4 382.38 609.63 384.56 609.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M850.1 668.3C852.282 668.3 854.05 666.532 854.05 664.35C854.05 662.168 852.282 660.4 850.1 660.4C847.918 660.4 846.15 662.168 846.15 664.35C846.15 666.532 847.918 668.3 850.1 668.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1053.63 693.17C1055.81 693.17 1057.58 694.94 1057.58 697.12C1057.58 699.3 1055.81 701.07 1053.63 701.07C1051.45 701.07 1049.68 699.3 1049.68 697.12C1049.68 694.94 1051.45 693.17 1053.63 693.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M752.51 280C754.69 280 756.47 281.77 756.47 283.96C756.47 286.15 754.7 287.92 752.51 287.92C750.32 287.92 748.55 286.15 748.55 283.96C748.55 281.77 750.32 280 752.51 280Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M196.47 569.66C198.66 569.66 200.43 571.43 200.43 573.62C200.43 575.81 198.66 577.58 196.47 577.58C194.28 577.58 192.51 575.81 192.51 573.62C192.51 571.43 194.28 569.66 196.47 569.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1005.67 525.2C1007.86 525.2 1009.63 526.97 1009.63 529.16C1009.63 531.35 1007.86 533.12 1005.67 533.12C1003.48 533.12 1001.71 531.35 1001.71 529.16C1001.71 526.97 1003.48 525.2 1005.67 525.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1531.76 610.36C1533.95 610.36 1535.72 608.587 1535.72 606.4C1535.72 604.213 1533.95 602.44 1531.76 602.44C1529.57 602.44 1527.8 604.213 1527.8 606.4C1527.8 608.587 1529.57 610.36 1531.76 610.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M315.5 792.32C317.693 792.32 319.47 790.542 319.47 788.35C319.47 786.157 317.693 784.38 315.5 784.38C313.307 784.38 311.53 786.157 311.53 788.35C311.53 790.542 313.307 792.32 315.5 792.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1174.66 654.05C1176.85 654.05 1178.63 652.273 1178.63 650.08C1178.63 647.887 1176.85 646.11 1174.66 646.11C1172.47 646.11 1170.69 647.887 1170.69 650.08C1170.69 652.273 1172.47 654.05 1174.66 654.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1490.04 642.21C1492.23 642.21 1494.01 643.99 1494.01 646.18C1494.01 648.37 1492.23 650.15 1490.04 650.15C1487.85 650.15 1486.07 648.37 1486.07 646.18C1486.07 643.99 1487.85 642.21 1490.04 642.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M382.84 431.87C385.04 431.87 386.82 433.65 386.82 435.85C386.82 438.05 385.04 439.83 382.84 439.83C380.64 439.83 378.86 438.05 378.86 435.85C378.86 433.65 380.64 431.87 382.84 431.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.67 392.2C244.868 392.2 246.65 390.418 246.65 388.22C246.65 386.022 244.868 384.24 242.67 384.24C240.472 384.24 238.69 386.022 238.69 388.22C238.69 390.418 240.472 392.2 242.67 392.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M487.09 639.06C489.288 639.06 491.07 637.278 491.07 635.08C491.07 632.882 489.288 631.1 487.09 631.1C484.892 631.1 483.11 632.882 483.11 635.08C483.11 637.278 484.892 639.06 487.09 639.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M933.81 469C936.014 469 937.8 467.214 937.8 465.01C937.8 462.806 936.014 461.02 933.81 461.02C931.606 461.02 929.82 462.806 929.82 465.01C929.82 467.214 931.606 469 933.81 469Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1018.84 198.48C1021.04 198.48 1022.83 200.27 1022.83 202.47C1022.83 204.67 1021.04 206.46 1018.84 206.46C1016.64 206.46 1014.85 204.67 1014.85 202.47C1014.85 200.27 1016.64 198.48 1018.84 198.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1188.65 756.6C1190.86 756.6 1192.65 758.39 1192.65 760.6C1192.65 762.81 1190.86 764.6 1188.65 764.6C1186.44 764.6 1184.65 762.81 1184.65 760.6C1184.65 758.39 1186.44 756.6 1188.65 756.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M388.85 461.24C391.059 461.24 392.85 459.449 392.85 457.24C392.85 455.031 391.059 453.24 388.85 453.24C386.641 453.24 384.85 455.031 384.85 457.24C384.85 459.449 386.641 461.24 388.85 461.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M960.64 650.9C962.85 650.9 964.64 652.69 964.64 654.9C964.64 657.11 962.85 658.9 960.64 658.9C958.43 658.9 956.64 657.11 956.64 654.9C956.64 652.69 958.43 650.9 960.64 650.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M472.82 690.79C475.03 690.79 476.82 692.58 476.82 694.79C476.82 697 475.03 698.79 472.82 698.79C470.61 698.79 468.82 697 468.82 694.79C468.82 692.58 470.61 690.79 472.82 690.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M282.97 263.44C285.18 263.44 286.97 265.23 286.97 267.44C286.97 269.65 285.18 271.44 282.97 271.44C280.76 271.44 278.97 269.65 278.97 267.44C278.97 265.23 280.76 263.44 282.97 263.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M514.5 745.27C516.715 745.27 518.51 743.475 518.51 741.26C518.51 739.045 516.715 737.25 514.5 737.25C512.285 737.25 510.49 739.045 510.49 741.26C510.49 743.475 512.285 745.27 514.5 745.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1183.96 512.63C1186.17 512.63 1187.97 514.42 1187.97 516.64C1187.97 518.86 1186.18 520.65 1183.96 520.65C1181.74 520.65 1179.95 518.86 1179.95 516.64C1179.95 514.42 1181.74 512.63 1183.96 512.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M406.23 479.48C408.44 479.48 410.24 481.28 410.24 483.49C410.24 485.7 408.44 487.5 406.23 487.5C404.02 487.5 402.22 485.7 402.22 483.49C402.22 481.28 404.02 479.48 406.23 479.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1361.41 505.11C1363.63 505.11 1365.42 506.91 1365.42 509.12C1365.42 511.33 1363.62 513.13 1361.41 513.13C1359.2 513.13 1357.4 511.33 1357.4 509.12C1357.4 506.91 1359.2 505.11 1361.41 505.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M266.07 466.36C268.285 466.36 270.08 464.565 270.08 462.35C270.08 460.135 268.285 458.34 266.07 458.34C263.855 458.34 262.06 460.135 262.06 462.35C262.06 464.565 263.855 466.36 266.07 466.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1597.62 532.3C1599.83 532.3 1601.63 530.505 1601.63 528.29C1601.63 526.075 1599.83 524.28 1597.62 524.28C1595.41 524.28 1593.61 526.075 1593.61 528.29C1593.61 530.505 1595.41 532.3 1597.62 532.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M833.9 528.34C836.12 528.34 837.92 530.14 837.92 532.36C837.92 534.58 836.12 536.38 833.9 536.38C831.68 536.38 829.88 534.58 829.88 532.36C829.88 530.14 831.68 528.34 833.9 528.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1248.51 393.88C1250.73 393.88 1252.53 392.08 1252.53 389.86C1252.53 387.64 1250.73 385.84 1248.51 385.84C1246.29 385.84 1244.49 387.64 1244.49 389.86C1244.49 392.08 1246.29 393.88 1248.51 393.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M791.06 453.45C793.28 453.45 795.08 451.65 795.08 449.43C795.08 447.21 793.28 445.41 791.06 445.41C788.84 445.41 787.04 447.21 787.04 449.43C787.04 451.65 788.84 453.45 791.06 453.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M950.86 655.97C953.086 655.97 954.89 654.166 954.89 651.94C954.89 649.714 953.086 647.91 950.86 647.91C948.634 647.91 946.83 649.714 946.83 651.94C946.83 654.166 948.634 655.97 950.86 655.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1185.9 592.8C1188.12 592.8 1189.93 594.6 1189.93 596.83C1189.93 599.06 1188.13 600.86 1185.9 600.86C1183.67 600.86 1181.87 599.06 1181.87 596.83C1181.87 594.6 1183.67 592.8 1185.9 592.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1555.33 458.16C1557.56 458.16 1559.36 459.96 1559.36 462.19C1559.36 464.42 1557.56 466.22 1555.33 466.22C1553.1 466.22 1551.3 464.42 1551.3 462.19C1551.3 459.96 1553.1 458.16 1555.33 458.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M718.95 608.26C721.18 608.26 722.98 610.07 722.98 612.29C722.98 614.51 721.17 616.32 718.95 616.32C716.73 616.32 714.92 614.51 714.92 612.29C714.92 610.07 716.73 608.26 718.95 608.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M849.15 739.7C851.38 739.7 853.19 741.51 853.19 743.74C853.19 745.97 851.38 747.78 849.15 747.78C846.92 747.78 845.11 745.97 845.11 743.74C845.11 741.51 846.92 739.7 849.15 739.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1453.98 695.09C1456.21 695.09 1458.02 693.281 1458.02 691.05C1458.02 688.819 1456.21 687.01 1453.98 687.01C1451.75 687.01 1449.94 688.819 1449.94 691.05C1449.94 693.281 1451.75 695.09 1453.98 695.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.75 283.61C118.98 283.61 120.79 285.42 120.79 287.65C120.79 289.88 118.98 291.69 116.75 291.69C114.52 291.69 112.71 289.88 112.71 287.65C112.71 285.42 114.52 283.61 116.75 283.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1537.89 753.21C1540.12 753.21 1541.93 755.02 1541.93 757.25C1541.93 759.48 1540.12 761.29 1537.89 761.29C1535.66 761.29 1533.85 759.48 1533.85 757.25C1533.85 755.02 1535.66 753.21 1537.89 753.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M638.82 683.99C641.05 683.99 642.86 685.8 642.86 688.03C642.86 690.26 641.05 692.07 638.82 692.07C636.59 692.07 634.78 690.26 634.78 688.03C634.78 685.8 636.59 683.99 638.82 683.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M448.16 670.04C450.39 670.04 452.2 671.85 452.2 674.08C452.2 676.31 450.39 678.12 448.16 678.12C445.93 678.12 444.12 676.31 444.12 674.08C444.12 671.85 445.93 670.04 448.16 670.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M562.31 420.5C564.547 420.5 566.36 418.687 566.36 416.45C566.36 414.213 564.547 412.4 562.31 412.4C560.073 412.4 558.26 414.213 558.26 416.45C558.26 418.687 560.073 420.5 562.31 420.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M406.03 338.47C408.27 338.47 410.08 340.28 410.08 342.52C410.08 344.76 408.27 346.57 406.03 346.57C403.79 346.57 401.98 344.76 401.98 342.52C401.98 340.28 403.79 338.47 406.03 338.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M653.16 557.74C655.4 557.74 657.21 559.55 657.21 561.79C657.21 564.03 655.4 565.84 653.16 565.84C650.92 565.84 649.11 564.03 649.11 561.79C649.11 559.55 650.92 557.74 653.16 557.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M617.86 233.71C620.108 233.71 621.93 231.888 621.93 229.64C621.93 227.392 620.108 225.57 617.86 225.57C615.612 225.57 613.79 227.392 613.79 229.64C613.79 231.888 615.612 233.71 617.86 233.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.43 345.03C126.68 345.03 128.5 346.85 128.5 349.1C128.5 351.35 126.68 353.17 124.43 353.17C122.18 353.17 120.36 351.35 120.36 349.1C120.36 346.85 122.18 345.03 124.43 345.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M964.09 320.39C966.338 320.39 968.16 318.568 968.16 316.32C968.16 314.072 966.338 312.25 964.09 312.25C961.842 312.25 960.02 314.072 960.02 316.32C960.02 318.568 961.842 320.39 964.09 320.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1164.68 701.88C1166.93 701.88 1168.75 700.058 1168.75 697.81C1168.75 695.562 1166.93 693.74 1164.68 693.74C1162.43 693.74 1160.61 695.562 1160.61 697.81C1160.61 700.058 1162.43 701.88 1164.68 701.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M832.51 621.08C834.758 621.08 836.58 619.258 836.58 617.01C836.58 614.762 834.758 612.94 832.51 612.94C830.262 612.94 828.44 614.762 828.44 617.01C828.44 619.258 830.262 621.08 832.51 621.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M885.18 550.26C887.43 550.26 889.26 552.08 889.26 554.34C889.26 556.6 887.44 558.42 885.18 558.42C882.92 558.42 881.1 556.6 881.1 554.34C881.1 552.08 882.92 550.26 885.18 550.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M504.08 623.54C506.33 623.54 508.16 625.37 508.16 627.62C508.16 629.87 506.33 631.7 504.08 631.7C501.83 631.7 500 629.88 500 627.62C500 625.36 501.82 623.54 504.08 623.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M464.96 702.46C467.21 702.46 469.04 704.29 469.04 706.54C469.04 708.79 467.21 710.62 464.96 710.62C462.71 710.62 460.88 708.79 460.88 706.54C460.88 704.29 462.71 702.46 464.96 702.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M536.92 396.89C539.173 396.89 541 395.063 541 392.81C541 390.557 539.173 388.73 536.92 388.73C534.667 388.73 532.84 390.557 532.84 392.81C532.84 395.063 534.667 396.89 536.92 396.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M514.29 510.97C516.543 510.97 518.37 509.143 518.37 506.89C518.37 504.637 516.543 502.81 514.29 502.81C512.037 502.81 510.21 504.637 510.21 506.89C510.21 509.143 512.037 510.97 514.29 510.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1111.29 424.87C1113.54 424.87 1115.37 426.7 1115.37 428.95C1115.37 431.2 1113.54 433.03 1111.29 433.03C1109.04 433.03 1107.21 431.2 1107.21 428.95C1107.21 426.7 1109.04 424.87 1111.29 424.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M672.24 232.78C674.5 232.78 676.33 234.61 676.33 236.87C676.33 239.13 674.5 240.96 672.24 240.96C669.98 240.96 668.15 239.13 668.15 236.87C668.15 234.61 669.98 232.78 672.24 232.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.89 240.93C155.149 240.93 156.98 239.099 156.98 236.84C156.98 234.581 155.149 232.75 152.89 232.75C150.631 232.75 148.8 234.581 148.8 236.84C148.8 239.099 150.631 240.93 152.89 240.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1741.6 627.97C1743.86 627.97 1745.69 629.8 1745.69 632.06C1745.69 634.32 1743.86 636.15 1741.6 636.15C1739.34 636.15 1737.51 634.32 1737.51 632.06C1737.51 629.8 1739.34 627.97 1741.6 627.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M748.88 713.49C751.139 713.49 752.97 711.659 752.97 709.4C752.97 707.141 751.139 705.31 748.88 705.31C746.621 705.31 744.79 707.141 744.79 709.4C744.79 711.659 746.621 713.49 748.88 713.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M762.24 281.7C764.5 281.7 766.34 283.53 766.34 285.8C766.34 288.07 764.51 289.9 762.24 289.9C759.97 289.9 758.14 288.07 758.14 285.8C758.14 283.53 759.97 281.7 762.24 281.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M394.16 441.11C396.42 441.11 398.26 442.94 398.26 445.21C398.26 447.48 396.43 449.31 394.16 449.31C391.89 449.31 390.06 447.48 390.06 445.21C390.06 442.94 391.89 441.11 394.16 441.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M871.29 500.41C873.56 500.41 875.39 502.25 875.39 504.51C875.39 506.77 873.55 508.61 871.29 508.61C869.03 508.61 867.19 506.77 867.19 504.51C867.19 502.25 869.03 500.41 871.29 500.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1289.74 437.66C1292.01 437.66 1293.85 439.5 1293.85 441.77C1293.85 444.04 1292.01 445.88 1289.74 445.88C1287.47 445.88 1285.63 444.04 1285.63 441.77C1285.63 439.5 1287.47 437.66 1289.74 437.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M362.31 499.87C364.58 499.87 366.42 501.71 366.42 503.98C366.42 506.25 364.58 508.09 362.31 508.09C360.04 508.09 358.2 506.25 358.2 503.98C358.2 501.71 360.04 499.87 362.31 499.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.38 366.21C366.65 366.21 368.49 364.37 368.49 362.1C368.49 359.83 366.65 357.99 364.38 357.99C362.11 357.99 360.27 359.83 360.27 362.1C360.27 364.37 362.11 366.21 364.38 366.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1801.65 564.98C1803.92 564.98 1805.76 563.14 1805.76 560.87C1805.76 558.6 1803.92 556.76 1801.65 556.76C1799.38 556.76 1797.54 558.6 1797.54 560.87C1797.54 563.14 1799.38 564.98 1801.65 564.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M343.93 434.95C346.2 434.95 348.04 436.79 348.04 439.06C348.04 441.33 346.2 443.17 343.93 443.17C341.66 443.17 339.82 441.33 339.82 439.06C339.82 436.79 341.66 434.95 343.93 434.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M804.15 392.92C806.42 392.92 808.27 394.76 808.27 397.04C808.27 399.32 806.43 401.16 804.15 401.16C801.87 401.16 800.03 399.32 800.03 397.04C800.03 394.76 801.87 392.92 804.15 392.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1005.69 395.36C1007.97 395.36 1009.81 397.2 1009.81 399.48C1009.81 401.76 1007.97 403.6 1005.69 403.6C1003.41 403.6 1001.57 401.76 1001.57 399.48C1001.57 397.2 1003.41 395.36 1005.69 395.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M561.19 513.41C563.465 513.41 565.31 511.565 565.31 509.29C565.31 507.015 563.465 505.17 561.19 505.17C558.915 505.17 557.07 507.015 557.07 509.29C557.07 511.565 558.915 513.41 561.19 513.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1548.95 406.3C1551.23 406.3 1553.07 404.455 1553.07 402.18C1553.07 399.905 1551.23 398.06 1548.95 398.06C1546.67 398.06 1544.83 399.905 1544.83 402.18C1544.83 404.455 1546.67 406.3 1548.95 406.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1178.66 656.6C1180.94 656.6 1182.79 658.45 1182.79 660.73C1182.79 663.01 1180.94 664.86 1178.66 664.86C1176.38 664.86 1174.53 663.01 1174.53 660.73C1174.53 658.45 1176.38 656.6 1178.66 656.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M429.77 627.43C432.056 627.43 433.91 625.576 433.91 623.29C433.91 621.004 432.056 619.15 429.77 619.15C427.484 619.15 425.63 621.004 425.63 623.29C425.63 625.576 427.484 627.43 429.77 627.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1426.72 642.49C1429.01 642.49 1430.87 640.632 1430.87 638.34C1430.87 636.048 1429.01 634.19 1426.72 634.19C1424.43 634.19 1422.57 636.048 1422.57 638.34C1422.57 640.632 1424.43 642.49 1426.72 642.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M141.85 626.76C144.14 626.76 146 628.62 146 630.91C146 633.2 144.14 635.06 141.85 635.06C139.56 635.06 137.7 633.2 137.7 630.91C137.7 628.62 139.56 626.76 141.85 626.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M493.81 744.73C496.102 744.73 497.96 742.872 497.96 740.58C497.96 738.288 496.102 736.43 493.81 736.43C491.518 736.43 489.66 738.288 489.66 740.58C489.66 742.872 491.518 744.73 493.81 744.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1036.53 571.23C1038.82 571.23 1040.68 573.09 1040.68 575.38C1040.68 577.67 1038.82 579.53 1036.53 579.53C1034.24 579.53 1032.38 577.67 1032.38 575.38C1032.38 573.09 1034.24 571.23 1036.53 571.23Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1070.86 588.25C1073.16 588.25 1075.02 590.11 1075.02 592.41C1075.02 594.71 1073.16 596.57 1070.86 596.57C1068.56 596.57 1066.7 594.71 1066.7 592.41C1066.7 590.11 1068.56 588.25 1070.86 588.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.38 221.98C98.68 221.98 100.54 223.84 100.54 226.14C100.54 228.44 98.68 230.3 96.38 230.3C94.08 230.3 92.22 228.44 92.22 226.14C92.22 223.84 94.08 221.98 96.38 221.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M685.4 498.96C687.7 498.96 689.56 500.82 689.56 503.12C689.56 505.42 687.7 507.28 685.4 507.28C683.1 507.28 681.24 505.42 681.24 503.12C681.24 500.82 683.1 498.96 685.4 498.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1210.5 741.48C1212.8 741.48 1214.66 739.617 1214.66 737.32C1214.66 735.022 1212.8 733.16 1210.5 733.16C1208.2 733.16 1206.34 735.022 1206.34 737.32C1206.34 739.617 1208.2 741.48 1210.5 741.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M554.64 338.72C556.94 338.72 558.81 340.59 558.81 342.89C558.81 345.19 556.94 347.06 554.64 347.06C552.34 347.06 550.47 345.19 550.47 342.89C550.47 340.59 552.34 338.72 554.64 338.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M727.39 409.68C729.7 409.68 731.58 411.55 731.58 413.87C731.58 416.19 729.71 418.06 727.39 418.06C725.07 418.06 723.2 416.19 723.2 413.87C723.2 411.55 725.07 409.68 727.39 409.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M974.81 291.01C977.12 291.01 979 292.88 979 295.2C979 297.52 977.13 299.39 974.81 299.39C972.49 299.39 970.62 297.52 970.62 295.2C970.62 292.88 972.49 291.01 974.81 291.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M576.16 316.82C578.47 316.82 580.35 318.7 580.35 321.01C580.35 323.32 578.47 325.2 576.16 325.2C573.85 325.2 571.97 323.32 571.97 321.01C571.97 318.7 573.85 316.82 576.16 316.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1620.61 573.21C1622.92 573.21 1624.8 575.09 1624.8 577.4C1624.8 579.71 1622.92 581.59 1620.61 581.59C1618.3 581.59 1616.42 579.71 1616.42 577.4C1616.42 575.09 1618.3 573.21 1620.61 573.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1713.72 739.94C1716.04 739.94 1717.92 741.82 1717.92 744.14C1717.92 746.46 1716.04 748.34 1713.72 748.34C1711.4 748.34 1709.52 746.46 1709.52 744.14C1709.52 741.82 1711.4 739.94 1713.72 739.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1197.35 724.27C1199.68 724.27 1201.56 722.385 1201.56 720.06C1201.56 717.735 1199.68 715.85 1197.35 715.85C1195.02 715.85 1193.14 717.735 1193.14 720.06C1193.14 722.385 1195.02 724.27 1197.35 724.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1038.2 637.45C1040.53 637.45 1042.42 639.34 1042.42 641.67C1042.42 644 1040.53 645.89 1038.2 645.89C1035.87 645.89 1033.98 644 1033.98 641.67C1033.98 639.34 1035.87 637.45 1038.2 637.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1488.05 696.51C1490.39 696.51 1492.28 698.4 1492.28 700.74C1492.28 703.08 1490.39 704.97 1488.05 704.97C1485.71 704.97 1483.82 703.08 1483.82 700.74C1483.82 698.4 1485.71 696.51 1488.05 696.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M374.21 252.69C376.55 252.69 378.45 254.59 378.45 256.93C378.45 259.27 376.55 261.17 374.21 261.17C371.87 261.17 369.97 259.27 369.97 256.93C369.97 254.59 371.87 252.69 374.21 252.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M726.48 446.45C728.827 446.45 730.73 444.547 730.73 442.2C730.73 439.853 728.827 437.95 726.48 437.95C724.133 437.95 722.23 439.853 722.23 442.2C722.23 444.547 724.133 446.45 726.48 446.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1596.28 481.76C1598.63 481.76 1600.53 479.857 1600.53 477.51C1600.53 475.163 1598.63 473.26 1596.28 473.26C1593.93 473.26 1592.03 475.163 1592.03 477.51C1592.03 479.857 1593.93 481.76 1596.28 481.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1104.29 436.4C1106.64 436.4 1108.54 438.3 1108.54 440.65C1108.54 443 1106.64 444.9 1104.29 444.9C1101.94 444.9 1100.04 443 1100.04 440.65C1100.04 438.3 1101.94 436.4 1104.29 436.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1488.04 369.42C1490.4 369.42 1492.31 367.508 1492.31 365.15C1492.31 362.792 1490.4 360.88 1488.04 360.88C1485.68 360.88 1483.77 362.792 1483.77 365.15C1483.77 367.508 1485.68 369.42 1488.04 369.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1224.08 283.68C1226.44 283.68 1228.36 285.6 1228.36 287.96C1228.36 290.32 1226.44 292.24 1224.08 292.24C1221.72 292.24 1219.8 290.32 1219.8 287.96C1219.8 285.6 1221.72 283.68 1224.08 283.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M859.8 309.36C862.16 309.36 864.08 311.28 864.08 313.64C864.08 316 862.16 317.92 859.8 317.92C857.44 317.92 855.52 316 855.52 313.64C855.52 311.28 857.44 309.36 859.8 309.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1674.38 401.45C1676.74 401.45 1678.66 403.37 1678.66 405.73C1678.66 408.09 1676.74 410.01 1674.38 410.01C1672.02 410.01 1670.1 408.09 1670.1 405.73C1670.1 403.37 1672.02 401.45 1674.38 401.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1154.34 413.06C1156.7 413.06 1158.62 414.98 1158.62 417.34C1158.62 419.7 1156.7 421.62 1154.34 421.62C1151.98 421.62 1150.06 419.7 1150.06 417.34C1150.06 414.98 1151.98 413.06 1154.34 413.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.26 760.09C321.63 760.09 323.56 762.01 323.56 764.39C323.56 766.77 321.64 768.69 319.26 768.69C316.88 768.69 314.96 766.77 314.96 764.39C314.96 762.01 316.88 760.09 319.26 760.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1372.02 383.81C1374.4 383.81 1376.33 381.88 1376.33 379.5C1376.33 377.12 1374.4 375.19 1372.02 375.19C1369.64 375.19 1367.71 377.12 1367.71 379.5C1367.71 381.88 1369.64 383.81 1372.02 383.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1416.42 417.28C1418.8 417.28 1420.74 419.21 1420.74 421.6C1420.74 423.99 1418.81 425.92 1416.42 425.92C1414.03 425.92 1412.1 423.99 1412.1 421.6C1412.1 419.21 1414.03 417.28 1416.42 417.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1248.51 749.25C1250.9 749.25 1252.84 751.19 1252.84 753.58C1252.84 755.97 1250.9 757.91 1248.51 757.91C1246.12 757.91 1244.18 755.97 1244.18 753.58C1244.18 751.19 1246.12 749.25 1248.51 749.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M919.91 484.73C922.307 484.73 924.25 482.787 924.25 480.39C924.25 477.993 922.307 476.05 919.91 476.05C917.513 476.05 915.57 477.993 915.57 480.39C915.57 482.787 917.513 484.73 919.91 484.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.39 260.06C59.8 260.06 61.76 262.01 61.76 264.43C61.76 266.85 59.81 268.8 57.39 268.8C54.97 268.8 53.03 266.85 53.03 264.43C53.03 262.01 54.98 260.06 57.39 260.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1064.49 360.76C1066.9 360.76 1068.86 358.804 1068.86 356.39C1068.86 353.977 1066.9 352.02 1064.49 352.02C1062.08 352.02 1060.12 353.977 1060.12 356.39C1060.12 358.804 1062.08 360.76 1064.49 360.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1520.94 319.36C1523.35 319.36 1525.31 317.403 1525.31 314.99C1525.31 312.577 1523.35 310.62 1520.94 310.62C1518.53 310.62 1516.57 312.577 1516.57 314.99C1516.57 317.403 1518.53 319.36 1520.94 319.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M206.13 467.22C208.55 467.22 210.51 469.18 210.51 471.6C210.51 474.02 208.55 475.98 206.13 475.98C203.71 475.98 201.75 474.02 201.75 471.6C201.75 469.18 203.71 467.22 206.13 467.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1433.4 340.36C1435.82 340.36 1437.78 338.399 1437.78 335.98C1437.78 333.561 1435.82 331.6 1433.4 331.6C1430.98 331.6 1429.02 333.561 1429.02 335.98C1429.02 338.399 1430.98 340.36 1433.4 340.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1429.91 653.44C1432.33 653.44 1434.3 655.41 1434.3 657.83C1434.3 660.25 1432.33 662.22 1429.91 662.22C1427.49 662.22 1425.52 660.25 1425.52 657.83C1425.52 655.41 1427.49 653.44 1429.91 653.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M780.53 606.11C782.98 606.11 784.96 608.09 784.96 610.54C784.96 612.99 782.98 614.97 780.53 614.97C778.08 614.97 776.1 612.99 776.1 610.54C776.1 608.09 778.08 606.11 780.53 606.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M930.93 325.89C933.38 325.89 935.36 327.87 935.36 330.32C935.36 332.77 933.38 334.75 930.93 334.75C928.48 334.75 926.5 332.77 926.5 330.32C926.5 327.87 928.48 325.89 930.93 325.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1035.2 530.87C1037.67 530.87 1039.68 528.864 1039.68 526.39C1039.68 523.916 1037.67 521.91 1035.2 521.91C1032.73 521.91 1030.72 523.916 1030.72 526.39C1030.72 528.864 1032.73 530.87 1035.2 530.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M822.8 581.11C825.27 581.11 827.28 583.12 827.28 585.59C827.28 588.06 825.27 590.07 822.8 590.07C820.33 590.07 818.32 588.06 818.32 585.59C818.32 583.12 820.33 581.11 822.8 581.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M732.12 379.21C734.6 379.21 736.61 381.22 736.61 383.7C736.61 386.18 734.6 388.19 732.12 388.19C729.64 388.19 727.63 386.18 727.63 383.7C727.63 381.22 729.64 379.21 732.12 379.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M418.66 619.79C421.15 619.79 423.18 621.81 423.18 624.31C423.18 626.81 421.16 628.82 418.66 628.82C416.16 628.82 414.15 626.8 414.15 624.31C414.15 621.82 416.17 619.79 418.66 619.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M629.58 336.39C632.087 336.39 634.12 334.357 634.12 331.85C634.12 329.343 632.087 327.31 629.58 327.31C627.073 327.31 625.04 329.343 625.04 331.85C625.04 334.357 627.073 336.39 629.58 336.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M561.22 502.61C563.73 502.61 565.76 504.64 565.76 507.15C565.76 509.66 563.73 511.69 561.22 511.69C558.71 511.69 556.68 509.66 556.68 507.15C556.68 504.64 558.71 502.61 561.22 502.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1031.76 687.27C1034.27 687.27 1036.3 689.3 1036.3 691.81C1036.3 694.32 1034.27 696.35 1031.76 696.35C1029.25 696.35 1027.22 694.32 1027.22 691.81C1027.22 689.3 1029.25 687.27 1031.76 687.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M621.69 283.31C624.203 283.31 626.24 281.273 626.24 278.76C626.24 276.247 624.203 274.21 621.69 274.21C619.177 274.21 617.14 276.247 617.14 278.76C617.14 281.273 619.177 283.31 621.69 283.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M785.15 246.05C787.68 246.05 789.72 248.1 789.72 250.62C789.72 253.14 787.67 255.19 785.15 255.19C782.63 255.19 780.58 253.14 780.58 250.62C780.58 248.1 782.63 246.05 785.15 246.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M418.5 648C421.04 648 423.09 650.06 423.09 652.59C423.09 655.12 421.03 657.18 418.5 657.18C415.97 657.18 413.91 655.12 413.91 652.59C413.91 650.06 415.97 648 418.5 648Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M538.38 711.53C540.932 711.53 543 709.462 543 706.91C543 704.358 540.932 702.29 538.38 702.29C535.828 702.29 533.76 704.358 533.76 706.91C533.76 709.462 535.828 711.53 538.38 711.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1639.4 395.65L1551.75 478.06C1550.93 478.85 1550.9 480.15 1551.68 480.97C1552.46 481.78 1553.74 481.82 1554.56 481.06L1642.2 398.65C1643.02 397.87 1643.05 396.56 1642.27 395.74C1641.49 394.93 1640.21 394.89 1639.39 395.65H1639.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1637.88 575.46L1569.35 653.05C1568.6 653.9 1568.68 655.2 1569.53 655.95C1570.38 656.7 1571.68 656.62 1572.43 655.77L1640.96 578.18C1641.71 577.33 1641.63 576.03 1640.78 575.28C1639.93 574.53 1638.63 574.61 1637.88 575.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1707.12 587.07L1639.8 574.79C1638.68 574.59 1637.61 575.33 1637.41 576.45C1637.21 577.57 1637.95 578.64 1639.07 578.84L1706.39 591.12C1707.51 591.32 1708.58 590.58 1708.78 589.47C1708.98 588.36 1708.24 587.28 1707.13 587.08L1707.12 587.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M172.4 534L168.87 575.46C168.77 576.59 169.61 577.59 170.75 577.69C171.88 577.79 172.88 576.95 172.98 575.81L176.51 534.35C176.61 533.22 175.77 532.22 174.63 532.12C173.5 532.02 172.5 532.86 172.4 534Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M172.47 534.74L205.22 648C205.56 649.08 206.71 649.69 207.8 649.35C208.85 649.02 209.46 647.92 209.17 646.86L176.42 533.6C176.09 532.51 174.94 531.9 173.86 532.22C172.79 532.54 172.17 533.66 172.47 534.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1668.08 658.48L1641.38 576.18C1641.03 575.1 1639.87 574.51 1638.79 574.86C1637.71 575.21 1637.12 576.37 1637.47 577.45L1664.17 659.74C1664.52 660.82 1665.68 661.41 1666.76 661.06C1667.84 660.71 1668.43 659.55 1668.08 658.47V658.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.08 576.55L205.36 648.36C205.88 649.37 207.12 649.77 208.13 649.25C209.13 648.74 209.53 647.51 209.03 646.51L172.75 574.7C172.23 573.69 170.99 573.29 169.98 573.8C168.97 574.31 168.57 575.54 169.08 576.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M232.71 545.97L174.92 532.17C173.81 531.92 172.71 532.62 172.46 533.73C172.22 534.82 172.88 535.9 173.96 536.18L231.75 549.98C232.86 550.23 233.96 549.53 234.21 548.42C234.45 547.33 233.79 546.25 232.71 545.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M176.44 533.64L129.47 356.15C129.16 355.06 128.02 354.42 126.93 354.74C125.87 355.04 125.23 356.13 125.5 357.21L172.47 534.7C172.78 535.79 173.92 536.43 175.01 536.11C176.07 535.81 176.71 534.72 176.44 533.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M231.39 546.09L170.07 573.75C169.04 574.23 168.6 575.46 169.08 576.49C169.55 577.5 170.74 577.94 171.76 577.5L233.08 549.84C234.11 549.36 234.55 548.13 234.07 547.1C233.6 546.09 232.41 545.65 231.39 546.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M230.24 547.47L205.2 646.93C204.92 648.03 205.59 649.15 206.69 649.43C207.79 649.71 208.91 649.04 209.19 647.94L234.22 548.47C234.47 547.36 233.78 546.26 232.67 546.01C231.6 545.77 230.53 546.41 230.23 547.47H230.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1705.86 587.24L1570 652.55C1568.98 653.04 1568.54 654.27 1569.04 655.3C1569.53 656.32 1570.76 656.76 1571.79 656.26L1707.66 590.95C1708.68 590.46 1709.11 589.22 1708.62 588.2C1708.13 587.18 1706.89 586.75 1705.87 587.24H1705.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1626.19 817.11L1572.85 653.77C1572.5 652.69 1571.34 652.1 1570.25 652.45C1569.16 652.8 1568.58 653.96 1568.93 655.05L1622.28 818.39C1622.65 819.47 1623.81 820.04 1624.89 819.68C1625.95 819.32 1626.53 818.18 1626.19 817.12V817.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M203.91 273.97L126 355.25C125.21 356.07 125.24 357.37 126.06 358.16C126.88 358.95 128.18 358.92 128.97 358.1L206.88 276.81C207.65 275.97 207.59 274.67 206.75 273.9C205.94 273.16 204.69 273.18 203.91 273.96V273.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1243.68 427.61L1390.87 341.73C1391.85 341.16 1392.18 339.9 1391.61 338.92C1391.04 337.94 1389.78 337.61 1388.8 338.18L1241.61 424.06C1240.64 424.65 1240.33 425.92 1240.92 426.89C1241.5 427.83 1242.71 428.15 1243.68 427.62V427.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1666.22 657.06L1570.99 652.36C1569.85 652.3 1568.89 653.18 1568.83 654.31C1568.77 655.44 1569.65 656.41 1570.78 656.47L1666.01 661.17C1667.15 661.2 1668.09 660.3 1668.12 659.17C1668.15 658.07 1667.31 657.14 1666.21 657.06H1666.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M168.99 574.91L117.19 714.68C116.8 715.75 117.34 716.93 118.4 717.32C119.47 717.71 120.65 717.17 121.04 716.1L172.84 576.33C173.23 575.26 172.69 574.08 171.62 573.69C170.55 573.3 169.37 573.84 168.98 574.9L168.99 574.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M120.37 717.03L208.45 649.06C209.34 648.35 209.49 647.06 208.78 646.17C208.09 645.3 206.83 645.14 205.94 645.8L117.86 713.76C116.96 714.45 116.79 715.75 117.49 716.65C118.18 717.55 119.48 717.72 120.38 717.02L120.37 717.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M155.62 460.98L172.45 534.63C172.7 535.74 173.81 536.43 174.91 536.18C176.01 535.93 176.71 534.82 176.46 533.72L159.63 460.07C159.38 458.96 158.27 458.27 157.17 458.52C156.07 458.77 155.37 459.88 155.62 460.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M155.58 460.75L168.88 575.86C169.01 576.99 170.03 577.8 171.16 577.67C172.29 577.54 173.1 576.52 172.97 575.39L159.67 460.28C159.54 459.15 158.52 458.34 157.39 458.47C156.26 458.6 155.45 459.62 155.58 460.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M86.33 749.87L208.51 649.02C209.39 648.3 209.51 647 208.79 646.12C208.07 645.24 206.77 645.12 205.89 645.84L83.71 746.69C82.85 747.43 82.75 748.73 83.49 749.59C84.21 750.43 85.46 750.55 86.33 749.86V749.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1704.98 588.07L1664.35 658.08C1663.78 659.06 1664.11 660.32 1665.1 660.89C1666.08 661.46 1667.34 661.13 1667.91 660.14L1708.54 590.13C1709.11 589.15 1708.78 587.89 1707.79 587.32C1706.8 586.75 1705.55 587.08 1704.98 588.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1708.8 589.24L1719.44 429.14C1719.43 428 1718.5 427.09 1717.36 427.1C1716.34 427.1 1715.48 427.86 1715.34 428.87L1704.7 588.97C1704.7 590.11 1705.64 591.02 1706.77 591.01C1707.79 591.01 1708.65 590.25 1708.79 589.24H1708.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1242.61 423.77L1114.13 426.12C1112.99 426.14 1112.09 427.08 1112.11 428.22C1112.13 429.36 1113.07 430.26 1114.21 430.24L1242.69 427.89C1243.83 427.87 1244.73 426.93 1244.71 425.79C1244.69 424.65 1243.75 423.75 1242.61 423.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1664.13 658.59L1622.24 817.23C1621.95 818.33 1622.61 819.46 1623.7 819.75C1624.8 820.04 1625.92 819.38 1626.22 818.29L1668.11 659.65C1668.37 658.54 1667.69 657.44 1666.59 657.17C1665.52 656.92 1664.44 657.54 1664.14 658.6L1664.13 658.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M233.8 546.64L159.19 459.19C158.43 458.34 157.13 458.27 156.28 459.02C155.46 459.75 155.36 461.01 156.06 461.86L230.67 549.31C231.43 550.16 232.73 550.24 233.57 549.48C234.39 548.75 234.49 547.49 233.79 546.64H233.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M127.55 354.62L32.79 351.6V355.72L127.42 358.73C128.56 358.76 129.5 357.87 129.53 356.73C129.56 355.6 128.68 354.66 127.55 354.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M159.6 459.95L129.46 356.11C129.14 355.02 128 354.39 126.91 354.71C125.82 355.03 125.19 356.17 125.51 357.26L155.65 461.1C155.97 462.19 157.11 462.82 158.2 462.5C159.29 462.18 159.92 461.04 159.6 459.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1708.76 588.7L1673.5 411.24C1673.28 410.13 1672.2 409.4 1671.08 409.62C1669.96 409.84 1669.24 410.92 1669.46 412.04L1704.72 589.5C1704.99 590.6 1706.1 591.28 1707.2 591.02C1708.24 590.77 1708.92 589.76 1708.75 588.7H1708.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1562.66 721.67L1572.92 654.72C1573.09 653.6 1572.32 652.55 1571.2 652.37C1570.08 652.2 1569.03 652.97 1568.85 654.09L1558.59 721.04C1558.42 722.16 1559.19 723.21 1560.31 723.39C1561.43 723.56 1562.48 722.79 1562.66 721.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1435.36 569.96L1569.77 656.14C1570.73 656.75 1572 656.48 1572.61 655.52C1573.22 654.56 1572.95 653.29 1571.99 652.68L1437.58 566.5C1436.62 565.89 1435.35 566.16 1434.74 567.12C1434.13 568.08 1434.4 569.35 1435.36 569.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1718.12 427.07L1672.21 409.71C1671.15 409.31 1669.96 409.84 1669.56 410.91C1669.16 411.97 1669.69 413.16 1670.76 413.56L1716.66 430.92C1717.72 431.32 1718.91 430.79 1719.32 429.73C1719.72 428.67 1719.19 427.48 1718.13 427.07H1718.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1705.18 590.43L1766.8 662.71C1767.57 663.54 1768.88 663.59 1769.71 662.81C1770.49 662.08 1770.59 660.88 1769.93 660.04L1708.33 587.76C1707.59 586.89 1706.29 586.78 1705.42 587.52C1704.55 588.26 1704.44 589.56 1705.18 590.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1558.91 722.49L1622.52 818.88C1623.17 819.81 1624.45 820.04 1625.38 819.4C1626.28 818.77 1626.53 817.55 1625.95 816.62L1562.34 720.23C1561.71 719.28 1560.43 719.03 1559.49 719.66C1558.55 720.29 1558.29 721.56 1558.91 722.5V722.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1768.41 659.32L1666.17 657.05C1665.03 657.05 1664.11 657.97 1664.11 659.11C1664.11 660.21 1664.98 661.12 1666.08 661.17L1768.33 663.44C1769.47 663.44 1770.38 662.51 1770.38 661.37C1770.38 660.27 1769.51 659.37 1768.41 659.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.45 749.77L120.54 716.88C121.36 716.09 121.38 714.79 120.59 713.97C119.8 713.15 118.5 713.13 117.68 713.92L83.59 746.81C82.77 747.6 82.75 748.9 83.54 749.72C84.33 750.54 85.63 750.56 86.45 749.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1706.42 591.13L1826.27 610.9C1827.39 611.09 1828.45 610.33 1828.64 609.21C1828.83 608.09 1828.07 607.03 1826.95 606.84L1707.1 587.07C1705.98 586.88 1704.92 587.64 1704.73 588.76C1704.54 589.88 1705.3 590.94 1706.42 591.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M152.65 330.98L126.1 355.16C125.26 355.93 125.2 357.23 125.96 358.07C126.73 358.91 128.03 358.97 128.87 358.21L155.42 334.03C156.26 333.26 156.32 331.96 155.56 331.12C154.79 330.28 153.49 330.22 152.65 330.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1561.67 723.13L1667.17 660.88C1668.15 660.3 1668.47 659.04 1667.9 658.06C1667.32 657.08 1666.06 656.76 1665.08 657.33L1559.58 719.58C1558.62 720.18 1558.32 721.45 1558.92 722.41C1559.5 723.34 1560.71 723.65 1561.67 723.12V723.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M128.97 355.26C128.19 354.44 126.88 354.41 126.06 355.19L32.79 444.2V449.89L128.9 358.17C129.72 357.39 129.75 356.08 128.97 355.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1825.97 606.91L1665.5 657.15C1664.42 657.49 1663.81 658.64 1664.15 659.73C1664.49 660.81 1665.64 661.42 1666.73 661.08L1827.2 610.84C1828.28 610.5 1828.89 609.34 1828.55 608.26C1828.21 607.18 1827.05 606.57 1825.97 606.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M155.56 333.88L206.92 276.77C207.66 275.91 207.57 274.61 206.71 273.87C205.87 273.14 204.61 273.21 203.86 274.02L152.5 331.13C151.76 331.99 151.85 333.29 152.71 334.03C153.55 334.76 154.81 334.69 155.56 333.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1360.92 751.03L1390.63 763.78C1391.68 764.21 1392.88 763.71 1393.32 762.66C1393.74 761.63 1393.27 760.45 1392.25 760L1362.54 747.25C1361.5 746.8 1360.29 747.28 1359.84 748.33C1359.39 749.37 1359.87 750.58 1360.92 751.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1240.63 426.26L1271.89 572.82C1272.13 573.93 1273.23 574.63 1274.34 574.39C1275.44 574.15 1276.14 573.07 1275.91 571.97L1244.65 425.41C1244.41 424.3 1243.31 423.6 1242.2 423.84C1241.1 424.08 1240.4 425.16 1240.63 426.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1619.21 634.47L1570.18 652.48C1569.12 652.89 1568.59 654.08 1568.99 655.14C1569.39 656.18 1570.54 656.72 1571.6 656.34L1620.63 638.33C1621.69 637.92 1622.22 636.73 1621.82 635.67C1621.42 634.63 1620.27 634.09 1619.21 634.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.9401 721.05L119.25 717.45C120.38 717.37 121.24 716.39 121.16 715.25C121.08 714.12 120.1 713.26 118.96 713.34L66.6501 716.94C65.5201 717.04 64.6801 718.03 64.7801 719.17C64.8801 720.27 65.8301 721.1 66.9301 721.05H66.9401Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M68.28 717.57L32.79 681.12V687.02L65.33 720.44C66.13 721.25 67.43 721.25 68.24 720.44C69.03 719.65 69.05 718.37 68.28 717.56V717.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1424.54 894.31L1363.63 748.35C1363.19 747.3 1361.99 746.81 1360.94 747.24C1359.89 747.68 1359.4 748.88 1359.83 749.93L1420.75 895.88C1421.22 896.92 1422.43 897.38 1423.47 896.91C1424.47 896.46 1424.94 895.31 1424.55 894.29L1424.54 894.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M120.13 713.65C119.17 713.09 117.94 713.4 117.35 714.34L32.79 855.07V862.78C32.98 862.63 33.15 862.46 33.28 862.24L120.88 716.45C121.45 715.47 121.11 714.21 120.13 713.64V713.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M123.99 327.16L125.42 356.78C125.5 357.91 126.49 358.76 127.62 358.68C128.71 358.6 129.55 357.68 129.53 356.58L128.1 326.96C128.04 325.82 127.08 324.95 125.94 325C124.8 325.06 123.93 326.02 123.98 327.15L123.99 327.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.06 720.09L83.28 749.37C83.88 750.34 85.15 750.63 86.11 750.03C87.08 749.43 87.37 748.16 86.77 747.2L68.55 717.92C67.95 716.96 66.68 716.66 65.72 717.26C64.76 717.86 64.46 719.13 65.06 720.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1193.43 300.91L1240.72 426.55C1241.12 427.61 1242.31 428.15 1243.37 427.75C1244.43 427.35 1244.97 426.16 1244.57 425.1L1197.28 299.46C1196.85 298.41 1195.66 297.9 1194.6 298.32C1193.58 298.73 1193.07 299.87 1193.43 300.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1193.62 299.09L1112.43 427.08C1111.83 428.05 1112.13 429.31 1113.09 429.91C1114.04 430.5 1115.29 430.22 1115.9 429.28L1197.09 301.29C1197.69 300.33 1197.4 299.06 1196.44 298.45C1195.48 297.85 1194.23 298.13 1193.62 299.08V299.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.77 746.24L32.79 752.73V756.88L85.28 750.33C86.4 750.16 87.18 749.11 87.01 747.99C86.85 746.91 85.86 746.14 84.77 746.25V746.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1705.78 587.29L1618.94 634.59C1617.95 635.15 1617.6 636.4 1618.15 637.39C1618.7 638.36 1619.92 638.72 1620.91 638.2L1707.74 590.9C1708.71 590.3 1709 589.03 1708.4 588.07C1707.85 587.18 1706.73 586.85 1705.78 587.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M85.84 746.45C84.84 746 83.66 746.42 83.16 747.41L32.78 853.7V862.76C33.02 862.58 33.22 862.36 33.37 862.07L86.88 749.17C87.34 748.13 86.88 746.92 85.84 746.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1769.74 662.91L1827.97 610.4C1828.81 609.64 1828.88 608.34 1828.12 607.49C1827.36 606.65 1826.06 606.58 1825.21 607.34L1766.98 659.85C1766.14 660.61 1766.07 661.91 1766.83 662.76C1767.59 663.6 1768.89 663.67 1769.74 662.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1657.11 734.59L1622.34 816.95C1621.9 818 1622.39 819.2 1623.44 819.65C1624.49 820.09 1625.69 819.6 1626.14 818.55L1660.91 736.19C1661.35 735.14 1660.86 733.94 1659.81 733.49C1658.76 733.05 1657.56 733.54 1657.11 734.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M153.76 330.46L32.79 346.76V350.91L154.31 334.54C155.44 334.39 156.23 333.35 156.08 332.23C155.93 331.11 154.89 330.31 153.77 330.46H153.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.98 332.56L155.57 460.57C155.62 461.71 156.58 462.59 157.71 462.54C158.82 462.49 159.7 461.57 159.68 460.46L156.09 332.45C156.04 331.31 155.08 330.43 153.95 330.48C152.84 330.53 151.96 331.45 151.98 332.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1550.82 365.72L1670.72 413.55C1671.79 413.94 1672.97 413.4 1673.36 412.34C1673.74 411.31 1673.25 410.17 1672.24 409.73L1552.34 361.9C1551.27 361.51 1550.09 362.05 1549.7 363.12C1549.32 364.15 1549.81 365.29 1550.82 365.73V365.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1767.54 663.27L1861.38 704.15C1862.45 704.53 1863.63 703.97 1864.01 702.9C1864.36 701.93 1863.93 700.84 1863.01 700.37L1769.19 659.49C1768.15 659.04 1766.94 659.53 1766.49 660.57C1766.05 661.6 1766.52 662.8 1767.55 663.26L1767.54 663.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1526.78 314.71L1670.32 413.33C1671.26 413.97 1672.54 413.74 1673.18 412.8C1673.82 411.86 1673.59 410.58 1672.65 409.94L1529.11 311.32C1528.17 310.69 1526.89 310.94 1526.25 311.88C1525.63 312.81 1525.86 314.07 1526.77 314.71H1526.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M217.95 844.96L120.77 714.17C120.09 713.26 118.8 713.07 117.89 713.74C116.98 714.41 116.79 715.71 117.46 716.62L214.64 847.41C215.33 848.31 216.62 848.49 217.52 847.8C218.41 847.12 218.59 845.86 217.94 844.96H217.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M157.74 458.46L32.79 451.27V455.39L157.51 462.56C158.64 462.63 159.62 461.76 159.68 460.62C159.75 459.49 158.88 458.51 157.74 458.45V458.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1619.01 638.24L1665.21 660.95C1666.23 661.45 1667.46 661.03 1667.96 660.01C1668.46 658.99 1668.04 657.76 1667.02 657.26L1620.81 634.55C1619.79 634.05 1618.56 634.48 1618.06 635.5C1617.57 636.52 1617.98 637.74 1618.99 638.24H1619.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1664.07 658.92L1656.95 735.2C1656.87 736.33 1657.72 737.32 1658.86 737.4C1659.96 737.48 1660.93 736.68 1661.05 735.58L1668.17 659.3C1668.25 658.17 1667.4 657.18 1666.27 657.1C1665.17 657.02 1664.2 657.82 1664.07 658.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M217.53 844.54L86.2501 746.64C85.3201 745.98 84.0401 746.2 83.3801 747.13C82.7401 748.03 82.9301 749.26 83.7901 749.94L215.06 847.84C215.97 848.52 217.26 848.33 217.94 847.42C218.62 846.51 218.43 845.22 217.52 844.54H217.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1574.92 874.7L1562.67 721.2C1562.58 720.07 1561.59 719.22 1560.46 719.31C1559.33 719.4 1558.48 720.39 1558.57 721.53L1570.82 875.03C1570.91 876.16 1571.9 877.01 1573.03 876.92C1574.16 876.83 1575.01 875.84 1574.92 874.71V874.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M68.7601 718.35C68.4001 717.27 67.2301 716.69 66.1601 717.05L32.8 728.2V732.54L67.4701 720.96C68.5501 720.6 69.13 719.43 68.77 718.36L68.7601 718.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M67.28 717.02C66.19 716.76 65.09 717.42 64.81 718.51L32.79 847.52V862.75C33.12 862.48 33.4 862.13 33.51 861.69L68.8 719.51C69.07 718.41 68.39 717.29 67.28 717.03V717.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1436.42 566.17L1273.85 570.34C1272.71 570.39 1271.84 571.35 1271.89 572.49C1271.94 573.59 1272.85 574.46 1273.96 574.46L1436.53 570.3C1437.67 570.27 1438.56 569.33 1438.54 568.19C1438.51 567.05 1437.57 566.16 1436.43 566.19L1436.42 566.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1439.45 710.66L1389.98 760.44C1389.21 761.27 1389.25 762.57 1390.08 763.35C1390.87 764.09 1392.11 764.09 1392.9 763.35L1442.38 713.57C1443.18 712.76 1443.18 711.46 1442.38 710.66C1441.57 709.86 1440.27 709.86 1439.47 710.66H1439.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M128.02 326.61C127.77 325.53 126.72 324.84 125.63 325.05L32.79 344.55V348.75L126.47 329.07C127.58 328.82 128.27 327.71 128.02 326.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M159.62 460.04L128.05 326.58C127.77 325.48 126.66 324.81 125.55 325.08C124.47 325.35 123.8 326.44 124.04 327.52L155.61 460.98C155.88 462.08 157 462.76 158.1 462.48C159.19 462.21 159.86 461.12 159.61 460.03L159.62 460.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1768.69 659.35L1620.25 634.37C1619.13 634.2 1618.08 634.97 1617.91 636.09C1617.74 637.19 1618.48 638.22 1619.57 638.42L1768.01 663.4C1769.13 663.56 1770.18 662.78 1770.34 661.65C1770.5 660.56 1769.77 659.55 1768.69 659.34V659.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1767.21 659.68L1657.85 733.69C1656.91 734.33 1656.66 735.61 1657.3 736.55C1657.94 737.49 1659.22 737.74 1660.16 737.1L1769.52 663.09C1770.44 662.43 1770.65 661.14 1769.99 660.22C1769.35 659.34 1768.14 659.1 1767.22 659.68H1767.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1560.98 719.33L1552.63 717.85C1551.51 717.67 1550.45 718.44 1550.28 719.56C1550.11 720.65 1550.83 721.69 1551.92 721.9L1560.27 723.38C1561.39 723.58 1562.46 722.83 1562.66 721.71C1562.86 720.59 1562.11 719.52 1560.99 719.32L1560.98 719.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1562.31 722.54L1621.6 637.58C1622.25 636.65 1622.02 635.37 1621.09 634.71C1620.16 634.06 1618.88 634.29 1618.22 635.22L1558.93 720.18C1558.3 721.13 1558.56 722.4 1559.5 723.03C1560.42 723.64 1561.65 723.42 1562.3 722.53L1562.31 722.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1560.34 723.4L1658.72 737.43C1659.85 737.59 1660.88 736.8 1661.04 735.68C1661.2 734.56 1660.42 733.52 1659.3 733.36L1560.92 719.33C1559.79 719.18 1558.76 719.96 1558.6 721.09C1558.45 722.21 1559.22 723.24 1560.34 723.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1560.78 719.31L1441.06 710.06C1439.93 709.98 1438.94 710.84 1438.87 711.97C1438.79 713.09 1439.63 714.06 1440.75 714.16L1560.47 723.41C1561.6 723.49 1562.59 722.64 1562.67 721.5C1562.75 720.38 1561.91 719.4 1560.79 719.31H1560.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M198.41 572.95L159.56 459.85C159.17 458.78 157.99 458.24 156.92 458.63C155.88 459.01 155.33 460.14 155.67 461.19L194.52 574.29C194.92 575.35 196.1 575.9 197.17 575.5C198.2 575.12 198.74 574 198.41 572.96V572.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M1440.04 710.25L1360.86 747.28C1359.84 747.79 1359.43 749.02 1359.94 750.04C1360.43 751.02 1361.6 751.44 1362.6 751.01L1441.78 713.98C1442.81 713.5 1443.25 712.27 1442.77 711.24C1442.29 710.21 1441.06 709.77 1440.03 710.25H1440.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1767.58 663.29L1859.05 700.44C1860.12 700.83 1861.3 700.29 1861.69 699.22C1862.07 698.2 1861.58 697.06 1860.59 696.63L1769.12 659.48C1768.05 659.09 1766.87 659.63 1766.48 660.7C1766.1 661.72 1766.59 662.86 1767.58 663.3V663.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1537.68 273.97L1549.55 364.08C1549.7 365.21 1550.73 366 1551.86 365.85C1552.99 365.7 1553.78 364.67 1553.63 363.54L1541.76 273.43C1541.61 272.3 1540.58 271.51 1539.45 271.66C1538.32 271.81 1537.53 272.84 1537.68 273.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1537.75 273.11L1525.97 312.43C1525.68 313.53 1526.33 314.66 1527.42 314.95C1528.47 315.23 1529.56 314.65 1529.91 313.61L1541.69 274.29C1542.02 273.2 1541.4 272.05 1540.31 271.73C1539.22 271.4 1538.07 272.02 1537.75 273.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1434.42 568.29L1438.85 712.18C1438.89 713.32 1439.84 714.2 1440.98 714.16C1442.11 714.12 1443 713.18 1442.96 712.05L1438.53 568.17C1438.49 567.03 1437.54 566.15 1436.4 566.19C1435.27 566.23 1434.38 567.17 1434.42 568.3V568.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1553.45 362.94L1529.81 312.15C1529.32 311.13 1528.09 310.7 1527.06 311.19C1526.06 311.67 1525.62 312.87 1526.08 313.89L1549.72 364.68C1550.21 365.7 1551.44 366.13 1552.47 365.64C1553.47 365.16 1553.91 363.96 1553.45 362.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1574.91 874.59L1554.31 719.61C1554.16 718.48 1553.13 717.69 1552 717.84C1550.87 717.99 1550.08 719.02 1550.23 720.15L1570.82 875.13C1570.97 876.26 1572 877.05 1573.13 876.9C1574.26 876.75 1575.05 875.72 1574.9 874.59H1574.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1574.62 875.94L1660.75 736.47C1661.35 735.5 1661.05 734.24 1660.08 733.64C1659.11 733.04 1657.85 733.34 1657.25 734.31L1571.12 873.78C1570.54 874.76 1570.87 876.02 1571.85 876.6C1572.8 877.16 1574.02 876.87 1574.62 875.95V875.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M753.33 285.84L882.93 229.66C883.97 229.19 884.43 227.98 883.96 226.94C883.5 225.92 882.32 225.46 881.29 225.88L751.68 282.06C750.64 282.51 750.16 283.72 750.61 284.77C751.06 285.81 752.27 286.29 753.32 285.84H753.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1562.62 720.86L1533.76 605.9C1533.48 604.8 1532.37 604.13 1531.26 604.41C1530.16 604.69 1529.49 605.8 1529.77 606.91L1558.63 721.87C1558.91 722.97 1560.02 723.64 1561.13 723.36C1562.23 723.08 1562.9 721.97 1562.62 720.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M154.43 330.48L126.44 325.04C125.32 324.84 124.25 325.58 124.05 326.7C123.85 327.8 124.56 328.85 125.65 329.08L153.64 334.52C154.76 334.72 155.83 333.98 156.03 332.86C156.23 331.76 155.52 330.71 154.42 330.48H154.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M241.33 386.66L156.29 458.95C155.43 459.7 155.34 460.99 156.09 461.85C156.82 462.69 158.1 462.8 158.96 462.08L244 389.78C244.84 389.02 244.91 387.72 244.15 386.87C243.42 386.06 242.19 385.96 241.33 386.64V386.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M998.81 812.42L1055.48 698.04C1055.98 697.02 1055.55 695.79 1054.53 695.29C1053.52 694.8 1052.3 695.21 1051.79 696.21L995.12 810.6C994.64 811.63 995.08 812.85 996.11 813.34C997.11 813.81 998.29 813.41 998.81 812.43V812.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1435.71 570.14L1531 608.31C1532.06 608.73 1533.25 608.22 1533.68 607.17C1534.1 606.11 1533.59 604.92 1532.53 604.49L1437.24 566.32C1436.18 565.92 1434.99 566.46 1434.59 567.52C1434.2 568.55 1434.7 569.71 1435.71 570.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M127.32 325.45C126.43 324.75 125.13 324.9 124.43 325.79L32.79 441.8V448.44L127.66 328.34C128.36 327.45 128.21 326.15 127.32 325.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1488.54 647.59L1559.12 722.77C1559.9 723.59 1561.2 723.63 1562.03 722.85C1562.85 722.07 1562.89 720.78 1562.12 719.96L1491.54 644.78C1490.74 643.97 1489.44 643.97 1488.63 644.77C1487.85 645.54 1487.81 646.78 1488.54 647.6V647.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M848.19 663.59L782.72 829.69C782.3 830.75 782.82 831.94 783.88 832.36C784.94 832.78 786.13 832.26 786.55 831.2L852.02 665.1C852.44 664.04 851.92 662.85 850.86 662.43C849.8 662.01 848.61 662.53 848.19 663.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1491.74 645.02L1438.17 567.07C1437.5 566.15 1436.22 565.95 1435.3 566.62C1434.42 567.26 1434.19 568.49 1434.78 569.4L1488.35 647.35C1489.02 648.27 1490.3 648.47 1491.22 647.81C1492.11 647.17 1492.33 645.94 1491.74 645.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1156.84 770.73L1054.85 695.46C1053.92 694.81 1052.64 695.03 1051.98 695.96C1051.35 696.86 1051.53 698.1 1052.4 698.77L1154.39 774.04C1155.32 774.69 1156.6 774.47 1157.26 773.54C1157.89 772.64 1157.71 771.4 1156.84 770.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M603.32 329.58L523.73 255.82C522.9 255.05 521.59 255.1 520.82 255.93C520.05 256.76 520.1 258.07 520.93 258.84L600.52 332.6C601.37 333.36 602.67 333.29 603.43 332.44C604.17 331.61 604.12 330.35 603.32 329.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1618.32 635.1L1550.68 718.58C1549.96 719.46 1550.1 720.76 1550.98 721.47C1551.86 722.19 1553.16 722.05 1553.87 721.17L1621.51 637.69C1622.22 636.81 1622.08 635.51 1621.2 634.8C1620.32 634.09 1619.03 634.22 1618.31 635.1H1618.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1551.98 721.92L1658.71 737.43C1659.84 737.58 1660.87 736.79 1661.02 735.66C1661.17 734.55 1660.4 733.53 1659.3 733.36L1552.57 717.85C1551.44 717.7 1550.41 718.49 1550.26 719.62C1550.11 720.73 1550.88 721.75 1551.98 721.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1618 637.15L1657.09 736.15C1657.52 737.2 1658.72 737.71 1659.77 737.29C1660.81 736.87 1661.32 735.69 1660.92 734.64L1621.83 635.64C1621.41 634.58 1620.21 634.07 1619.16 634.49C1618.11 634.91 1617.59 636.1 1618.01 637.15H1618Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1550.22 719.78L1542.83 869.32C1542.77 870.46 1543.65 871.42 1544.78 871.48C1545.92 871.54 1546.88 870.66 1546.94 869.53L1554.33 719.99C1554.39 718.85 1553.51 717.89 1552.38 717.83C1551.24 717.77 1550.28 718.65 1550.22 719.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1657.44 734.06L1543.32 868.08C1542.58 868.95 1542.69 870.24 1543.55 870.98C1544.41 871.72 1545.71 871.61 1546.45 870.75L1660.57 736.73C1661.31 735.86 1661.2 734.57 1660.34 733.83C1659.47 733.09 1658.18 733.2 1657.44 734.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1552.42 717.83L1441.05 710.06C1439.92 710 1438.94 710.86 1438.88 712C1438.82 713.11 1439.65 714.07 1440.76 714.17L1552.13 721.94C1553.26 722 1554.24 721.14 1554.3 720C1554.36 718.89 1553.53 717.93 1552.42 717.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M292.72 671.75L385.63 615.34C386.59 614.73 386.87 613.46 386.26 612.5C385.67 611.57 384.45 611.27 383.49 611.82L290.58 668.23C289.62 668.84 289.34 670.11 289.95 671.07C290.54 672 291.76 672.3 292.71 671.75H292.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1175.92 651.7L1275.17 574.02C1276.06 573.32 1276.22 572.03 1275.52 571.13C1274.82 570.24 1273.53 570.08 1272.63 570.78L1173.38 648.46C1172.5 649.18 1172.37 650.47 1173.09 651.35C1173.79 652.21 1175.04 652.36 1175.92 651.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1157.65 772.7L1176.69 650.39C1176.85 649.27 1176.07 648.22 1174.95 648.06C1173.84 647.9 1172.81 648.65 1172.63 649.76L1153.59 772.07C1153.41 773.19 1154.18 774.25 1155.31 774.42C1156.43 774.6 1157.49 773.83 1157.66 772.7H1157.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M152.94 334.25L241.57 389.97C242.53 390.58 243.8 390.29 244.41 389.32C245.02 388.36 244.73 387.09 243.76 386.48L155.13 330.76C154.17 330.16 152.9 330.44 152.29 331.41C151.68 332.37 151.97 333.64 152.94 334.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M314.47 786.57L215.26 844.41C214.28 844.99 213.96 846.25 214.54 847.23C215.11 848.2 216.36 848.53 217.34 847.97L316.55 790.13C317.53 789.56 317.86 788.3 317.29 787.31C316.72 786.33 315.45 786 314.47 786.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M487.03 690.78L385.83 611.95C384.92 611.27 383.63 611.47 382.95 612.38C382.3 613.26 382.45 614.5 383.3 615.19L484.5 694.02C485.4 694.72 486.69 694.56 487.39 693.66C488.09 692.76 487.93 691.47 487.03 690.77V690.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M870.2 488.78L848.06 664.09C847.92 665.22 848.72 666.25 849.84 666.39C850.97 666.53 852 665.73 852.14 664.61L874.28 489.3C874.4 488.17 873.58 487.16 872.45 487.04C871.35 486.92 870.35 487.7 870.2 488.79V488.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1554.3 719.52L1533.79 606.04C1533.57 604.92 1532.49 604.2 1531.38 604.42C1530.29 604.63 1529.56 605.68 1529.75 606.77L1550.26 720.25C1550.48 721.36 1551.56 722.09 1552.68 721.87C1553.77 721.65 1554.49 720.62 1554.31 719.52H1554.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1620.58 634.45L1532.43 604.45C1531.35 604.11 1530.19 604.71 1529.85 605.79C1529.52 606.84 1530.07 607.97 1531.11 608.34L1619.26 638.34C1620.34 638.68 1621.5 638.08 1621.84 637C1622.17 635.95 1621.62 634.82 1620.58 634.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M602.54 333.05L753.13 285.92C754.21 285.58 754.82 284.43 754.48 283.34C754.14 282.26 752.99 281.65 751.9 281.99L601.32 329.12C600.24 329.46 599.63 330.61 599.97 331.7C600.31 332.78 601.46 333.39 602.55 333.05H602.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1442.47 713.45L1533.32 607.73C1534.05 606.86 1533.93 605.56 1533.06 604.83C1532.2 604.12 1530.94 604.21 1530.2 605.05L1439.35 710.76C1438.61 711.62 1438.71 712.92 1439.57 713.66C1440.43 714.4 1441.73 714.3 1442.47 713.44V713.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1360.14 510.74L1435.21 569.85C1436.1 570.55 1437.4 570.4 1438.1 569.51C1438.8 568.62 1438.65 567.32 1437.76 566.62L1362.69 507.51C1361.8 506.81 1360.5 506.96 1359.8 507.85C1359.1 508.74 1359.25 510.04 1360.14 510.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1488.47 647.51L1550.71 721.21C1551.44 722.08 1552.74 722.19 1553.61 721.45C1554.48 720.72 1554.59 719.42 1553.85 718.55L1491.61 644.85C1490.86 643.99 1489.56 643.91 1488.71 644.65C1487.87 645.38 1487.77 646.64 1488.47 647.5V647.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1490.19 648.23L1620.07 638.45C1621.2 638.34 1622.03 637.34 1621.92 636.21C1621.82 635.11 1620.86 634.29 1619.76 634.35L1489.88 644.13C1488.75 644.24 1487.92 645.24 1488.03 646.37C1488.13 647.47 1489.09 648.29 1490.19 648.23Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1006.27 527.19L872.84 487.06C871.75 486.75 870.61 487.39 870.3 488.48C870 489.55 870.6 490.66 871.66 491L1005.09 531.13C1006.18 531.44 1007.32 530.8 1007.63 529.71C1007.93 528.64 1007.33 527.53 1006.28 527.19H1006.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1003.7 529.73L1051.66 697.69C1051.98 698.78 1053.13 699.4 1054.22 699.07C1055.29 698.75 1055.91 697.63 1055.62 696.56L1007.66 528.6C1007.34 527.51 1006.19 526.89 1005.1 527.22C1004.03 527.54 1003.41 528.66 1003.7 529.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1488.39 644.95L1439.26 710.88C1438.58 711.79 1438.77 713.08 1439.68 713.76C1440.59 714.44 1441.88 714.25 1442.56 713.34L1491.69 647.41C1492.37 646.5 1492.18 645.21 1491.27 644.53C1490.36 643.85 1489.07 644.04 1488.39 644.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M317.2 789.51L412.75 649.94C413.38 649 413.13 647.72 412.18 647.09C411.25 646.47 409.99 646.7 409.35 647.62L313.8 787.19C313.17 788.14 313.43 789.41 314.37 790.04C315.3 790.66 316.55 790.42 317.19 789.51H317.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M859.02 835.56L852.16 664.27C852.11 663.13 851.16 662.25 850.02 662.3C848.88 662.35 848 663.3 848.05 664.44L854.91 835.73C854.98 836.86 855.95 837.73 857.08 837.66C858.18 837.59 859.04 836.67 859.02 835.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1182.87 518.39L1272.82 574.15C1273.8 574.73 1275.06 574.41 1275.64 573.44C1276.21 572.49 1275.92 571.26 1274.99 570.66L1185.04 514.9C1184.07 514.3 1182.81 514.6 1182.21 515.56C1181.61 516.53 1181.91 517.79 1182.87 518.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1360.2 507.45L1272.7 570.72C1271.79 571.4 1271.61 572.69 1272.29 573.6C1272.95 574.49 1274.2 574.69 1275.11 574.05L1362.61 510.78C1363.52 510.09 1363.69 508.8 1363.01 507.9C1362.34 507.02 1361.11 506.83 1360.2 507.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M243.62 386.4L127 325.24C125.99 324.72 124.75 325.13 124.23 326.14C123.72 327.14 124.1 328.36 125.09 328.89L241.71 390.05C242.72 390.57 243.96 390.16 244.48 389.15C244.99 388.16 244.61 386.94 243.62 386.41V386.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1173.91 648.16L1052.89 695.2C1051.83 695.61 1051.31 696.8 1051.72 697.86C1052.13 698.92 1053.32 699.44 1054.38 699.03L1175.4 651.99C1176.45 651.56 1176.96 650.36 1176.53 649.31C1176.11 648.28 1174.95 647.78 1173.92 648.16H1173.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M380.78 435.86L382.5 613.6C382.51 614.74 383.44 615.65 384.58 615.64C385.72 615.63 386.63 614.7 386.62 613.56L384.9 435.82C384.89 434.68 383.96 433.77 382.82 433.78C381.68 433.79 380.77 434.72 380.78 435.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M485.04 635.03L483.7 692.36C483.67 693.5 484.57 694.44 485.71 694.46C486.85 694.49 487.79 693.59 487.81 692.45L489.14 635.12C489.14 633.98 488.22 633.06 487.09 633.06C485.99 633.06 485.08 633.92 485.03 635.03H485.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M487.52 633.06L384.98 611.56C383.86 611.35 382.79 612.09 382.58 613.21C382.38 614.29 383.06 615.34 384.14 615.59L486.67 637.09C487.79 637.3 488.86 636.57 489.08 635.46C489.29 634.37 488.6 633.31 487.52 633.07V633.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M933.06 463.09L871.5 487.12C870.45 487.55 869.94 488.75 870.37 489.8C870.79 490.83 871.95 491.34 873 490.95L934.56 466.92C935.61 466.49 936.12 465.29 935.69 464.24C935.27 463.21 934.1 462.69 933.06 463.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1491.46 647.67L1533.18 607.89C1533.99 607.09 1533.99 605.79 1533.18 604.98C1532.4 604.2 1531.15 604.17 1530.33 604.91L1488.61 644.69C1487.79 645.47 1487.76 646.78 1488.54 647.6C1489.32 648.42 1490.63 648.45 1491.45 647.67H1491.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1186.44 598.81L1274.45 574.38C1275.54 574.06 1276.17 572.92 1275.85 571.83C1275.54 570.76 1274.43 570.13 1273.34 570.41L1185.33 594.84C1184.23 595.14 1183.59 596.28 1183.9 597.37C1184.2 598.47 1185.34 599.11 1186.43 598.8L1186.44 598.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M485.89 690.35L312.38 679.36C311.25 679.29 310.27 680.16 310.21 681.29C310.14 682.42 311 683.39 312.12 683.46L485.63 694.45C486.76 694.52 487.74 693.65 487.8 692.51C487.87 691.38 487.01 690.42 485.89 690.34V690.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1703.58 808.77L1660.79 734.37C1660.22 733.38 1658.97 733.05 1657.98 733.61C1656.99 734.18 1656.66 735.43 1657.22 736.42L1700.01 810.82C1700.63 811.77 1701.91 812.04 1702.86 811.41C1703.73 810.84 1704.04 809.7 1703.57 808.76L1703.58 808.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M198.47 574.11L244.67 388.72C244.94 387.62 244.27 386.5 243.17 386.23C242.07 385.96 240.95 386.63 240.68 387.73L194.48 573.12C194.21 574.22 194.88 575.34 195.98 575.61C197.08 575.88 198.2 575.21 198.47 574.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M282.23 265.52L125.32 325.14C124.26 325.54 123.72 326.73 124.13 327.79C124.53 328.85 125.72 329.39 126.78 328.98L283.69 269.36C284.74 268.93 285.24 267.73 284.81 266.68C284.39 265.67 283.26 265.16 282.23 265.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M485.39 690.38L472.45 692.76C471.33 692.97 470.59 694.04 470.8 695.16C471.01 696.28 472.08 697.02 473.2 696.81L486.14 694.43C487.25 694.19 487.96 693.09 487.72 691.98C487.49 690.92 486.47 690.22 485.4 690.38H485.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M383.15 612.08L310.84 679.92C310.03 680.72 310.03 682.02 310.83 682.83C311.6 683.61 312.84 683.65 313.66 682.92L385.97 615.08C386.8 614.3 386.84 613 386.06 612.17C385.28 611.34 383.98 611.3 383.15 612.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M386.79 457.18L382.5 613.52C382.47 614.66 383.36 615.6 384.5 615.63C385.64 615.66 386.58 614.77 386.61 613.63L390.9 457.29C390.91 456.15 390 455.22 388.86 455.21C387.75 455.2 386.83 456.07 386.78 457.18H386.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M960.46 652.85L849.92 662.3C848.79 662.43 847.98 663.44 848.1 664.57C848.22 665.66 849.17 666.46 850.27 666.39L960.8 656.94C961.93 656.81 962.74 655.79 962.61 654.66C962.49 653.58 961.54 652.78 960.45 652.84L960.46 652.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M474.21 693.27L385.95 612.06C385.09 611.31 383.79 611.4 383.05 612.26C382.33 613.08 382.38 614.33 383.17 615.09L471.43 696.3C472.27 697.07 473.57 697.01 474.34 696.18C475.11 695.34 475.05 694.04 474.22 693.27H474.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1193.58 301.24L1246.74 390.91C1247.35 391.87 1248.62 392.16 1249.58 391.55C1250.5 390.97 1250.81 389.77 1250.28 388.81L1197.12 299.14C1196.54 298.16 1195.28 297.84 1194.3 298.42C1193.32 299 1193 300.26 1193.58 301.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M932.44 466.54L1004.31 530.7C1005.16 531.46 1006.46 531.38 1007.22 530.54C1007.98 529.7 1007.9 528.39 1007.06 527.63L935.19 463.47C934.34 462.71 933.04 462.79 932.28 463.63C931.52 464.48 931.6 465.78 932.44 466.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1557.38 462.12L1553.64 363.74C1553.6 362.6 1552.64 361.72 1551.51 361.76C1550.37 361.8 1549.49 362.76 1549.53 363.89L1553.27 462.27C1553.34 463.4 1554.32 464.27 1555.45 464.2C1556.55 464.13 1557.4 463.22 1557.38 462.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1189.53 758.74L1054.51 695.26C1053.48 694.78 1052.26 695.22 1051.77 696.25C1051.29 697.28 1051.73 698.5 1052.76 698.99L1187.78 762.47C1188.81 762.95 1190.03 762.51 1190.52 761.48C1191.01 760.45 1190.56 759.23 1189.53 758.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M1127.05 767.41L1055.08 695.66C1054.26 694.87 1052.96 694.9 1052.17 695.72C1051.4 696.52 1051.4 697.78 1052.17 698.58L1124.13 770.33C1124.93 771.13 1126.24 771.13 1127.04 770.33C1127.84 769.52 1127.84 768.22 1127.04 767.42L1127.05 767.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M959.79 656.77L1052.78 698.99C1053.82 699.45 1055.03 698.99 1055.5 697.95C1055.96 696.92 1055.5 695.71 1054.48 695.24L961.49 653.02C960.45 652.55 959.23 653.01 958.77 654.04C958.3 655.08 958.76 656.3 959.79 656.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1595.6 528.7L1617.9 636.81C1618.13 637.92 1619.22 638.64 1620.33 638.41C1621.44 638.18 1622.16 637.09 1621.93 635.98L1599.63 527.87C1599.4 526.76 1598.31 526.04 1597.2 526.27C1596.09 526.5 1595.37 527.59 1595.6 528.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M516.27 740.22L487.53 691.37C486.95 690.39 485.69 690.06 484.71 690.64C483.73 691.22 483.4 692.48 483.98 693.46L512.72 742.31C513.3 743.29 514.56 743.62 515.54 743.04C516.52 742.46 516.85 741.2 516.27 740.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M386.59 613.92L408.26 483.84C408.42 482.71 407.63 481.68 406.5 481.52C405.42 481.37 404.41 482.09 404.2 483.16L382.52 613.24C382.33 614.36 383.09 615.42 384.21 615.61C385.33 615.8 386.39 615.04 386.58 613.92H386.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1003.74 528.47L958.7 654.21C958.32 655.28 958.88 656.46 959.96 656.83C961.03 657.21 962.19 656.65 962.58 655.59L1007.62 529.86C1008 528.79 1007.45 527.61 1006.38 527.23C1005.31 526.85 1004.13 527.4 1003.75 528.47H1003.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1190.69 760.34L1176.69 649.82C1176.54 648.69 1175.5 647.9 1174.38 648.05C1173.27 648.2 1172.48 649.22 1172.61 650.33L1186.61 760.85C1186.77 761.98 1187.8 762.76 1188.93 762.61C1190.04 762.46 1190.82 761.45 1190.69 760.33V760.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M835.44 533.73L873.79 490.4C874.54 489.55 874.46 488.25 873.61 487.49C872.76 486.73 871.46 486.82 870.7 487.67L832.36 531C831.63 531.87 831.75 533.17 832.62 533.9C833.46 534.6 834.69 534.52 835.44 533.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1127.5 769.65L1176.56 650.86C1176.98 649.8 1176.46 648.61 1175.4 648.19C1174.37 647.78 1173.2 648.27 1172.76 649.29L1123.7 768.08C1123.29 769.14 1123.83 770.33 1124.89 770.74C1125.91 771.13 1127.06 770.65 1127.5 769.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M831.85 532.61L848.06 664.59C848.21 665.72 849.24 666.51 850.37 666.36C851.48 666.21 852.27 665.2 852.15 664.09L835.94 532.11C835.79 530.98 834.75 530.2 833.62 530.35C832.52 530.5 831.73 531.5 831.85 532.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1005.82 531.21L1184.1 518.69C1185.23 518.61 1186.09 517.63 1186.01 516.49C1185.93 515.36 1184.95 514.5 1183.81 514.58L1005.53 527.11C1004.4 527.2 1003.55 528.19 1003.64 529.33C1003.73 530.45 1004.7 531.29 1005.81 531.22L1005.82 531.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M790.16 451.28L871.34 490.88C872.36 491.38 873.59 490.95 874.09 489.93C874.59 488.91 874.16 487.68 873.14 487.18L791.96 447.58C790.94 447.08 789.71 447.51 789.21 448.53C788.71 449.55 789.14 450.78 790.16 451.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M198.21 574.71L267.81 463.44C268.4 462.47 268.08 461.2 267.11 460.62C266.16 460.05 264.93 460.33 264.32 461.26L194.72 572.53C194.13 573.5 194.45 574.77 195.42 575.35C196.37 575.92 197.6 575.64 198.21 574.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1453.4 693.03L1551.69 721.86C1552.78 722.17 1553.92 721.53 1554.23 720.44C1554.53 719.36 1553.92 718.24 1552.85 717.91L1454.56 689.08C1453.47 688.77 1452.33 689.41 1452.02 690.5C1451.72 691.58 1452.33 692.7 1453.4 693.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M950.61 649.9L849.86 662.3C848.73 662.44 847.93 663.47 848.07 664.59C848.21 665.72 849.24 666.52 850.36 666.38L951.11 653.98C952.24 653.84 953.04 652.81 952.9 651.69C952.76 650.56 951.73 649.76 950.61 649.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.86 436.4L386.87 457.79C387.18 458.88 388.31 459.52 389.41 459.22C390.5 458.91 391.14 457.78 390.84 456.68L384.83 435.29C384.52 434.2 383.39 433.56 382.29 433.86C381.19 434.16 380.56 435.3 380.86 436.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1539.81 757.98L1554.2 720.62C1554.59 719.55 1554.04 718.37 1552.98 717.98C1551.94 717.6 1550.78 718.11 1550.36 719.14L1535.97 756.5C1535.56 757.56 1536.09 758.75 1537.15 759.16C1538.21 759.57 1539.4 759.04 1539.81 757.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1596.04 526.96L1530.19 605.07C1529.47 605.95 1529.6 607.24 1530.47 607.97C1531.33 608.68 1532.6 608.57 1533.33 607.73L1599.18 529.62C1599.9 528.74 1599.77 527.45 1598.9 526.72C1598.04 526.01 1596.77 526.12 1596.04 526.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M486.57 633.09L311.72 679.43C310.62 679.72 309.97 680.85 310.26 681.95C310.55 683.05 311.68 683.7 312.78 683.41L487.63 637.07C488.73 636.77 489.37 635.63 489.07 634.54C488.77 633.46 487.66 632.82 486.58 633.09H486.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M114.75 288.12L124.05 327.53C124.34 328.63 125.46 329.29 126.56 329C127.62 328.72 128.28 327.66 128.05 326.59L118.75 287.18C118.46 286.08 117.34 285.42 116.24 285.71C115.18 285.99 114.52 287.05 114.75 288.12Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1535.84 757.37L1542.84 869.54C1542.92 870.67 1543.91 871.52 1545.04 871.44C1546.16 871.36 1547 870.4 1546.94 869.28L1539.94 757.11C1539.86 755.98 1538.87 755.13 1537.74 755.21C1536.62 755.29 1535.78 756.25 1535.84 757.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M950.03 653.83L1052.81 699C1053.85 699.46 1055.06 698.98 1055.52 697.94C1055.98 696.9 1055.5 695.69 1054.46 695.23L951.68 650.06C950.64 649.6 949.43 650.08 948.97 651.12C948.51 652.16 948.99 653.37 950.03 653.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M754.56 284.1L761.68 185.07C761.76 183.94 760.91 182.95 759.78 182.87C758.65 182.79 757.66 183.64 757.58 184.77L750.46 283.8C750.38 284.93 751.23 285.92 752.37 286C753.5 286.08 754.49 285.23 754.57 284.09L754.56 284.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1452.24 689.97L1439.17 711.03C1438.58 712 1438.89 713.27 1439.86 713.86C1440.82 714.44 1442.06 714.15 1442.66 713.2L1455.73 692.14C1456.32 691.17 1456.01 689.9 1455.04 689.31C1454.08 688.73 1452.84 689.02 1452.24 689.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M718.2 614.21L849.35 666.26C850.41 666.66 851.6 666.13 852 665.06C852.39 664.02 851.89 662.86 850.86 662.43L719.71 610.38C718.65 609.98 717.46 610.51 717.06 611.57C716.67 612.61 717.17 613.77 718.2 614.2V614.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1181.9 516.49L1172.6 649.93C1172.52 651.06 1173.38 652.05 1174.51 652.13C1175.64 652.21 1176.63 651.35 1176.71 650.22L1186.01 516.78C1186.08 515.65 1185.21 514.67 1184.08 514.6C1182.96 514.53 1182 515.37 1181.91 516.49H1181.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M485.09 634.6L470.82 694.31C470.57 695.42 471.27 696.52 472.38 696.77C473.47 697.01 474.55 696.35 474.83 695.27L489.1 635.56C489.35 634.45 488.65 633.35 487.54 633.1C486.45 632.86 485.37 633.52 485.09 634.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M244.62 388.88L284.92 268.1C285.28 267.02 284.7 265.85 283.62 265.49C282.54 265.13 281.37 265.71 281.01 266.79L240.71 387.57C240.37 388.65 240.96 389.81 242.05 390.15C243.11 390.49 244.25 389.92 244.62 388.87V388.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1005.64 527.11L833.86 530.31C832.72 530.36 831.84 531.32 831.89 532.46C831.94 533.55 832.84 534.42 833.93 534.43L1005.71 531.23C1006.85 531.18 1007.73 530.22 1007.68 529.08C1007.63 527.99 1006.73 527.12 1005.64 527.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M931.77 465.29L958.6 655.18C958.78 656.3 959.83 657.07 960.96 656.89C962.05 656.72 962.81 655.71 962.68 654.61L935.85 464.72C935.67 463.6 934.62 462.83 933.5 463.01C932.4 463.18 931.64 464.2 931.78 465.3L931.77 465.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M447.26 675.93L484.86 694.25C485.88 694.75 487.11 694.32 487.61 693.3C488.11 692.28 487.68 691.05 486.66 690.55L449.06 672.23C448.04 671.73 446.81 672.16 446.31 673.18C445.81 674.2 446.24 675.43 447.26 675.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M851.21 743.76L852.16 664.37C852.14 663.23 851.2 662.33 850.07 662.35C848.98 662.37 848.09 663.23 848.05 664.32L847.09 743.71C847.08 744.85 847.99 745.78 849.12 745.79C850.26 745.8 851.19 744.89 851.2 743.76H851.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1491.56 647.57L1599.13 529.68C1599.88 528.83 1599.8 527.53 1598.94 526.78C1598.11 526.05 1596.85 526.11 1596.09 526.91L1488.51 644.8C1487.74 645.64 1487.8 646.94 1488.64 647.71C1489.48 648.48 1490.78 648.42 1491.55 647.58L1491.56 647.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M235.78 428.06L382.7 437.89C383.83 437.97 384.82 437.11 384.89 435.97C384.96 434.83 384.11 433.85 382.97 433.78L236.05 423.95C234.91 423.9 233.95 424.78 233.9 425.91C233.85 427.01 234.68 427.95 235.77 428.05L235.78 428.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M280.58 577.19L383.84 615.51C384.91 615.91 386.09 615.36 386.48 614.3C386.88 613.23 386.33 612.05 385.27 611.66L282.01 573.34C280.94 572.94 279.76 573.49 279.37 574.55C278.97 575.62 279.52 576.8 280.58 577.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M952.74 652.78L1007.55 530C1007.99 528.95 1007.5 527.75 1006.46 527.3C1005.44 526.87 1004.27 527.32 1003.8 528.32L948.99 651.1C948.55 652.15 949.03 653.35 950.08 653.8C951.1 654.23 952.28 653.78 952.75 652.78H952.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.99 436.75L404.38 484.4C404.88 485.42 406.11 485.84 407.13 485.34C408.15 484.84 408.57 483.61 408.07 482.59L384.68 434.94C384.18 433.92 382.95 433.5 381.93 434C380.91 434.5 380.49 435.73 380.99 436.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M485.1 635.59L512.5 741.77C512.78 742.87 513.91 743.53 515.01 743.25C516.11 742.97 516.77 741.84 516.49 740.74L489.09 634.56C488.81 633.46 487.68 632.8 486.58 633.08C485.48 633.36 484.82 634.49 485.1 635.59Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M600.06 330.22L560.44 415.59C559.97 416.63 560.44 417.84 561.47 418.31C562.49 418.77 563.69 418.33 564.17 417.32L603.79 331.95C604.26 330.91 603.79 329.7 602.76 329.23C601.74 328.77 600.54 329.21 600.06 330.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M488.91 634.11L408.05 482.53C407.49 481.54 406.23 481.2 405.24 481.76C404.29 482.3 403.93 483.49 404.42 484.47L485.28 636.05C485.81 637.05 487.06 637.43 488.06 636.9C489.06 636.37 489.44 635.12 488.91 634.12V634.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1553.29 461.86L1529.73 606.06C1529.55 607.18 1530.31 608.24 1531.43 608.42C1532.55 608.6 1533.61 607.84 1533.79 606.72L1557.35 462.52C1557.53 461.4 1556.77 460.34 1555.65 460.16C1554.53 459.98 1553.47 460.74 1553.29 461.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M472.99 692.74L312.41 679.36C311.28 679.27 310.28 680.11 310.19 681.24C310.1 682.37 310.94 683.37 312.07 683.46L472.64 696.83C473.77 696.91 474.76 696.06 474.84 694.93C474.92 693.81 474.09 692.84 472.98 692.73L472.99 692.74Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M240.71 388.84L264.12 462.96C264.48 464.04 265.64 464.62 266.72 464.26C267.77 463.91 268.36 462.78 268.04 461.72L244.63 387.59C244.29 386.51 243.13 385.91 242.05 386.25C240.97 386.59 240.37 387.75 240.71 388.83V388.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1176.67 650.5L1187.91 597.25C1188.14 596.14 1187.43 595.05 1186.32 594.81C1185.21 594.58 1184.12 595.29 1183.88 596.4L1172.64 649.65C1172.41 650.76 1173.12 651.85 1174.23 652.09C1175.34 652.32 1176.43 651.61 1176.67 650.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1455.5 692.44L1533.28 607.79C1534.05 606.95 1533.99 605.65 1533.16 604.88C1532.32 604.11 1531.02 604.17 1530.25 605L1452.47 689.65C1451.7 690.49 1451.76 691.79 1452.59 692.56C1453.43 693.33 1454.73 693.27 1455.5 692.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M235.51 428.03L388.44 459.26C389.55 459.49 390.64 458.77 390.87 457.66C391.1 456.55 390.38 455.46 389.27 455.23L236.34 424.01C235.22 423.81 234.15 424.55 233.95 425.67C233.76 426.75 234.45 427.79 235.52 428.04L235.51 428.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M932.66 463.3L832.75 530.66C831.81 531.3 831.56 532.57 832.19 533.52C832.83 534.46 834.1 534.71 835.05 534.08L934.96 466.72C935.89 466.07 936.12 464.79 935.47 463.85C934.83 462.94 933.59 462.7 932.66 463.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M847.1 743.91L854.91 835.82C855.01 836.95 856 837.79 857.13 837.7C858.26 837.6 859.1 836.61 859.01 835.48L851.2 743.57C851.1 742.44 850.11 741.6 848.98 741.69C847.85 741.79 847.01 742.78 847.1 743.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M516.03 739.88L474.35 693.41C473.58 692.57 472.28 692.52 471.44 693.29C470.62 694.05 470.55 695.32 471.28 696.16L512.96 742.63C513.72 743.48 515.02 743.55 515.87 742.79C516.72 742.03 516.79 740.73 516.03 739.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M387.13 458.37L404.52 484.63C405.15 485.58 406.42 485.84 407.37 485.21C408.32 484.58 408.58 483.31 407.95 482.36L390.56 456.1C389.93 455.15 388.66 454.89 387.71 455.52C386.76 456.15 386.5 457.42 387.13 458.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M126.48 349.25L128.1 327.21C128.15 326.07 127.28 325.11 126.14 325.06C125.05 325.01 124.1 325.82 123.99 326.91L122.37 348.94C122.31 350.08 123.19 351.04 124.33 351.09C125.42 351.14 126.37 350.33 126.48 349.24V349.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1488.44 644.89L1452.38 689.76C1451.67 690.65 1451.81 691.94 1452.69 692.65C1453.58 693.36 1454.87 693.22 1455.58 692.34L1491.64 647.47C1492.33 646.57 1492.16 645.28 1491.26 644.59C1490.39 643.92 1489.14 644.06 1488.43 644.9L1488.44 644.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M603.96 331.4L619.9 229.95C620.08 228.83 619.31 227.77 618.19 227.6C617.07 227.42 616.01 228.19 615.84 229.31L599.9 330.76C599.75 331.89 600.55 332.92 601.67 333.07C602.76 333.21 603.76 332.48 603.96 331.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M934.03 462.96L791.28 447.39C790.15 447.28 789.14 448.11 789.04 449.24C788.93 450.35 789.73 451.34 790.84 451.48L933.59 467.05C934.72 467.16 935.73 466.33 935.83 465.2C935.94 464.09 935.14 463.1 934.03 462.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M1488.15 646.99L1536 758.05C1536.45 759.09 1537.66 759.58 1538.7 759.13C1539.74 758.68 1540.23 757.47 1539.78 756.43L1491.93 645.37C1491.46 644.34 1490.24 643.88 1489.2 644.35C1488.2 644.81 1487.73 645.97 1488.15 647V646.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M280.91 267.26L264.02 462.17C263.92 463.3 264.76 464.3 265.89 464.4C267.02 464.5 268.02 463.66 268.12 462.53L285 267.62C285.04 266.48 284.16 265.53 283.02 265.49C281.96 265.45 281.05 266.22 280.9 267.27L280.91 267.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M282.96 576.47L384.51 437.06C385.17 436.13 384.95 434.85 384.02 434.19C383.11 433.55 381.86 433.74 381.19 434.63L279.64 574.04C278.97 574.96 279.17 576.25 280.09 576.92C281.01 577.59 282.3 577.39 282.97 576.47H282.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M243.95 386.62L118.03 286.04C117.14 285.33 115.85 285.48 115.14 286.36C114.43 287.24 114.58 288.54 115.46 289.25L241.38 389.83C242.27 390.54 243.56 390.39 244.27 389.51C244.98 388.62 244.83 387.33 243.95 386.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M484.6 690.7L463.8 704.83C462.87 705.48 462.65 706.77 463.3 707.7C463.94 708.61 465.18 708.85 466.11 708.24L486.91 694.11C487.84 693.46 488.07 692.17 487.41 691.24C486.77 690.33 485.52 690.09 484.59 690.7H484.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M235.26 427.96L405.57 485.44C406.65 485.8 407.81 485.23 408.18 484.15C408.54 483.07 407.97 481.91 406.89 481.54L236.58 424.06C235.5 423.7 234.34 424.27 233.97 425.35C233.6 426.43 234.18 427.59 235.26 427.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M617.1 231.55L751.74 285.87C752.79 286.3 753.99 285.79 754.42 284.73C754.85 283.68 754.34 282.48 753.28 282.05L618.63 227.73C617.58 227.31 616.38 227.81 615.95 228.87C615.53 229.92 616.04 231.12 617.09 231.55H617.1Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1361.32 507.06L1183.87 514.58C1182.74 514.64 1181.87 515.62 1181.93 516.75C1181.99 517.86 1182.93 518.72 1184.04 518.69L1361.49 511.17C1362.62 511.11 1363.49 510.13 1363.43 509C1363.37 507.89 1362.43 507.03 1361.32 507.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M485.64 633.62L446.71 672.62C445.92 673.44 445.94 674.74 446.76 675.53C447.56 676.3 448.82 676.3 449.62 675.53L488.55 636.52C489.34 635.7 489.32 634.4 488.5 633.61C487.7 632.84 486.44 632.84 485.64 633.61V633.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M513.03 742.7L594.45 825.15C595.26 825.95 596.56 825.93 597.36 825.12C598.14 824.33 598.15 823.06 597.38 822.26L515.96 739.8C515.16 738.99 513.86 738.98 513.05 739.78C512.24 740.58 512.23 741.88 513.03 742.69V742.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1190.71 760.56L1187.95 596.79C1187.93 595.65 1186.99 594.75 1185.86 594.77C1184.73 594.79 1183.82 595.73 1183.84 596.86L1186.6 760.63C1186.62 761.77 1187.56 762.67 1188.69 762.65C1189.83 762.63 1190.73 761.69 1190.71 760.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1127.54 769.55L1187.83 597.51C1188.19 596.43 1187.61 595.27 1186.53 594.91C1185.47 594.56 1184.33 595.11 1183.95 596.15L1123.65 768.19C1123.27 769.26 1123.84 770.44 1124.91 770.81C1125.98 771.19 1127.16 770.62 1127.53 769.55H1127.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M950.26 653.92L960.04 656.87C961.14 657.17 962.27 656.53 962.57 655.43C962.86 654.37 962.27 653.27 961.23 652.93L951.45 649.98C950.36 649.65 949.21 650.27 948.89 651.36C948.56 652.45 949.18 653.6 950.27 653.92H950.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M404.03 342.03L380.84 435.35C380.58 436.46 381.26 437.57 382.36 437.83C383.45 438.09 384.55 437.43 384.83 436.34L408.02 343.02C408.29 341.92 407.61 340.8 406.5 340.54C405.41 340.28 404.3 340.94 404.02 342.03H404.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1185.79 517.57L1250.35 390.79C1250.84 389.77 1250.41 388.54 1249.39 388.04C1248.4 387.56 1247.2 387.95 1246.68 388.92L1182.12 515.7C1181.61 516.71 1182.02 517.95 1183.03 518.46C1184.04 518.97 1185.27 518.57 1185.79 517.56V517.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M470.78 694.52L451.25 841.37C451.1 842.5 451.89 843.53 453.02 843.68C454.15 843.83 455.18 843.04 455.33 841.91L474.86 695.06C475.01 693.93 474.22 692.9 473.09 692.75C471.96 692.6 470.93 693.39 470.78 694.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M959.36 653.29L847.87 742.13C846.98 742.84 846.84 744.13 847.54 745.02C848.25 745.91 849.54 746.05 850.43 745.35L961.92 656.51C962.79 655.79 962.92 654.49 962.19 653.61C961.48 652.76 960.23 652.62 959.35 653.29H959.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1362.91 507.71L1250.01 388.45C1249.22 387.64 1247.91 387.62 1247.1 388.42C1246.31 389.2 1246.27 390.46 1247.02 391.28L1359.92 510.54C1360.71 511.35 1362.02 511.37 1362.83 510.58C1363.63 509.8 1363.66 508.54 1362.91 507.72V507.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1181.9 516.69L1183.84 596.88C1183.89 598.02 1184.85 598.9 1185.99 598.84C1187.09 598.79 1187.96 597.88 1187.96 596.78L1186.02 516.59C1185.99 515.45 1185.05 514.55 1183.91 514.58C1182.77 514.61 1181.87 515.55 1181.9 516.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1005.25 527.15L884.76 552.33C883.65 552.59 882.97 553.69 883.22 554.8C883.47 555.87 884.52 556.56 885.6 556.36L1006.09 531.18C1007.2 530.92 1007.88 529.81 1007.62 528.7C1007.37 527.64 1006.33 526.96 1005.25 527.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M448.05 672.03L312.13 679.36C310.99 679.42 310.12 680.39 310.19 681.53C310.26 682.67 311.22 683.54 312.36 683.47L448.28 676.14C449.41 676.07 450.27 675.09 450.2 673.95C450.13 672.83 449.18 671.98 448.06 672.03H448.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M282.82 576.64L390.37 458.62C391.14 457.78 391.08 456.48 390.24 455.71C389.4 454.94 388.1 455 387.33 455.84L279.78 573.86C279.03 574.71 279.11 576.01 279.96 576.76C280.79 577.49 282.06 577.44 282.82 576.63V576.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M117 289.69L283.22 269.48C284.34 269.32 285.13 268.27 284.96 267.15C284.8 266.06 283.82 265.29 282.72 265.4L116.5 285.61C115.37 285.77 114.59 286.81 114.75 287.93C114.9 289.03 115.9 289.81 117 289.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1702.42 807.84L1538.51 755.29C1537.43 754.94 1536.27 755.54 1535.92 756.62C1535.57 757.7 1536.17 758.86 1537.25 759.21L1701.16 811.76C1702.24 812.11 1703.4 811.51 1703.75 810.43C1704.1 809.35 1703.5 808.19 1702.42 807.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1360.49 507.28L1184.98 594.99C1183.97 595.5 1183.56 596.74 1184.08 597.76C1184.59 598.76 1185.81 599.17 1186.82 598.67L1362.33 510.96C1363.35 510.45 1363.76 509.22 1363.25 508.2C1362.74 507.18 1361.51 506.77 1360.49 507.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M446.84 675.66L471.5 696.37C472.39 697.08 473.68 696.94 474.39 696.05C475.08 695.19 474.97 693.95 474.14 693.22L449.48 672.51C448.61 671.78 447.31 671.89 446.58 672.76C445.85 673.63 445.96 674.93 446.83 675.66H446.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M671.2 238.65L751.47 285.73C752.46 286.3 753.71 285.96 754.28 284.97C754.84 284 754.52 282.76 753.55 282.18L673.28 235.1C672.3 234.53 671.04 234.87 670.47 235.86C669.91 236.83 670.23 238.08 671.2 238.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1166.69 698.23L1176.67 650.5C1176.9 649.39 1176.19 648.3 1175.08 648.06C1173.97 647.83 1172.88 648.54 1172.64 649.65L1162.66 697.39C1162.43 698.5 1163.14 699.59 1164.25 699.82C1165.36 700.05 1166.45 699.34 1166.68 698.23H1166.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M512.74 740.19L451.53 840.57C450.96 841.55 451.3 842.81 452.28 843.38C453.23 843.93 454.44 843.63 455.04 842.71L516.25 742.33C516.83 741.35 516.51 740.09 515.54 739.51C514.58 738.94 513.33 739.24 512.74 740.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M514.02 743.26L618.51 768.42C619.62 768.66 620.72 767.96 620.96 766.85C621.2 765.77 620.54 764.7 619.47 764.42L514.98 739.26C513.87 739.02 512.77 739.72 512.53 740.83C512.3 741.91 512.95 742.98 514.02 743.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1553.59 463.3L1595.88 529.4C1596.49 530.36 1597.76 530.64 1598.72 530.02C1599.68 529.41 1599.96 528.13 1599.34 527.18L1557.05 461.09C1556.41 460.15 1555.13 459.91 1554.19 460.56C1553.3 461.17 1553.03 462.38 1553.59 463.31V463.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M835.72 531.42L792.88 448.49C792.36 447.48 791.12 447.08 790.11 447.61C789.1 448.13 788.7 449.37 789.23 450.38L832.07 533.31C832.61 534.31 833.86 534.68 834.86 534.14C835.83 533.61 836.22 532.41 835.73 531.42H835.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M952.33 650.51L835.36 530.93C834.55 530.13 833.25 530.13 832.45 530.93C831.66 531.72 831.65 532.99 832.42 533.8L949.38 653.38C950.17 654.19 951.48 654.21 952.29 653.41C953.1 652.62 953.12 651.31 952.32 650.5L952.33 650.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M403.99 342.22L386.81 456.93C386.64 458.05 387.42 459.1 388.54 459.27C389.66 459.44 390.71 458.66 390.88 457.54L408.06 342.83C408.23 341.71 407.45 340.66 406.33 340.49C405.21 340.32 404.16 341.1 403.99 342.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M752.13 285.98L761.86 287.82C762.98 288.02 764.05 287.28 764.25 286.16C764.45 285.06 763.73 284 762.63 283.78L752.9 281.94C751.78 281.74 750.71 282.49 750.51 283.6C750.31 284.7 751.03 285.76 752.13 285.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.96 739.81L449.63 672.63C448.83 671.82 447.53 671.81 446.72 672.61C445.91 673.41 445.9 674.71 446.7 675.52L513.03 742.7C513.83 743.51 515.13 743.52 515.94 742.72C516.75 741.92 516.76 740.62 515.96 739.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M123.78 351.05L242.02 390.18C243.1 390.54 244.26 389.95 244.62 388.87C244.98 387.79 244.39 386.63 243.31 386.27L125.07 347.14C123.99 346.78 122.83 347.37 122.47 348.45C122.11 349.53 122.7 350.69 123.78 351.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M282.51 576.91L407.45 485.15C408.37 484.48 408.56 483.19 407.89 482.27C407.22 481.35 405.93 481.16 405.01 481.83L280.07 573.59C279.15 574.26 278.96 575.55 279.63 576.47C280.3 577.39 281.59 577.58 282.51 576.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M832.72 530.67L717.78 610.6C716.86 611.27 716.66 612.56 717.33 613.47C717.98 614.36 719.21 614.58 720.13 613.97L835.07 534.04C835.99 533.37 836.19 532.08 835.52 531.17C834.87 530.28 833.64 530.06 832.72 530.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M636.86 687.4L593.95 823.09C593.61 824.17 594.21 825.33 595.29 825.67C596.37 826.01 597.53 825.41 597.87 824.33L640.78 688.64C641.09 687.55 640.45 686.41 639.36 686.1C638.31 685.8 637.22 686.37 636.86 687.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M962.08 315.91L931.79 464.59C931.56 465.7 932.28 466.79 933.4 467.02C934.51 467.25 935.6 466.53 935.83 465.41L966.12 316.73C966.35 315.62 965.63 314.53 964.51 314.3C963.39 314.07 962.31 314.79 962.08 315.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M789.18 448.6L717.07 611.47C716.62 612.51 717.1 613.72 718.14 614.17C719.17 614.61 720.37 614.15 720.83 613.13L792.93 450.27C793.39 449.23 792.93 448.02 791.88 447.56C790.84 447.1 789.63 447.56 789.17 448.61L789.18 448.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M487.92 636.96L504.91 629.5C505.94 629.03 506.4 627.81 505.93 626.77C505.47 625.76 504.28 625.3 503.26 625.73L486.27 633.19C485.23 633.65 484.76 634.86 485.21 635.9C485.67 636.94 486.88 637.41 487.92 636.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M561.5 414.56L405.42 481.61C404.38 482.08 403.92 483.3 404.39 484.33C404.85 485.34 406.02 485.81 407.04 485.39L563.11 418.34C564.15 417.89 564.64 416.68 564.19 415.64C563.74 414.6 562.53 414.11 561.49 414.56H561.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M485.13 634.47L463 705.93C462.66 707.02 463.27 708.17 464.36 708.5C465.45 708.84 466.6 708.23 466.93 707.14L489.06 635.68C489.4 634.59 488.79 633.44 487.7 633.1C486.61 632.76 485.46 633.37 485.13 634.46V634.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M932 464.02L883.38 553.35C882.85 554.35 883.23 555.6 884.24 556.13C885.23 556.65 886.45 556.29 886.99 555.32L935.62 465.99C936.16 464.99 935.79 463.74 934.8 463.2C933.8 462.66 932.55 463.03 932.01 464.02H932Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M965.95 317.22L1020.7 203.36C1021.19 202.34 1020.76 201.11 1019.74 200.61C1018.72 200.12 1017.49 200.55 1016.99 201.57L962.25 315.42C961.77 316.45 962.23 317.67 963.26 318.15C964.27 318.61 965.46 318.2 965.96 317.2L965.95 317.22Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M403.97 342.53L404.18 483.5C404.18 484.64 405.1 485.56 406.24 485.55C407.38 485.54 408.3 484.63 408.29 483.49L408.08 342.52C408.08 341.38 407.16 340.46 406.02 340.47C404.88 340.47 403.96 341.39 403.97 342.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M949.48 650.42L847.77 742.21C846.93 742.97 846.86 744.27 847.62 745.12C848.38 745.96 849.68 746.03 850.53 745.27L952.24 653.48C953.08 652.72 953.15 651.42 952.39 650.57C951.63 649.72 950.33 649.66 949.48 650.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M717.23 611.17L617.27 765.3C616.66 766.26 616.95 767.53 617.91 768.14C618.85 768.74 620.1 768.47 620.72 767.54L720.68 613.41C721.3 612.46 721.03 611.18 720.07 610.56C719.11 609.94 717.84 610.21 717.22 611.17H717.23Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1190.57 759.86L1166.6 697.07C1166.18 696.01 1164.99 695.5 1163.93 695.92C1162.89 696.33 1162.37 697.5 1162.76 698.54L1186.73 761.33C1187.15 762.39 1188.35 762.9 1189.4 762.48C1190.43 762.07 1190.95 760.91 1190.57 759.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1162.88 696.82L1123.8 767.87C1123.27 768.87 1123.65 770.12 1124.66 770.65C1125.64 771.17 1126.86 770.82 1127.41 769.85L1166.49 698.8C1167.02 697.8 1166.64 696.55 1165.63 696.02C1164.65 695.5 1163.43 695.85 1162.88 696.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M831.93 618.98L960.06 656.87C961.15 657.19 962.29 656.57 962.62 655.48C962.94 654.39 962.32 653.25 961.23 652.92L833.1 615.04C832 614.75 830.88 615.41 830.59 616.51C830.31 617.56 830.9 618.65 831.94 618.99L831.93 618.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M850.61 742.29L720.42 610.85C719.61 610.06 718.3 610.07 717.51 610.88C716.73 611.67 716.73 612.94 717.5 613.74L847.69 745.18C848.5 745.97 849.8 745.96 850.6 745.15C851.38 744.36 851.38 743.09 850.61 742.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M640.24 689.52L720.37 613.79C721.17 612.98 721.17 611.68 720.37 610.88C719.6 610.11 718.36 610.08 717.55 610.8L637.42 686.53C636.59 687.31 636.56 688.61 637.34 689.44C638.12 690.27 639.42 690.3 640.25 689.52H640.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M395.47 443.62L384.15 434.25C383.27 433.53 381.98 433.65 381.25 434.52C380.53 435.4 380.65 436.69 381.52 437.42L392.84 446.79C393.73 447.49 395.03 447.34 395.73 446.44C396.41 445.58 396.29 444.34 395.46 443.62H395.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M883.54 555.57L959 656.13C959.69 657.04 960.98 657.21 961.88 656.53C962.78 655.85 962.96 654.57 962.29 653.67L886.83 553.11C886.15 552.2 884.86 552.02 883.95 552.7C883.04 553.38 882.86 554.67 883.54 555.58V555.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M636.83 687.52L617 765.92C616.73 767.02 617.4 768.14 618.51 768.41C619.6 768.68 620.71 768.02 620.99 766.93L640.82 688.53C641.06 687.42 640.36 686.32 639.25 686.08C638.19 685.85 637.13 686.48 636.83 687.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M502.22 626.75L470.96 693.92C470.49 694.96 470.96 696.17 471.99 696.64C473.01 697.1 474.2 696.66 474.69 695.66L505.95 628.49C506.42 627.45 505.95 626.24 504.92 625.77C503.9 625.31 502.71 625.75 502.22 626.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1452.21 692.09L1533.82 831.04C1534.41 832.01 1535.68 832.31 1536.65 831.72C1537.59 831.14 1537.91 829.92 1537.37 828.96L1455.77 690.01C1455.19 689.03 1453.93 688.7 1452.95 689.28C1451.97 689.86 1451.64 691.12 1452.22 692.1L1452.21 692.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M446.11 674.14L451.23 841.7C451.27 842.84 452.23 843.72 453.37 843.67C454.49 843.63 455.37 842.69 455.35 841.57L450.23 674.01C450.19 672.87 449.23 671.99 448.1 672.03C446.98 672.07 446.09 673.01 446.12 674.14H446.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1452.71 692.67L1536.61 758.86C1537.5 759.56 1538.8 759.41 1539.5 758.52C1540.2 757.63 1540.05 756.33 1539.16 755.63L1455.26 689.44C1454.37 688.74 1453.07 688.89 1452.37 689.78C1451.67 690.67 1451.82 691.97 1452.71 692.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M471.11 693.65L463.25 705.4C462.63 706.36 462.91 707.63 463.86 708.24C464.79 708.84 466.03 708.6 466.67 707.68L474.53 695.93C475.14 694.97 474.87 693.7 473.91 693.09C472.98 692.49 471.74 692.74 471.11 693.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1537.65 830.07L1539.95 757.31C1539.98 756.17 1539.08 755.23 1537.94 755.2C1536.81 755.17 1535.88 756.05 1535.83 757.18L1533.53 829.94C1533.49 831.08 1534.39 832.03 1535.52 832.06C1536.66 832.1 1537.61 831.2 1537.64 830.07H1537.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M789.76 447.84L651.87 560.2C651.01 560.94 650.91 562.24 651.64 563.1C652.35 563.93 653.6 564.06 654.46 563.39L792.35 451.03C793.21 450.29 793.31 448.99 792.58 448.13C791.87 447.3 790.62 447.17 789.76 447.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M123.15 350.7L264.79 463.95C265.68 464.66 266.97 464.51 267.68 463.62C268.38 462.73 268.24 461.45 267.36 460.74L125.72 347.49C124.83 346.79 123.53 346.94 122.83 347.84C122.14 348.72 122.28 350 123.15 350.71V350.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.04 627.8L512.45 741.44C512.55 742.57 513.55 743.41 514.69 743.3C515.82 743.2 516.66 742.2 516.55 741.06L506.14 627.42C506.04 626.29 505.03 625.46 503.9 625.56C502.77 625.66 501.94 626.67 502.04 627.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M362.39 362.6L380.85 436.34C381.13 437.44 382.26 438.1 383.36 437.82C384.45 437.54 385.11 436.44 384.84 435.34L366.38 361.6C366.1 360.5 364.99 359.83 363.88 360.1C362.78 360.38 362.11 361.49 362.38 362.6H362.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M651.91 563.42L717.7 613.93C718.61 614.61 719.9 614.43 720.58 613.52C721.25 612.62 721.09 611.35 720.2 610.66L654.41 560.16C653.5 559.48 652.21 559.67 651.53 560.59C650.87 561.48 651.03 562.74 651.9 563.43L651.91 563.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M515.68 739.57L466.15 704.85C465.22 704.2 463.94 704.42 463.28 705.35C462.63 706.28 462.85 707.56 463.78 708.22L513.31 742.94C514.24 743.59 515.52 743.37 516.18 742.44C516.83 741.51 516.61 740.23 515.68 739.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M932.71 463.27L870.2 502.78C869.24 503.39 868.95 504.66 869.56 505.62C870.17 506.58 871.44 506.87 872.4 506.26L934.92 466.75C935.87 466.13 936.13 464.85 935.51 463.9C934.9 462.97 933.67 462.7 932.72 463.27H932.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M152.42 238.84L282.49 269.44C283.6 269.7 284.7 269.02 284.97 267.91C285.23 266.8 284.55 265.7 283.44 265.43L153.36 234.83C152.25 234.57 151.15 235.26 150.89 236.36C150.63 237.47 151.32 238.57 152.42 238.83V238.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M847.41 763.56L962.05 656.4C962.88 655.62 962.92 654.32 962.15 653.49C961.37 652.66 960.07 652.62 959.24 653.39L844.6 760.55C843.77 761.33 843.73 762.63 844.5 763.46C845.28 764.29 846.58 764.33 847.41 763.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M618.48 231.6L760.25 186.89C761.33 186.53 761.92 185.37 761.56 184.29C761.21 183.23 760.08 182.64 759.01 182.96L617.24 227.67C616.16 228.03 615.58 229.19 615.94 230.27C616.29 231.32 617.42 231.91 618.48 231.59V231.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M514.73 504.88L406.67 481.49C405.56 481.25 404.46 481.96 404.22 483.07C403.98 484.18 404.69 485.28 405.8 485.52L513.86 508.91C514.97 509.15 516.07 508.44 516.31 507.33C516.55 506.22 515.84 505.12 514.73 504.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1109.71 430.26L1182.37 517.95C1183.1 518.82 1184.4 518.94 1185.27 518.21C1186.14 517.49 1186.26 516.2 1185.54 515.33L1112.88 427.64C1112.15 426.77 1110.85 426.66 1109.98 427.39C1109.12 428.11 1109 429.39 1109.71 430.26Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M651.12 561.56L636.78 687.79C636.65 688.92 637.46 689.94 638.59 690.07C639.72 690.2 640.74 689.39 640.87 688.26L655.21 562.03C655.32 560.9 654.5 559.89 653.37 559.78C652.26 559.67 651.27 560.46 651.12 561.57V561.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M834.56 617.05L835.95 532.4C835.94 531.26 835.01 530.35 833.87 530.36C832.78 530.37 831.88 531.24 831.84 532.33L830.45 616.98C830.43 618.12 831.34 619.05 832.47 619.07C833.61 619.09 834.54 618.18 834.56 617.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M392.28 444.38L386.97 456.41C386.51 457.45 386.98 458.66 388.02 459.12C389.06 459.58 390.27 459.11 390.73 458.07L396.04 446.04C396.48 444.99 395.98 443.79 394.93 443.35C393.91 442.93 392.74 443.38 392.28 444.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M885.99 552.45L834.7 530.47C833.66 530.02 832.45 530.51 832 531.55C831.55 532.59 832.04 533.8 833.08 534.25L884.37 556.23C885.41 556.68 886.62 556.19 887.07 555.15C887.52 554.11 887.03 552.9 885.99 552.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M951.44 649.97L833.09 615.04C832 614.72 830.86 615.34 830.53 616.43C830.2 617.52 830.83 618.66 831.92 618.99L950.27 653.92C951.36 654.23 952.5 653.59 952.8 652.49C953.1 651.42 952.49 650.3 951.43 649.97H951.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1166.69 698.24L1187.9 597.25C1188.12 596.14 1187.4 595.05 1186.28 594.83C1185.18 594.61 1184.11 595.31 1183.87 596.4L1162.65 697.39C1162.42 698.5 1163.13 699.59 1164.24 699.83C1165.35 700.06 1166.44 699.35 1166.68 698.24H1166.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M405.15 344.38L561.43 418.3C562.46 418.78 563.68 418.33 564.16 417.3C564.64 416.28 564.2 415.07 563.19 414.58L406.91 340.66C405.88 340.18 404.66 340.62 404.18 341.65C403.7 342.67 404.14 343.89 405.16 344.38H405.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M886.71 552.97L792.59 448.06C791.83 447.21 790.53 447.14 789.68 447.9C788.83 448.66 788.76 449.96 789.52 450.81L883.64 555.72C884.42 556.54 885.73 556.58 886.55 555.79C887.34 555.04 887.41 553.8 886.7 552.97H886.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M560.56 417.54L651.42 562.88C652.02 563.84 653.29 564.14 654.26 563.53C655.22 562.93 655.52 561.66 654.91 560.69L564.05 415.35C563.44 414.39 562.17 414.1 561.21 414.71C560.25 415.31 559.96 416.57 560.56 417.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M952.57 650.8L886.89 553.19C886.26 552.25 884.98 552 884.03 552.63C883.09 553.26 882.84 554.54 883.47 555.49L949.15 653.1C949.79 654.04 951.07 654.29 952.01 653.65C952.95 653.02 953.2 651.74 952.57 650.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.09 505L390.63 458.25C391.19 457.26 390.85 456.01 389.86 455.44C388.87 454.88 387.62 455.22 387.05 456.21L360.51 502.96C359.97 503.96 360.34 505.21 361.34 505.75C362.31 506.27 363.52 505.94 364.09 504.99V505Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M832.59 614.96L719.04 610.24C717.9 610.19 716.95 611.08 716.9 612.21C716.85 613.35 717.74 614.3 718.87 614.35L832.42 619.07C833.56 619.12 834.51 618.23 834.56 617.1C834.61 615.97 833.72 615.01 832.59 614.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M362.39 362.61L386.86 457.74C387.15 458.84 388.27 459.5 389.37 459.21C390.46 458.92 391.12 457.81 390.84 456.72L366.37 361.59C366.08 360.49 364.96 359.83 363.86 360.12C362.77 360.41 362.11 361.52 362.39 362.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1162.66 697.43L1130.55 867.95C1130.34 869.07 1131.08 870.14 1132.19 870.35C1133.31 870.56 1134.38 869.83 1134.59 868.71L1166.7 698.19C1166.91 697.07 1166.18 696 1165.06 695.79C1163.94 695.58 1162.87 696.31 1162.66 697.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1111.85 430.93L1249.07 391.84C1250.16 391.51 1250.77 390.35 1250.43 389.27C1250.11 388.22 1249.01 387.61 1247.94 387.89L1110.72 426.98C1109.63 427.29 1108.99 428.43 1109.3 429.52C1109.61 430.61 1110.75 431.25 1111.84 430.94L1111.85 430.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M392.2 445.83L404.27 484.12C404.61 485.2 405.77 485.81 406.85 485.46C407.93 485.12 408.54 483.96 408.19 482.88L396.12 444.59C395.76 443.51 394.6 442.93 393.52 443.29C392.46 443.64 391.88 444.77 392.2 445.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.47 348.84L118.79 287.39C118.62 286.27 117.57 285.49 116.45 285.66C115.37 285.82 114.6 286.81 114.71 287.9L122.39 349.35C122.56 350.47 123.6 351.25 124.73 351.08C125.82 350.92 126.58 349.93 126.47 348.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M884.51 552.4L718.28 610.36C717.21 610.73 716.64 611.91 717.01 612.98C717.38 614.05 718.56 614.62 719.63 614.25L885.86 556.29C886.93 555.92 887.5 554.74 887.13 553.67C886.76 552.6 885.58 552.03 884.51 552.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1545.33 891.37L1539.95 757.16C1539.9 756.02 1538.95 755.14 1537.81 755.19C1536.67 755.24 1535.79 756.19 1535.84 757.33L1541.22 891.53C1541.29 892.66 1542.26 893.53 1543.4 893.46C1544.5 893.39 1545.35 892.47 1545.33 891.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M830.47 617.28L847.11 744C847.26 745.13 848.29 745.92 849.42 745.77C850.55 745.62 851.34 744.59 851.19 743.46L834.55 616.74C834.4 615.61 833.37 614.82 832.24 614.97C831.11 615.12 830.32 616.15 830.47 617.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1109.41 429.79L1184.01 597.66C1184.47 598.7 1185.69 599.17 1186.73 598.71C1187.77 598.25 1188.24 597.03 1187.78 595.99L1113.18 428.12C1112.72 427.08 1111.5 426.61 1110.46 427.07C1109.42 427.53 1108.95 428.75 1109.41 429.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M673.29 238.64L760.69 186.7C761.67 186.12 761.99 184.86 761.41 183.88C760.83 182.9 759.57 182.58 758.59 183.16L671.19 235.1C670.22 235.69 669.91 236.96 670.51 237.93C671.09 238.88 672.33 239.2 673.3 238.64H673.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M455.34 841.81L467.01 706.71C467.11 705.58 466.27 704.58 465.14 704.48C464.01 704.38 463.01 705.22 462.91 706.35L451.24 841.45C451.14 842.58 451.98 843.58 453.11 843.68C454.24 843.78 455.24 842.94 455.34 841.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M464.22 708.45L618.25 768.34C619.31 768.75 620.5 768.23 620.91 767.17C621.32 766.11 620.8 764.92 619.74 764.51L465.71 704.62C464.65 704.21 463.46 704.73 463.05 705.79C462.64 706.85 463.16 708.04 464.22 708.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M615.89 229.05L560.33 415.86C560.01 416.95 560.64 418.09 561.74 418.41C562.82 418.72 563.95 418.11 564.28 417.04L619.84 230.23C620.16 229.14 619.53 228 618.43 227.68C617.35 227.37 616.22 227.98 615.89 229.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1288.56 440.09L1182.77 514.96C1181.85 515.62 1181.64 516.91 1182.3 517.83C1182.96 518.74 1184.22 518.96 1185.15 518.32L1290.94 443.45C1291.87 442.79 1292.09 441.51 1291.43 440.58C1290.77 439.65 1289.49 439.43 1288.56 440.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M503.24 629.49L637.98 689.9C639.02 690.36 640.23 689.88 640.69 688.84C641.14 687.81 640.69 686.61 639.66 686.14L504.92 625.73C503.88 625.27 502.67 625.75 502.21 626.79C501.76 627.82 502.21 629.02 503.24 629.48V629.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1288.34 443.27L1360.01 510.62C1360.84 511.4 1362.14 511.36 1362.92 510.53C1363.7 509.7 1363.66 508.4 1362.83 507.62L1291.17 440.27C1290.34 439.5 1289.03 439.55 1288.26 440.38C1287.5 441.2 1287.54 442.49 1288.35 443.26L1288.34 443.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M363.17 505.85L407.1 485.36C408.13 484.88 408.58 483.65 408.09 482.62C407.61 481.59 406.38 481.14 405.35 481.63L361.42 502.12C360.39 502.6 359.94 503.82 360.42 504.85C360.9 505.88 362.12 506.33 363.15 505.85H363.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M502.77 626.03L446.85 672.5C445.98 673.23 445.86 674.52 446.58 675.4C447.31 676.27 448.6 676.39 449.48 675.67L505.4 629.2C506.26 628.46 506.36 627.16 505.62 626.3C504.9 625.46 503.64 625.34 502.77 626.04V626.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M949.37 650.53L844.51 760.64C843.74 761.48 843.8 762.78 844.64 763.55C845.45 764.29 846.71 764.26 847.49 763.48L952.35 653.37C953.13 652.55 953.1 651.24 952.28 650.46C951.46 649.68 950.15 649.71 949.37 650.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M362.44 362.77L404.29 484.16C404.69 485.22 405.87 485.76 406.94 485.37C407.96 484.99 408.51 483.87 408.18 482.82L366.33 361.43C365.96 360.36 364.79 359.78 363.71 360.16C362.63 360.54 362.06 361.7 362.44 362.78V362.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M757.58 184.98L760.18 285.85C760.21 286.99 761.15 287.88 762.29 287.86C763.43 287.83 764.32 286.89 764.3 285.75L761.7 184.88C761.65 183.74 760.69 182.86 759.56 182.91C758.45 182.96 757.58 183.87 757.59 184.98H757.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M793.09 449.08L764.27 285.44C764.07 284.32 763.01 283.57 761.89 283.77C760.77 283.97 760.02 285.03 760.22 286.15L789.04 449.79C789.24 450.91 790.3 451.66 791.42 451.46C792.54 451.26 793.29 450.2 793.09 449.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M446.34 675.03L463.14 707.48C463.68 708.48 464.93 708.85 465.93 708.31C466.9 707.78 467.29 706.58 466.8 705.59L450 673.14C449.48 672.13 448.24 671.74 447.23 672.26C446.22 672.78 445.83 674.02 446.35 675.03H446.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M870.06 502.87L832.66 530.72C831.75 531.4 831.56 532.69 832.24 533.6C832.92 534.51 834.21 534.7 835.12 534.02L872.52 506.17C873.42 505.47 873.58 504.18 872.89 503.28C872.21 502.41 870.97 502.22 870.07 502.87H870.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1412.33 770.2L1455.78 692.05C1456.33 691.06 1455.97 689.8 1454.98 689.25C1453.99 688.7 1452.73 689.06 1452.18 690.05L1408.73 768.2C1408.18 769.19 1408.54 770.45 1409.53 771C1410.52 771.55 1411.78 771.19 1412.33 770.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M117.65 285.8L32.79 244.54V249.12L115.85 289.5C116.87 290 118.1 289.57 118.6 288.55C119.1 287.53 118.67 286.3 117.65 285.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M750.85 708.8L720.92 611.69C720.57 610.61 719.41 610.02 718.33 610.37C717.28 610.71 716.68 611.83 716.99 612.9L746.92 710.01C747.27 711.09 748.43 711.68 749.51 711.33C750.56 710.99 751.16 709.87 750.85 708.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1410.72 771.25L1538.08 759.29C1539.21 759.17 1540.02 758.15 1539.9 757.02C1539.78 755.92 1538.8 755.11 1537.69 755.19L1410.33 767.15C1409.2 767.27 1408.39 768.29 1408.51 769.42C1408.63 770.52 1409.61 771.33 1410.72 771.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1190.7 760.39L1180.71 660.52C1180.58 659.39 1179.55 658.58 1178.42 658.71C1177.32 658.84 1176.51 659.82 1176.6 660.93L1186.61 760.8C1186.72 761.93 1187.73 762.76 1188.86 762.64C1189.99 762.53 1190.82 761.52 1190.7 760.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M872.46 502.82L792.23 447.74C791.28 447.12 790 447.39 789.38 448.35C788.78 449.27 789.01 450.49 789.9 451.13L870.13 506.21C871.07 506.85 872.35 506.61 872.99 505.68C873.63 504.74 873.4 503.46 872.46 502.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1572.97 777.55L1455.22 689.41C1454.31 688.73 1453.02 688.91 1452.34 689.82C1451.66 690.73 1451.84 692.02 1452.75 692.7L1570.5 780.84C1571.41 781.52 1572.7 781.34 1573.38 780.43C1574.06 779.52 1573.88 778.23 1572.97 777.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M343.33 437.09L265.48 460.38C264.4 460.72 263.79 461.87 264.13 462.96C264.46 464.03 265.59 464.63 266.66 464.33L344.52 441.05C345.61 440.72 346.22 439.57 345.9 438.48C345.57 437.39 344.42 436.77 343.33 437.1V437.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M563.71 414.94L538.33 391.3C537.48 390.54 536.18 390.62 535.43 391.47C534.7 392.29 534.74 393.55 535.53 394.31L560.91 417.95C561.74 418.72 563.04 418.68 563.82 417.85C564.59 417.02 564.55 415.72 563.72 414.94H563.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M151.22 235.65L115.07 286.46C114.41 287.39 114.63 288.67 115.56 289.33C116.48 289.99 117.77 289.77 118.42 288.85L154.56 238.05C155.21 237.11 154.97 235.83 154.04 235.19C153.12 234.56 151.87 234.77 151.21 235.67L151.22 235.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M748.06 707.52L618.17 764.54C617.13 765 616.66 766.21 617.11 767.25C617.56 768.29 618.78 768.76 619.82 768.31L749.71 711.29C750.74 710.82 751.2 709.59 750.72 708.56C750.26 707.55 749.08 707.09 748.05 707.52H748.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1572.85 777.47L1539 755.52C1538.03 754.92 1536.77 755.22 1536.17 756.18C1535.59 757.12 1535.85 758.35 1536.76 758.97L1570.6 780.92C1571.55 781.54 1572.83 781.27 1573.45 780.31C1574.07 779.36 1573.8 778.08 1572.84 777.46L1572.85 777.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M516.11 507.85L564.13 417.41C564.66 416.41 564.28 415.16 563.28 414.63C562.28 414.1 561.03 414.48 560.5 415.48L512.49 505.92C511.98 506.93 512.38 508.17 513.39 508.69C514.38 509.19 515.58 508.82 516.12 507.85H516.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1291.36 440.49L1250.13 388.58C1249.42 387.69 1248.13 387.55 1247.24 388.25C1246.35 388.96 1246.21 390.25 1246.91 391.14L1288.14 443.05C1288.85 443.93 1290.15 444.08 1291.03 443.36C1291.91 442.65 1292.05 441.37 1291.36 440.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M848.03 762.4L851.18 744.08C851.36 742.96 850.6 741.9 849.48 741.72C848.37 741.54 847.32 742.28 847.12 743.39L843.97 761.71C843.79 762.83 844.55 763.89 845.67 764.07C846.78 764.25 847.83 763.51 848.03 762.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M748.22 711.35L848.49 745.68C849.57 746.04 850.73 745.45 851.09 744.37C851.44 743.31 850.88 742.16 849.82 741.78L749.55 707.45C748.47 707.09 747.31 707.68 746.95 708.76C746.6 709.82 747.16 710.97 748.22 711.34V711.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M405.29 344.44L536.18 394.73C537.24 395.13 538.43 394.59 538.83 393.53C539.23 392.48 538.7 391.3 537.66 390.89L406.77 340.6C405.71 340.2 404.52 340.74 404.12 341.8C403.73 342.85 404.25 344.03 405.29 344.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M749.27 707.38L639.21 686C638.09 685.78 637.01 686.51 636.8 687.63C636.58 688.75 637.31 689.83 638.43 690.04L748.49 711.42C749.61 711.62 750.68 710.87 750.87 709.75C751.06 708.66 750.35 707.62 749.27 707.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M513.54 508.8L652.41 563.7C653.47 564.11 654.66 563.59 655.07 562.53C655.48 561.48 654.97 560.3 653.92 559.88L515.05 504.98C513.99 504.57 512.8 505.09 512.39 506.15C511.98 507.2 512.49 508.38 513.54 508.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M282.85 576.61L395.71 446.56C396.44 445.69 396.33 444.39 395.46 443.66C394.61 442.94 393.34 443.03 392.6 443.86L279.74 573.91C278.99 574.77 279.09 576.07 279.95 576.81C280.81 577.55 282.11 577.46 282.85 576.6V576.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M802.14 397.48L831.88 532.8C832.15 533.9 833.26 534.58 834.36 534.32C835.43 534.06 836.11 533 835.9 531.92L806.16 396.6C805.92 395.49 804.82 394.79 803.71 395.03C802.6 395.27 801.9 396.37 802.14 397.48Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1547.02 402.92L1595.69 529.03C1596.13 530.08 1597.34 530.57 1598.38 530.13C1599.38 529.71 1599.89 528.58 1599.52 527.55L1550.86 401.44C1550.45 400.38 1549.26 399.85 1548.19 400.26C1547.13 400.67 1546.6 401.86 1547.01 402.93L1547.02 402.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M802.16 396.54L789.07 448.93C788.81 450.04 789.5 451.14 790.61 451.4C791.69 451.65 792.77 451 793.06 449.93L806.15 397.54C806.41 396.43 805.72 395.32 804.62 395.06C803.54 394.8 802.44 395.46 802.16 396.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M394.51 447.24L562.66 418.48C563.78 418.29 564.53 417.22 564.34 416.1C564.15 414.98 563.08 414.23 561.96 414.42L393.81 443.18C392.69 443.37 391.94 444.44 392.13 445.56C392.32 446.68 393.38 447.43 394.51 447.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M616.02 228.72L535.08 391.89C534.58 392.91 534.99 394.14 536.01 394.65C537.03 395.16 538.26 394.74 538.77 393.72L619.71 230.55C620.21 229.53 619.8 228.3 618.78 227.79C617.76 227.28 616.53 227.7 616.02 228.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M750.61 708.28L654.89 560.67C654.26 559.72 652.98 559.47 652.04 560.1C651.11 560.72 650.84 561.97 651.44 562.91L747.16 710.52C747.79 711.47 749.07 711.72 750.01 711.09C750.94 710.47 751.2 709.23 750.61 708.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M360.95 502.44L279.94 573.71C279.09 574.46 279 575.76 279.75 576.61C280.5 577.46 281.8 577.55 282.65 576.8L363.66 505.53C364.51 504.78 364.6 503.48 363.85 502.63C363.1 501.78 361.8 501.69 360.95 502.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M883.61 553.02L830.94 615.69C830.21 616.56 830.32 617.86 831.19 618.59C832.06 619.32 833.36 619.21 834.09 618.34L886.76 555.67C887.49 554.8 887.38 553.5 886.51 552.77C885.64 552.04 884.34 552.15 883.61 553.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M403.98 342.29L392.11 444.97C391.98 446.1 392.79 447.12 393.92 447.25C395.05 447.38 396.07 446.57 396.2 445.44L408.07 342.76C408.2 341.63 407.39 340.61 406.26 340.48C405.13 340.35 404.11 341.16 403.98 342.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M672.51 234.83L618.14 227.6C617.01 227.45 615.98 228.24 615.83 229.37C615.68 230.5 616.47 231.53 617.6 231.68L671.97 238.91C673.1 239.03 674.12 238.22 674.24 237.09C674.36 236 673.6 235 672.51 234.83Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M502.24 626.7L463.12 705.62C462.62 706.64 463.04 707.87 464.06 708.37C465.07 708.87 466.3 708.45 466.8 707.44L505.92 628.52C506.42 627.5 505.99 626.27 504.97 625.77C503.96 625.28 502.74 625.69 502.23 626.69L502.24 626.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M962.84 317.96L1110.04 430.59C1110.94 431.28 1112.23 431.11 1112.92 430.21C1113.61 429.31 1113.44 428.02 1112.54 427.33L965.34 314.7C964.44 314.01 963.15 314.18 962.45 315.08C961.76 315.98 961.93 317.27 962.83 317.97L962.84 317.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1546.9 402.39L1553.28 462.41C1553.43 463.54 1554.47 464.32 1555.6 464.17C1556.68 464.02 1557.46 463.06 1557.37 461.97L1551 401.95C1550.88 400.82 1549.86 400 1548.73 400.12C1547.6 400.24 1546.78 401.26 1546.9 402.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M1180.71 660.96L1187.94 597.06C1188.05 595.93 1187.23 594.92 1186.1 594.81C1184.99 594.7 1184 595.49 1183.86 596.6L1176.61 660.5C1176.48 661.63 1177.3 662.66 1178.43 662.78C1179.56 662.91 1180.59 662.09 1180.72 660.96H1180.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M125.82 347.58L32.79 261.9V267.49L123.04 350.6C123.9 351.35 125.2 351.26 125.94 350.4C126.66 349.58 126.61 348.33 125.82 347.57V347.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M512.24 506.71L502.03 627.44C501.93 628.57 502.77 629.57 503.91 629.66C505.04 629.76 506.04 628.92 506.13 627.78L516.34 507.05C516.44 505.92 515.6 504.92 514.46 504.83C513.33 504.73 512.33 505.57 512.24 506.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M214.81 294.34L405.5 344.52C406.6 344.8 407.72 344.13 408 343.02C408.27 341.94 407.63 340.83 406.55 340.54L215.86 290.36C214.76 290.08 213.64 290.75 213.36 291.86C213.09 292.94 213.73 294.05 214.81 294.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M150.9 236.34L122.44 348.59C122.19 349.7 122.89 350.8 124 351.05C125.07 351.29 126.13 350.65 126.43 349.6L154.89 237.35C155.17 236.25 154.5 235.13 153.4 234.85C152.3 234.57 151.18 235.24 150.9 236.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M364.29 504.52L408.01 343.06C408.31 341.96 407.66 340.83 406.56 340.54C405.46 340.24 404.33 340.89 404.04 341.99L360.32 503.45C360.02 504.55 360.67 505.68 361.77 505.97C362.87 506.27 364 505.62 364.29 504.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M516.31 507.29L538.94 393.21C539.16 392.1 538.44 391.01 537.32 390.79C536.21 390.57 535.12 391.29 534.9 392.41L512.27 506.49C512.05 507.6 512.77 508.69 513.89 508.91C515 509.13 516.09 508.41 516.31 507.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M365.26 363.96L406.9 344.38C407.93 343.9 408.37 342.67 407.89 341.64C407.41 340.61 406.18 340.17 405.15 340.65L363.51 360.23C362.48 360.71 362.04 361.94 362.52 362.97C363 364 364.23 364.44 365.26 363.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M617.12 231.56L761.49 287.72C762.55 288.13 763.74 287.61 764.15 286.55C764.56 285.49 764.04 284.3 762.98 283.89L618.61 227.73C617.55 227.32 616.36 227.84 615.95 228.9C615.54 229.96 616.06 231.15 617.12 231.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M830.46 617.2L843.95 762.24C844.08 763.37 845.1 764.18 846.23 764.05C847.32 763.92 848.13 762.96 848.05 761.86L834.56 616.82C834.45 615.69 833.45 614.86 832.32 614.96C831.19 615.07 830.36 616.07 830.46 617.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M750.41 710.78L834.04 618.39C834.8 617.55 834.74 616.25 833.9 615.48C833.06 614.72 831.76 614.78 830.99 615.62L747.36 708.01C746.6 708.85 746.66 710.15 747.51 710.92C748.35 711.68 749.65 711.62 750.42 710.77L750.41 710.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M964.4 314.29L762.54 283.76C761.41 283.62 760.38 284.41 760.24 285.54C760.1 286.63 760.84 287.64 761.93 287.83L963.79 318.36C964.92 318.5 965.95 317.71 966.09 316.58C966.23 315.49 965.49 314.48 964.4 314.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M563.25 509.32L564.36 416.48C564.37 415.34 563.46 414.41 562.33 414.4C561.19 414.39 560.26 415.3 560.25 416.43L559.13 509.27C559.13 510.41 560.07 511.32 561.21 511.31C562.32 511.31 563.22 510.42 563.25 509.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M834.45 617.68L873.23 505.18C873.6 504.11 873.03 502.93 871.96 502.56C870.89 502.19 869.71 502.76 869.34 503.83L830.56 616.33C830.2 617.41 830.78 618.57 831.86 618.93C832.92 619.29 834.08 618.72 834.45 617.67V617.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M560.17 511.08L652.14 563.57C653.13 564.12 654.39 563.76 654.94 562.76C655.48 561.78 655.14 560.56 654.18 559.99L562.21 507.49C561.22 506.94 559.96 507.29 559.41 508.29C558.87 509.27 559.2 510.5 560.17 511.07V511.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M394.87 447.14L537.63 394.74C538.69 394.32 539.21 393.13 538.79 392.07C538.39 391.05 537.25 390.52 536.21 390.88L393.45 443.28C392.38 443.67 391.84 444.85 392.23 445.92C392.62 446.99 393.8 447.53 394.87 447.14Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M153.02 234.79L32.79 227.34V231.46L152.76 238.9C153.89 238.96 154.86 238.08 154.92 236.95C154.98 235.83 154.13 234.88 153.02 234.8V234.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M515.23 505.06L395.1 443.38C394.09 442.86 392.85 443.26 392.33 444.27C391.81 445.28 392.21 446.52 393.22 447.04L513.35 508.72C514.36 509.24 515.6 508.84 516.12 507.83C516.64 506.82 516.24 505.58 515.23 505.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M887.16 553.79L873.27 503.96C872.94 502.87 871.79 502.26 870.7 502.59C869.65 502.91 869.04 504 869.31 505.06L883.2 554.89C883.53 555.98 884.68 556.59 885.77 556.26C886.82 555.94 887.44 554.85 887.17 553.78L887.16 553.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1070.78 594.48L1185.82 598.88C1186.96 598.9 1187.89 597.99 1187.91 596.86C1187.93 595.76 1187.08 594.84 1185.98 594.77L1070.95 590.32C1069.8 590.28 1068.84 591.17 1068.79 592.32C1068.75 593.47 1069.64 594.43 1070.79 594.48H1070.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M491.88 739.81L451.38 840.87C450.96 841.93 451.47 843.12 452.52 843.55C453.58 843.97 454.77 843.46 455.2 842.41L495.74 741.36C496.17 740.3 495.65 739.09 494.59 738.66C493.53 738.23 492.32 738.75 491.89 739.81H491.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M360.95 505.53L502.73 629.16C503.6 629.89 504.9 629.76 505.63 628.89C506.33 628.05 506.25 626.8 505.44 626.06L363.66 502.43C362.8 501.68 361.5 501.77 360.76 502.63C360.02 503.49 360.1 504.79 360.96 505.53H360.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M671.26 238.68L761.26 287.6C762.26 288.14 763.51 287.77 764.05 286.78C764.59 285.79 764.22 284.53 763.23 283.99L673.23 235.07C672.22 234.54 670.98 234.93 670.45 235.94C669.93 236.92 670.29 238.14 671.26 238.69V238.68Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M493.39 742.61L618.58 768.43C619.7 768.63 620.77 767.88 620.97 766.76C621.16 765.68 620.48 764.65 619.42 764.4L494.24 738.54C493.11 738.34 492.03 739.09 491.83 740.22C491.64 741.3 492.33 742.35 493.4 742.6L493.39 742.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M427.82 624L446.23 674.79C446.62 675.86 447.8 676.41 448.87 676.02C449.94 675.63 450.49 674.45 450.1 673.38L431.71 622.59C431.32 621.51 430.13 620.96 429.06 621.35C427.98 621.74 427.43 622.93 427.82 624Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M747.9 711.21L845.02 763.86C846.03 764.38 847.27 763.99 847.8 762.99C848.31 762.01 847.95 760.79 846.99 760.25L749.87 707.6C748.86 707.08 747.62 707.47 747.1 708.48C746.59 709.46 746.95 710.67 747.91 711.22L747.9 711.21Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1424.88 639.3L1452.16 692C1452.7 693 1453.95 693.37 1454.95 692.83C1455.92 692.3 1456.31 691.1 1455.82 690.11L1428.57 637.39C1428.04 636.37 1426.79 635.97 1425.77 636.5C1424.75 637.03 1424.35 638.28 1424.88 639.3Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M362.26 506.04L514.25 508.95C515.39 508.95 516.3 508.02 516.29 506.88C516.29 505.78 515.42 504.89 514.32 504.84L362.33 501.93C361.19 501.91 360.25 502.81 360.23 503.95C360.21 505.09 361.11 506.03 362.25 506.05L362.26 506.04Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M963.17 314.49L803.23 395.21C802.23 395.75 801.85 397 802.39 398C802.91 398.96 804.09 399.35 805.08 398.89L965.02 318.17C966.02 317.64 966.4 316.39 965.87 315.39C965.35 314.42 964.16 314.03 963.17 314.5V314.49Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M364.02 364.13L536.56 394.84C537.68 395.04 538.75 394.29 538.95 393.18C539.15 392.06 538.4 390.99 537.29 390.79L364.75 360.08C363.63 359.88 362.56 360.63 362.36 361.74C362.16 362.85 362.91 363.93 364.02 364.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M494.52 742.53L639.53 689.96C640.59 689.56 641.13 688.37 640.73 687.31C640.34 686.26 639.18 685.72 638.12 686.09L493.1 738.63C492.02 739.02 491.46 740.21 491.86 741.29C492.25 742.37 493.44 742.93 494.52 742.54V742.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1289.89 439.71L1111.44 426.9C1110.31 426.82 1109.32 427.67 1109.24 428.8C1109.16 429.93 1110.01 430.92 1111.14 431L1289.59 443.81C1290.72 443.89 1291.71 443.04 1291.79 441.9C1291.87 440.77 1291.02 439.78 1289.88 439.7L1289.89 439.71Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M683.41 503.73L716.99 612.9C717.36 613.98 718.52 614.55 719.6 614.19C720.63 613.84 721.21 612.75 720.92 611.7L687.39 502.52C687.02 501.43 685.84 500.84 684.76 501.21C683.71 501.56 683.12 502.68 683.42 503.74L683.41 503.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M495.52 739.41L449.86 672.92C449.22 671.98 447.94 671.75 447 672.39C446.06 673.03 445.83 674.31 446.47 675.25L492.1 741.76C492.77 742.69 494.07 742.9 495 742.23C495.9 741.58 496.13 740.34 495.52 739.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M962.25 317.24L1003.84 400.4C1004.36 401.41 1005.6 401.82 1006.61 401.3C1007.61 400.79 1008.02 399.57 1007.52 398.55L965.92 315.39C965.41 314.37 964.18 313.96 963.16 314.47C962.14 314.98 961.73 316.21 962.24 317.23L962.25 317.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M887.01 553.4L805.98 396.1C805.45 395.1 804.2 394.71 803.2 395.24C802.21 395.76 801.82 396.98 802.32 397.98L883.35 555.28C883.89 556.28 885.14 556.65 886.14 556.11C887.11 555.59 887.49 554.39 887.01 553.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1516.85 767.2L1455.6 689.77C1454.89 688.88 1453.6 688.73 1452.71 689.43C1451.82 690.13 1451.67 691.43 1452.37 692.32L1513.59 769.77C1514.31 770.66 1515.62 770.8 1516.51 770.07C1517.39 769.36 1517.54 768.08 1516.85 767.18V767.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M94.4 226.79L114.79 288.29C115.17 289.36 116.35 289.92 117.42 289.54C118.46 289.17 119.02 288.05 118.7 287L98.35 225.48C97.99 224.39 96.81 223.8 95.72 224.16C94.63 224.52 94.04 225.7 94.4 226.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1516.14 770.35L1538.8 759.08C1539.81 758.55 1540.19 757.31 1539.67 756.3C1539.16 755.33 1537.97 754.93 1536.97 755.39L1514.29 766.62C1513.27 767.15 1512.87 768.4 1513.4 769.42C1513.92 770.42 1515.13 770.82 1516.14 770.34V770.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M505.94 628.51L563.05 510.19C563.54 509.16 563.11 507.93 562.09 507.44C561.06 506.95 559.83 507.38 559.34 508.4L502.24 626.72C501.76 627.75 502.22 628.97 503.25 629.45C504.26 629.91 505.45 629.5 505.95 628.51H505.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1166.6 698.54L1180.58 661.46C1180.98 660.39 1180.44 659.2 1179.38 658.8C1178.31 658.4 1177.12 658.94 1176.72 660L1162.75 697.09C1162.35 698.15 1162.89 699.34 1163.95 699.74C1165.01 700.14 1166.2 699.6 1166.6 698.54Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M563.21 508.87L538.93 392.39C538.7 391.28 537.61 390.56 536.5 390.8C535.39 391.03 534.67 392.12 534.91 393.23L559.18 509.71C559.44 510.82 560.55 511.51 561.65 511.25C562.72 511 563.41 509.95 563.21 508.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M514.19 508.94L561.09 511.35C562.23 511.41 563.2 510.53 563.25 509.4C563.31 508.26 562.43 507.29 561.3 507.24L514.4 504.84C513.26 504.8 512.32 505.7 512.28 506.83C512.25 507.93 513.09 508.87 514.19 508.95V508.94Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1743.18 633.38L1803.22 562.19C1803.95 561.32 1803.84 560.02 1802.97 559.29C1802.1 558.56 1800.8 558.67 1800.07 559.54L1740.03 630.73C1739.3 631.6 1739.41 632.9 1740.28 633.63C1741.15 634.36 1742.45 634.25 1743.18 633.38Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M364.11 504.96L395.97 446.18C396.51 445.18 396.14 443.93 395.14 443.39C394.14 442.85 392.89 443.22 392.35 444.22L360.49 503C359.95 504 360.32 505.25 361.32 505.79C362.32 506.33 363.57 505.96 364.11 504.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1005.13 401.46L1110.73 430.93C1111.83 431.22 1112.95 430.56 1113.24 429.46C1113.52 428.39 1112.9 427.28 1111.84 426.97L1006.24 397.5C1005.14 397.2 1004.01 397.85 1003.71 398.95C1003.42 400.04 1004.05 401.16 1005.13 401.47V401.46Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M362.45 362.79L392.23 445.9C392.62 446.97 393.8 447.52 394.86 447.14C395.92 446.76 396.48 445.58 396.1 444.52L366.32 361.41C365.93 360.34 364.75 359.79 363.68 360.18C362.62 360.57 362.06 361.73 362.44 362.8L362.45 362.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M683.58 502.12L651.37 560.8C650.82 561.8 651.19 563.05 652.18 563.59C653.18 564.14 654.43 563.77 654.97 562.78L687.22 504.12C687.75 503.1 687.35 501.84 686.33 501.32C685.34 500.81 684.13 501.16 683.57 502.12H683.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M552.57 343.11L560.26 416.67C560.39 417.8 561.41 418.61 562.54 418.48C563.65 418.35 564.45 417.36 564.35 416.25L556.71 342.69C556.58 341.55 555.54 340.73 554.4 340.86C553.28 340.99 552.46 341.99 552.57 343.12V343.11Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M806.08 396.31L764.16 285.07C763.76 284.01 762.57 283.47 761.51 283.87C760.45 284.27 759.91 285.46 760.31 286.52L802.23 397.77C802.63 398.83 803.82 399.37 804.88 398.97C805.94 398.57 806.48 397.38 806.08 396.32V396.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1802.6 562.7L1933.54 495.36C1934.52 494.79 1934.86 493.53 1934.29 492.55C1933.76 491.64 1932.63 491.27 1931.67 491.7L1800.71 559.04C1799.7 559.56 1799.3 560.81 1799.83 561.82C1800.35 562.83 1801.6 563.23 1802.61 562.7H1802.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M365.25 360.24L216.2 290.48C215.17 290 213.95 290.44 213.46 291.47C212.97 292.5 213.42 293.72 214.45 294.21L363.5 363.97C364.53 364.45 365.75 364.01 366.24 362.98C366.72 361.95 366.28 360.73 365.25 360.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M362.33 362.07L360.25 503.95C360.27 505.09 361.2 505.99 362.34 505.98C363.43 505.97 364.32 505.1 364.37 504.01L366.45 362.13C366.44 360.99 365.5 360.08 364.37 360.1C363.28 360.11 362.39 360.98 362.34 362.07H362.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M561.93 507.37L394.9 443.29C393.84 442.88 392.65 443.41 392.24 444.47C391.83 445.53 392.36 446.72 393.42 447.13L560.45 511.22C561.52 511.6 562.7 511.03 563.08 509.96C563.44 508.93 562.94 507.79 561.93 507.37Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M802.41 398.13L869.55 505.6C870.17 506.55 871.45 506.81 872.4 506.19C873.32 505.59 873.6 504.37 873.04 503.42L805.9 395.95C805.28 395 804.01 394.72 803.05 395.34C802.12 395.94 801.83 397.18 802.41 398.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M429.64 625.36L503.96 629.67C505.09 629.74 506.07 628.87 506.13 627.73C506.19 626.59 505.33 625.62 504.19 625.56L429.87 621.22C428.73 621.18 427.77 622.07 427.73 623.22C427.69 624.33 428.53 625.27 429.63 625.36H429.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M126.41 348.69C126.19 347.61 125.15 346.89 124.06 347.07L32.79 363.72V367.93L124.8 351.13C125.91 350.9 126.63 349.82 126.41 348.71V348.69Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M427.86 624.1L463.07 707.34C463.52 708.38 464.73 708.87 465.77 708.42C466.8 707.97 467.29 706.78 466.86 705.74L431.68 622.49C431.23 621.44 430.01 620.96 428.96 621.41C427.92 621.86 427.43 623.06 427.87 624.1H427.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1004.42 397.86L870.03 502.9C869.13 503.6 868.98 504.89 869.68 505.79C870.38 506.69 871.67 506.84 872.57 506.14L1006.97 401.11C1007.86 400.4 1008.01 399.11 1007.3 398.22C1006.6 397.34 1005.32 397.18 1004.43 397.87L1004.42 397.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M431.44 624.51L515.95 508.1C516.6 507.17 516.37 505.89 515.44 505.24C514.53 504.61 513.29 504.81 512.62 505.69L428.08 622.08C427.41 623.01 427.61 624.3 428.54 624.97C429.47 625.64 430.76 625.44 431.43 624.51H431.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1246.92 796.42L1166.28 696.52C1165.55 695.65 1164.25 695.53 1163.38 696.26C1162.53 696.97 1162.4 698.23 1163.08 699.1L1243.69 799.02C1244.43 799.9 1245.74 800.01 1246.62 799.27C1247.47 798.55 1247.61 797.29 1246.92 796.41V796.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1035.09 576.89L1163.25 699.3C1164.07 700.09 1165.37 700.06 1166.16 699.23C1166.94 698.41 1166.92 697.11 1166.09 696.32L1037.95 573.88C1037.12 573.09 1035.8 573.12 1035.01 573.95C1034.22 574.78 1034.25 576.1 1035.08 576.89H1035.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1069.31 593.78L1163.14 699.18C1163.9 700.03 1165.2 700.1 1166.05 699.35C1166.9 698.59 1166.97 697.29 1166.22 696.44L1072.42 591.02C1071.66 590.16 1070.34 590.09 1069.49 590.85C1068.63 591.61 1068.56 592.93 1069.32 593.78H1069.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M94.35 226.6L122.42 349.55C122.67 350.66 123.78 351.35 124.88 351.1C125.99 350.85 126.68 349.74 126.43 348.64L98.4 225.68C98.14 224.56 97.03 223.86 95.91 224.12C94.79 224.38 94.09 225.49 94.35 226.61V226.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M495.39 739.24L466.53 705.21C465.8 704.34 464.5 704.24 463.63 704.97C462.76 705.7 462.66 707 463.39 707.87L492.22 741.93C492.97 742.8 494.28 742.89 495.15 742.14C496 741.4 496.11 740.11 495.39 739.25V739.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1036.82 573.33L885.47 552.3C884.34 552.14 883.31 552.93 883.15 554.05C882.99 555.18 883.78 556.21 884.9 556.37L1036.24 577.44C1037.38 577.6 1038.43 576.81 1038.58 575.67C1038.74 574.53 1037.95 573.48 1036.81 573.33H1036.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M684.12 504.77L831.24 618.64C832.15 619.31 833.44 619.12 834.12 618.2C834.77 617.32 834.61 616.08 833.76 615.38L686.67 501.47C685.76 500.77 684.45 500.93 683.75 501.84C683.05 502.75 683.21 504.06 684.12 504.76V504.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M556.46 343.91L619.66 230.64C620.2 229.64 619.83 228.39 618.83 227.85C617.85 227.32 616.63 227.67 616.07 228.63L552.82 341.87C552.26 342.87 552.62 344.14 553.62 344.71C554.62 345.27 555.89 344.91 556.46 343.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1211.86 735.75L1166.02 696.26C1165.16 695.52 1163.86 695.61 1163.12 696.48C1162.38 697.34 1162.47 698.64 1163.33 699.38L1209.14 738.91C1210.01 739.66 1211.32 739.56 1212.07 738.69C1212.82 737.82 1212.72 736.51 1211.85 735.76L1211.86 735.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M1424.66 638.09L1408.49 768.95C1408.35 770.08 1409.15 771.11 1410.28 771.25C1411.41 771.39 1412.44 770.59 1412.58 769.46L1428.79 638.6C1428.93 637.46 1428.12 636.43 1426.98 636.29C1425.84 636.15 1424.81 636.96 1424.67 638.1L1424.66 638.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1038.38 576.33L1113.12 429.89C1113.64 428.88 1113.24 427.64 1112.22 427.12C1111.2 426.6 1109.97 427 1109.45 428.02L1034.67 574.45C1034.15 575.47 1034.55 576.72 1035.58 577.25C1036.6 577.77 1037.85 577.37 1038.38 576.34V576.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1005.71 397.42L804.18 394.98C803.04 394.97 802.11 395.88 802.1 397.01C802.09 398.15 803 399.08 804.13 399.09L1005.66 401.53C1006.8 401.54 1007.73 400.63 1007.75 399.49C1007.76 398.35 1006.85 397.42 1005.71 397.4V397.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1072.88 592.9L1113.29 429.44C1113.56 428.34 1112.89 427.22 1111.79 426.95C1110.69 426.68 1109.57 427.35 1109.3 428.45L1068.85 591.9C1068.57 593.01 1069.25 594.14 1070.37 594.42C1071.48 594.7 1072.61 594.02 1072.89 592.9H1072.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M431.8 622.89L396.18 444.81C395.94 443.7 394.85 442.99 393.74 443.23C392.65 443.46 391.95 444.52 392.15 445.62L427.74 623.71C427.96 624.83 429.06 625.56 430.18 625.34C431.3 625.12 432.03 624.02 431.81 622.9L431.8 622.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.37 224.06L32.79 224.5V228.63L96.4 228.21C97.55 228.21 98.47 227.26 98.47 226.12C98.47 224.97 97.52 224.05 96.38 224.05L96.37 224.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M552.67 342.19L534.98 392.12C534.6 393.19 535.16 394.37 536.23 394.75C537.3 395.13 538.48 394.57 538.86 393.5L556.6 343.59C556.99 342.51 556.42 341.31 555.33 340.93C554.25 340.54 553.05 341.11 552.67 342.2V342.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M552.62 342.39L512.3 506.39C512.05 507.5 512.74 508.6 513.85 508.85C514.93 509.1 516.02 508.44 516.3 507.37L556.67 343.38C556.95 342.26 556.26 341.13 555.14 340.86C554.02 340.59 552.89 341.27 552.62 342.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M95.9901 228.18L152.51 238.86C153.63 239.06 154.7 238.32 154.9 237.2C155.1 236.1 154.38 235.04 153.28 234.82L96.7701 224.09C95.6401 223.88 94.5501 224.62 94.3401 225.75C94.1301 226.88 94.8701 227.97 96.0001 228.18H95.9901Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M431.57 622.27L364.1 502.97C363.53 501.99 362.27 501.66 361.29 502.23C360.33 502.79 359.98 504.02 360.52 505L427.97 624.32C428.53 625.32 429.8 625.67 430.79 625.1C431.79 624.54 432.14 623.27 431.57 622.28V622.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M578.07 321.88L619.74 230.49C620.21 229.46 619.76 228.24 618.72 227.76C617.69 227.29 616.47 227.74 615.99 228.78L574.25 320.14C573.77 321.19 574.23 322.44 575.29 322.92C576.34 323.4 577.59 322.94 578.07 321.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M556.03 344.44L673.61 238.4C674.45 237.64 674.52 236.34 673.76 235.49C673 234.65 671.7 234.58 670.85 235.34L553.23 341.34C552.38 342.12 552.32 343.43 553.1 344.28C553.87 345.12 555.17 345.19 556.02 344.43L556.03 344.44Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1037.35 573.48L872.11 502.63C871.06 502.2 869.86 502.7 869.42 503.75C869 504.78 869.47 505.96 870.49 506.41L1035.72 577.3C1036.79 577.72 1037.99 577.21 1038.42 576.14C1038.83 575.11 1038.36 573.95 1037.36 573.48H1037.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M972.94 294.25L962.26 315.39C961.75 316.4 962.15 317.64 963.16 318.16C964.17 318.67 965.41 318.27 965.93 317.26L976.67 296.15C977.19 295.12 976.78 293.86 975.75 293.34C974.72 292.82 973.46 293.23 972.94 294.26V294.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M685.38 505.2L871.28 506.57C872.42 506.57 873.34 505.66 873.35 504.53C873.35 503.39 872.44 502.47 871.31 502.46L685.42 501.04C684.27 501.04 683.33 501.96 683.32 503.1C683.31 504.24 684.24 505.19 685.38 505.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M431.12 624.86L562.54 510.85C563.4 510.1 563.49 508.8 562.75 507.94C562 507.08 560.7 506.99 559.84 507.73L428.4 621.72C427.54 622.47 427.44 623.78 428.19 624.64C428.94 625.5 430.25 625.6 431.11 624.85L431.12 624.86Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M574.32 320.01L535.12 391.83C534.58 392.83 534.96 394.08 535.97 394.61C536.96 395.14 538.19 394.78 538.73 393.8L578 322.02C578.56 321 578.18 319.73 577.17 319.18C576.15 318.62 574.88 319 574.33 320.01H574.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1038.57 575.03L1007.71 399.13C1007.49 398.01 1006.4 397.29 1005.29 397.51C1004.21 397.73 1003.49 398.75 1003.66 399.84L1034.48 575.75C1034.68 576.88 1035.76 577.64 1036.89 577.44C1038.02 577.24 1038.78 576.17 1038.58 575.03H1038.57Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M670.88 235.32L574.78 319.43C573.92 320.2 573.85 321.53 574.62 322.39C575.38 323.23 576.67 323.32 577.53 322.58L673.59 238.41C674.43 237.65 674.5 236.35 673.74 235.5C672.99 234.67 671.73 234.59 670.88 235.31V235.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M686.78 504.67L805.52 398.57C806.35 397.8 806.4 396.49 805.63 395.66C804.88 394.85 803.62 394.78 802.78 395.5L684.01 501.56C683.15 502.33 683.08 503.64 683.85 504.5C684.62 505.36 685.93 505.43 686.79 504.66L686.78 504.67Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1619.75 579.31L1740.76 633.94C1741.8 634.41 1743.02 633.95 1743.49 632.92C1743.96 631.88 1743.5 630.66 1742.47 630.19L1621.48 575.5C1620.43 575.02 1619.18 575.5 1618.71 576.55C1618.23 577.6 1618.71 578.85 1619.76 579.32L1619.75 579.31Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M729.42 414.42L764.23 286.34C764.53 285.24 763.88 284.11 762.78 283.81C761.68 283.51 760.55 284.16 760.25 285.26L725.37 413.32C725.07 414.44 725.73 415.59 726.84 415.89C727.96 416.19 729.11 415.53 729.41 414.42H729.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M561.3 511.35L685.51 505.2C686.66 505.11 687.51 504.11 687.43 502.97C687.35 501.87 686.41 501.02 685.31 501.05L561.11 507.24C559.97 507.31 559.11 508.28 559.17 509.42C559.24 510.54 560.19 511.4 561.31 511.36L561.3 511.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1247.17 796.81L1180.51 659.82C1180 658.8 1178.76 658.39 1177.74 658.9C1176.74 659.4 1176.32 660.62 1176.8 661.63L1243.44 798.63C1243.95 799.66 1245.19 800.08 1246.22 799.57C1247.24 799.07 1247.66 797.84 1247.17 796.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1198.53 718.32L1165.84 696.11C1164.9 695.47 1163.62 695.71 1162.98 696.65C1162.34 697.59 1162.58 698.87 1163.52 699.51L1196.16 721.8C1197.13 722.44 1198.44 722.17 1199.08 721.2C1199.7 720.25 1199.46 718.98 1198.53 718.32Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1035.46 577.17L1177.59 662.5C1178.57 663.08 1179.84 662.75 1180.42 661.77C1180.99 660.8 1180.68 659.55 1179.72 658.96L1037.6 573.61C1036.6 573.04 1035.34 573.38 1034.76 574.38C1034.21 575.35 1034.51 576.58 1035.46 577.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1069.75 594.16L1177.55 662.48C1178.52 663.08 1179.79 662.78 1180.39 661.81C1180.98 660.86 1180.7 659.61 1179.76 659L1071.97 590.66C1070.99 590.06 1069.71 590.37 1069.11 591.35C1068.52 592.31 1068.8 593.56 1069.74 594.17L1069.75 594.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M726.28 415.64L870.2 506.26C871.17 506.85 872.44 506.55 873.03 505.58C873.61 504.63 873.33 503.39 872.4 502.78L728.52 412.1C727.54 411.48 726.25 411.78 725.63 412.76C725.01 413.74 725.31 415.03 726.29 415.65L726.28 415.64Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M552.56 342.97L559.14 509.37C559.18 510.51 560.14 511.39 561.28 511.35C562.42 511.31 563.3 510.35 563.26 509.21L556.73 342.81C556.66 341.66 555.67 340.79 554.52 340.86C553.41 340.93 552.55 341.86 552.57 342.98L552.56 342.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1212.43 736.53L1180.56 659.94C1180.1 658.9 1178.88 658.42 1177.84 658.88C1176.82 659.33 1176.34 660.5 1176.75 661.53L1208.59 738.13C1209.05 739.18 1210.28 739.66 1211.33 739.2C1212.35 738.75 1212.84 737.57 1212.43 736.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M427.95 624.28L491.99 741.57C492.54 742.58 493.8 742.95 494.81 742.4C495.82 741.85 496.19 740.59 495.64 739.58L431.59 622.29C431.04 621.29 429.78 620.92 428.78 621.46C427.78 622.01 427.41 623.27 427.95 624.27V624.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1715.78 744.65L1743.6 632.55C1743.84 631.44 1743.14 630.34 1742.03 630.1C1740.96 629.86 1739.9 630.51 1739.6 631.56L1711.68 743.63C1711.4 744.76 1712.09 745.9 1713.22 746.18C1714.35 746.46 1715.49 745.77 1715.77 744.64L1715.78 744.65Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M702.65 776.89L750.55 710.61C751.22 709.69 751.01 708.4 750.09 707.74C749.17 707.08 747.88 707.28 747.22 708.2L699.24 774.42C698.56 775.36 698.77 776.68 699.71 777.36C700.65 778.04 701.97 777.83 702.65 776.89Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M727.84 415.91L804.59 399.05C805.69 398.78 806.37 397.67 806.1 396.56C805.84 395.49 804.79 394.82 803.71 395.03L726.94 411.82C725.81 412.08 725.1 413.2 725.36 414.32C725.61 415.44 726.72 416.14 727.84 415.91Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M972.8 295.79L1003.71 400.07C1004.05 401.16 1005.2 401.76 1006.29 401.43C1007.36 401.1 1007.97 399.98 1007.66 398.9L976.81 294.61C976.48 293.5 975.32 292.87 974.21 293.2C973.1 293.53 972.47 294.69 972.8 295.8V295.79Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1425 639.51L1513.49 769.66C1514.16 770.59 1515.46 770.81 1516.39 770.14C1517.29 769.49 1517.53 768.26 1516.93 767.32L1428.43 637.17C1427.79 636.22 1426.49 635.98 1425.55 636.62C1424.6 637.26 1424.36 638.56 1425 639.5V639.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M97.6 224.48C96.69 223.81 95.4 223.99 94.71 224.89L32.78 307.31V314.23L98.03 227.39C98.71 226.47 98.52 225.16 97.59 224.48H97.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M342.76 440.76L458.02 520.49C458.97 521.15 460.28 520.91 460.94 519.96C461.6 519.01 461.36 517.7 460.41 517.04L345.11 437.38C344.18 436.73 342.89 436.97 342.24 437.9C341.59 438.83 341.83 440.12 342.76 440.77V440.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1035.61 577.25L1069.94 594.27C1070.98 594.75 1072.22 594.3 1072.7 593.26C1073.16 592.26 1072.76 591.07 1071.79 590.55L1037.46 573.54C1036.43 573.04 1035.18 573.48 1034.69 574.51C1034.2 575.53 1034.61 576.75 1035.62 577.26L1035.61 577.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M574.07 320.85L559.14 509.13C559.07 510.27 559.93 511.24 561.07 511.31C562.18 511.38 563.14 510.56 563.25 509.45L578.25 321.17C578.34 320.02 577.48 319.01 576.33 318.92C575.18 318.83 574.17 319.69 574.08 320.84L574.07 320.85Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1208.7 738.36L1243.5 798.75C1244.07 799.74 1245.34 800.08 1246.34 799.51C1247.33 798.94 1247.68 797.67 1247.1 796.67L1212.3 736.27C1211.73 735.27 1210.45 734.93 1209.46 735.51C1208.47 736.09 1208.12 737.36 1208.7 738.35V738.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1212 735.88L1072.36 590.96C1071.56 590.14 1070.24 590.13 1069.42 590.93C1068.61 591.72 1068.59 593.02 1069.37 593.84L1209.01 738.77C1209.82 739.59 1211.14 739.59 1211.95 738.78C1212.75 737.99 1212.77 736.7 1212 735.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M553.02 344.21L683.78 504.44C684.52 505.32 685.83 505.43 686.71 504.69C687.57 503.97 687.7 502.69 687 501.81L556.24 341.58C555.5 340.7 554.19 340.58 553.3 341.32C552.44 342.05 552.31 343.33 553.01 344.21H553.02Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M143.12 629.27L32.79 543.12V548.42L140.57 632.55C141.48 633.24 142.79 633.06 143.48 632.15C144.16 631.26 144 629.98 143.13 629.28L143.12 629.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M1199.36 719.43L1180.63 660.11C1180.29 659.02 1179.13 658.42 1178.04 658.76C1176.95 659.1 1176.35 660.26 1176.69 661.35L1195.34 720.7C1195.69 721.81 1196.87 722.43 1197.98 722.08C1199.09 721.73 1199.71 720.55 1199.36 719.44V719.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1037.92 643.76L1178.38 662.78C1179.51 662.92 1180.54 662.12 1180.69 660.99C1180.83 659.87 1180.05 658.85 1178.94 658.69L1038.49 639.59C1037.34 639.43 1036.27 640.24 1036.12 641.4C1035.97 642.56 1036.77 643.62 1037.93 643.77L1037.92 643.76Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M725.5 412.98L683.52 502.24C683.03 503.28 683.48 504.52 684.52 505.01C685.56 505.5 686.8 505.05 687.29 504.01L729.3 414.76C729.79 413.71 729.34 412.47 728.3 411.97C727.26 411.47 726.01 411.93 725.51 412.97L725.5 412.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M553.85 344.82L726.6 415.81C727.68 416.23 728.89 415.7 729.31 414.62C729.72 413.57 729.22 412.39 728.19 411.94L555.43 340.97C554.37 340.53 553.15 341.04 552.71 342.11C552.27 343.18 552.78 344.39 553.85 344.83V344.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M556.13 344.35L577.66 322.48C578.45 321.64 578.42 320.31 577.58 319.52C576.76 318.75 575.48 318.76 574.68 319.54L553.17 341.43C552.36 342.25 552.37 343.57 553.19 344.38C554.01 345.19 555.33 345.18 556.14 344.36L556.13 344.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M727.55 444.03L805.19 398.82C806.16 398.23 806.47 396.96 805.88 395.99C805.31 395.04 804.09 394.72 803.12 395.26L725.41 440.36C724.4 440.95 724.05 442.25 724.64 443.26C725.23 444.27 726.53 444.62 727.54 444.03H727.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M1195.55 721.17L1243.53 798.81C1244.13 799.79 1245.41 800.09 1246.39 799.49C1247.37 798.89 1247.67 797.61 1247.07 796.63L1199.14 718.96C1198.52 717.98 1197.21 717.69 1196.23 718.31C1195.26 718.92 1194.96 720.19 1195.55 721.17Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1040.31 641.62L1038.61 575.34C1038.58 574.19 1037.63 573.29 1036.48 573.32C1035.33 573.35 1034.43 574.3 1034.46 575.45L1036.1 641.73C1036.16 642.89 1037.15 643.79 1038.31 643.73C1039.43 643.67 1040.31 642.75 1040.31 641.63V641.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1198.84 718.58L1072.33 590.94C1071.51 590.14 1070.19 590.16 1069.39 590.98C1068.61 591.78 1068.61 593.05 1069.38 593.86L1195.84 721.54C1196.67 722.36 1198 722.35 1198.82 721.52C1199.63 720.7 1199.63 719.39 1198.83 718.57L1198.84 718.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1039.96 642.83L1072.6 593.55C1073.23 592.59 1072.97 591.3 1072.02 590.67C1071.07 590.04 1069.77 590.3 1069.14 591.25L1036.46 640.5C1035.82 641.47 1036.08 642.78 1037.05 643.42C1038.02 644.06 1039.33 643.8 1039.97 642.83H1039.96Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1598.08 476.38L1550.7 401.08C1550.09 400.12 1548.82 399.83 1547.86 400.43C1546.9 401.04 1546.61 402.31 1547.21 403.27L1594.49 478.64C1595.11 479.63 1596.43 479.93 1597.42 479.31C1598.41 478.69 1598.71 477.37 1598.09 476.38H1598.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1212.16 736.06L1199.02 718.78C1198.31 717.86 1196.98 717.7 1196.06 718.41C1195.15 719.11 1194.98 720.42 1195.67 721.34L1208.85 738.59C1209.56 739.5 1210.86 739.66 1211.77 738.95C1212.66 738.25 1212.83 736.97 1212.16 736.07V736.06Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1211.51 735.51L1039.22 639.83C1038.19 639.3 1036.91 639.7 1036.38 640.74C1035.87 641.73 1036.22 642.95 1037.17 643.52L1209.49 739.15C1210.5 739.69 1211.76 739.31 1212.3 738.29C1212.83 737.3 1212.48 736.07 1211.5 735.51H1211.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M575.06 322.8L726.3 415.65C727.3 416.24 728.58 415.91 729.17 414.91C729.74 413.94 729.44 412.69 728.49 412.08L577.25 319.22C576.25 318.63 574.97 318.97 574.38 319.97C573.81 320.94 574.11 322.19 575.06 322.79V322.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1425.24 639.8L1486.54 702.23C1487.36 703.06 1488.7 703.07 1489.53 702.24C1490.36 701.42 1490.37 700.09 1489.56 699.26L1428.21 636.89C1427.38 636.1 1426.07 636.13 1425.28 636.96C1424.52 637.75 1424.51 638.99 1425.25 639.8H1425.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M1486.08 701.53L1513.29 769.27C1513.73 770.33 1514.95 770.83 1516.01 770.39C1517.05 769.96 1517.56 768.77 1517.15 767.72L1490.01 699.96C1489.58 698.88 1488.34 698.35 1487.26 698.78C1486.18 699.21 1485.65 700.45 1486.08 701.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1208.43 737.42L1213.66 856.64C1213.71 857.81 1214.7 858.71 1215.87 858.66C1217.04 858.61 1217.94 857.62 1217.89 856.45L1212.59 737.23C1212.52 736.08 1211.54 735.21 1210.39 735.28C1209.27 735.35 1208.4 736.29 1208.43 737.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1486.93 366.97L1547.88 403.94C1548.85 404.53 1550.12 404.22 1550.71 403.25C1551.3 402.28 1550.99 401.01 1550.02 400.42L1489.15 363.33C1488.14 362.72 1486.83 363.04 1486.22 364.05C1485.61 365.06 1485.93 366.37 1486.94 366.98L1486.93 366.97Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1618.78 578.42L1711.89 745.17C1712.46 746.19 1713.74 746.55 1714.76 745.99C1715.78 745.42 1716.14 744.14 1715.58 743.12L1622.45 576.38C1621.87 575.38 1620.59 575.04 1619.59 575.62C1618.61 576.19 1618.26 577.43 1618.79 578.43L1618.78 578.42Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1102.39 439.7L1034.67 574.46C1034.17 575.49 1034.59 576.73 1035.63 577.24C1036.64 577.73 1037.87 577.33 1038.39 576.33L1106.2 441.62C1106.73 440.57 1106.3 439.29 1105.26 438.76C1104.21 438.23 1102.93 438.66 1102.4 439.7H1102.39Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M724.72 441.01L683.68 501.96C683.05 502.92 683.32 504.21 684.29 504.84C685.23 505.45 686.49 505.21 687.13 504.29L728.25 443.39C728.91 442.42 728.65 441.1 727.68 440.44C726.71 439.78 725.39 440.04 724.73 441.01H724.72Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M1102.22 440.19L1068.84 591.95C1068.59 593.07 1069.3 594.18 1070.42 594.43C1071.54 594.68 1072.65 593.97 1072.9 592.85L1106.38 441.11C1106.63 439.96 1105.91 438.83 1104.76 438.58C1103.61 438.33 1102.48 439.05 1102.23 440.2L1102.22 440.19Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1208.46 736.95L1179.77 894.62C1179.56 895.78 1180.33 896.88 1181.48 897.09C1182.64 897.3 1183.74 896.53 1183.95 895.38L1212.55 737.7C1212.75 736.57 1212 735.49 1210.87 735.28C1209.74 735.07 1208.66 735.83 1208.45 736.96L1208.46 736.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1489.49 702.29L1622.04 578.93C1622.87 578.13 1622.89 576.8 1622.09 575.97C1621.31 575.16 1620.03 575.11 1619.19 575.87L1486.61 699.2C1485.75 700 1485.71 701.33 1486.5 702.19C1487.3 703.05 1488.63 703.09 1489.49 702.3V702.29Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1198.28 718.17L1039.14 639.78C1038.09 639.27 1036.83 639.69 1036.32 640.74C1035.81 641.78 1036.23 643.05 1037.28 643.56L1196.43 721.95C1197.47 722.46 1198.74 722.03 1199.25 720.99C1199.76 719.95 1199.33 718.68 1198.29 718.17H1198.28Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M728.6 442.27L729.49 413.94C729.51 412.78 728.59 411.83 727.43 411.81C726.3 411.79 725.35 412.67 725.3 413.81L724.35 442.14C724.31 443.31 725.23 444.29 726.4 444.33C727.57 444.37 728.55 443.45 728.59 442.28L728.6 442.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1712.53 745.87L1791.84 801.02C1792.8 801.69 1794.12 801.46 1794.79 800.49C1795.46 799.53 1795.23 798.21 1794.26 797.54L1714.92 742.42C1713.97 741.76 1712.66 741.99 1711.99 742.94C1711.32 743.89 1711.56 745.2 1712.51 745.87H1712.53Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M1622.65 576.9L1598.35 477.01C1598.05 475.87 1596.89 475.19 1595.76 475.49C1594.65 475.78 1593.97 476.9 1594.22 478.02L1618.58 577.9C1618.85 579.02 1619.99 579.71 1621.11 579.44C1622.23 579.17 1622.92 578.03 1622.65 576.91V576.9Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1195.26 720.34L1213.68 856.82C1213.87 857.97 1214.96 858.75 1216.11 858.56C1217.21 858.38 1217.98 857.37 1217.87 856.25L1199.44 719.77C1199.28 718.62 1198.22 717.81 1197.07 717.96C1195.92 718.12 1195.11 719.18 1195.26 720.33V720.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M858.51 311.93L726.13 412.2C725.21 412.91 725.04 414.22 725.75 415.14C726.45 416.04 727.74 416.22 728.66 415.54L861.09 315.34C862.03 314.63 862.22 313.29 861.5 312.34C860.79 311.4 859.45 311.21 858.5 311.93H858.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M860.14 315.75L975.14 297.26C976.28 297.08 977.06 296 976.88 294.86C976.7 293.72 975.62 292.94 974.48 293.12L859.47 311.52C858.3 311.71 857.51 312.81 857.7 313.97C857.89 315.14 858.98 315.93 860.15 315.74L860.14 315.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M1195.25 719.88L1179.75 894.82C1179.65 895.99 1180.51 897.02 1181.68 897.13C1182.85 897.23 1183.88 896.37 1183.99 895.2L1199.45 720.26C1199.55 719.1 1198.7 718.08 1197.54 717.97C1196.38 717.87 1195.36 718.72 1195.25 719.88Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1672.34 405.09L1618.61 576.78C1618.26 577.88 1618.88 579.06 1619.98 579.41C1621.08 579.76 1622.26 579.14 1622.61 578.04L1676.42 406.38C1676.77 405.25 1676.14 404.05 1675.02 403.7C1673.89 403.35 1672.69 403.98 1672.34 405.1V405.09Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1486.5 366.63L1594.75 478.99C1595.56 479.84 1596.91 479.86 1597.76 479.05C1598.61 478.24 1598.63 476.89 1597.82 476.04L1489.59 363.67C1488.76 362.83 1487.41 362.82 1486.57 363.64C1485.74 364.46 1485.71 365.79 1486.51 366.63H1486.5Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M727.95 443.73L861.29 315.18C862.14 314.36 862.16 313.01 861.34 312.15C860.52 311.3 859.17 311.28 858.31 312.1L725 440.67C724.18 441.51 724.2 442.86 725.04 443.67C725.84 444.45 727.11 444.47 727.94 443.72L727.95 443.73Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M1672.93 404.15L1594.84 475.95C1593.98 476.75 1593.93 478.09 1594.73 478.95C1595.52 479.8 1596.85 479.86 1597.71 479.08L1675.82 407.3C1676.69 406.5 1676.75 405.15 1675.95 404.28C1675.15 403.41 1673.8 403.35 1672.93 404.15Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M1222.4 286.63L1102.62 439.33C1101.9 440.25 1102.06 441.59 1102.98 442.32C1103.9 443.04 1105.24 442.88 1105.97 441.96L1225.77 289.27C1226.49 288.34 1226.32 286.99 1225.39 286.27C1224.46 285.55 1223.13 285.71 1222.4 286.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1153.44 415.4L1103.4 438.72C1102.34 439.22 1101.87 440.48 1102.37 441.55C1102.87 442.61 1104.13 443.08 1105.2 442.58L1155.25 419.28C1156.31 418.76 1156.75 417.47 1156.22 416.41C1155.71 415.38 1154.49 414.94 1153.44 415.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1249.69 751.77L1198.5 718.3C1197.53 717.66 1196.22 717.93 1195.58 718.91C1194.94 719.89 1195.21 721.19 1196.19 721.83L1247.32 755.4C1248.32 756.06 1249.66 755.78 1250.32 754.77C1250.98 753.77 1250.7 752.43 1249.69 751.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1674.83 403.63L1488.49 363.06C1487.33 362.82 1486.21 363.57 1485.97 364.73C1485.74 365.86 1486.45 366.97 1487.58 367.24L1673.92 407.82C1675.08 408.05 1676.21 407.3 1676.44 406.14C1676.66 405.01 1675.95 403.9 1674.83 403.64V403.63Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M1222.2 286.94L1152.45 416.33C1151.89 417.37 1152.28 418.67 1153.32 419.23C1154.36 419.79 1155.66 419.4 1156.22 418.36L1225.96 288.97C1226.5 287.92 1226.09 286.63 1225.03 286.09C1224.01 285.57 1222.76 285.94 1222.19 286.94H1222.2Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1246.44 752.92L1213.76 855.9C1213.44 857.02 1214.09 858.19 1215.22 858.51C1216.29 858.81 1217.42 858.23 1217.79 857.18L1250.57 754.23C1250.9 753.08 1250.24 751.88 1249.09 751.55C1247.98 751.23 1246.82 751.83 1246.44 752.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1415.78 423.66L1595.65 479.54C1596.78 479.86 1597.96 479.21 1598.28 478.08C1598.59 476.99 1597.99 475.84 1596.92 475.48L1417.07 419.53C1415.93 419.18 1414.72 419.82 1414.38 420.96C1414.03 422.09 1414.66 423.29 1415.79 423.65L1415.78 423.66Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M1842.04 737.33L1791.43 797.92C1790.68 798.82 1790.8 800.15 1791.7 800.9C1792.6 801.65 1793.93 801.53 1794.68 800.63L1845.38 740.11C1846.15 739.19 1846.03 737.82 1845.11 737.05C1844.19 736.28 1842.82 736.4 1842.05 737.32L1842.04 737.33Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1487.78 363.03L1371.76 377.36C1370.58 377.54 1369.77 378.64 1369.95 379.82C1370.12 380.95 1371.15 381.75 1372.28 381.64L1488.3 367.27C1489.47 367.12 1490.29 366.04 1490.14 364.87C1489.99 363.71 1488.94 362.89 1487.78 363.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1246.55 752.66L1179.94 894.1C1179.44 895.16 1179.9 896.43 1180.96 896.93C1182.02 897.43 1183.29 896.97 1183.79 895.91L1250.47 754.51C1250.95 753.42 1250.47 752.14 1249.37 751.65C1248.31 751.18 1247.07 751.63 1246.56 752.66H1246.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1417.75 423.29L1489.36 366.82C1490.28 366.08 1490.42 364.73 1489.67 363.82C1488.94 362.92 1487.63 362.77 1486.71 363.47L1415.07 419.9C1414.13 420.64 1413.97 421.99 1414.71 422.93C1415.45 423.87 1416.8 424.03 1417.74 423.29H1417.75Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1222.96 289.77L1370.89 381.33C1371.92 381.93 1373.24 381.57 1373.84 380.54C1374.41 379.55 1374.11 378.29 1373.16 377.66L1225.21 286.13C1224.2 285.51 1222.89 285.83 1222.27 286.83C1221.65 287.83 1221.96 289.14 1222.96 289.76V289.77Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1485.94 700.51L1474.06 806.54C1473.93 807.74 1474.79 808.82 1475.99 808.95C1477.19 809.08 1478.27 808.22 1478.4 807.02L1490.14 700.97C1490.26 699.81 1489.41 698.77 1488.25 698.65C1487.11 698.54 1486.08 699.36 1485.94 700.5V700.51Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M1428.61 659.6L1486.79 702.45C1487.75 703.12 1489.06 702.89 1489.74 701.93C1490.39 701.01 1490.2 699.74 1489.31 699.05L1431.23 656.07C1430.25 655.35 1428.88 655.56 1428.16 656.53C1427.44 657.51 1427.65 658.88 1428.62 659.6H1428.61Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1062.52 357.32L1102.37 441.56C1102.87 442.62 1104.14 443.08 1105.2 442.57C1106.26 442.07 1106.72 440.8 1106.21 439.74L1066.46 355.46C1065.92 354.38 1064.61 353.94 1063.53 354.48C1062.49 355 1062.04 356.25 1062.51 357.32H1062.52Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M921.95 479.65L861.81 312.91C861.4 311.8 860.16 311.24 859.06 311.66C857.97 312.07 857.41 313.27 857.79 314.36L917.87 481.12C918.28 482.25 919.52 482.83 920.65 482.43C921.78 482.02 922.36 480.78 921.96 479.65H921.95Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1417.9 420.03L1373.5 377.93C1372.64 377.11 1371.27 377.15 1370.45 378.01C1369.63 378.87 1369.67 380.24 1370.53 381.06L1414.93 423.16C1415.81 423.96 1417.17 423.9 1417.98 423.02C1418.76 422.16 1418.73 420.84 1417.9 420.03Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M1519.12 313.8L1486.25 363.98C1485.6 364.97 1485.88 366.29 1486.86 366.94C1487.85 367.59 1489.17 367.31 1489.82 366.33L1522.77 316.21C1523.41 315.19 1523.09 313.84 1522.07 313.2C1521.08 312.58 1519.78 312.85 1519.12 313.81V313.8Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1065.35 358.4L1224.92 289.92C1226.01 289.45 1226.51 288.2 1226.04 287.11C1225.57 286.02 1224.32 285.52 1223.23 285.99L1063.62 354.39C1062.51 354.87 1062 356.15 1062.47 357.26C1062.94 358.37 1064.23 358.88 1065.34 358.41L1065.35 358.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1063.27 358.2L1153.14 419.11C1154.12 419.77 1155.45 419.5 1156.11 418.52C1156.76 417.55 1156.51 416.24 1155.55 415.57L1065.73 354.59C1064.72 353.93 1063.37 354.21 1062.71 355.22C1062.07 356.2 1062.32 357.52 1063.28 358.2H1063.27Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1519.83 316.87L1673.29 407.56C1674.31 408.16 1675.62 407.82 1676.22 406.8C1676.81 405.79 1676.48 404.48 1675.47 403.88L1522.06 313.11C1521.02 312.5 1519.68 312.86 1519.07 313.9C1518.47 314.93 1518.81 316.25 1519.83 316.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1432.36 337.91L1487.03 367.03C1488.07 367.59 1489.36 367.19 1489.92 366.15C1490.48 365.11 1490.08 363.82 1489.04 363.26L1434.42 334.04C1433.35 333.47 1432.02 333.87 1431.45 334.94C1430.88 336.01 1431.28 337.34 1432.35 337.91H1432.36Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1520.08 312.99L1371.17 377.52C1370.08 378 1369.59 379.28 1370.07 380.37C1370.55 381.45 1371.8 381.94 1372.88 381.48L1521.82 317C1522.93 316.52 1523.44 315.23 1522.96 314.13C1522.48 313.02 1521.19 312.51 1520.09 312.99H1520.08Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M1519.38 313.47L1414.87 420.09C1414.05 420.95 1414.08 422.32 1414.95 423.14C1415.8 423.94 1417.13 423.93 1417.95 423.11L1522.5 316.53C1523.34 315.67 1523.33 314.28 1522.47 313.44C1521.61 312.6 1520.22 312.61 1519.38 313.47Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1432.13 334.19L1370.77 377.74C1369.81 378.44 1369.59 379.79 1370.29 380.75C1370.98 381.7 1372.3 381.92 1373.26 381.26L1434.66 337.77C1435.65 337.07 1435.88 335.7 1435.18 334.71C1434.48 333.72 1433.11 333.49 1432.12 334.19H1432.13Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1418.53 422.01L1435.54 336.4C1435.74 335.21 1434.93 334.08 1433.74 333.88C1432.6 333.69 1431.5 334.42 1431.24 335.55L1414.29 421.17C1414.06 422.34 1414.82 423.48 1415.99 423.71C1417.16 423.94 1418.3 423.18 1418.53 422.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M1063.07 354.73L918.5 478.74C917.61 479.54 917.53 480.91 918.33 481.81C919.11 482.68 920.43 482.78 921.33 482.04L1065.92 358.05C1066.84 357.26 1066.94 355.89 1066.16 354.97C1065.37 354.05 1064 353.95 1063.08 354.73H1063.07Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1520.44 312.87L1432.89 333.84C1431.71 334.12 1430.99 335.31 1431.27 336.48C1431.55 337.66 1432.74 338.38 1433.91 338.1L1521.46 317.11C1522.63 316.81 1523.33 315.62 1523.03 314.45C1522.74 313.31 1521.59 312.61 1520.44 312.86V312.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1427.82 658.48L1474.15 807.43C1474.51 808.58 1475.74 809.22 1476.89 808.86C1478.04 808.5 1478.68 807.28 1478.32 806.13L1432.01 657.18C1431.65 656.02 1430.42 655.38 1429.26 655.73C1428.1 656.09 1427.45 657.32 1427.81 658.48H1427.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M918.43 478.8L779.03 608.92C778.15 609.77 778.13 611.17 778.98 612.05C779.81 612.91 781.17 612.95 782.06 612.15L921.41 481.97C922.29 481.15 922.33 479.78 921.51 478.9C920.69 478.02 919.32 477.98 918.44 478.8H918.43Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M922.07 480.55L933.14 330.48C933.23 329.26 932.31 328.2 931.09 328.11C929.87 328.02 928.81 328.94 928.72 330.16L917.74 480.24C917.67 481.44 918.59 482.46 919.78 482.53C920.95 482.6 921.96 481.72 922.07 480.56V480.55Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1064.91 354.25L931.36 328.15C930.16 327.92 929 328.71 928.77 329.91C928.54 331.1 929.32 332.26 930.51 332.49L1064.07 358.53C1065.25 358.76 1066.4 357.99 1066.63 356.8C1066.86 355.62 1066.09 354.47 1064.9 354.24L1064.91 354.25Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M206.08 469.41L32.79 473.33V477.77L206.18 473.78C207.39 473.75 208.35 472.75 208.32 471.54C208.29 470.33 207.29 469.37 206.08 469.4V469.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M781.66 612.45L823.94 587.52C825.01 586.89 825.36 585.52 824.73 584.45C824.1 583.38 822.73 583.03 821.66 583.66L779.4 608.63C778.35 609.25 778 610.61 778.62 611.66C779.24 612.71 780.6 613.06 781.65 612.44L781.66 612.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M732.7 385.87L931.51 332.46C932.69 332.12 933.37 330.9 933.03 329.72C932.7 328.57 931.52 327.89 930.36 328.18L731.54 381.54C730.35 381.9 729.68 383.15 730.03 384.34C730.37 385.48 731.54 386.15 732.7 385.88V385.87Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1029.49 691.82L1030.23 829.89C1030.23 831.11 1031.23 832.09 1032.45 832.09C1033.67 832.09 1034.65 831.09 1034.65 829.87L1034.03 691.8C1034.03 690.55 1033 689.54 1031.75 689.54C1030.5 689.54 1029.49 690.57 1029.49 691.82Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M1034.6 524.24L822.2 583.44C821.01 583.78 820.33 585.02 820.67 586.21C821.01 587.38 822.22 588.07 823.4 587.75L1035.8 528.55C1036.99 528.2 1037.67 526.96 1037.32 525.77C1036.98 524.61 1035.77 523.92 1034.6 524.23V524.24Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M730.07 384.62L820.76 586.51C821.27 587.64 822.59 588.14 823.72 587.64C824.85 587.13 825.35 585.81 824.85 584.68L734.17 382.79C733.66 381.66 732.33 381.15 731.2 381.66C730.07 382.17 729.56 383.5 730.07 384.63V384.62Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M784.05 252.63L929.87 332.26C930.94 332.85 932.29 332.45 932.88 331.38C933.47 330.31 933.07 328.96 932 328.37L786.25 248.62C785.14 248.01 783.75 248.42 783.15 249.53C782.54 250.64 782.95 252.03 784.06 252.63H784.05Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M872.22 778.58L824.98 585.06C824.65 583.87 823.42 583.17 822.23 583.49C821.08 583.8 820.38 584.96 820.63 586.12L867.82 779.66C868.12 780.88 869.34 781.62 870.56 781.33C871.78 781.03 872.52 779.81 872.23 778.59L872.22 778.58Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1032.96 526.35L1029.5 691.76C1029.5 693.01 1030.52 694.03 1031.77 694.03C1032.99 694.03 1033.98 693.07 1034.04 691.86L1037.44 526.45C1037.47 525.21 1036.48 524.19 1035.25 524.17C1034.01 524.14 1032.99 525.13 1032.97 526.36L1032.96 526.35Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M733.13 381.7L630.6 329.83C629.48 329.26 628.12 329.71 627.55 330.83C626.98 331.95 627.43 333.31 628.55 333.88L731.1 385.71C732.22 386.25 733.56 385.78 734.1 384.66C734.62 383.57 734.2 382.27 733.13 381.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M562.55 508.99L733.43 385.52C734.42 384.77 734.61 383.36 733.86 382.37C733.14 381.41 731.79 381.2 730.8 381.88L559.89 505.31C558.89 506.06 558.68 507.48 559.43 508.48C560.16 509.46 561.54 509.69 562.55 508.98V508.99Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M620.13 280.41L730.58 385.33C731.49 386.17 732.91 386.11 733.75 385.2C734.57 384.31 734.54 382.92 733.67 382.07L623.26 277.11C622.34 276.26 620.9 276.32 620.05 277.24C619.22 278.14 619.25 279.54 620.13 280.4V280.41Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M559.78 505.4L417.23 622.56C416.27 623.35 416.13 624.77 416.92 625.74C417.71 626.71 419.13 626.84 420.1 626.05L562.67 508.9C563.63 508.09 563.75 506.66 562.94 505.7C562.15 504.76 560.75 504.62 559.79 505.39L559.78 505.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M416.41 624.18L408.86 764.89C408.8 766.14 409.77 767.21 411.02 767.27C412.26 767.33 413.32 766.38 413.4 765.14L420.92 624.43C420.97 623.18 420 622.13 418.76 622.08C417.54 622.03 416.49 622.96 416.41 624.19V624.18Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M1029.67 690.93L956.5 864.6C956.02 865.75 956.56 867.08 957.71 867.56C958.86 868.05 960.19 867.5 960.67 866.35L1033.85 692.69C1034.33 691.53 1033.78 690.21 1032.62 689.73C1031.47 689.25 1030.16 689.79 1029.67 690.93Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M783.02 249.78L730.03 382.87C729.6 384.03 730.19 385.32 731.35 385.76C732.47 386.18 733.73 385.64 734.2 384.53L787.27 251.47C787.72 250.29 787.13 248.97 785.95 248.52C784.79 248.08 783.49 248.63 783.02 249.78Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M1030.69 689.81L868.94 777.13C867.84 777.72 867.43 779.1 868.02 780.2C868.61 781.3 869.99 781.71 871.09 781.12L1032.84 693.81C1033.93 693.19 1034.31 691.81 1033.7 690.72C1033.1 689.66 1031.77 689.26 1030.69 689.82V689.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M563.33 507.98L631.68 332.68C632.12 331.51 631.52 330.2 630.34 329.77C629.19 329.34 627.92 329.91 627.45 331.04L559.1 506.34C558.66 507.51 559.25 508.82 560.42 509.26C561.58 509.7 562.87 509.13 563.33 507.98Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M619.45 279.1L627.34 332.18C627.52 333.42 628.68 334.27 629.92 334.09C631.16 333.91 632.01 332.75 631.83 331.51L623.95 278.43C623.77 277.19 622.61 276.33 621.37 276.52C620.13 276.7 619.27 277.86 619.46 279.1H619.45Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M416.4 624.29L416.2 652.58C416.2 653.85 417.24 654.87 418.51 654.86C419.76 654.86 420.77 653.85 420.79 652.6L420.91 624.31C420.91 623.06 419.91 622.05 418.66 622.04C417.41 622.04 416.4 623.04 416.39 624.29H416.4Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M784.09 248.6L628.53 329.84C627.43 330.44 627.03 331.82 627.63 332.92C628.21 333.99 629.54 334.41 630.63 333.86L786.21 252.65C787.33 252.07 787.76 250.68 787.18 249.56C786.6 248.44 785.21 248.01 784.09 248.59V248.6Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M241.83 596.92L418.29 626.53C419.52 626.72 420.68 625.88 420.87 624.65C421.06 623.44 420.25 622.29 419.03 622.08L242.59 592.38C241.34 592.17 240.15 593.02 239.94 594.27C239.73 595.52 240.58 596.71 241.83 596.92Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M622.08 281L785.54 252.87C786.78 252.66 787.62 251.47 787.41 250.23C787.2 248.99 786.01 248.15 784.77 248.36L621.32 276.51C620.09 276.74 619.27 277.93 619.5 279.16C619.73 280.37 620.87 281.18 622.09 280.99L622.08 281Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M559.6 505.56L416.86 650.98C415.99 651.9 416.03 653.36 416.96 654.23C417.86 655.08 419.26 655.06 420.14 654.2L562.84 508.74C563.72 507.85 563.7 506.41 562.81 505.53C561.92 504.65 560.48 504.67 559.6 505.56Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M539.7 705.01L419.95 622.45C418.92 621.74 417.52 622 416.81 623.03C416.1 624.06 416.36 625.46 417.39 626.17L537.08 708.82C538.14 709.53 539.58 709.25 540.29 708.19C540.99 707.15 540.73 705.74 539.71 705.02L539.7 705.01Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M413.4 765.16L420.79 652.74C420.85 651.47 419.87 650.4 418.6 650.34C417.37 650.28 416.31 651.21 416.21 652.44L408.86 764.86C408.78 766.11 409.73 767.2 410.98 767.28C412.23 767.36 413.31 766.41 413.4 765.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M537.43 704.81L410.19 762.95C409.06 763.5 408.6 764.86 409.15 765.99C409.68 767.07 410.97 767.55 412.08 767.08L539.35 709.01C540.5 708.46 541 707.09 540.45 705.93C539.91 704.8 538.57 704.3 537.43 704.8V704.81Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M241.49 596.84L417.78 654.78C418.99 655.18 420.28 654.52 420.68 653.32C421.08 652.12 420.42 650.82 419.22 650.42L242.93 592.47C241.72 592.09 240.42 592.76 240.04 593.97C239.66 595.16 240.31 596.44 241.49 596.84Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M539.34 704.8L419.45 650.5C418.29 649.99 416.93 650.53 416.43 651.69C415.94 652.83 416.43 654.15 417.56 654.68L537.44 709.01C538.6 709.54 539.97 709.02 540.5 707.86C541.03 706.7 540.51 705.33 539.35 704.8H539.34Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M861.7 185.7L783.71 248.85C782.74 249.66 782.62 251.11 783.43 252.07C784.22 253.01 785.61 253.16 786.58 252.4L864.62 189.31C865.6 188.48 865.73 187.02 864.9 186.03C864.1 185.07 862.68 184.92 861.69 185.69L861.7 185.7Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M287.18 714.16L410.23 767.1C411.38 767.6 412.72 767.07 413.22 765.91C413.72 764.76 413.19 763.42 412.03 762.92L289.04 709.84C287.85 709.33 286.46 709.88 285.95 711.07C285.44 712.26 285.99 713.65 287.18 714.16Z",
    fill: "#3D78BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M289.09 714.14L419.45 654.68C420.6 654.15 421.1 652.78 420.57 651.63C420.04 650.49 418.69 649.99 417.55 650.5L287.14 709.86C285.96 710.4 285.44 711.8 285.97 712.98C286.5 714.16 287.91 714.68 289.09 714.15V714.14Z",
    fill: "#3D78BB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1949.56,
    height: 1080,
    fill: "white",
    transform: "translate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLight);
export default __webpack_public_path__ + "static/media/backgroundLight.dc1cafa5e944f4eccd2c390cb1567504.svg";
export { ForwardRef as ReactComponent };